angular.module('controllers').controller('orderController', ['$scope', '$rootScope', '$controller', 'Crud', '$mdDialog', '$filter', 'orderByFilter', '$http', '$route', '$routeParams', '$location', '$timeout', '$interval', '$window', 'Mqtt', '$compile', '$q', '$sce',
    function ($scope, $rootScope, $controller, Crud, $mdDialog, $filter, orderByFilter, $http, $route, $routeParams, $location, $timeout, $interval, $window, Mqtt, $compile, $q, $sce) {

        Mqtt.connect($rootScope.mq);

        $rootScope.path = '/order';
        $scope.path = $rootScope.path;
        $rootScope.modelName = 'order';
        $scope.title = 'Comenzi';

        angular.extend(this, $controller('crudController', {$scope: $scope}));

        $scope.additionals['publicAppPath'] = '/images/app';
        $scope.additionals['publicUserPath'] = '/images/users';
        $scope.additionals['publicAudioPath'] = '/audio';
        $scope.additionals['columnDisplay'] = 'order_no';
        $scope.additionals['pathFilesCalls'] = 'calls';//var/calls/';
        $scope.sortType = 'order_no';
        $scope.defaultItem = 10;
        $rootScope.typeId = 'id';
        $scope.search.order = 'desc';
        $scope.search.period = 'cumulative';
        $scope.classAction = 'td-med';
        $scope.mode_action = 'page';

        $scope.additionals['dispatchTime'] = 0;
        $scope.additionals['kitchenTime'] = 0;
        $scope.additionals['plannedTime'] = 0;
        $scope.additionals['distributionTime'] = 0;
        $scope.additionals['deliveryTime'] = 0;

        $scope.additionals['dispatchTimeLastOrder'] = 0;
        $scope.additionals['kitchenTimeLastOrder'] = 0;
        $scope.additionals['plannedTimeLastOrder'] = 0;
        $scope.additionals['distributionTimeLastOrder'] = 0;
        $scope.additionals['deliveryTimeLastOrder'] = 0;

        $scope.additionals['dispatchTimeKitchenHistory'] = 0;
        $scope.additionals['kitchenTimeKitchenHistory'] = 0;
        $scope.additionals['plannedTimeKitchenHistory'] = 0;
        $scope.additionals['distributionTimeKitchenHistory'] = 0;
        $scope.additionals['deliveryTimeKitchenHistory'] = 0;

        $scope.additionals['formatTimePlan'] = function (content, maxCharacters) {
            if (content == null)
                return '';

            content = '' + content;
            content = content.trim();
            content = content.replace(':', ' : ');

            content = content.substring(0, maxCharacters);

            return content;
        }

        $scope.additionals['delivery_time'] = [
            {'id': 50, 'value': 50},
            {'id': 60, 'value': 60},
            {'id': 80, 'value': 80},
            {'id': 100, 'value': 100},
            {'id': 120, 'value': 120}
        ];

        $scope.additionals['discount_models'] = [
            {'id': 1, 'value': 'discount produse'},
            {'id': 2, 'value': 'discount client'},
            {'id': 3, 'value': 'discount puncte de fidelizare'},
            {'id': 4, 'value': 'discount comanda'},
            {'id': 5, 'value': 'discount tazz'},
        ];

        $scope.additionals['discount_types'] = [
            {'id': 0, 'value': 'procent', 'mark': '%'},
            {'id': 1, 'value': 'suma fixa', 'mark': ''}
        ];
        $scope.additionals['discount_type'] = {};
        $scope.additionals['discount_type'].options = $scope.additionals['discount_types'];

        $scope.additionals['discount_campaign_value_type'] = {};
        $scope.additionals['discount_campaign_value_type'].options = $scope.additionals['discount_types'];
        $scope.additionals['discount_campaign_types'] = [
            {'id': 0, 'value': 'Reducere one-time'},
            {'id': 1, 'value': 'Reducere multipla'}
        ];
        $scope.additionals['discount_campaign_type'] = {};
        $scope.additionals['discount_campaign_type'].options = $scope.additionals['discount_campaign_types'];

        if (angular.isUndefined($scope.additionals['discount_campaign_times'])) {
          $scope.additionals['discount_campaign_times'] = [];
        }
        $scope.additionals['discount_campaign_times'][0] = {'id':0, 'value' : 'nelimitat'};
        for (var i = 1; i <= 100; i++) {
          $scope.additionals['discount_campaign_times'][i] = {'id':i, 'value' : i};
        }

        $scope.additionals['type_orders'] = [
            {'value': 'order_active', 'name': 'Comenzi active'},
            {'value': 'order_cancelled', 'name': 'Comenzi anulate'}
        ];
        $scope.additionals['type_planning'] = [
            {'value': 'order_planned', 'name': 'Comenzi planificate'},
            {'value': 'order_unplanned', 'name': 'Comenzi neplanificate'}
        ];
        $scope.additionals['type_orders_incident'] = [
            {'value': 0, 'name': 'Comenzi fara incident'},
            {'value': 1, 'name': 'Comenzi cu incident'},
            {'value': 2, 'name': 'Comenzi generate de incident'}
        ];
        $scope.additionals['type_orders_discount_import'] = [
            {'value': 0, 'name': 'Comenzi fara diferente discount import'},
            {'value': 1, 'name': 'Comenzi cu diferente discount import'}
        ];
        $scope.additionals['type_times_processing'] = [
            {'value': 0, 'name': 'Timp procesare depasit'},
            {'value': 1, 'name': 'Timp de procesare normal'}
        ];
        $scope.additionals['incident_departments'] = [
            {'id': 1, 'value': 'Bucatarie'},
            {'id': 2, 'value': 'Livrare'},
            {'id': 3, 'value': 'Client'},
            {'id': 4, 'value': 'Dispecerat'}
        ];
        $scope.additionals['incident_department'] = {};
        $scope.additionals['incident_department'].options = $scope.additionals['incident_departments'];

        $scope.additionals['type_delivery'] = [
            {'id': 0, 'value': 'Livrare interna'},
            {'id': 1, 'value': 'Livrare externa'}
        ];

        $scope.additionals['estimated_times'] = [
            {'id': 1, 'value': 'Comenzi ce se incadreaza in timpul estimat'},
            {'id': 2, 'value': 'Comenzi ce au depasit timpul estimat'}
        ];
        $scope.additionals['estimated_time'] = {};
        $scope.additionals['estimated_time'].options = $scope.additionals['estimated_times'];

        $scope.additionals['cancellations_status_tazz'] = [
            {'id': '', 'value': ''},
            {'id': '4', 'value': 'Anulata de Tazz'},
            {'id': '5', 'value': 'Anulata de client'},
            {'id': '6', 'value': 'Anulata de partener'}
        ];
        $scope.additionals['cancellation_status_tazz'] = {};
        $scope.additionals['cancellation_status_tazz'].options = $scope.additionals['cancellations_status_tazz'];

        $scope.additionals['sgr'] = [
            {'id':0, 'value' : 'Fara taxa SGR', 'price' : 0},
            {'id':1, 'value' : 'Plastic', 'price' : 0.5},
            {'id':2, 'value' : 'Aluminiu', 'price' : 0.5},
            {'id':3, 'value' : 'Sticla', 'price' : 0.5}
        ];
				$scope.additionals['sgr_id_string'] = JSON.stringify($scope.additionals['sgr']);

        $scope.additionals['showColumns'] = {'code':'code', 'name':'name', 'price':'price', 'total_price':'total_price'};

        if ($location.path() == $scope.path + '/getOrder') {
            $scope.pathTemplate = 'orders/getorders';
            $scope.columns = {
                //'id':{'label':'Id', 'filter':1, 'filterType':'input'},
                //'address_detail':{'label': 'Adresa', 'filter': 1, 'filterType': 'input'},
                'street_name': {'label': 'Strada', 'filter': 1, 'filterType': 'input'},
                'address_no': {'label': 'Nr.str.', 'filter': 1, 'filterType': 'input'},
                'locality_name': {'label': 'Loc.', 'filter': 1, 'filterType': 'input'},
                'order_no': {'label': 'Nr.com.', 'filter': 1, 'filterType': 'input'},
                'client_name': {'label': 'Client', 'filter': 1, 'filterType': 'input'},
                'payment_method_name': {'label': 'Plata', 'filter': 1, 'filterType': 'select'},
                'shipping_method_name': {'label': 'Livrare', 'filter': 1, 'filterType': 'select'},
                //'call_id':{'label': 'Telefon', 'filter': 1, 'filterType': 'input'},
                'order_phone': {'label': 'Telefon', 'filter': 1, 'filterType': 'input'},
                'order_source': {'label': 'Sursa', 'filter': 1, 'filterType': 'select'},
                'order_total': {'label': 'Total (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_start': {'label': 'Start', 'filter': 1, 'filterType': 'input'},
                'order_end': {'label': 'End', 'filter': 1, 'filterType': 'input'},
                'order_status': {'label': 'Status', 'filter': 1, 'filterType': 'select'},
                'timer': {'label': 'Timer', 'filter': 0, 'filterType': 'input'},
                'created_by': {'label': 'Adaugat', 'filter': 1, 'filterType': 'input'}

            };
        } else {
          if ($location.path() == $scope.path + '/orderPlanned') {
            $scope.pathTemplate = 'orders/orders';
            $scope.columns = {
                //'id':{'label':'Id', 'filter':1, 'filterType':'input'},
                'street_name': {'label': 'Strada', 'filter': 1, 'filterType': 'input'},
                'address_no': {'label': 'Nr.str.', 'filter': 1, 'filterType': 'input'},
                'address_block': {'label': 'Bloc', 'filter': 1, 'filterType': 'input'},
                'locality_name': {'label': 'Loc.', 'filter': 1, 'filterType': 'input'},
                //'order_no': {'label': 'Nr.com.', 'filter': 1, 'filterType': 'input'},
                'client_name': {'label': 'Client', 'filter': 1, 'filterType': 'input'},
                'payment_method_name': {'label': 'Plata', 'filter': 1, 'filterType': 'select'},
                'shipping_method_name': {'label': 'Livrare', 'filter': 1, 'filterType': 'select'},
                //'call_id':{'label': 'Telefon', 'filter': 1, 'filterType': 'input'},
                'order_phone': {'label': 'Telefon', 'filter': 1, 'filterType': 'input'},
                'order_source': {'label': 'Sursa', 'filter': 1, 'filterType': 'select'},
                'order_total': {'label': 'Total (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                //'order_start': {'label': 'Start', 'filter': 1, 'filterType': 'input'},
                'order_planning': {'label': 'Planificare', 'filter': 1, 'filterType': 'input'},
                'order_end': {'label': 'End', 'filter': 1, 'filterType': 'input'},
                'order_status': {'label': 'Status cmd.', 'filter': 1, 'filterType': 'select'},
                'status': {'label': 'Status', 'filter': 1, 'filterType': 'select'},
                'created_by': {'label': 'Adaugat', 'filter': 1, 'filterType': 'input'}
            };
            $scope.columns.status.options = [
                {'id': '', 'value': ''},
                {'id': 1, 'value': 'true'},
                {'id': 0, 'value': 'false'}
            ];

          } else {
            if ($location.path() == $scope.path + '/orderPersonal') {
              $scope.pathTemplate = 'orders/orders';
              $scope.columns = {
                  //'id':{'label':'Id', 'filter':1, 'filterType':'input'},
                  'order_no': {'label': 'Nr.com.', 'filter': 1, 'filterType': 'input'},
                  'client_name': {'label': 'Client', 'filter': 1, 'filterType': 'input'},
                  'payment_method_name': {'label': 'Plata', 'filter': 1, 'filterType': 'select'},
                  'shipping_method_name': {'label': 'Livrare', 'filter': 1, 'filterType': 'select'},
                  'order_phone': {'label': 'Telefon', 'filter': 1, 'filterType': 'input'},
                  'order_source': {'label': 'Sursa', 'filter': 1, 'filterType': 'select'},
                  'order_total': {'label': 'Total (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                  'order_start': {'label': 'Start', 'filter': 1, 'filterType': 'input'},
                  'order_end': {'label': 'End', 'filter': 1, 'filterType': 'input'},
                  'order_status': {'label': 'Status cmd.', 'filter': 1, 'filterType': 'select'},
                  'status': {'label': 'Status', 'filter': 1, 'filterType': 'select'},
                  'created_by': {'label': 'Adaugat', 'filter': 1, 'filterType': 'input'}
              };
              $scope.columns.status.options = [
                  {'id': '', 'value': ''},
                  {'id': 1, 'value': 'true'},
                  {'id': 0, 'value': 'false'}
              ];

            } else {

            $scope.pathTemplate = 'orders/orders';
            $scope.columns = {
                //'id':{'label':'Id', 'filter':1, 'filterType':'input'},
                'street_name': {'label': 'Strada', 'filter': 1, 'filterType': 'input'},
                'address_no': {'label': 'Nr.str.', 'filter': 1, 'filterType': 'input'},
                'address_block': {'label': 'Bloc', 'filter': 1, 'filterType': 'input'},
                'locality_name': {'label': 'Loc.', 'filter': 1, 'filterType': 'input'},
                'order_no': {'label': 'Nr.com.', 'filter': 1, 'filterType': 'input'},
                'client_name': {'label': 'Client', 'filter': 1, 'filterType': 'input'},
                'payment_method_name': {'label': 'Plata', 'filter': 1, 'filterType': 'select'},
                'shipping_method_name': {'label': 'Livrare', 'filter': 1, 'filterType': 'select'},
                //'call_id':{'label': 'Telefon', 'filter': 1, 'filterType': 'input'},
                'order_phone': {'label': 'Telefon', 'filter': 1, 'filterType': 'input'},
                'order_source': {'label': 'Sursa', 'filter': 1, 'filterType': 'select'},
                'order_total': {'label': 'Total (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_start': {'label': 'Start', 'filter': 1, 'filterType': 'input'},
                'order_end': {'label': 'End', 'filter': 1, 'filterType': 'input'},
                'order_status': {'label': 'Status cmd.', 'filter': 1, 'filterType': 'select'},
                'status': {'label': 'Status', 'filter': 1, 'filterType': 'select'},
                'created_by': {'label': 'Adaugat', 'filter': 1, 'filterType': 'input'}
            };
            $scope.columns.status.options = [
                {'id': '', 'value': ''},
                {'id': 1, 'value': 'true'},
                {'id': 0, 'value': 'false'}
            ];
           }
          }
        }

        $scope.columnsPreloaded = {
            'order_no': {'label': 'Nr.com.', 'filter': 1, 'filterType': 'input'},
            'client_name': {'label': 'Client', 'filter': 1, 'filterType': 'input'},
            'order_phone': {'label': 'Telefon', 'filter': 1, 'filterType': 'input'},
            'order_source': {'label': 'Sursa', 'filter': 1, 'filterType': 'select'},
            'order_total': {'label': 'Total (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
            'timer': {'label': 'Timer', 'filter': 0, 'filterType': 'input'}
        };

        $scope.columnsHistory = {
            'order_no': {'label': 'Comanda', 'filter': 1, 'filterType': 'input'},
            'client_name': {'label': 'Client', 'filter': 1, 'filterType': 'input'},
            'order_products': {'label': 'Meniuri', 'filter': 0, 'filterType': 'input'}
        };

        $scope.columnsKitchenHistory = {
            'order_no': {'label': 'Nr.com.', 'filter': 1, 'filterType': 'input'},
            'client_name': {'label': 'Client', 'filter': 1, 'filterType': 'input'},
            'order_phone': {'label': 'Telefon', 'filter': 1, 'filterType': 'input'},
            'order_source': {'label': 'Sursa', 'filter': 1, 'filterType': 'select'},
            'order_total': {'label': 'Total (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'}
        };
        $scope.columnsKitchenHistory.order_source.options = [
            {'id': '', 'value': ''},
            {'id': 0, 'value': 'Directa', 'icon': $scope.additionals['publicAppPath'] + '/direct.png'},
            {'id': 1, 'value': 'Telefon', 'icon': $scope.additionals['publicAppPath'] + '/phone.png'},
            {'id': 2, 'value': $rootScope.nameProject, 'icon': $scope.additionals['publicAppPath'] + '/logo_ssmall.png'},
            {'id': 3, 'value': 'HipMenu', 'icon': $scope.additionals['publicAppPath'] + '/hipmenu.png'},
            {'id': 4, 'value': 'FoodPanda', 'icon': $scope.additionals['publicAppPath'] + '/foodpanda.png'},
            {'id': 5, 'value': 'Tazz', 'icon': $scope.additionals['publicAppPath'] + '/tazz.png'},
            {'id': 6, 'value': 'Glovo', 'icon': $scope.additionals['publicAppPath'] + '/glovo.png'},
            {'id': 7, 'value': 'Takeaway', 'icon': $scope.additionals['publicAppPath'] + '/takeaway.png'}
        ];

        $scope.order_tip = [
            /*{'id': '', 'value': ''},*/
            {'id': '2.00', 'value': '2.00'},
            {'id': '3.00', 'value': '3.00'},
            {'id': '5.00', 'value': '5.00'},
            {'id': '10.00', 'value': '10.00'}
        ];
        //$scope.columns.order_tip.options = $scope.order_tip;
        $scope.additionals['order_tips'] = $scope.order_tip;

        $scope.order_source = [
            /*{'id': '', 'value': ''},*/
            {'id': 0, 'value': 'Directa', 'icon': $scope.additionals['publicAppPath'] + '/direct.png'},
            {'id': 1, 'value': 'Telefon', 'icon': $scope.additionals['publicAppPath'] + '/phone.png'},
            {'id': 2, 'value': $rootScope.nameProject, 'icon': $scope.additionals['publicAppPath'] + '/logo_ssmall.png'},
            {'id': 3, 'value': 'HipMenu', 'icon': $scope.additionals['publicAppPath'] + '/hipmenu.png'},
            {'id': 4, 'value': 'FoodPanda', 'icon': $scope.additionals['publicAppPath'] + '/foodpanda.png'},
            {'id': 5, 'value': 'Tazz', 'icon': $scope.additionals['publicAppPath'] + '/tazz.png'},
            {'id': 6, 'value': 'Glovo', 'icon': $scope.additionals['publicAppPath'] + '/glovo.png'},
            {'id': 7, 'value': 'Takeaway', 'icon': $scope.additionals['publicAppPath'] + '/takeaway.png'}
        ];
        $scope.columns.order_source.options = $scope.order_source;

        $scope.order_status = [
            {
                'id': 0,
                'value': 'Preluata',
                'color': 'rgba(217, 217, 217, 0.9)',
                'color-even': 'rgba(217, 217, 217, 0.5)'
            }, //gray
            {'id': 1, 'value': 'Derulare', 'color': 'rgba(242, 237, 86, 0.9)', 'color-even': 'rgba(242, 237, 86, 0.7)'}, //yellow
            {'id': 2, 'value': 'Anulata', 'color': 'rgba(193, 32, 38, 0.5)', 'color-even': 'rgba(193, 32, 38, 0.3)'}, //red
            {
                'id': 3,
                'value': 'Trimisa spre livrare',
                'color': 'rgba(222, 96, 27, 0.5)',
                'color-even': 'rgba(222, 96, 27, 0.3)'
            }, //brown
            {
                'id': 4,
                'value': 'Curs de livrare',
                'color': 'rgba(169, 215, 65, 0.9)',
                'color-even': 'rgba(169, 215, 65, 0.7)'
            }, //green
            {'id': 5, 'value': 'Livrata', 'color': 'rgba(0, 51, 153, 0.4)', 'color-even': 'rgba(0, 51, 153, 0.2)'}, //blue
            {'id': 6, 'value': 'Anulata sofer/ospatar', 'color': 'rgba(90, 87, 87, 0.8)', 'color-even': 'rgba(90, 87, 87, 0.6)'},//black
            {'id': 7, 'value': 'Stand by', 'color': 'rgba(160, 160, 160, 0.8)', 'color-even': 'rgba(160, 160, 160, 0.6)'}//dark grey
        ];
        $scope.columns.order_status.options = $scope.order_status;

        $scope.additionals['content_type'] = 'form-urlencoded';
        $scope.additionals['order_source'] = $scope.columns.order_source.options;
        $scope.additionals['order_source_ext'] = [
            {'id': 0, 'value': 'Directa', 'icon': $scope.additionals['publicAppPath'] + '/direct.png'},
            {'id': 2, 'value': $rootScope.nameProject, 'icon': $scope.additionals['publicAppPath'] + '/logo_ssmall.png'},
            {'id': 4, 'value': 'FoodPanda', 'icon': $scope.additionals['publicAppPath'] + '/foodpanda.png'},
            {'id': 5, 'value': 'Tazz', 'icon': $scope.additionals['publicAppPath'] + '/tazz.png'},
            {'id': 6, 'value': 'Glovo', 'icon': $scope.additionals['publicAppPath'] + '/glovo.png'},
            {'id': 7, 'value': 'Takeaway', 'icon': $scope.additionals['publicAppPath'] + '/takeaway.png'}
        ];
        $scope.additionals['order_status'] = $scope.columns.order_status.options;
        $scope.controlGetOrder = true;

        $scope.additionals['chooseField'] = function (newField, editField, keyAddress) {
            if (angular.isUndefined(newField)) {
                newField = false;
            }
            if (angular.isUndefined(editField)) {
                editField = false;
            }
            if (newField == false) {
                $scope.modelData.address[keyAddress].street_edit = false;
            }
            if (editField == false) {
                $scope.modelData.address[keyAddress].street_new = false;
            }
        }

        $scope.additionals['calcPlannedTime'] = function (date, minDiff) {
           duration = moment(date).format("x") - minDiff*60*1000;
            if(duration > 0){
                return moment(duration).format('HH:mm:ss');
            } else {
                return '00:00:00';
            }
        }

        $scope.additionals['calcProcess'] = function (data, add) {
           if (angular.isUndefined(add)){
             add = '';
           }
           if (!angular.isUndefined(data['order_start']) && !angular.isUndefined(data['validated_at'])) {
            	$scope.additionals['dispatchTime'+add] = $scope.additionals['diffDatesMinutes'](data['order_start'], data['validated_at']);
            }
          if (!angular.isUndefined(data['order_planning']) && data['order_planning'] != null && data['order_planning'] != 'null' && data['order_planning'] != '' && !angular.isUndefined(data['validated_at']) && data['validated_at'] != null && data['validated_at'] != 'null') {
            	$scope.additionals['kitchenTime'+add] = $scope.additionals['diffDatesMinutes'](data['validated_at'], data['order_planning'].substring(0, 10)+' '+$scope.additionals['calcPlannedTime'](data['order_planning'], data['planned_time']));

              if (!angular.isUndefined(data['processed_at'])) {
            		$scope.additionals['plannedTime'+add] = $scope.additionals['diffDatesMinutes'](data['order_planning'].substring(0, 10)+' '+$scope.additionals['calcPlannedTime'](data['order_planning'], data['planned_time']), data['processed_at']);
            	}
            } else {
              if (!angular.isUndefined(data['processed_at']) && !angular.isUndefined(data['validated_at'])) {
              		$scope.additionals['kitchenTime'+add] = $scope.additionals['diffDatesMinutes'](data['validated_at'], data['processed_at']);
              	}
            }
            if (!angular.isUndefined(data['delivered_at']) && !angular.isUndefined(data['processed_at'])) {
            	$scope.additionals['distributionTime'+add] = $scope.additionals['diffDatesMinutes'](data['processed_at'], data['delivered_at']);
            }
            if (!angular.isUndefined(data['order_end']) && !angular.isUndefined(data['delivered_at'])) {
            	$scope.additionals['deliveryTime'+add] = $scope.additionals['diffDatesMinutes'](data['delivered_at'], data['order_end']);
            }
        }

        $scope.closeNotificationCancellationTazz = function (keyNotification) {
          if (!angular.isUndefined($scope.notificationsCancellationTazz)) {
            if (!angular.isUndefined($scope.notificationsCancellationTazz[keyNotification])) {
                $scope.notificationsCancellationTazz.splice(keyNotification, 1);
            }
          }
        }

        /* get dependent fields */
        $scope.getDependedFields = function () {
            Crud.getDependedFields($scope.path)
                    .success(function (data) {

                        if($location.path() == $scope.path + '/getOrder'){
                          $rootScope.notificationsOverKitchens = data.notificationsOverKitchens;
                          angular.forEach($rootScope.notificationsOverKitchens, function (item, index) {
                             if (!angular.isUndefined(item.kitchen_name)) {
                                if (!angular.isUndefined(item.total_no_products)) {
                                     $scope.setIntervalNot(item['kitchen_name'], 'prod');
                                } else {
                                      $scope.setIntervalNot(item['kitchen_name']);
                                }
                             }
                          });
                        }

                        $scope.additionals['discounts'] = data.discounts;
                        $scope.additionals['kitchens'] = data.kitchens;
                        $scope.additionals['settings'] = data.settings;

                        $scope.additionals['order_discount_reasons'] = data.discountsReasons;
                        if (!angular.isUndefined($scope.additionals['order_discount_reasons'])) {
                          $scope.additionals['order_discount_reason_string'] = JSON.stringify($scope.additionals['order_discount_reasons']);
                        }

                        $scope.additionals['payment_methods'] = data.paymentMethods;
                        if (!angular.isUndefined($scope.columns.payment_method_name)) {
                            $scope.columns.payment_method_name.options = [{id: '', value: ''}];
                            angular.forEach(data.paymentMethods, function (item, key) {
                                $scope.columns.payment_method_name.options.push({
                                    id: item.payment_method_name,
                                    value: item.payment_method_name
                                });
                            });
                        }

                        $scope.additionals['shipping_methods'] = data.shippingMethods;
                        if (!angular.isUndefined($scope.columns.shipping_method_name)) {
                            $scope.columns.shipping_method_name.options = [{id: '', value: ''}];
                            angular.forEach(data.shippingMethods, function (item, key) {
                                $scope.columns.shipping_method_name.options.push({
                                    id: item.shipping_method_name,
                                    value: item.shipping_method_name
                                });
                            });
                        }

                        if (!angular.isUndefined($scope.columns.shipping_method_name)) {
                          $scope.additionals['shipping_method_name_string'] = JSON.stringify($scope.columns.shipping_method_name.options);
                        }
                        if (!angular.isUndefined($scope.columns.payment_method_name)) {
                          $scope.additionals['payment_method_name_string'] = JSON.stringify($scope.columns.payment_method_name.options);
                        }

              });
        }

        $scope.editOrder = function (ev, path, modelId, section) {
            Crud.show(modelId, $scope.path)
                    .success(function (data) {

                        $scope.additionals['calcProcess'](data);

                        $scope.additionals['discount_campaigns'] = data['discount_campaigns'];

                        $scope.editModel(ev, path, data, section);

                        $scope.additionals['total_product_discount'] = parseFloat(data.order_product_discount);
                        $scope.additionals['total_product'] = parseFloat(data.order_amount) - parseFloat(data.order_product_discount);
                        $scope.additionals['total_client_discount'] = parseFloat(data.order_client_discount);
                        $scope.additionals['total_loyalty_point_discount'] = parseFloat(data.order_loyalty_point_discount);
                        $scope.additionals['shipping'] = parseFloat(data.order_shipping);
                        $scope.additionals['order_product_sgr'] = parseFloat(data.order_product_sgr);

                        $scope.modelsHistory = [];
                        $scope.getOrdersHistory(path, 1, perPage, data.client_id);

                    });
        }

        /* add incidents */
        $scope.addIncidentOrder = function (ev, path, modelId, section) {
            Crud.show(modelId, $scope.path)
                    .success(function (data) {
                        $scope.addIncidentModel(ev, path, data, section);
                    });
        }

        /* show model */
        if ($location.path() == $scope.path || $location.path() == $scope.path + '/orderPlanned') {
          $scope.showModel = function (ev, path, model, key) {
            $scope.controlOrderRoute = false;
            $interval.cancel($rootScope.stopTimerShowOrder);

            /* key is index model */
            if (!angular.isUndefined(key)) {
                $scope.additionals['indexModel'] = key;
            }
            $scope.additionals['buttonDisabled'] = true;

            if ($scope.mode_action == 'page') {
                $scope.controlSH = true;
                $scope.action = 'show';
                angular.element(document.querySelector('.fill-height')).animate({scrollTop: 250}, 'slow');

                $scope.modelData = {};
                $scope.cancel = function () {
                    $scope.modelData = {};
                    $scope.errors = {};
                    $scope.controlSH = false;
                    $interval.cancel($rootScope.stopTimerShowOrder);
                };
                if (!angular.isUndefined($scope.additionals['function'])) {
                    $scope.additionals['function'](ev, $scope.modelData);
                }
                Crud.show(model, path)
                        .success(function (data) {
                            $scope.modelData = data;
                            $rootScope.stopTimerShowOrder = $interval(function () {
                                $scope.modelData.timerShowOrder = $scope.timer(data.validated_at);
                              }, 1000);

                            $scope.additionals['buttonDisabled'] = false;
                            if (!angular.isUndefined($scope.additionals['functionResult'])) {
                                $scope.additionals['functionResult'](ev, data);
                            }
                        });
              }
          };
        }

        $scope.additionals['food_product_incidents'] = {};
        $scope.additionals['cloneItemFoodProductIncidents'] = function (keyFoodProduct) {
            var itemToClone = {};
            $scope.additionals['food_product_incidents'][keyFoodProduct].push(itemToClone);
        }
        $scope.additionals['removeItemFoodProductIncidents'] = function (itemIndex, keyFoodProduct) {

            $scope.interm = [];
            angular.forEach($scope.additionals['food_product_incidents'][keyFoodProduct], function (itemy, indexy) {
                $scope.interm[indexy] = {
                    'id': itemy['id'],
                    'food_product_incident': itemy['food_product_incident'],
                    'food_product_quantity': itemy['food_product_quantity'],
                    'department_incident': itemy['department_incident']
                };
            });
            $scope.interms = [];
            angular.forEach($scope.interm, function (itemyy, indexyy) {
                $scope.interms.push({
                    'id': itemyy['id'],
                    'food_product_incident': itemyy['food_product_incident'],
                    'food_product_quantity': itemyy['food_product_quantity'],
                    'department_incident': itemyy['department_incident']
                });
            });
            $scope.interms.splice(itemIndex, 1);
            $scope.additionals['food_product_incidents'][keyFoodProduct] = $scope.interms;

            $timeout(function () {
                $scope.modelData.food_products[keyFoodProduct].food_product_incidents = $scope.additionals['food_product_incidents'][keyFoodProduct];
            }, 100);
        }

        $scope.additionals['supplement_incidents'] = {};
        $scope.additionals['cloneItemSupplementIncidents'] = function (keyFoodProduct, valueSupplement, valueFoodProduct) {
            if (angular.isUndefined($scope.additionals['control_supplement_incidents'])) {
              $scope.additionals['control_supplement_incidents'] = {};
            }
            $scope.additionals['control_supplement_incidents'][valueFoodProduct['food_product_id']+'-'+valueFoodProduct['food_product_index']+'-'+valueSupplement['supplement_id']+'-'+valueSupplement['supplement_parent_id']+'-'+valueSupplement['supplement_parent_index']+'-'+valueSupplement['supplement_index']] = true;

            if (angular.isUndefined($scope.additionals['supplement_incidents'])) {
              $scope.additionals['supplement_incidents'] = {};
            }
            if (angular.isUndefined($scope.additionals['supplement_incidents'][valueFoodProduct['food_product_id']+'-'+valueFoodProduct['food_product_index']+'-'+valueSupplement['supplement_id']+'-'+valueSupplement['supplement_parent_id']+'-'+valueSupplement['supplement_parent_index']+'-'+valueSupplement['supplement_index']])) {
                $scope.additionals['supplement_incidents'][valueFoodProduct['food_product_id']+'-'+valueFoodProduct['food_product_index']+'-'+valueSupplement['supplement_id']+'-'+valueSupplement['supplement_parent_id']+'-'+valueSupplement['supplement_parent_index']+'-'+valueSupplement['supplement_index']] = [];
            }
            var itemToClone = {};
            $scope.additionals['supplement_incidents'][valueFoodProduct['food_product_id']+'-'+valueFoodProduct['food_product_index']+'-'+valueSupplement['supplement_id']+'-'+valueSupplement['supplement_parent_id']+'-'+valueSupplement['supplement_parent_index']+'-'+valueSupplement['supplement_index']].push(itemToClone);

            //$scope.modelData['supplement_incidents'][valueFoodProduct['food_product_id']+'-'+valueFoodProduct['food_product_index']+'-'+valueSupplement['supplement_id']+'-'+valueSupplement['supplement_parent_id']+'-'+valueSupplement['supplement_parent_index']+'-'+valueSupplement['supplement_index']]['parent_food_product_quantity'] = valueFoodProduct['food_product_quantity'];

        }
        $scope.additionals['changeQauntitySupplementIncidents'] = function (quantitySupplement, valueSupplement,  valueFoodProduct, keyIncidentSupplement) {
          $scope.modelData.supplement_incidents[valueFoodProduct['food_product_id']+'-'+valueFoodProduct['food_product_index']+'-'+valueSupplement['supplement_id']+'-'+valueSupplement['supplement_parent_id']+'-'+valueSupplement['supplement_parent_index']+'-'+valueSupplement['supplement_index']][keyIncidentSupplement]['parent_food_product_quantity'] = valueFoodProduct['food_product_quantity'];
        }

        $scope.additionals['removeItemSupplementIncidents'] = function (itemIndex, keyFoodProduct, valueSupplement, valueFoodProduct) {

            $scope.additionals['supplement_incidents'][valueFoodProduct['food_product_id']+'-'+valueFoodProduct['food_product_index']+'-'+valueSupplement['supplement_id']+'-'+valueSupplement['supplement_parent_id']+'-'+valueSupplement['supplement_parent_index']+'-'+valueSupplement['supplement_index']].splice(itemIndex, 1);

            if($scope.additionals['supplement_incidents'][valueFoodProduct['food_product_id']+'-'+valueFoodProduct['food_product_index']+'-'+valueSupplement['supplement_id']+'-'+valueSupplement['supplement_parent_id']+'-'+valueSupplement['supplement_parent_index']+'-'+valueSupplement['supplement_index']].length <= 0) {
                $scope.additionals['control_supplement_incidents'][valueFoodProduct['food_product_id']+'-'+valueFoodProduct['food_product_index']+'-'+valueSupplement['supplement_id']+'-'+valueSupplement['supplement_parent_id']+'-'+valueSupplement['supplement_parent_index']+'-'+valueSupplement['supplement_index']] = false;
            }
        }

        $scope.additionals['order_incidents'] = [];
        $scope.additionals['cloneItemOrderIncidents'] = function () {
            var itemToClone = {};
            $scope.additionals['order_incidents'].push(itemToClone);
        }
        $scope.additionals['removeItemOrderIncidents'] = function (itemIndex) {
            $scope.interm = [];
            angular.forEach($scope.additionals['order_incidents'], function (itemy, indexy) {
                $scope.interm[indexy] = {
                    'id': itemy['id'],
                    'order_incident': itemy['order_incident'],
                    'department_incident': itemy['department_incident']
                };
            });
            $scope.interms = [];
            angular.forEach($scope.interm, function (itemyy, indexyy) {
                $scope.interms.push({
                    'id': itemyy['id'],
                    'order_incident': itemyy['order_incident'],
                    'department_incident': itemyy['department_incident']
                });
            });
            $scope.interms.splice(itemIndex, 1);
            $scope.additionals['order_incidents'] = $scope.interms;

            $timeout(function () {
                $scope.modelData.order_incidents = $scope.additionals['order_incidents'];
            }, 100);
        }

        $scope.addIncidentModel = function (ev, path, model) {

            $scope.actionLabel = 'Adaugare incidente';

            if ($scope.mode_action == 'page') {
                $scope.controlSH = true;
                $scope.action = 'addincident';
                $scope.errors = {};

                angular.element(document.querySelector('.fill-height')).animate({scrollTop: 250}, 'slow');

                $scope.additionals['invalid'] = '';
                var currentModel = {};

                angular.forEach(model, function (item, key) {
                    switch (key) {
                        case 'food_products':
                            currentModel['food_products'] = [];

                            angular.forEach(item, function (itemProduct, keyProduct) {
                                currentModel['food_products'][keyProduct] = itemProduct;
                                if (angular.isUndefined(currentModel['food_products'][keyProduct]['food_product_incidents'])) {
                                    currentModel['food_products'][keyProduct]['food_product_incidents'] = [];
                                }
                                angular.forEach(itemProduct['food_product_incidents'], function (itemProductIncident, keyProductIncident) {
                                    currentModel['food_products'][keyProduct]['food_product_incidents'][keyProductIncident] = {};
                                    angular.forEach(itemProductIncident, function (itemProductIncidentDetail, keyProductIncidentDetail) {
                                        currentModel['food_products'][keyProduct]['food_product_incidents'][keyProductIncident][keyProductIncidentDetail] = itemProductIncidentDetail;
                                    });
                                });


                            });
                            break;
                        case 'order_incidents':
                            currentModel['order_incidents'] = [];
                            angular.forEach(item, function (itemOrderIncidents, keyOrderIncidents) {
                                currentModel['order_incidents'][keyOrderIncidents] = {};
                                angular.forEach(itemOrderIncidents, function (itemOrderIncidentsDetail, keyOrderIncidentsDetail) {
                                    currentModel['order_incidents'][keyOrderIncidents][keyOrderIncidentsDetail] = itemOrderIncidentsDetail;
                                });
                            });
                            break;
                        default:
                            currentModel[key] = item;
                            break;
                    }
                });
                $scope.modelData = currentModel;

                $scope.additionals['supplement_incidents'] = $scope.modelData['supplement_incidents'];

                if (!angular.isUndefined(currentModel['supplement_incidents'])) {
                    angular.forEach(currentModel['supplement_incidents'], function (item, index) {
                      var supplementReferenceArray = index.split('-');

                      if (angular.isUndefined($scope.additionals['control_supplement_incidents'])) {
                          $scope.additionals['control_supplement_incidents'] = {};
                      }
                      if (angular.isUndefined($scope.modelData.supplement_incidents)) {
                          $scope.modelData.supplement_incidents = {};
                      }
                      $scope.additionals['control_supplement_incidents'][supplementReferenceArray[0]+'-'+supplementReferenceArray[1]+'-'+supplementReferenceArray[2]+'-'+supplementReferenceArray[3]+'-'+supplementReferenceArray[4]+'-'+supplementReferenceArray[5]] = true;

                      angular.forEach(item, function (itemSup, indexSup) {
                          itemSup['parent_food_product_quantity'] = $scope.modelData.food_products[supplementReferenceArray[1]]['food_product_quantity'];
                      });

                      $scope.modelData.supplement_incidents[supplementReferenceArray[0]+'-'+supplementReferenceArray[1]+'-'+supplementReferenceArray[2]+'-'+supplementReferenceArray[3]+'-'+supplementReferenceArray[4]+'-'+supplementReferenceArray[5]] = item;

                      $scope.additionals['supplement_incidents'][supplementReferenceArray[0]+'-'+supplementReferenceArray[1]+'-'+supplementReferenceArray[2]+'-'+supplementReferenceArray[3]+'-'+supplementReferenceArray[4]+'-'+supplementReferenceArray[5]] = item;
                  });
                }

                angular.forEach(currentModel['food_products'], function (item, index) {
                    if (angular.isUndefined($scope.additionals['food_product_incidents'][index])) {
                        $scope.additionals['food_product_incidents'][index] = [{}];
                    }
                    if (angular.isUndefined(item.food_product_incidents) || item.food_product_incidents.length == 0) {
                        item.food_product_incidents = [{}];
                    }
                    $scope.additionals['food_product_incidents'][index] = item.food_product_incidents;
                });

                if (angular.isUndefined(currentModel.order_incidents) || currentModel.order_incidents.length == 0) {
                    currentModel.order_incidents = [{}];
                }
                $scope.additionals['order_incidents'] = currentModel.order_incidents;

                $scope.cancel = function () {
                    $scope.modelData = {};
                    $scope.errors = {};
                    $scope.controlSH = false;
                };

                $scope.addIncident = function (typeSave) {
                    $scope.additionals['buttonDisabled'] = true;

                    if (!angular.isUndefined($scope.additionals['internFunction'])) {
                        $scope.additionals['internFunction'](ev, $scope.modelData);
                    }
                    $scope.isLoading = true;

                    var post = {};
                    post['route'] = 'addIncident';
                    post['order_id'] = model.id;
                    post['order_status'] = model.order_status;
                    post['is_incident'] = model.is_incident;
                    post['typeSave'] = typeSave;
                    post['supplement_incidents'] = angular.extend({}, $scope.modelData['supplement_incidents']);
                    post['food_products'] = [];

                    angular.forEach($scope.modelData['food_products'], function (item, index) {
                        angular.forEach(item['food_product_incidents'], function (itemIncident, indexIncident) {
                            if (!angular.isUndefined(item['food_product_incidents'][indexIncident]['food_product_incident']) || !angular.isUndefined(item['food_product_incidents'][indexIncident]['food_product_quantity']) || !angular.isUndefined(item['food_product_incidents'][indexIncident]['department_incident'])) {
                                post['food_products'][index] = item;
                            }
                        });
                    });

                    post['food_products'] = post['food_products'].filter(function () {
                        return true;
                    });

                    angular.forEach($scope.modelData['order_incidents'], function (item, index) {
                        if (!angular.isUndefined($scope.modelData['order_incidents'][index]['order_incident']) || !angular.isUndefined($scope.modelData['order_incidents'][index]['department_incident'])) {
                            post['order_incidents'] = $scope.modelData['order_incidents'];
                        }
                    });

                    Crud.post($scope.additionals['content_type'], post, $scope.path + '/addIncident')
                            .success(function (data) {
                                if (!angular.isUndefined(data.invalid)) {
                                    $scope.additionals['invalid'] = data.invalid;
                                } else {
                                    if (!angular.isUndefined($scope.additionals['functionResult'])) {
                                        $scope.additionals['functionResult'](ev, data);
                                    }
                                    if (!angular.isUndefined(data.currentModel)) {
                                        if (!angular.isUndefined($scope.models)) {
                                            $scope.getElement($scope.models, data.currentModel);
                                        }
                                        if (!angular.isUndefined($scope.modelData)) {
                                            $scope.modelData = data.currentModel;
                                        }
                                    } else {
                                        if (!angular.isUndefined($scope.models)) {
                                            $scope.getElement($scope.models, currentModel);
                                        }
                                        if (!angular.isUndefined($scope.modelData)) {
                                            $scope.modelData = currentModel;
                                        }
                                    }

                                    if ($location.path() == $scope.path + '/getOrder' || $location.path() == $scope.path || $location.path() == $scope.path + '/orderPlanned') {
                                        if (data.currentModel) {
                                            var post = {};
                                            post['id'] = data.currentModel.id;
                                            post['route'] = 'printOrderAsincron';
                                            $scope.additionals['printOrderAsincron'](path, post);
                                        }
                                    }

                                }
                                if ($location.path() == $scope.path + '/getOrder') {
                                    $scope.action = 'store';
                                }
                                $scope.modelData = {};
                                $scope.errors = {};
                                $scope.isLoading = false;
                                $scope.controlSH = false;
                                $scope.additionals['buttonDisabled'] = false;

                                $scope.additionals['supplement_incidents'] = {};
                                $scope.additionals['control_supplement_incidents'] = {};
                            })
                            .error(function (data) {
                                $scope.isLoading = false;
                                $scope.errors = data.errors;
                                $scope.additionals['buttonDisabled'] = false;
                                if (data == null) {
                                    $rootScope.checkNetworkConnection();
                                }
                            });
                };
            }

            if ($scope.mode_action == 'dialog') {
                $scope.additionals['invalid'] = '';
                $scope.errors = {};
                $scope.action = 'addincident';
                var currentModel = {};

                angular.forEach(model, function (item, key) {
                    switch (key) {
                        case 'food_products':
                            currentModel['food_products'] = [];

                            angular.forEach(item, function (itemProduct, keyProduct) {
                                currentModel['food_products'][keyProduct] = itemProduct;
                                if (angular.isUndefined(currentModel['food_products'][keyProduct]['food_product_incidents'])) {
                                    currentModel['food_products'][keyProduct]['food_product_incidents'] = [];
                                }
                                angular.forEach(itemProduct['food_product_incidents'], function (itemProductIncident, keyProductIncident) {
                                    currentModel['food_products'][keyProduct]['food_product_incidents'][keyProductIncident] = {};
                                    angular.forEach(itemProductIncident, function (itemProductIncidentDetail, keyProductIncidentDetail) {
                                        currentModel['food_products'][keyProduct]['food_product_incidents'][keyProductIncident][keyProductIncidentDetail] = itemProductIncidentDetail;
                                    });
                                });


                            });
                            break;
                        case 'order_incidents':
                            currentModel['order_incidents'] = [];
                            angular.forEach(item, function (itemOrderIncidents, keyOrderIncidents) {
                                currentModel['order_incidents'][keyOrderIncidents] = {};
                                angular.forEach(itemOrderIncidents, function (itemOrderIncidentsDetail, keyOrderIncidentsDetail) {
                                    currentModel['order_incidents'][keyOrderIncidents][keyOrderIncidentsDetail] = itemOrderIncidentsDetail;
                                });
                            });
                            break;
                        default:
                            currentModel[key] = item;
                            break;
                    }
                });
                $scope.modelData = currentModel;

                angular.forEach(currentModel['food_products'], function (item, index) {
                    if (angular.isUndefined($scope.additionals['food_product_incidents'][index])) {
                        $scope.additionals['food_product_incidents'][index] = [{}];
                    }
                    if (angular.isUndefined(item.food_product_incidents) || item.food_product_incidents.length == 0) {
                        item.food_product_incidents = [{}];
                    }
                    $scope.additionals['food_product_incidents'][index] = item.food_product_incidents;
                });

                if (angular.isUndefined(currentModel.order_incidents) || currentModel.order_incidents.length == 0) {
                    currentModel.order_incidents = [{}];
                }
                $scope.additionals['order_incidents'] = currentModel.order_incidents;

                $mdDialog.show({
                    controller: DialogController,
                    templateUrl: 'incidentDialog.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    locals: {
                        pathTemplate: $scope.pathTemplate,
                        model: currentModel,
                        selected: $scope.selected,
                        additionals: $scope.additionals,
                        action: $scope.action
                    }
                }).then(function () {
                    if (angular.isUndefined($scope.additionals['invalid']) || $scope.additionals['invalid'] == '') {
                        if (!angular.isUndefined($scope.additionals['dataCurrentModel'])) {
                            if (!angular.isUndefined($scope.models) && !angular.isUndefined($scope.models)) {
                                $scope.getElement($scope.models, $scope.additionals['dataCurrentModel']);
                            }
                            if (!angular.isUndefined($scope.modelData)) {
                                $scope.modelData = $scope.additionals['dataCurrentModel'];
                            }
                        } else {
                            if (!angular.isUndefined($scope.models) && !angular.isUndefined($scope.models)) {
                                $scope.getElement($scope.models, currentModel, $rootScope.typeId);
                            }
                            if (!angular.isUndefined($scope.modelData)) {
                                $scope.modelData = currentModel;
                            }
                        }

                    }
                });
                DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'model', 'selected', 'additionals', 'action'];
                function DialogController($scope, $mdDialog, pathTemplate, model, selected, additionals, action) {
                    $scope.pathTemplate = pathTemplate;
                    $scope.modelData = model;
                    $scope.additionals = additionals;
                    $scope.selected = selected;
                    $scope.action = action;

                    $scope.cancel = function () {
                        $mdDialog.cancel();
                    };

                    angular.forEach($scope.modelData['food_products'], function (item, index) {
                        if (angular.isUndefined($scope.additionals['food_product_incidents'][index])) {
                            $scope.additionals['food_product_incidents'][index] = [{}];
                        }
                        if (angular.isUndefined(item.food_product_incidents) || item.food_product_incidents.length == 0) {
                            item.food_product_incidents = [{}];
                        }
                        $scope.additionals['food_product_incidents'][index] = item.food_product_incidents;
                    });

                    if (angular.isUndefined(currentModel.order_incidents) || currentModel.order_incidents.length == 0) {
                        currentModel.order_incidents = [{}];
                    }
                    $scope.additionals['order_incidents'] = currentModel.order_incidents;

                    $scope.addIncident = function (typeSave) {
                        $scope.additionals['buttonDisabled'] = true;
                        if (!angular.isUndefined($scope.additionals['internFunction'])) {
                            $scope.additionals['internFunction'](ev, $scope.modelData);
                        }
                        $scope.isLoading = true;

                        var post = {};
                        post['route'] = 'addIncident';
                        post['order_id'] = model.id;
                        post['order_status'] = model.order_status;
                        post['is_incident'] = model.is_incident;
                        post['typeSave'] = typeSave;
                        post['food_products'] = [];
                        angular.forEach($scope.modelData['food_products'], function (item, index) {
                            angular.forEach(item['food_product_incidents'], function (itemIncident, indexIncident) {
                                if (!angular.isUndefined(item['food_product_incidents'][indexIncident]['food_product_incident']) || !angular.isUndefined(item['food_product_incidents'][indexIncident]['food_product_quantity']) || !angular.isUndefined(item['food_product_incidents'][indexIncident]['department_incident'])) {
                                    post['food_products'][index] = item;
                                }
                            });

                        });
                        post['food_products'] = post['food_products'].filter(function () {
                            return true;
                        });

                        angular.forEach($scope.modelData['order_incidents'], function (item, index) {
                            if (!angular.isUndefined($scope.modelData['order_incidents'][index]['order_incident']) || !angular.isUndefined($scope.modelData['order_incidents'][index]['department_incident'])) {
                                post['order_incidents'] = $scope.modelData['order_incidents'];
                            }
                        });

                        Crud.post($scope.additionals['content_type'], post, $scope.path + '/addIncident')
                                .success(function (data) {
                                    if (!angular.isUndefined(data.invalid)) {
                                        $scope.additionals['invalid'] = data.invalid;
                                    } else {
                                        if (!angular.isUndefined($scope.additionals['functionResult'])) {
                                            $scope.additionals['functionResult'](ev, data);
                                        }
                                        if (!angular.isUndefined(data.currentModel)) {
                                            if (!angular.isUndefined($scope.models)) {
                                                $scope.getElement($scope.models, data.currentModel);
                                            }
                                            if (!angular.isUndefined($scope.modelData)) {
                                                $scope.modelData = data.currentModel;
                                            }
                                        } else {
                                            if (!angular.isUndefined($scope.models)) {
                                                $scope.getElement($scope.models, currentModel);
                                            }
                                            if (!angular.isUndefined($scope.modelData)) {
                                                $scope.modelData = currentModel;
                                            }
                                        }

                                        if ($location.path() == $scope.path + '/getOrder' || $location.path() == $scope.path || $location.path() == $scope.path + '/orderPlanned') {
                                            if (data.currentModel) {
                                                var post = {};
                                                post['id'] = data.currentModel.id;
                                                post['route'] = 'printOrderAsincron';
                                                $scope.additionals['printOrderAsincron'](path, post);
                                            }
                                        }

                                    }
                                    if ($location.path() == $scope.path + '/getOrder') {
                                        $scope.action = 'store';
                                    }
                                    $scope.modelData = {};
                                    $scope.errors = {};
                                    $scope.isLoading = false;
                                    $scope.controlSH = false;
                                    $scope.additionals['buttonDisabled'] = false;
                                })
                                .error(function (data) {
                                    $scope.isLoading = false;
                                    $scope.errors = data.errors;
                                    $scope.additionals['buttonDisabled'] = false;
                                    if (data == null) {
                                        $rootScope.checkNetworkConnection();
                                    }
                                });
                    };

                }
            }
        };
        /* end add incidents */

        /* autocomplete */
        function createFilterForClientFirstName(query) {
            var capitalizeQuery = $scope.formatText(query);
            return function filterFn(item) {
                if (!angular.isUndefined(item.client_first_name)) {
                    return item.client_first_name.indexOf(capitalizeQuery) >= 0;
                }
            };
        }

        function createFilterForClientLastName(query) {
            var capitalizeQuery = $scope.formatText(query);
            return function filterFn(item) {
                if (!angular.isUndefined(item.client_last_name)) {
                    return item.client_last_name.indexOf(capitalizeQuery) >= 0;
                }
            };
        }

        $scope.additionals['clients'] = [];
        $scope.additionals['getClients'] = function (search_first_name, search_last_name, search) {
            if (!angular.isUndefined(search_first_name)) {
                if (search_first_name != '' && search_first_name != 'undefined' && search_first_name.length >= 2) {
                    var pathClient = 'search_first_name=' + search_first_name;
                }
            }
            if (!angular.isUndefined(search_last_name)) {
                if (search_last_name != '' && search_last_name != 'undefined' && search_last_name.length >= 2) {
                    var pathClient = 'search_last_name=' + search_last_name;
                }
            }
            if (!angular.isUndefined(search)) {
                if (search != '' && search != 'undefined' && search.length >= 2) {
                    var pathClient = 'search=' + search;
                }
            }
            $scope.additionals['errors'] = {};
            if (!angular.isUndefined($scope.errors)) {
                $scope.errors['client_id'] = {};
            }
            if (!angular.isUndefined(pathClient) && pathClient != 'undefined') {
                return Crud.get($scope.path + '/getClients?' + pathClient)
                        .then(function (data) {
                            $scope.additionals['clients'] = data.data.clients;
                            return data.data.clients;
                        });
            } else {
                return [];
            }

        }

        /*address*/
        $scope.additionals['jsonPath'] = '/json';
        $scope.additionals['address_type'] = [
            {'id': '', 'value': ''},
            {'id': 1, 'value': 'Casa'},
            {'id': 2, 'value': 'Bloc'},
            {'id': 3, 'value': 'Birou'},
            {'id': 4, 'value': 'Institutie'}
        ];

        $scope.additionals['getCounties'] = function () {
            Crud.get($scope.additionals['jsonPath'] + '/counties.json')
                    .success(function (data) {
                        $scope.additionals['counties'] = data;
                    });
        }
        $scope.additionals['getCounties']();

        /* autocomplete */
        function createFilterForLocality(query) {
            var capitalizeQuery = $scope.formatText(query);
            return function filterFn(item) {
                if (!angular.isUndefined(item.locality_name)) {
                    return item.locality_name.indexOf(capitalizeQuery) >= 0;
                } else {
                    return '';
                }
            };
        }

        function createFilterForSection(query) {
            var capitalizeQuery = $scope.formatText(query);
            return function filterFn(item) {
                if (!angular.isUndefined(item.section_name)) {
                    return item.section_name.indexOf(capitalizeQuery) >= 0;
                } else {
                    return '';
                }
            };
        }

        function createFilterForStreet(query) {
            var capitalizeQuery = $scope.formatText(query);
            return function filterFn(item) {
                if (!angular.isUndefined(item.street_name)) {
                    return item.street_name.indexOf(capitalizeQuery) >= 0;
                } else {
                    return '';
                }
            };
        }

        $scope.additionals['localities'] = [];
        $scope.additionals['getLocalities'] = function (model, indexAddress, index) {
            if (!angular.isUndefined(model.address[indexAddress])) {
                if (!angular.isUndefined(model.address[indexAddress].locality_name) && model.address[indexAddress].locality_name.length >= 2) {
                    return Crud.get($scope.path + '/getLocalities?county_name=' + model.address[indexAddress].county_name + '&locality_name=' + model.address[indexAddress].locality_name)
                            .then(function (data) {
                                $scope.additionals['localities'][indexAddress] = data.data.localities;
                                return data.data.localities;
                            });
                } else {
                    return [];
                }
            }
        }

        $scope.additionals['sections'] = [];
        $scope.additionals['getSections'] = function (model, indexAddress, index) {
            if ($location.path() != $scope.path + '/orderPersonal') {
                if (!angular.isUndefined(model.address)) {
                  if (!angular.isUndefined(model.address[indexAddress])) {
                      Crud.get($scope.path + '/getSections?county_name=' + model.address[indexAddress].county_name + '&locality_name=' + model.address[indexAddress].locality_name)
                              .success(function (data) {

                                  if (!angular.isUndefined(index)) {
                                      $scope.additionals['sections' + index] = data['sections'];
                                  } else {
                                      $scope.additionals['sections'][indexAddress] = data['sections'];
                                  }

                                  /* autocomplete */
                                  function querySearch(query) {
                                      if (!angular.isUndefined(index)) {
                                          var results = query ? $scope.additionals['sections' + index].filter(createFilterForSection(query)) : [];
                                      } else {
                                          if (!angular.isUndefined($scope.additionals['sections'][indexAddress])) {
                                              var results = query ? $scope.additionals['sections'][indexAddress].filter(createFilterForSection(query)) : [];
                                          }
                                      }
                                      return results;
                                  }

                                  $scope.additionals['searchSection'] = querySearch;
                                  $scope.additionals['errors'] = {};
                                  /* end autocomplete */
                              });
                  }
              }
            }
        }

        //$scope.additionals['streets'] = [];
        $scope.additionals['getStreets'] = function (model, indexAddress) {

                if (angular.isUndefined($scope.additionals['streets']) || $scope.additionals['streets'] == null) {
                        $scope.additionals['streets'] = [];
                 }

            $scope.additionals['errors'] = {};
            if (!angular.isUndefined($scope.errors)) {
                $scope.errors['street_id'] = {};
            }
            if (!angular.isUndefined(model.address[indexAddress])) {
                if (!angular.isUndefined(model.address[indexAddress].county_name) && !angular.isUndefined(model.address[indexAddress].locality_name) && !angular.isUndefined(model.address[indexAddress].street_name) && model.address[indexAddress].street_name.length >= 2) {
                    return Crud.get($scope.path + '/getStreets?county_name=' + model.address[indexAddress].county_name + '&locality_name=' + model.address[indexAddress].locality_name + '&street_name=' + model.address[indexAddress].street_name)
                            .then(function (data) {
                                $scope.additionals['streets'][indexAddress] = data.data.streets;

                                if (!angular.isUndefined($scope.additionals['streets'][indexAddress]) && !angular.isUndefined(model.address[indexAddress])) {
                                    var position = $scope.additionals['streets'][indexAddress].map(function (e) {
                                        return e['street_name'];
                                    }).indexOf(model.address[indexAddress].street_name);
                                    if (position >= 0) {
                                        $scope.additionals['sections'][indexAddress] = [{
                                                'id': $scope.additionals['streets'][indexAddress][position]['section_id'],
                                                'section_name': $scope.additionals['streets'][indexAddress][position]['section_name']
                                            }];

                                        model.address[indexAddress].section_name = $scope.additionals['streets'][indexAddress][position]['section_name'];
                                        $scope.additionals['selectAddress'](model, model.select_address);
                                    }
                                }

                                return data.data.streets;
                            });
                } else {
                    return [];
                }
            }

        }

        $scope.additionals['selectedItemLocality'] = [];
        $scope.additionals['selectedItemStreet'] = [];
        $scope.additionals['selectedItemSection'] = [];

        $scope.additionals['selectedItemLocality'] = [];
        $scope.additionals['selectedItemStreet'] = [];

        /* add multiple address forms */
        $scope.additionals['address'] = [{}];
        $scope.additionals['cloneItemAddress'] = function (model, modelLength) {
            var itemToClone = {};
            if (angular.isUndefined(itemToClone.county_name)) {
                itemToClone.county_name = 'Cluj';
            } else {
                if (itemToClone.county_name == '') {
                    itemToClone.county_name = 'Cluj';
                }
            }
            if (angular.isUndefined(itemToClone.locality_name)) {
                itemToClone.locality_name = 'Cluj-Napoca';
            } else {
                if (itemToClone.locality_name == '') {
                    itemToClone.locality_name = 'Cluj-Napoca';
                }
            }
            $scope.additionals[model].push(itemToClone);

            angular.forEach($scope.modelData[model], function (item, key) {
                if ($scope.action == 'store') {
                    $scope.additionals['selectedItemLocality'][$scope.additionals[model].length - 1] = '';
                    $scope.additionals['selectedItemStreet'][$scope.additionals[model].length - 1] = '';

                    if (angular.isUndefined(item.county_name)) {
                        item.county_name = 'Cluj';
                    } else {
                        if (item.county_name == '') {
                            item.county_name = 'Cluj';
                        }
                    }
                    if (angular.isUndefined(item.locality_name)) {
                        item.locality_name = 'Cluj-Napoca';
                    } else {
                        if (item.locality_name == '') {
                            item.locality_name = 'Cluj-Napoca';
                        }
                    }

                }
                if ($scope.action == 'update') {
                    if (angular.isUndefined(item.county_name)) {
                        item.county_name = 'Cluj';
                    }
                    if (angular.isUndefined(item.locality_name)) {
                        item.locality_name = 'Cluj-Napoca';
                    }
                }
                /*/!* in case of select *!/
                 angular.forEach($scope.modelData['address'], function (item, keyAddress) {
                 $scope.additionals['getLocalities']({'address':[{'county_name': 'Cluj'}]}, keyAddress);
                 })*/

            });
        }
        $scope.additionals['removeErrors'] = function (itemIndex) {
            if (!angular.isUndefined($scope.errors)) {
                if (!angular.isUndefined(itemIndex)) {
                    if (!angular.isUndefined($scope.errors['address.' + itemIndex + '.county_name'])) {
                        delete $scope.errors['address.' + itemIndex + '.county_name'];
                    }
                    if (!angular.isUndefined($scope.errors['address.' + itemIndex + '.locality_name'])) {
                        delete $scope.errors['address.' + itemIndex + '.locality_name'];
                    }
                    if (!angular.isUndefined($scope.errors['address.' + itemIndex + '.section_name'])) {
                        delete $scope.errors['address.' + itemIndex + '.section_name'];
                    }
                    if (!angular.isUndefined($scope.errors['address.' + itemIndex + '.street_id'])) {
                        delete $scope.errors['address.' + itemIndex + '.street_id'];
                    }
                    if (!angular.isUndefined($scope.errors['address.' + itemIndex + '.street_no'])) {
                        delete $scope.errors['address.' + itemIndex + '.street_no'];
                    }
                    if (!angular.isUndefined($scope.errors['address.' + itemIndex + '.address_block'])) {
                        delete $scope.errors['address.' + itemIndex + '.address_block'];
                    }
                    if (!angular.isUndefined($scope.errors['address.' + itemIndex + '.address_section'])) {
                        delete $scope.errors['address.' + itemIndex + '.address_section'];
                    }
                    if (!angular.isUndefined($scope.errors['address.' + itemIndex + '.address_level'])) {
                        delete $scope.errors['address.' + itemIndex + '.address_level'];
                    }
                    if (!angular.isUndefined($scope.errors['address.' + itemIndex + '.address_flat'])) {
                        delete $scope.errors['address.' + itemIndex + '.address_flat'];
                    }
                    if (!angular.isUndefined($scope.errors['address.' + itemIndex + '.address_type'])) {
                        delete $scope.errors['address.' + itemIndex + '.address_type'];
                    }
                } else {
                    angular.forEach($scope.modelData.address, function (item, itemIndex) {
                        if (!angular.isUndefined($scope.errors['address.' + itemIndex + '.county_name'])) {
                            delete $scope.errors['address.' + itemIndex + '.county_name'];
                        }
                        if (!angular.isUndefined($scope.errors['address.' + itemIndex + '.locality_name'])) {
                            delete $scope.errors['address.' + itemIndex + '.locality_name'];
                        }
                        if (!angular.isUndefined($scope.errors['address.' + itemIndex + '.section_name'])) {
                            delete $scope.errors['address.' + itemIndex + '.section_name'];
                        }
                        if (!angular.isUndefined($scope.errors['address.' + itemIndex + '.street_id'])) {
                            delete $scope.errors['address.' + itemIndex + '.street_id'];
                        }
                        if (!angular.isUndefined($scope.errors['address.' + itemIndex + '.street_no'])) {
                            delete $scope.errors['address.' + itemIndex + '.street_no'];
                        }
                        if (!angular.isUndefined($scope.errors['address.' + itemIndex + '.address_block'])) {
                            delete $scope.errors['address.' + itemIndex + '.address_block'];
                        }
                        if (!angular.isUndefined($scope.errors['address.' + itemIndex + '.address_section'])) {
                            delete $scope.errors['address.' + itemIndex + '.address_section'];
                        }
                        if (!angular.isUndefined($scope.errors['address.' + itemIndex + '.address_level'])) {
                            delete $scope.errors['address.' + itemIndex + '.address_level'];
                        }
                        if (!angular.isUndefined($scope.errors['address.' + itemIndex + '.address_flat'])) {
                            delete $scope.errors['address.' + itemIndex + '.address_flat'];
                        }
                        if (!angular.isUndefined($scope.errors['address.' + itemIndex + '.address_type'])) {
                            delete $scope.errors['address.' + itemIndex + '.address_type'];
                        }
                    });
                }
            }
        }

        $scope.additionals['removeItemAddress'] = function (itemIndex, modelAddress) {
            $scope.additionals['removeErrors'](itemIndex);

            $scope.interm = [];
            angular.forEach($scope.additionals[modelAddress], function (itemy, indexy) {
                $scope.interm[indexy] = {
                    'id': itemy['id'],
                    'street_id': itemy['street_id'],
                    'county_name': itemy['county_name'],
                    //'locality_id': itemy['locality_id'],
                    'locality_name': itemy['locality_name'],
                    'section_name': itemy['section_name'],
                    'street_name': itemy['street_name'],
                    'address_no': itemy['address_no'],
                    'address_block': itemy['address_block'],
                    'address_section': itemy['address_section'],
                    'address_level': itemy['address_level'],
                    'address_flat': itemy['address_flat'],
                    'address_type': itemy['address_type'],
                    'address_mention': itemy['address_mention']
                };
            });
            $scope.interms = [];
            angular.forEach($scope.interm, function (itemyy, indexyy) {
                $scope.interms.push({
                    'id': itemyy['id'],
                    'street_id': itemyy['street_id'],
                    'county_name': itemyy['county_name'],
                    //'locality_id': itemyy['locality_id'],
                    'locality_name': itemyy['locality_name'],
                    'section_name': itemyy['section_name'],
                    'street_name': itemyy['street_name'],
                    'address_no': itemyy['address_no'],
                    'address_block': itemyy['address_block'],
                    'address_section': itemyy['address_section'],
                    'address_level': itemyy['address_level'],
                    'address_flat': itemyy['address_flat'],
                    'address_type': itemyy['address_type'],
                    'address_mention': itemyy['address_mention']
                });
            });

            $scope.interms.splice(itemIndex, 1);
            $scope.additionals[modelAddress] = $scope.interms;
            //if ($scope.modelData['select_address'] == itemIndex) {
            delete $scope.modelData['select_address'];
            //}

            $timeout(function () {
                /*if(!angular.isUndefined($scope.additionals[model][itemIndex]) ) {
                 $scope.modelData.address[itemIndex].county_name = $scope.additionals[model][itemIndex].county_name;
                 }*/
                $scope.modelData.address = $scope.additionals[modelAddress];

                $scope.additionals['getLocalities']($scope.modelData, itemIndex);
                $scope.additionals['localities'].splice(itemIndex, 1);

                $scope.additionals['getSections']($scope.modelData, itemIndex);
                $scope.additionals['sections'].splice(itemIndex, 1);

                $scope.additionals['getStreets']($scope.modelData, itemIndex);
                $scope.additionals['streets'].splice(itemIndex, 1);

            }, 100);
        }

        /* close field */
        $scope.additionals['closeField'] = function (paramName, paramId, model, keyAddress, key) {
            if (!angular.isUndefined(key)) {
                model[key][paramName] = '';
                if (!angular.isUndefined(paramId)) {
                    model[key][paramId] = '';
                }
            } else {
                if (!angular.isUndefined(keyAddress)) {
                    model.address[keyAddress][paramName] = '';
                    if (!angular.isUndefined(paramId)) {
                        model.address[keyAddress][paramId] = '';
                    }

                    if (paramName == 'county_name') {
                        $scope.additionals['removeFields']('county', model, keyAddress);
                    }
                    if (paramName == 'locality_name') {
                        $scope.additionals['removeFields']('locality', model, keyAddress);
                    }
                    if (paramName == 'section_name') {
                        $scope.additionals['removeFields']('section', model, keyAddress);
                    }
                    if (paramName == 'street_name') {
                        $scope.additionals['removeFields']('street', model, keyAddress);
                    }

                } else {
                    model[paramName] = '';
                    if (!angular.isUndefined(paramId)) {
                        model[paramId] = '';
                    }
                    if (paramName == 'order_phone') {
                        $scope.lastOrderClient = '';
                        $scope.modelData['order_total'] = 0;
                        $scope.modelData['client_blacklist_reason'] = '';
                        $scope.additionals['discount_campaigns'] = [];
                        $scope.modelsHistory = [];
                        //$scope.additionals['applyDiscountCampaign']();
                    }
                }
            }
        }

        /* change field address*/
        $scope.additionals['changeFieldAddress'] = function (model, prop, indexAddress, key) {
            if (prop == 'locality') {
                if (!angular.isUndefined(key)) {
                    model[key].locality_new = false;
                } else {
                    if (!angular.isUndefined(model.address)) {
                        model.address[indexAddress].locality_new = false;
                    }
                }
                if (!angular.isUndefined(model.address[indexAddress])) {
                    //model.select_address = '';
                }
                if(indexAddress == $scope.modelData.select_address){
                  model['order_shipping'] = 0;
                  model['order_total'] = 0;
                }
            }
            if (prop == 'section') {
                if (!angular.isUndefined(key)) {
                    model[key].section_new = false;
                } else {
                    if (!angular.isUndefined(model.address)) {
                        model.address[indexAddress].section_new = false;
                    }
                }
                //if (!angular.isUndefined(model.address[indexAddress])) {
                //model.select_address = '';
                //}
                //model['order_shipping'] = 0;
                //model['order_total'] = 0;
            }
            if (prop == 'street') {
                if (!angular.isUndefined(key)) {
                    model[key].street_new = false;
                } else {
                    if (!angular.isUndefined(model.address)) {
                        model.address[indexAddress].street_new = false;
                    }
                }
            }
            if(indexAddress == $scope.modelData.select_address){
              $scope.additionals['selectAddress'](model, $scope.modelData.select_address);
            }
        }

        /* show last order */
        $scope.controlLastOrder = false;
        $scope.showLastOrder = function (orderId) {

            $scope.classOrder = 'class-order';
            $scope.controlLastOrder = true;

            Crud.get($scope.path + '/show/' + orderId)
                    .success(function (data) {
                        $scope.modelLastOrder = data;
                        $scope.additionals['calcProcess'](data, 'LastOrder');
                    });

        }
        $scope.closeLastOrder = function () {
            $scope.controlLastOrder = false;
            $scope.classOrder = '';
        }
        /* end last order */

        /* call client */
        $scope.additionals['callClient'] = function (order_phone) {
            //window.location.href = "tel://" + order_phone;
            //window.location.href = "tel:+4" + order_phone;
            //window.location.href = "callto:+4" + order_phone;
            Crud.get($scope.path + '/callClient?order_phone=' + order_phone)
                .success(function (data) {
            });
        }

        /* change status order */
        $scope.changeStatusOrder = function (ev, path, model) {
            $scope.actionLabel = 'Schimbare status comanda';
            $scope.modelData[$scope.additionals['columnDisplay']] = model.order_no;

            if (angular.isUndefined($scope.modelDataOrder)) {
                $scope.modelDataOrder = {};
            }
            $scope.modelDataOrder.shipping_method_id = model.shipping_method_id;
            $scope.modelDataOrder.order_status = model.order_status;
            $scope.modelDataOrder.reason_nondelivery = model.reason_nondelivery;
            $scope.modelDataOrder.reason_cancellation = model.reason_cancellation;

            if (angular.isUndefined($scope.modelDataOrderOrig)) {
                $scope.modelDataOrderOrig = {};
            }
            $scope.modelDataOrderOrig.shipping_method_id = model.shipping_method_id;
            $scope.modelDataOrderOrig.order_status = model.order_status;

            if ($scope.mode_action == 'page') {
                $scope.controlSH = true;
                $scope.action = 'changestatusorder';
                $scope.errors = {};

                angular.element(document.querySelector('.fill-height')).animate({scrollTop: 250}, 'slow');

                $scope.additionals['invalid'] = '';

                $scope.cancel = function () {
                    $scope.modelData = {};
                    $scope.errors = {};
                    $scope.controlSH = false;
                };

                $scope.changeStatusOrderModel = function () {
                    $scope.additionals['buttonDisabled'] = true;

                    $scope.isLoading = true;

                    var post = {};
                    post['route'] = 'changeStatusOrder';
                    post['id'] = model.id;
                    post['order_status'] = $scope.modelDataOrder.order_status;
                    post['reason_nondelivery'] = $scope.modelDataOrder.reason_nondelivery;
                    post['reason_cancellation'] = $scope.modelDataOrder.reason_cancellation;
                    post['shipping_method_id'] = $scope.modelDataOrder.shipping_method_id;

                    post['client_id'] = model.client_id;
                    post['loyalty_point_selected'] = model.loyalty_point_selected;
                    post['order_amount'] = model.order_amount;
                    post['order_packaging'] = model.order_packaging;
                    post['order_product_discount'] = model.order_product_discount;
                    post['order_discount'] = model.order_discount;
                    post['tazz_discount'] = model.tazz_discount;
                    post['order_client_discount'] = model.order_client_discount;
                    post['order_shipping'] = model.order_shipping;

                    Crud.post('form-urlencoded', post, $scope.path + '/changeStatusOrder')
                        .success(function (data) {
                            if (!angular.isUndefined(data.invalid)) {
                                $scope.additionals['invalid'] = data.invalid;
                            }
                            $scope.modelDataOrder = {};
                            $scope.errors = {};
                            $scope.isLoading = false;
                            $scope.controlSH = false;
                            $scope.additionals['buttonDisabled'] = false;

                            // var postCbms = {};
                            // postCbms['order'] = {'id': model.id};
                            // postCbms['route'] = 'cbms';
                            // $scope.additionals['cbms'](path, postCbms);

                        })
                        .error(function (data) {
                            $scope.isLoading = false;
                            $scope.errors = data.errors;
                            $scope.additionals['buttonDisabled'] = false;
                            if (data == null) {
                                $rootScope.checkNetworkConnection();
                            }
                        });
                };
            }

        };

        /* get last order of client per day */
        $scope.additionals['getLastOrderClient'] = function (phone) {
            var url = $scope.path + '/getLastOrderClient/?phone=' + phone;
            if ($location.path() == $scope.path + '/orderPersonal') {
              var url =  url+'&shipping_method_id=4';
            }
            Crud.get(url)
              .success(function (data) {
                  $scope.lastOrderClient = data.lastOrderClient;
                  if(!angular.isUndefined(data.totalNoOrdersPersonal)) {
                      $scope.totalNoOrdersPersonal = data.totalNoOrdersPersonal;
                  }
              });
        }

        /* change field phone */
        $scope.additionals['applyDiscountCampaign'] = function () {
            if(angular.isUndefined($scope.additionals['order_product_sgr']) || (!angular.isUndefined($scope.additionals['order_product_sgr']) && $scope.additionals['order_product_sgr'] == '')){
              $scope.additionals['order_product_sgr'] = 0;
            }
            if(angular.isUndefined($scope.additionals['total_client_discount']) || (!angular.isUndefined($scope.additionals['total_client_discount']) && $scope.additionals['total_client_discount'] == '')){
              $scope.additionals['total_client_discount'] = 0;
            }
            if(angular.isUndefined($scope.additionals['total_loyalty_point_discount']) || (!angular.isUndefined($scope.additionals['total_loyalty_point_discount']) && $scope.additionals['total_loyalty_point_discount'] == '')){
              $scope.additionals['total_loyalty_point_discount'] = 0;
            }

            if(angular.isUndefined($scope.modelData['order_discount']) || (!angular.isUndefined($scope.modelData['order_discount']) && $scope.modelData['order_discount'] == '')){
              $scope.modelData['order_discount'] = 0;
            }
            if(angular.isUndefined($scope.modelData['order_shipping']) || (!angular.isUndefined($scope.modelData['order_shipping']) && $scope.modelData['order_shipping'] == '')){
              $scope.modelData['order_shipping'] = 0;
            }

            if(angular.isUndefined($scope.modelData['order_tip']) || (!angular.isUndefined($scope.modelData['order_tip']) && $scope.modelData['order_tip'] == '')){
              $scope.modelData['order_tip'] = 0;
            }
            if(angular.isUndefined($scope.modelData['tazz_discount']) || (!angular.isUndefined($scope.modelData['tazz_discount']) && $scope.modelData['tazz_discount'] == '')){
              $scope.modelData['tazz_discount'] = 0;
            }

            if (!angular.isUndefined($scope.additionals['discount_campaigns'])) {
                var total_client_discount = 0;
                angular.forEach($scope.additionals['discount_campaigns'], function (item, index) {
                    if (item.discount_campaign_value_type == 0) {//procent
                        total_client_discount += parseFloat((parseFloat($scope.additionals['total_product']) - parseFloat($scope.modelData['order_discount']) - parseFloat($scope.modelData['tazz_discount'])) * parseFloat(item.discount_campaign_value) / 100);
                    }
                    if (item.discount_campaign_value_type == 1) {//fixed value
                        total_client_discount += parseFloat(item.discount_campaign_value);
                    }
                });
                $scope.additionals['total_client_discount'] = $scope.formatDecimal(parseFloat(total_client_discount));
            }
            if ($scope.modelData.order_loyalty_point_discount > 0) {
                $scope.additionals['total_loyalty_point_discount'] = $scope.formatDecimal(parseFloat($scope.modelData.order_loyalty_point_discount));
            }

            if ($scope.modelData['order_total'] >= 0) {
                if (angular.isUndefined($scope.additionals['order_discount'])) {
                    $scope.additionals['order_discount'] = 0;
                }
                if (angular.isUndefined($scope.additionals['order_product_sgr']) || isNaN($scope.additionals['order_product_sgr'])) {
                    $scope.additionals['order_product_sgr'] = 0;
                }
                $scope.modelData['order_total'] = $scope.formatDecimal(parseFloat($scope.additionals['total_product']) - parseFloat($scope.additionals['total_client_discount']) - parseFloat($scope.additionals['total_loyalty_point_discount']) - parseFloat($scope.modelData['order_discount']) - parseFloat($scope.modelData['tazz_discount']) + parseFloat($scope.modelData['order_shipping']) + parseFloat($scope.modelData['order_tip']) + parseFloat($scope.additionals['order_product_sgr']));

            }

            $scope.modelData['order_client_discount'] = $scope.additionals['total_client_discount'];
        }

        $scope.phone = 0;
        $scope.additionals['changeFieldPhone'] = function (model) {
            $scope.phone = 1;
            Crud.get($scope.path + '/getClients?client_phone=' + model.order_phone)
                    .success(function (data) {

                        $scope.additionals['clients'] = data.clients;

                        if (data['clients'].length > 0) {
                            $scope.additionals['getSections'](data.clients[0], 0);
                            $scope.getOrdersHistory($scope.path, 1, perPage, data['clients'][0].id);
                            $scope.additionals['getLastOrderClient'](model.order_phone);
                        } else {
                            $scope.modelsHistory = [];
                            $scope.lastOrderClient = '';

                            model.client_first_name = '';
                            model.client_last_name = '';
                            model.client_email = '';
                        }

                        $scope.additionals['selectedItemClientFirstName'] = null;
                        $scope.additionals['selectedItemClientLastName'] = null;

                        if (angular.isUndefined(model.address) || model.address.length <= 0) {
                            model.address = [{}];
                            if (angular.isUndefined(model.address[0].county_name)) {
                                model.address[0].county_name = 'Cluj';
                            }
                        }
                        if (model['order_phone'] != '') {
                            if (!angular.isUndefined($scope.additionals['clients'][0])) {
                                $scope.modelData.address = $scope.additionals['clients'][0]['address'];
                                model.address = $scope.additionals['clients'][0]['address'];
                                if (!angular.isUndefined($scope.additionals['clients'][0]['client_first_name'])) {
                                    model.client_first_name = $scope.additionals['clients'][0]['client_first_name'];
                                }
                                if (!angular.isUndefined($scope.additionals['clients'][0]['client_last_name'])) {
                                    model.client_last_name = $scope.additionals['clients'][0]['client_last_name'];
                                }
                                model.client_id = $scope.additionals['clients'][0]['id'];
                                model.client_email = $scope.additionals['clients'][0]['client_email'];

                                if (model['client_gdpr'] == 0) {
                                    $scope.modelData.client_gdpr = false;
                                }
                                if (model['client_gdpr'] == 1) {
                                    $scope.modelData.client_gdpr = true;
                                }
                                model.client_cutlery = $scope.additionals['clients'][0]['client_cutlery'];
                                if (model['client_cutlery'] == 0) {
                                    $scope.modelData.client_cutlery = false;
                                }
                                if (model['client_cutlery'] == 1) {
                                    $scope.modelData.client_cutlery = true;
                                }
                                $scope.additionals['address'] = model.address;
                            } else {

                                model.address = [{}];
                                $scope.modelData.address = [{}];
                                if (angular.isUndefined(model.address[0].county_name)) {
                                    model.address[0].county_name = 'Cluj';
                                    $scope.modelData.address[0].county_name = 'Cluj';
                                }
                                if (angular.isUndefined(model.address[0].locality_name)) {
                                    model.address[0].locality_name = 'Cluj-Napoca';
                                    $scope.modelData.address[0].locality_name = 'Cluj-Napoca';
                                }
                                model.client_first_name = '';
                                model.client_last_name = '';
                                model.client_email = '';
                                //model.client_id = 0;
                            }

                            //if (angular.isUndefined(model['select_address'])) {
                            $scope.modelData.select_address = 0;
                            model.select_address = 0;
                            //}
                            //$scope.additionals['selectAddress'](model, model.select_address);

                        }

                        if (!angular.isUndefined(data.clients[0])) {
                          if (!angular.isUndefined(data.clients[0]['client_blacklist_reason'])) {
                              $scope.modelData.client_blacklist_reason = data.clients[0]['client_blacklist_reason'];
                              model.client_blacklist_reason = data.clients[0]['client_blacklist_reason'];
                          } else {
                              $scope.modelData.client_blacklist_reason = '';
                              model.client_blacklist_reason = '';
                          }
                        } else {
                            $scope.modelData.client_blacklist_reason = '';
                            model.client_blacklist_reason = '';
                        }

                        if ($scope.action == 'store') {

                            if (!angular.isUndefined(data.clients[0])) {
                                if (!angular.isUndefined(data.clients[0]['discount_campaigns'])) {
                                    $scope.additionals['discount_campaigns'] = data.clients[0]['discount_campaigns'];
                                    $scope.additionals['applyDiscountCampaign']();
                                } else {
                                    $scope.additionals['discount_campaigns'] = [];
                                }
                            } else {
                                $scope.additionals['discount_campaigns'] = [];
                            }

                            /*model['order_total'] = $scope.modelData['order_total'];
                             if(model['order_total'] == 0) {
                             model['order_total'] = $scope.additionals['total_product'];
                             }*/

                            $scope.additionals['selectAddress'](model, model.select_address);

                            if (!angular.isUndefined(data.clients[0])) {
                                if (!angular.isUndefined(data.clients[0]['loyalty_point_accumulated'])) {
                                    $scope.additionals['loyalty_point_accumulated'] = data.clients[0]['loyalty_point_accumulated'];
                                } else {
                                    $scope.additionals['loyalty_point_accumulated'] = 0;
                                }
                            } else {
                                $scope.additionals['loyalty_point_accumulated'] = 0;
                            }

                        }
                        if ($scope.action == 'update') {
                            if ($scope.order_phone_original == model['order_phone']) {
                                $scope.additionals['discount_campaigns'] = model['discount_campaigns'];
                                $scope.additionals['applyDiscountCampaign']();
                                model['order_total'] = $scope.modelData['order_total'];
                                if (model['order_total'] == 0) {
                                    model['order_total'] = $scope.additionals['total_product'];
                                }
                            }
                            $scope.additionals['selectAddress'](model, model.select_address);

                            if ($scope.order_phone_original != model['order_phone']) {
                                if (!angular.isUndefined(data.clients[0])) {
                                    if (!angular.isUndefined(data.clients[0]['loyalty_point_accumulated'])) {
                                        $scope.additionals['loyalty_point_accumulated'] = data.clients[0]['loyalty_point_accumulated'];
                                    } else {
                                        $scope.additionals['loyalty_point_accumulated'] = 0;
                                    }
                                } else {
                                    $scope.additionals['loyalty_point_accumulated'] = 0;
                                }
                                $scope.modelData['loyalty_point_selected'] = 0;
                                $scope.modelData['order_loyalty_point_discount'] = 0;
                                $scope.additionals['total_loyalty_point_discount'] = 0;
                            }
                        }

                        $timeout(function () {
                            $scope.phone = 0;
                        }, 500);
                    });

        }

        $scope.additionals['updateLoyaltyPointDiscount'] = function (model) {
            if (!angular.isUndefined(model['order_status'])) {
                if(model['order_status'] == 2) {
                  model['loyalty_point_selected'] = 0;
                  $scope.additionals['calcLoyaltyPointDiscount'](model);
                }
            }
        }

        $scope.additionals['calcLoyaltyPointDiscount'] = function (model) {

            var loyalty_point_selected = model.loyalty_point_selected;
            if(model.loyalty_point_selected == ''){
              model.order_loyalty_point_discount = 0;
              $scope.modelData.order_loyalty_point_discount = 0;
              loyalty_point_selected = 0;
            }
            //if ($scope.additionals['loyalty_point_accumulated'] >= $scope.additionals['settings']['min_no_loyalty_points']) {
                model.order_loyalty_point_discount = $scope.formatDecimal(parseFloat($scope.additionals['settings']['value_granted_loyalty_points']) * parseFloat(loyalty_point_selected));

                $scope.additionals['total_client_discount'] = $scope.formatDecimal(parseFloat($scope.additionals['total_client_discount']));
                $scope.additionals['total_loyalty_point_discount'] = $scope.formatDecimal(parseFloat($scope.additionals['total_loyalty_point_discount']));

                $scope.additionals['total_loyalty_point_discount'] = model.order_loyalty_point_discount;
                $scope.modelData['order_total'] =  $scope.formatDecimal(parseFloat($scope.additionals['total_product']) - parseFloat($scope.additionals['total_client_discount']) - parseFloat($scope.additionals['total_loyalty_point_discount']) + parseFloat($scope.additionals['shipping']) + parseFloat($scope.modelData['order_shipping']) + parseFloat($scope.additionals['order_product_sgr']));

                /* hardcoded shipping */
                $scope.additionals['selectAddress'](model, model['select_address']);
                /* end hardcoded shipping */
           // }
        }

        /* change field client*/
        $scope.additionals['changeFieldClient'] = function (model, name, clients) {
            if ($scope.phone == 0) {
                model['client_new'] = false;

                if (angular.isUndefined(model.address) || model.address.length <= 0) {
                    model.address = [{}];
                    if (angular.isUndefined(model.address[0].county_name)) {
                        model.address[0].county_name = 'Cluj';
                    }
                    if (angular.isUndefined(model.address[0].locality_name)) {
                        model.address[0].locality_name = 'Cluj-Napoca';
                    }
                }

                if ($scope.additionals['selectedItemClientFirstName'] == null && $scope.additionals['selectedItemClientLastName'] == null) {

                } else {
                    if ($scope.additionals['selectedItemClientFirstName'] != null) {
                        var first_name = $scope.additionals['selectedItemClientFirstName'];
                    }
                    if ($scope.additionals['selectedItemClientLastName'] != null) {
                        var last_name = $scope.additionals['selectedItemClientLastName'];
                    }
                }
                if (!angular.isUndefined(first_name) && first_name != null && first_name != '' && name == 'client_first_name') {
                    /* $scope.modelData.address = first_name['address'];
                     model.address = first_name['address'];
                     angular.forEach(first_name['address'], function (item, indexAddress) {
                     $scope.additionals['selectedItemStreet'][indexAddress] = {
                     'id': item.street_id,
                     'street_name': item.street_name
                     };
                     });*/

                    //model.order_phone = first_name['client_phone'];
                    model.client_first_name = first_name['client_first_name'];
                    model.client_last_name = first_name['client_last_name'];
                    model.client_last_name = model.client_last_name + ' ';
                    //model.client_id = first_name['id'];

                    $scope.additionals['selectedItemClientLastName'] = null;
                    $timeout(function () {
                        model.client_last_name = model.client_last_name.substring(0, model.client_last_name.length - 1);
                    }, 100);
                }

                if (!angular.isUndefined(last_name) && last_name != null && last_name != '' && name == 'client_last_name') {
                    /*$scope.modelData.address = last_name['address'];
                     model.address = last_name['address'];
                     angular.forEach(last_name['address'], function (item, indexAddress) {
                     $scope.additionals['selectedItemStreet'][indexAddress] = {
                     'id': item.street_id,
                     'street_name': item.street_name
                     };
                     });*/

                    //model.order_phone = last_name['client_phone'];
                    model.client_first_name = last_name['client_first_name'];
                    model.client_first_name = model.client_first_name + ' ';
                    model.client_last_name = last_name['client_last_name'];
                    //model.client_id = last_name['id'];

                    $scope.additionals['selectedItemClientFirstName'] = null;
                    $timeout(function () {
                        model.client_first_name = model.client_first_name.substring(0, model.client_first_name.length - 1);
                    }, 100);
                }

                if (last_name == null && first_name == null) {
                    /*if (angular.isUndefined(model.address[0].county_name)) {
                     model.address[0].county_name = 'Cluj';
                     }
                     if (angular.isUndefined(model.address[0].locality_name)) {
                     model.address[0].locality_name = 'Cluj-Napoca';
                     }
                     if (!angular.isUndefined(model.call_source)) {
                     model.order_phone = model.call_source;
                     }*/
                    if (model['client_first_name'] != '') {
                        model.client_first_name = model['client_first_name'];
                    }
                    if (model['client_last_name'] != '') {
                        model.client_last_name = model['client_last_name'];
                    }
                    model.client_id = 0;

                }

                //$scope.additionals['address'] = model.address;
                $scope.additionals['removeErrors']();
                /*if (angular.isUndefined(model['select_address'])) {
                 $scope.modelData.select_address = 0;
                 model.select_address = 0;
                 }
                 angular.forEach(model.address, function (item, indexAddress) {
                 $scope.additionals['getStreets'](model, indexAddress);
                 });
                 $timeout(function () {
                 $scope.additionals['selectAddress'](model, model['select_address']);
                 }, 101);*/

                //delete model['select_address'];
                if (!angular.isUndefined(model.order_phone)) {
                    $scope.additionals['getLastOrderClient'](model.order_phone);
                }


            }

        }

        $scope.additionals['searchTermSource'] = [];
        $scope.additionals['searchTermUser'] = [];
        $scope.additionals['searchTerm'] = [];
        $scope.additionals['clearSearchTerm'] = function (type, indexAddress) {
            $scope.additionals['searchTerm'][type] = [];
            $scope.additionals['searchTerm'][type][indexAddress] = '';
        };
        $scope.additionals['onSearchChange'] = function (ev) {
            ev.stopPropagation();
        };

        $scope.additionals['formatTime'] = function (time) {
            if (!angular.isUndefined(time)) {
                if (time != null && time != '') {
                    return moment(time).format('HH:mm:ss');
                } else {
                    return '';
                }
            } else {
                return '';
            }
        }
        $scope.additionals['closeDate'] = function () {
          $scope.modelData.order_planning_date = null;
          angular.element(document.querySelector('mdp-date-picker .md-input-has-value')).removeClass('md-input-has-value');
          angular.element(document.querySelector('mdp-date-picker .md-input-invalid')).removeClass('md-input-invalid');
          angular.element(document.querySelector('#order_planning_date input')).val('');
      }
      $scope.additionals['closeTime'] = function () {
          $scope.modelData.order_planning_time = null;
          angular.element(document.querySelector('mdp-time-picker .md-input-has-value')).removeClass('md-input-has-value');
          angular.element(document.querySelector('mdp-time-picker .md-input-invalid')).removeClass('md-input-invalid');
          angular.element(document.querySelector('#order_planning_time input')).val('');
      }
      $scope.additionals['changeTime'] = function (event, dateTime) {
          if (event.keyCode == 8) {//backspace press
             //$scope.modelData.order_planning = null;
             if(dateTime == 'order_planning_date'){
               $scope.modelData.order_planning_date = null;
             }
             if(dateTime == 'order_planning_time'){
               $scope.modelData.order_planning_time = null;
             }
          }
          if (event.keyCode == 46) { //delete press
              //$scope.modelData.order_planning = null;
              if(dateTime == 'order_planning_date'){
                $scope.modelData.order_planning_date = null;
              }
              if(dateTime == 'order_planning_time'){
                $scope.modelData.order_planning_time = null;
              }
          }
      }

      $scope.additionals['linearArray'] = function (parents) {
          $scope.additionals['data'] = [];
          angular.forEach(parents, function (parent) {
              $scope.additionals['data'].push(parent);
              if (!angular.isUndefined(parent['sub'])) {
                  $scope.additionals['linearSubArray'](parent['sub']);
              }
          });
          return $scope.additionals['data'];
      }

      $scope.additionals['linearSubArray'] = function (children) {
          angular.forEach(children, function (child, childKey) {
              $scope.additionals['data'].push(child);
              if (!angular.isUndefined(child['sub'])) {
                  $scope.additionals['linearSubArray'](child['sub']);
              }
          });
      }

      $scope.hierarchicalArray = function(supplements, id, index) {
           var arr = [];
           angular.forEach(supplements, function (item, key) {
                if(item.supplement_parent_id == id && item.supplement_parent_index == index){
                  arr.push(item);
                }
          });
          return arr;
         }

        $scope.additionals['function'] = function (ev, data) {
          $scope.indexSups = {};

          if (!angular.isUndefined(data['food_products'])) {
              angular.forEach(data['food_products'], function (itemProduct, keyProduct) {
                  if (!angular.isUndefined(itemProduct['food_supplements'])) {
                    $scope.indexSups[keyProduct] = itemProduct['no_supplements'];
                    //  $scope.indexSups[keyProduct] = itemProduct['food_supplements'].length;
                    //  itemProduct['food_supplements'].map(function (item) {
                    //      item.sub = $scope.hierarchicalArray(itemProduct['food_supplements'], item.supplement_id, item.supplement_index);
                    //      return item;
                    //  });
                    //  itemProduct['food_supplements'] = itemProduct['food_supplements'].filter(function (e, i, arr) {
                    //     return e.supplement_parent_id == 0;
                    // });
                 }
              });
            }

            $scope.getDependedFields();
            $scope.controlOrderChangedHistory = false;

            //$scope.modelsHistory = [];
            $scope.additionals['streets'] = null;
            $scope.fromCall = 0;
            $scope.additionals['searchTermCategory'] = '';
            $scope.additionals['searchTermProduct'] = '';
            $scope.additionals['searchTermSupplement'] = '';
            $scope.lastOrderClient = '';
            $scope.modelsHistory = [];
            $scope.controlLastOrder = false;

            $scope.additionals['total_product'] = 0;
            $scope.additionals['total_product_discount'] = 0;
            $scope.additionals['total_client_discount'] = 0;
            $scope.additionals['total_loyalty_point_discount'] = 0;
            $scope.additionals['shipping'] = 0;
            $scope.additionals['order_product_sgr'] = 0;

            $scope.additionals['address'] = [];
            $scope.modelData.product_errors = {};
            //$scope.additionals['getLocalities']({'address':[{'county_name': 'Cluj'}]}, 0);

            if ($scope.modelData['client_gdpr'] == 0) {
                $scope.modelData.client_gdpr = false;
            }
            if ($scope.modelData['client_gdpr'] == 1) {
                $scope.modelData.client_gdpr = true;
            }
            if ($scope.modelData['client_cutlery'] == 0) {
                $scope.modelData.client_cutlery = false;
            }
            if ($scope.modelData['client_cutlery'] == 1) {
                $scope.modelData.client_cutlery = true;
            }
            if ($scope.modelData['order_cutlery'] == 0) {
                $scope.modelData.order_cutlery = false;
            }
            if ($scope.modelData['order_cutlery'] == 1) {
                $scope.modelData.order_cutlery = true;
            }
            // if (!angular.isUndefined(data.order_planning)) {
            //     if (data.order_planning != null) {
            //         var timeArray = data.order_planning.split(':');
            //         var current_time = new Date();
            //         current_time.setHours(timeArray[0], timeArray[1], timeArray[2], 0);
            //         $scope.modelData.order_planning = current_time;
            //     }
            // }
            $scope.maxDate = new Date();
            var max_current_date = new Date();
            max_current_date.setHours(0, 0, 0, 0);
            $scope.maxDate = max_current_date;

            if (!angular.isUndefined(data.order_planning)) {
                if (data.order_planning != null) {
                    var dateArray = data.order_planning.split(' ');
                    $scope.modelData.order_planning_date = new Date(data.order_planning);
                    $scope.modelData.order_planning_time = new Date(dateArray[0] + ' ' + dateArray[1]);
                }
            } else {
                //data.order_planning_date = current_init_date;
                //data.order_planning_time = new Date();
            }

            if (angular.isUndefined(data.address) || data.address.length <= 0) {
                data.address = [{}];
                if (angular.isUndefined(data.address[0].county_name)) {
                    data.address[0].county_name = 'Cluj';
                }
                if (angular.isUndefined(data.address[0].locality_name)) {
                    data.address[0].locality_name = 'Cluj-Napoca';
                }
            }

            $scope.additionals['loyalty_point_accumulated'] = data.loyalty_point_accumulated;
            if ($scope.action == 'store') {
                $scope.additionals['discount_campaigns'] = [];

                data.shipping_method_id = 1;
                data.shipping_method_name = 'domiciliu';

                angular.forEach(data.address, function (item, key) {
                    $scope.additionals['getSections'](data, key);
                });
                //data.shipping_method_id = $scope.additionals['shipping_methods'][0]['id'];
                //data.shipping_method_name = $scope.additionals['shipping_methods'][0]['shipping_method_name'];
            }
            if ($scope.action == 'update') {
                $scope.additionals['clients'] = [{}];
                if (!angular.isUndefined(data.client_first_name)) {
                    $scope.additionals['clients'][0].client_first_name = data.client_first_name;
                    $scope.additionals['clients'][0].value = data.client_first_name;
                }
                if (!angular.isUndefined(data.client_last_name)) {
                    $scope.additionals['clients'][0].client_last_name = data.client_last_name;
                    $scope.additionals['clients'][0].value = data.client_last_name;
                }
                if (!angular.isUndefined(data.client_first_name) && !angular.isUndefined(data.client_last_name)) {
                    $scope.additionals['clients'][0].value = data.client_first_name + ' ' + data.client_last_name;
                }
                $scope.additionals['clients'][0].client_phone = data.order_phone;
                $scope.additionals['clients'][0].id = data.client_id;
                $scope.additionals['clients'][0].address = data.address;

                angular.forEach(data.address, function (item, key) {
                    //$scope.additionals['getLocalities'](data, key);
                    //$scope.additionals['getStreets'](data, key);
                    $scope.additionals['getSections'](data, key);
                });

                if (!angular.isUndefined(data.address_id) && !angular.isUndefined(data.address[data.select_address]) && data.address_id != data.address[data.select_address].id) {
                    data.select_address = null;
                }

                //$scope.additionals['applyDiscountCampaign']();

                $scope.order_phone_original = data['order_phone'];

            }

            //$scope.printBC = $window;

            if (angular.isUndefined($scope.modelData.order_packets) || $scope.modelData.order_packets == null) {
                $scope.modelData.order_packets = 1;
            }

            $scope.additionals['selectedItemClient'] = '';
            $scope.additionals['selectedItemClientMultiple'] = '';

            $scope.additionals['selectedItemStreet'] = '';
            $scope.additionals['selectedItemStreeMultiple'] = '';

            $scope.additionals['selectedItemSection'] = '';
            $scope.additionals['selectedItemSectionMultiple'] = '';

            if ($scope.action != 'updatemultiple') {
                var currentModel = {};
                angular.forEach(data, function (item, key) {
                    switch (key) {
                        // case 'food_products'://
                        //     currentModel['food_products'] = [];
                        //     angular.forEach(item, function (itemDetail, keyDetail) {
                        //         currentModel['food_products'][keyDetail] = {};
                        //         angular.forEach(itemDetail, function (itemDetail1, keyDetail1) {
                        //             if (keyDetail1 == 'food_supplements') {
                        //                 currentModel['food_products'][keyDetail]['food_supplements'] = [];
                        //                 angular.forEach(itemDetail['food_supplements'], function (itemDetailSup, keyDetailSup) {
                        //                     currentModel['food_products'][keyDetail]['food_supplements'][keyDetailSup] = {};
                        //                     angular.forEach(itemDetailSup, function (itemDetail1Sup, keyDetail1Sup) {
                        //                         currentModel['food_products'][keyDetail]['food_supplements'][keyDetailSup][keyDetail1Sup] = itemDetail1Sup;
                        //                     });
                        //                 });
                        //             } else {
                        //                 currentModel['food_products'][keyDetail][keyDetail1] = itemDetail1;
                        //             }
                        //         });
                        //     });
                        //     break;
                        case 'address':
                            currentModel['address'] = [];
                            angular.forEach(item, function (itemAddress, keyAddress) {
                                $scope.additionals['selectedItemLocality'][keyAddress] = '';
                                $scope.additionals['selectedItemStreet'][keyAddress] = '';

                                currentModel['address'][keyAddress] = {};
                                angular.forEach(itemAddress, function (itemAddressDetail, keyAddressDetail) {
                                    currentModel['address'][keyAddress][keyAddressDetail] = itemAddressDetail;
                                });
                            });
                            break;
                        default:
                            currentModel[key] = item;
                            break;
                    }
                });

                $scope.modelData = currentModel;
                if (angular.isUndefined(currentModel.address) || currentModel.address.length == 0) {
                    currentModel.address = [{}];
                }
                $scope.additionals['address'] = currentModel.address;
                if (angular.isUndefined($scope.modelData.shipping_method_id)) {
                    $scope.modelData.shipping_method_id = 1;
                }
            }
            $scope.additionals['closeStep'](1);
            $scope.additionals['controlCategories'] = false;
            $scope.additionals['controlProducts'] = false;
            $scope.additionals['controlMentionProduct'] = [];
            $scope.additionals['controlClientProduct'] = [];
            $scope.additionals['selectedItemClientFirstName'] = null;
            $scope.additionals['selectedItemClientLastName'] = null;

            $scope.errors = {};

        }

        $scope.additionals['changePackets'] = function (ev, model, type) {
            model = parseInt(model);
            if (!angular.isUndefined(type)) {
                if (type == 'increase') {
                    $scope.modelData.order_packets = model + 1;
                }
                if (type == 'decrease') {
                    if (model > 1) {
                        $scope.modelData.order_packets = model - 1;
                    }
                }
            }
        }

        /* apply discount */
        $scope.additionals['changeInputDiscount'] = function (discountValue, orderAmount, orderShipping) {
            $scope.additionals['total_client_discount'] = $scope.formatDecimal(parseFloat($scope.additionals['total_client_discount']));
            $scope.additionals['total_loyalty_point_discount'] = $scope.formatDecimal(parseFloat($scope.additionals['total_loyalty_point_discount']));

            $scope.modelData['order_total'] =  $scope.formatDecimal($scope.additionals['total_product'] - $scope.additionals['total_client_discount'] - $scope.additionals['total_loyalty_point_discount'] + $scope.additionals['shipping'] + parseFloat($scope.modelData['order_shipping']) + $scope.additionals['order_product_sgr'] + parseFloat($scope.modelData['order_tip']) - parseFloat($scope.modelData['tazz_discount']) );

            if ($scope.modelData.discount_type_id == 2) {
                $scope.modelData.order_discount = discountValue;
                $scope.modelData.order_discount = $scope.formatDecimal(parseFloat($scope.modelData.order_discount));
                $scope.modelData['order_total'] = $scope.formatDecimal($scope.modelData['order_total'] - $scope.modelData.order_discount - $scope.modelData.tazz_discount - $scope.modelData.order_tip);

                if(discountValue == 0 || discountValue == 0.00){
                  $scope.modelData.order_discount_reason = '';
                }
            }
            $scope.additionals['applyDiscountCampaign']();
            $scope.additionals['selectAddress']($scope.modelData, $scope.modelData.select_address);
        }

        $scope.additionals['changeSelectDiscountEvent'] = function (discountId, orderAmount, orderShipping) {
            //$scope.additionals['applyDiscountCampaign']();
            $scope.additionals['changeSelectDiscount'](discountId, orderAmount, orderShipping);
            $scope.additionals['selectAddress']($scope.modelData, $scope.modelData.select_address);
        }

        $scope.additionals['changeSelectDiscount'] = function (discountId, orderAmount, orderShipping) {

            $scope.additionals['total_client_discount'] = $scope.formatDecimal(parseFloat($scope.additionals['total_client_discount']));
            $scope.additionals['total_loyalty_point_discount'] = $scope.formatDecimal(parseFloat($scope.additionals['total_loyalty_point_discount']));

            $scope.modelData['order_total'] = $scope.formatDecimal(parseFloat($scope.additionals['total_product']) - parseFloat($scope.additionals['total_client_discount']) - parseFloat($scope.additionals['total_loyalty_point_discount']) + parseFloat($scope.additionals['shipping']) + parseFloat($scope.modelData['order_tip']) + parseFloat($scope.additionals['order_product_sgr']) - parseFloat($scope.modelData['tazz_discount']));

            if (!angular.isUndefined($scope.additionals['discounts'])) {
              var position = $scope.additionals['discounts'].map(function (e) {
                  return e['id'];
              }).indexOf(discountId);
              if (position >= 0) {
                  $scope.modelData.discount_type_id = $scope.additionals['discounts'][position]['discount_type_id'];
                  if ($scope.modelData.discount_type_id != 2) {
                      $scope.modelData.discount_value = $scope.additionals['discounts'][position]['discount_value'];                }

                  if ($scope.modelData.discount_type_id == 1) {
                      $scope.modelData.order_discount = $scope.additionals['discounts'][position]['discount_value'];
                  }
                  if ($scope.modelData.discount_type_id == 0) {
                      if ($scope.additionals['total_product'] > 0) {
                          $scope.modelData.order_discount = $scope.formatDecimal($scope.additionals['total_product'] * $scope.modelData.discount_value / 100);
                      } else {
                          $scope.modelData.order_discount = 0;
                          $scope.modelData.order_discount_reason = '';
                      }
                  }
                  if ($scope.modelData.discount_type_id == 2) {
                      $scope.modelData.order_discount = $scope.modelData.discount_value;
                  }

                  $scope.modelData.order_discount = $scope.formatDecimal(parseFloat($scope.modelData.order_discount));
                  $scope.modelData['order_total'] = $scope.formatDecimal(parseFloat($scope.modelData['order_total']) - parseFloat($scope.modelData.order_discount));

              } else {
                  $scope.modelData.discount_type_id = 0;
                  $scope.modelData.discount_value = 0;
                  $scope.modelData.order_discount = 0;
                  $scope.modelData.order_discount_reason = '';
              }
            } else {
              $scope.modelData.discount_type_id = 0;
              $scope.modelData.discount_value = 0;
              $scope.modelData.order_discount = 0;
              $scope.modelData.order_discount_reason = '';
            }

            $scope.additionals['applyDiscountCampaign']();

        }
        /* end apply discount */

        $scope.additionals['selectAddressEvent'] = function (model, keyAddress) {
            $scope.additionals['selectAddress'](model, keyAddress);
        }

        $scope.additionals['selectSection'] = function (model, keyAddress) {
          if(keyAddress == $scope.modelData.select_address){
            $scope.additionals['selectAddress'](model, keyAddress);
          }
        }

        $scope.additionals['selectAddress'] = function (model, keyAddress) {

              if(angular.isUndefined($scope.additionals['order_product_sgr']) || (!angular.isUndefined($scope.additionals['order_product_sgr']) && $scope.additionals['order_product_sgr'] == '')){
                $scope.additionals['order_product_sgr'] = 0;
              }

              if(angular.isUndefined($scope.modelData['order_tip']) || (!angular.isUndefined($scope.modelData['order_tip']) && $scope.modelData['order_tip'] == '')){
                $scope.modelData['order_tip'] = 0;
              }

             if (angular.isUndefined($scope.additionals['streets']) || $scope.additionals['streets'] == null) {
                    $scope.additionals['streets'] = [];
             }

            model['order_total'] = $scope.formatDecimal(parseFloat($scope.additionals['total_product']) - parseFloat($scope.additionals['total_client_discount']) - parseFloat($scope.additionals['total_loyalty_point_discount']) - parseFloat($scope.modelData['order_discount']) - parseFloat($scope.modelData['tazz_discount']) );
            //model['order_total'] = $scope.formatDecimal(parseFloat($scope.additionals['total_product']));

            if (!angular.isUndefined($scope.additionals['streets'][keyAddress]) && !angular.isUndefined(model.address[keyAddress])) {
                var positionStreet = $scope.additionals['streets'][keyAddress].map(function (e) {
                    return e['street_name'];
                }).indexOf(model.address[keyAddress]['street_name']);
                if (positionStreet >= 0) {
                    model.address[keyAddress]['section_name'] = $scope.additionals['streets'][keyAddress][positionStreet]['section_name'];
                }
            }

            //$scope.getDependedFields();
            if (!angular.isUndefined(model) && !angular.isUndefined(keyAddress)) {
                if (angular.isUndefined(model.shipping_method_id)) {
                    model.shipping_method_id = 1;
                    $scope.modelData.shipping_method_id = 1;
                }

                if (!angular.isUndefined(model.address)) {
                    if (!angular.isUndefined(model.food_products) && !angular.isUndefined(model.address[keyAddress])) {
                        if (model.food_products.length > 0) {
                            model['order_shipping'] = 0;
                            var rule_value0 = 'no'; //for special rule 0
                            var position = $scope.additionals['shipping_methods'].map(function (e) {
                                return e['id'];
                            }).indexOf(model.shipping_method_id);

                            angular.forEach($scope.additionals['shipping_methods'][position]['rules'], function (itemRule, indexRule) {
                                if (!angular.isUndefined(model.address[keyAddress]['locality_name'])) {
                                    if (itemRule['locality_ids'].indexOf($scope.additionals['formatTextResult'](model.address[keyAddress]['locality_name'])) >= 0) {
                                        if (itemRule.rule_value == 0) {
                                            rule_value0 = 'yes';
                                        }
                                        if (itemRule.rule_sign == '=') {
                                            itemRule.rule_sign = '==';
                                        }
                                        if (!angular.isUndefined(itemRule['section_ids'][$scope.additionals['formatTextResult'](model.address[keyAddress]['locality_name'])])) {
                                            if (!angular.isUndefined(model.address[keyAddress]['section_name']) && model.address[keyAddress]['section_name'] != null) {
                                                if (itemRule['section_ids'][$scope.additionals['formatTextResult'](model.address[keyAddress]['locality_name'])].indexOf($scope.additionals['formatTextResult'](model.address[keyAddress]['section_name'])) >= 0) {
                                                    if (!angular.isUndefined(model['order_total'])) {

                                                        if (eval(Math.round(model['order_total'] * 100) + itemRule.rule_sign + Math.round(itemRule.order_value * 100))) {
                                                            model['order_shipping'] = model['order_shipping'] + parseFloat(itemRule.rule_value);
                                                        }
                                                    } else {
                                                        if (!angular.isUndefined($scope.additionals['total_product'])) {
                                                            if (eval(Math.round($scope.additionals['total_product'] * 100) + itemRule.rule_sign + Math.round(itemRule.order_value * 100))) {
                                                                model['order_shipping'] = model['order_shipping'] + parseFloat(itemRule.rule_value);
                                                            }
                                                        } else {
                                                            if (eval(Math.round(model['order_amount'] * 100) + itemRule.rule_sign + Math.round(itemRule.order_value * 100))) {
                                                                model['order_shipping'] = model['order_shipping'] + parseFloat(itemRule.rule_value);
                                                            }
                                                        }
                                                    }

                                                }
                                            }
                                        } else {
                                            if (!angular.isUndefined(model['order_total'])) {
                                                if (eval(Math.round(model['order_total'] * 100) + itemRule.rule_sign + Math.round(itemRule.order_value * 100))) {
                                                    model['order_shipping'] = model['order_shipping'] + parseFloat(itemRule.rule_value);
                                                }
                                            } else {
                                                if (!angular.isUndefined($scope.additionals['total_product'])) {
                                                    if (eval(Math.round($scope.additionals['total_product'] * 100) + itemRule.rule_sign + Math.round(itemRule.order_value * 100))) {
                                                        model['order_shipping'] = model['order_shipping'] + parseFloat(itemRule.rule_value);
                                                    }
                                                } else {
                                                    if (eval(Math.round(model['order_amount'] * 100) + itemRule.rule_sign + Math.round(itemRule.order_value * 100))) {
                                                        model['order_shipping'] = model['order_shipping'] + parseFloat(itemRule.rule_value);
                                                    }
                                                }
                                            }

                                        }

                                        /* hardcoded shipping */
                                        if (!angular.isUndefined(model['order_total'])) {
                                              //console.log(model['order_total'] +'- '+model.order_discount +'-- '+ $scope.additionals['total_client_discount'] +'--- '+$scope.additionals['total_loyalty_point_discount'] )
                                            //if (model['order_total'] - model.order_discount - $scope.additionals['total_client_discount'] - $scope.additionals['total_loyalty_point_discount'] <= 0) {
                                            if (model['order_total'] <= 0) {
                                                if (model.address[keyAddress]['locality_name'] == 'Cluj-Napoca') {
                                                    model['order_shipping'] = 6;
                                                    if (!angular.isUndefined(model['source_incident_id']) && model['source_incident_id'] != 0) {
                                                        model['order_shipping'] = 0;
                                                    }
                                                } else {
                                                    if (!angular.isUndefined(model['source_incident_id']) && model['source_incident_id'] != 0) {
                                                        model['order_shipping'] = 0;
                                                    }
                                                }
                                            }
                                        }
                                        /* end hardcoded shipping */

                                    }
                                }
                            });
                            /*case of imports or none rules*/
                           /* if ((!angular.isUndefined(model['order_source']) && model['order_source'] > 1) || (model['order_shipping'] == 0 && model['shipping_method_id'] == 1)) {
                                if (rule_value0 == 'yes') {
                                    model['order_shipping'] = 0;
                                }
                            }*/

                            if (angular.isUndefined(model['order_packaging'])) {
                                model['order_packaging'] = 0;
                            }

                            /* if (!angular.isUndefined($scope.additionals['total_product'])) {
                             model['order_total'] = $scope.additionals['total_product'] + parseFloat(model['order_packaging']) + model['order_shipping'];
                             } else {
                             model['order_total'] = parseFloat(model['order_amount']) + parseFloat(model['order_packaging']) + model['order_shipping'];
                             }*/
                        } else {
                            model['order_shipping'] = 0;
                            model['order_total'] = 0;
                        }
                    }
                }

            }

            if (angular.isUndefined(model['order_shipping'])) {
                model['order_shipping'] = 0;
            }

            $scope.additionals['shipping'] = parseFloat(model['order_shipping']);
            $scope.modelData['order_total'] = $scope.formatDecimal(parseFloat(model['order_total']) + parseFloat(model['order_shipping']));

            $scope.additionals['changeSelectDiscount'](model.discount_id, model['order_amount'], model['order_shipping']);

        }

        $scope.submitModel = function () {
            $scope.modelData.final = 1;
        }
        $scope.validateForm = function () {
            $scope.modelData.final = 0;
        }
        $scope.additionals['functionErrors'] = function (ev, errors) {
            if (errors && !errors['food_products'] && !errors['food_products.0.food_product_id']) {
                $scope.additionals['expandStep'](2);
                if (errors && !errors['client_id'] && !errors['order_phone']) {
                    $scope.additionals['expandStep'](3);
                    if (errors && !errors['shipping_method_id'] && !errors['address.0.locality_name'] && !errors['address.0.locality_name'] && !errors['address.0.section_name'] && !errors['address.0.street_name'] && !errors['select_address']) {
                        $scope.additionals['expandStep'](4);
                        if (errors && !errors['payment_method_id']) {
                            $scope.additionals['expandStep'](5);
                        }
                    }
                }
            }

            if (errors && errors['generic']) {
                $scope.modelData['controlErrorsPrinter'] = 1;
            }
        }
        $scope.additionals['internFunction'] = function (ev, model) {
            if(angular.element('#order_planning_date').hasClass('ng-invalid-format')){
              $scope.modelData.order_planning_date = 'undefined';
            }
            if(angular.element('#order_planning_time').hasClass('ng-invalid-format')){
              $scope.modelData.order_planning_time = 'undefined';
            }

            if ($scope.action != 'updatemultiple') {
                if (model['client_phone'] != '') {
                    var checkClient = $scope.additionals['checkField']($scope.additionals['clients'], 'id', 'client_phone', model['order_phone']);
                    if (checkClient) {
                        model.client_id = checkClient;
                    } else {
                        model.client_id = 0;
                    }
                }
                angular.forEach(model.address, function (item, indexAddress) {
                    if (item['locality_name'] != '' && $scope.additionals['localities'][indexAddress]) {
                        if (!angular.isUndefined($scope.additionals['localities'][indexAddress][0])) {
                            if (!angular.isUndefined($scope.additionals['localities'][indexAddress][0]['id'])) {
                                var checkLocalityId = $scope.additionals['checkField']($scope.additionals['localities'][indexAddress], 'id', 'locality_name', item['locality_name']);
                                if (checkLocalityId) {
                                    item.locality_id = checkLocalityId;
                                } else {
                                    item.locality_id = 0;
                                }
                            } else {
                                item.locality_id = 'js';
                            }
                        } else {
                            item.locality_id = 'js';
                        }

                        var checkLocalityName = $scope.additionals['checkField']($scope.additionals['localities'][indexAddress], 'locality_name', 'locality_name', item['locality_name']);
                        if (checkLocalityName) {
                            item.locality_name = checkLocalityName;
                        } else {
                            if (item.locality_id == 'js') {
                                item.locality_name = '';
                            }
                        }
                    }

                    if (item['section_name'] != '' && $scope.additionals['sections'][indexAddress]) {
                        var checkSectionId = $scope.additionals['checkField']($scope.additionals['sections'][indexAddress], 'id', 'section_name', item['section_name']);
                        if (checkSectionId) {
                            item.section_id = checkSectionId;
                        } else {
                            item.section_id = 0;
                        }

                        var checkSectionName = $scope.additionals['checkField']($scope.additionals['sections'][indexAddress], 'section_name', 'section_name', item['section_name']);
                        if (checkSectionName) {
                            item.section_name = checkSectionName;
                        }
                    }

                    if (item['street_name'] != '' && $scope.additionals['streets'] != null && $scope.additionals['streets'][indexAddress] ) {
                        var checkStreetId = $scope.additionals['checkField']($scope.additionals['streets'][indexAddress], 'id', 'street_name', item['street_name']);
                        if (checkStreetId) {
                            item.street_id = checkStreetId;
                        } else {
                            item.street_id = 0;
                        }

                        var checkStreetName = $scope.additionals['checkField']($scope.additionals['streets'][indexAddress], 'street_name', 'street_name', item['street_name']);
                        if (checkStreetName) {
                            item.street_name = checkStreetName;
                        }
                    }

                });
            }
        }

        $scope.printBC = $window;
        $scope.additionals['printOrderBC'] = function (modelId) {
            Crud.show(modelId, $scope.path)
                    .success(function (data) {

                        var model = data;

                        /*print order*/
                        var popup = $scope.printBC.open('', '_blank', 'width=800,height=300,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no,top=50');
                        popup.document.open();
                        var html = '<div class="order-print">'
                                + '<h2>Nr. comanda: ' + model.order_no + '</h2>';

                        html = html + '<div>Start comanda: ' + moment(model.order_start).format('DD/MM/YY HH:mm:ss') + '</div>';

                        if (model.food_products) {
                            html = html + '<div class="margin-top">Produse comandate: </div>';
                            angular.forEach(model.food_products, function (item, key) {
                                html = html + '<div class="margin-left margin-top clear">';
                                html = html + '<div class="div-big left">' + $scope.additionals['truncate'](item['food_product_name'], 30) + '</div>';
                                html = html + '<div class="div-small left">x</div>';
                                html = html + '<div class="div-medium left">' + item['food_product_quantity'] + '</div>';
                                angular.forEach(item['food_supplements'], function (itemSupplement, keySupplement) {
                                    html = html + '<div class="margin-left clear">';
                                    html = html + '<div class="div-big-sup left">' + $scope.additionals['truncate'](itemSupplement['supplement_name'], 26) + '</div>';
                                    html = html + '<div class="div-small left">x</div>';
                                    html = html + '<div class="div-medium left">' + item['food_product_quantity'] + '</div>';
                                    html = html + '</div>';
                                });
                                html = html + '</div>';
                            });
                            html = html + '<div class="margin-left margin-top clear"></div>';
                        }
                        /*if (model.order_packets) {
                         html = html + '<div class="margin-top clear">Nr. pachete: ' + model.order_packets + '</div>'
                         }*/
                        if (model.order_mention) {
                            html = html + '<div class="margin-top">Mentiuni: ' + model.order_mention + '</div>'
                        }
                        if (model.order_planning) {
                            html = html + '<div class="margin-top">Programare comanda: ' + model.order_planning + '</div>'
                        }
                        html = html + '<div></div>';

                        popup.document.write('<!DOCTYPE html><html><head><title>Bon comanda: ' + model.order_no + '</title>'
                                + '<link rel="stylesheet" type="text/css" href="/css/print.css" />'
                                + '</head><body onload="window.print(); window.close();">'
                                + html
                                + '</body></html>');
                        //popup.document.close();
                        /*end print order*/
                    });
        }

        $scope.additionals['functionResult'] = function (ev, data) {

            $scope.additionals['originalModelShow'] = angular.copy(data);

            $scope.modelsHistory = [];
            $scope.additionals['closeStep'](1);
            $scope.additionals['controlCategories'] = false;
            $scope.additionals['controlProducts'] = false;
            $scope.additionals['controlMentionProduct'] = [];
            $scope.additionals['controlClientProduct'] = [];

            $scope.additionals['controlSupplements'] = [];
            $scope.additionals['supplements'] = [];

            $scope.additionals['selectedProduct'] = {};
            $scope.additionals['selectedProduct'].food_product_quantity = 0;
            $scope.additionals['selectedProductClass'] = [];
            $scope.additionals['controlMentionProduct'] = [];
            $scope.additionals['controlClientProduct'] = [];

            $scope.additionals['selectedItemClientFirstName'] = null;
            $scope.additionals['selectedItemClientLastName'] = null;

            $scope.additionals['loyalty_point_accumulated'] = 0;
            $scope.additionals['total_product'] = 0;
            $scope.additionals['order_product_sgr'] = 0;
            $scope.additionals['total_product_discount'] = 0;
            $scope.additionals['total_client_discount'] = 0;
            $scope.additionals['total_loyalty_point_discount'] = 0;
            $scope.additionals['shipping'] = 0;
            $scope.lastOrderClient = '';
            $scope.modelsHistory = [];
            $scope.additionals['discount_campaigns'] = [];

            $scope.additionals['calcProcess'](data);

        }

        $scope.additionals['changeSelectShipping'] = function (field, array, id) {
            if (id == 2 || id == 3 || id == 4) {
                $scope.modelData.select_address = '';
            } else {
                $scope.modelData.select_address = 0;
            }
            $scope.modelData['order_shipping'] = 0;
            $scope.modelData['order_total'] = $scope.formatDecimal($scope.additionals['total_product']);

            var position = $scope.additionals[array].map(function (e) {
                return e[$rootScope.typeId];
            }).indexOf(id);
            if (!angular.isUndefined($scope.additionals[array][position])) {
                $scope.modelData[field] = $scope.additionals[array][position][field];
            } else {
                $scope.modelData[field] = '';
            }
            //$scope.additionals['applyDiscountCampaign']();
            //$scope.modelData['order_total'] = $scope.modelData['order_total'];

            $scope.additionals['selectAddress']($scope.modelData, $scope.modelData.select_address);

            $scope.additionals['updateTotalPrice']();
        }

        $scope.additionals['changeSelectPayment'] = function (field, array, id) {
            var position = $scope.additionals[array].map(function (e) {
                return e[$rootScope.typeId];
            }).indexOf(id);
            if (!angular.isUndefined($scope.additionals[array][position])) {
                $scope.modelData[field] = $scope.additionals[array][position][field];
            } else {
                $scope.modelData[field] = '';
            }
            if (id == 1) {
                $scope.modelData['order_partial'] = 0;
            }
        }

        $scope.additionals['changeQuantity'] = function (ev, model, product, keyProduct, modelIndex) {
            /*on enter*/
            //if(ev.keyCode == 13) {
            product['food_product_quantity'] = parseInt(product['food_product_quantity']);
            var post = {};
            post = model;
            post['route'] = 'changeQuantity';
            post['current_product'] = product;
            post['keyProduct'] = keyProduct;

            Crud.post('form-urlencoded', post, $scope.path + '/changeQuantity')
                    .success(function (data) {
                        $scope.modelData = data['currentModel'];
                        if (!angular.isUndefined($scope.models)) {
                            $scope.models[modelIndex] = data['currentModel'];
                        }
                        $scope.errors = [];

                        var post = {};
                        post['id'] = model.id;
                        post['route'] = 'printOrderAsincron';
                        $scope.additionals['printOrderAsincron']($scope.path, post);

                        // var postCbms = {};
                        // postCbms['order'] = $scope.additionals['originalModelShow'];
                        // postCbms['route'] = 'cbms';
                        // $scope.additionals['cbms']($scope.path, postCbms);


                    }).error(function (data) {
                if (!angular.isUndefined(data['generic'])) {
                    $scope.modelData = data['currentModel'][0];
                    if (!angular.isUndefined($scope.models)) {
                        $scope.models[modelIndex] = data['currentModel'][0];
                    }
                }
                $scope.errors = data.errors;
            });
            //}
            /*on delete*/
            if (ev.keyCode == 46) {
                //$scope.deleteModel(ev, model[$rootScope.typeId]);
            }
        }

        $scope.additionals['deleteProduct'] = function (ev, model, productId, productIndex, keyProduct, modelIndex) {
            var post = {};
            post = model;
            post['route'] = 'deleteProduct';
            post['food_product_id'] = productId;
            post['food_product_index'] = productIndex;
            post['keyProduct'] = keyProduct;
            $scope.additionals['buttonDisabled'] = true;
            Crud.post('form-urlencoded', post, $scope.path + '/deleteProduct')
                    .success(function (data) {
                        $scope.modelData = data['currentModel'];
                        if (!angular.isUndefined($scope.models)) {
                          $scope.models[modelIndex] = data['currentModel'];
                        }
                        $scope.errors = [];
                        $scope.additionals['buttonDisabled'] = false;

                        var post = {};
                        post['id'] = model.id;
                        post['route'] = 'printOrderAsincron';
                        $scope.additionals['printOrderAsincron']($scope.path, post);

                        // var postCbms = {};
                        // postCbms['order'] = $scope.additionals['originalModelShow'];
                        // postCbms['route'] = 'cbms';
                        // $scope.additionals['cbms']($scope.path, postCbms);

                    }).error(function (data) {
                if (!angular.isUndefined(data['generic'])) {
                    $scope.modelData = data['currentModel'][0];
                    $scope.models[modelIndex] = data['currentModel'][0];
                }
                $scope.errors = data.errors;
                $scope.additionals['buttonDisabled'] = false;
            });
        }

        $scope.additionals['closeStep'] = function (step, multiple) {
            if (angular.isUndefined($scope.modelData.product_errors) || $scope.modelData.product_errors == null || $scope.modelData.product_errors == 'null' || Object.keys($scope.modelData.product_errors).length === 0) {
                $scope.additionals['controlExpandStep'][step] = false;
                if (!angular.isUndefined(multiple)) {
                    $scope.additionals['productsControl' + multiple] = false;
                }

                $scope.additionals['controlCategories'] = false;
                $scope.additionals['controlProducts'] = false;
                $scope.additionals['controlSupplements'] = [];
                $scope.additionals['controlMentionProduct'] = [];
                $scope.additionals['controlClientProduct'] = [];
            }
        }

        $scope.additionals['controlCategories'] = false;
        $scope.additionals['getFoodCategories'] = function () {
            $scope.additionals['controlCategories'] = true;
            $scope.additionals['controlProducts'] = false;
            $scope.additionals['controlSupplements'] = [];
            if (angular.isUndefined($scope.additionals['food_categories'])) {
              var path = $scope.path + '/getFoodCategories';
              Crud.get(path)
                  .success(function (data) {
                      $scope.additionals['food_categories'] = data.foodCategories;
                  });
            }
            $scope.additionals['controlMentionProduct'] = [];
            $scope.additionals['controlClientProduct'] = [];

            /* set heigth from card */
            var heightCard = $('#send-order').height();
            if (!angular.isUndefined(heightCard)) {
                if (heightCard >= 700) {
                    heightCard = 600;
                }
                heightOverload = heightCard - 50;
                angular.element(document.querySelector('.overload')).css('height', heightOverload + 'px');
            }
            var heightCard = $('#action').height();
            if (!angular.isUndefined(heightCard)) {
                if (heightCard >= 700) {
                    heightCard = 600;
                }
                heightOverload = heightCard - 50;

                angular.element(document.querySelector('#action')).css('min-height', '700px');
                angular.element(document.querySelector('#action md-card-content')).css('min-height', '590px');
                angular.element(document.querySelector('.overload')).css('height', '598px');
            }

            /* end set heigth from card */
        }

        $scope.additionals['controlProducts'] = false;
        $scope.additionals['closeProducts'] = function (step) {
            if (angular.isUndefined($scope.modelData.product_errors) || $scope.modelData.product_errors == null || $scope.modelData.product_errors == 'null' || Object.keys($scope.modelData.product_errors).length === 0) {
                $scope.additionals['controlProducts'] = false;
                $scope.additionals['controlMentionProduct'] = [];
                $scope.additionals['controlClientProduct'] = [];
            }
        }

        $scope.additionals['controlSupplements'] = [];
        $scope.additionals['closeSupplements'] = function (keyControl) {
            //if (Object.keys($scope.modelData.product_errors).length === 0) {
              if (angular.isUndefined($scope.modelData.product_errors[keyControl])) {
                $scope.additionals['controlSupplements'][keyControl].controlSupplement = false;
                if (!angular.isUndefined($scope.selectedSupplements)) {
                    $scope.selectedSupplements.pop();
                    $scope.selectedProduct = $scope.selectedSupplements[$scope.selectedSupplements.length - 1];
                }

            }
        }

        $scope.additionals['getFoodProducts'] = function (categoryId) {

            $scope.additionals['controlProducts'] = true;
            $scope.additionals['updateTotalPrice']();
            var path = $scope.path + '/getFoodProducts/?category_id=' + categoryId;
            if ($location.path() == $scope.path + '/orderPersonal') {
                path = path + '&order_type=personal';
            }
            if (!angular.isUndefined($scope.modelData.order_orig_id) && $scope.modelData.order_orig_id != 0 && $scope.modelData.order_orig_id != null && $scope.modelData.order_orig_id != 'null') {
                path = path + '&order_type=import';
            }
            if (!angular.isUndefined($scope.modelData['source_incident_id']) && $scope.modelData['source_incident_id'] != 0 && $scope.modelData['source_incident_id'] != null && $scope.modelData['source_incident_id'] != 'null') {
                path = path + '&order_type=incident';
            }

            Crud.get(path)
            .success(function (data) {
                $scope.additionals['food_products'] = data.foodProducts;

                if (angular.isUndefined($scope.modelData.product_errors) || $scope.modelData.product_errors == null || $scope.modelData.product_errors == 'null' || Object.keys($scope.modelData.product_errors).length === 0) {
                    $scope.additionals['controlSupplements'] = [];
                    $scope.additionals['supplements'] = [];
                    $scope.additionals['selectedProduct'] = {};
                    $scope.additionals['selectedProduct'].food_product_quantity = 0;
                    $scope.additionals['selectedProductClass'] = [];
                    $scope.additionals['controlMentionProduct'] = [];
                    $scope.additionals['controlClientProduct'] = [];
                } else {

                    $scope.additionals['selectedProductClass'] = [];
                    if (!angular.isUndefined($scope.additionals['selectedProduct'])) {
                        var poss = $scope.additionals['food_products'].map(function (e) {
                            return e['food_product_id'];
                        }).indexOf($scope.additionals['selectedProduct']['food_product_id']);
                        if (poss >= 0) {
                            $scope.additionals['selectedProductClass'][poss] = 'selected-product';
                        }
                    }

                }
            });
        }

        $scope.additionals['checkErrorsSupplement'] = function (productIndex, keyControl) {
           if (angular.isUndefined(keyControl)) {
             keyControl = 0;
           }
           var sups = []; var cats = [];
           var sup_no = 0; var cat_no = 0;

            angular.forEach($scope.additionals['supplements'][keyControl], function (itemSupplement, keySupplement) {
              //angular.forEach(itemSupplement, function (itemSup, keySup) {
                angular.forEach(itemSupplement.supplets, function (items, keys) {
                    //if (items['supplement_type_price'] == 0 && items['supplement_option'] == 0 && items['supplement_price'] == 0) {
                    if (items['supplement_option'] == 0 && items['supplement_display_menu'] == 1) {
                        cats[cat_no] = items['food_category_id']+'-'+items['supplement_parent_id']+'-'+items['supplement_parent_index'];
                        //cats[cat_no] = items['food_category_id'];
                        cat_no++;
                    }
                });
            //});
            });

            if (angular.isUndefined($scope.modelData.food_products)) {
                $scope.modelData.food_products = [];
            }
            cats = cats.filter(function (e, i, arr) {
                return arr.lastIndexOf(e) === i;
            });

            if ($scope.modelData.food_products.length > 0) {

             if (!angular.isUndefined($scope.selectedProduct.food_supplements)){
               var food_supplements = $scope.selectedProduct.food_supplements;
             }
             if (!angular.isUndefined($scope.selectedProduct.sub)){
               var food_supplements = $scope.selectedProduct.sub;
             }

              if (!angular.isUndefined(food_supplements)) {
                  angular.forEach(food_supplements, function (itemSup, keysSup) {
                      //if (itemSup['supplement_type_price'] == 0 && itemSup['supplement_option'] == 0 && itemSup['supplement_price'] == 0) {
                      angular.forEach(cats, function (itemCaty, keysCaty) {
                        var catyArray = itemCaty.split('-');
                      if (parseInt(itemSup['supplement_parent_id']) == parseInt(catyArray[1]) && parseInt(itemSup['supplement_parent_index']) == parseInt(catyArray[2]) && itemSup['supplement_option'] == 0 && itemSup['supplement_display_menu'] == 1) {

                          if (!angular.isUndefined(itemSup['food_category_id'])) {
                              sups[sup_no] = parseInt(itemSup['food_category_id'])
                              //sups[sup_no] = parseInt(itemSup['food_category_id'])+'-'+parseInt(itemSup['supplement_parent_id'])+'-'+parseInt(itemSup['supplement_parent_index']);
                              sup_no++;
                          }
                      }
                    });
                    // if (itemSup['supplement_option'] == 0 && itemSup['supplement_display_menu'] == 1) {
                    //     if (!angular.isUndefined(itemSup['food_category_id'])) {
                    //         sups[sup_no] = parseInt(itemSup['food_category_id']);
                    //         sup_no++;
                    //     }
                    // }
                  });
              }
            }

            //console.log(cats)
            //console.log(sups)

          if (angular.isUndefined($scope.modelData.product_errors)) {
            $scope.modelData.product_errors = {};
          }
          var control = 1;
          angular.forEach(cats, function (itemCat, keysCat) {
              var catArray = itemCat.split('-');
              if(!sups.includes(parseInt(catArray[0]))){
                control = 0;
                $scope.modelData.product_errors[keyControl] = 'Trebuie sa selectati suplimente';
              }
            });
            if(control == 1 && cats.length > 0){
              delete $scope.modelData.product_errors[keyControl];
            }
        }

        $scope.additionals['buttonDisabledProduct'] = {};
        $scope.additionals['getSupplements'] = function (product, productIndex, type) {

           $scope.selectedProductName = product['food_product_name'];
           $scope.selectedProductNavigate = product;
           $scope.selectedProduct = product;
           $scope.selectedSupplementName = '';

           if (angular.isUndefined($scope.additionals.indexSupplement)) {
               $scope.additionals.indexSupplement = 0;
           }

            var productId = product['food_product_id'];

            $scope.additionals['buttonDisabledProduct'][product.food_product_id] = true;

            if ((angular.isUndefined($scope.modelData.product_errors) || $scope.modelData.product_errors == null || $scope.modelData.product_errors == 'null' || Object.keys($scope.modelData.product_errors).length === 0) || $scope.actionSup == 'edit') {
                if ($scope.actionSup == 'edit') {
                    $scope.actionSup = '';
                }
                if (angular.isUndefined($scope.modelData.food_products)) {
                    $scope.modelData.food_products = [];
                } else {
                    $scope.additionals['selectedProduct'] = $scope.additionals['food_products'][productIndex];
                    $scope.additionals['selectedProduct'].food_product_quantity = 1;

                    $scope.additionals['selectedProductClass'] = [];
                    $scope.additionals['selectedProductClass'][productIndex] = 'selected-product';
                }

                if (angular.isUndefined(product['food_product_discount_type'])) {
                    product['food_product_discount_type'] = 0;
                }
                if (angular.isUndefined(product['food_product_discount_value'])) {
                    product['food_product_discount_value'] = 0;
                }

                var p_additional_categories = $scope.additionals['settings']['p_additional_categories'].split(',');
                if ($scope.modelData.shipping_method_id == 4 && p_additional_categories.indexOf(product['food_category_id'].toString()) < 0) {
                    product['food_product_discount_type'] = 0;
                    product['food_product_discount_value'] = 50;
                }

                $scope.selectedProduct = {
                  'food_category_id': product['food_category_id'],
                  'food_product_id': product['food_product_id'],
                  'food_product_code': product['food_product_code'],
                  'food_product_name': product['food_product_name'],
                  'food_product_short_name':$scope.additionals['truncate'](product['food_product_name'], 40),
                  'food_product_price': product['food_product_price'],
                  'food_product_packaging': product['food_product_packaging'],
                  'food_product_discount_type': product['food_product_discount_type'],
                  'food_product_discount_value': product['food_product_discount_value'],
                  'food_product_sgr': product['food_product_sgr'],
                  'sgr_id': product['sgr_id'],
                  'food_product_quantity': 1
                };
                $scope.selectedProductParent = $scope.selectedProduct;

                 if (!angular.isUndefined($scope.modelData['source_incident_id']) && $scope.modelData['source_incident_id'] != 0) {
                      $scope.selectedProduct['food_product_price'] = 0;
                      $scope.selectedProduct['food_product_discount_value'] = 0;
                      $scope.selectedProduct['food_product_new'] = 1;
                 }
                $scope.modelData.food_products.push($scope.selectedProduct);

                $scope.additionals['indexProduct'] = $scope.modelData.food_products.length - 1;

                if (angular.isUndefined($scope.indexSups)){
                  $scope.indexSups = {};
                }
                if (angular.isUndefined($scope.indexSups[$scope.modelData.food_products.length - 1])){
                  $scope.indexSups[$scope.modelData.food_products.length - 1] = 0;
                }

                if (!angular.isUndefined($scope.modelData.order_source)) {
                    var pathSup = $scope.path + '/getSupplements/?productId=' + productId + '&orderSource=' + $scope.modelData.order_source+'&type='+type;
                } else {
                  var pathSup = $scope.path + '/getSupplements/?productId=' + productId+'&type='+type;
                }
                if ($location.path() == $scope.path + '/orderPersonal') {
                   pathSup = pathSup + '&order_type=personal';
                }
                if (!angular.isUndefined($scope.modelData.order_orig_id) && $scope.modelData.order_orig_id != 0 && $scope.modelData.order_orig_id != null && $scope.modelData.order_orig_id != 'null') {
                    pathSup = pathSup + '&order_type=import';
                }
                if (!angular.isUndefined($scope.modelData['source_incident_id']) && $scope.modelData['source_incident_id'] != 0 && $scope.modelData['source_incident_id'] != null && $scope.modelData['source_incident_id'] != 'null') {
                    pathSup = pathSup + '&order_type=incident';
                }
                Crud.get(pathSup)
                        .success(function (data) {
                            if (data.supplements.length > 0) {
                            //if (angular.isUndefined($scope.additionals['controlSupplements'])) {
                                $scope.additionals['controlSupplements'] = [];
                            //  }
                              $scope.additionals['controlSupplements'].push({'controlSupplement':true});
                            }
                            $scope.additionals.indexCategorySupplement = 0;

                            //if (angular.isUndefined($scope.additionals['supplements'])) {
                              $scope.additionals['supplements'] = [];
                            //}

                            angular.forEach(data.supplements, function (item, key) {
                                angular.forEach(item.supplets, function (items, keys) {
                                    items.supplement_parent_index = 0;
                                    if (angular.isUndefined(items.supplement_nos)) {
                                        //items.supplement_nos = 0;
                                    }
                                });
                            });
                            $scope.additionals['supplements'].push(data.supplements);

                            $scope.additionals['checkErrorsSupplement'](productIndex);

                            $timeout(function () {
                                $scope.additionals['buttonDisabledProduct'][product.food_product_id] = false;
                            }, 500);
                        });

                $scope.additionals['updateTotalPrice']();
            }
        }

        $scope.additionals['getSubSupplements'] = function (supplement, productIndex, additionals_supplements, supplementType, type) {

            var supplementId = supplement['supplement_id'];

            $scope.additionals['buttonDisabledProduct'][supplement.food_product_id] = true;

                if (!angular.isUndefined($scope.modelData.order_source)) {
                    var pathSup = $scope.path + '/getSupplements/?productId=' + supplementId + '&orderSource=' + $scope.modelData.order_source+'&type='+type;
                } else {
                    var pathSup = $scope.path + '/getSupplements/?productId=' + supplementId+'&type='+type;
                }
                if ($location.path() == $scope.path + '/orderPersonal') {
                   pathSup = pathSup + '&order_type=personal';
                }
                if (!angular.isUndefined($scope.modelData.order_orig_id) && $scope.modelData.order_orig_id != 0 && $scope.modelData.order_orig_id != null && $scope.modelData.order_orig_id != 'null') {
                    pathSup = pathSup + '&order_type=import';
                }
                if (!angular.isUndefined($scope.modelData['source_incident_id']) && $scope.modelData['source_incident_id'] != 0 && $scope.modelData['source_incident_id'] != null && $scope.modelData['source_incident_id'] != 'null') {
                    pathSup = pathSup + '&order_type=incident';
                }
                Crud.get(pathSup)
                .success(function (data) {
                    if (data.supplements.length > 0) {

                        if (angular.isUndefined($scope.additionals['controlSupplements'])) {
                          $scope.additionals['controlSupplements'] = [];
                        }
                        $scope.additionals['controlSupplements'].push({'controlSupplement':true});
                        supplement.is_parent = 1;

                        if (angular.isUndefined($scope.selectedSupplements)){
                          $scope.selectedSupplements = [];
                        }
                        $scope.selectedSupplements.push(supplement);
                        $scope.selectedProduct = $scope.selectedSupplements[$scope.selectedSupplements.length - 1];

                        $scope.additionals.indexCategorySupplement = 0;

                        if (angular.isUndefined($scope.additionals['supplements'])) {
                          $scope.additionals['supplements'] = [];
                        }
                        angular.forEach(data.supplements, function (item, key) {
                            angular.forEach(item.supplets, function (items, keys) {
                                items.supplement_parent_index = supplement.supplement_index;
                                if (angular.isUndefined(items.supplement_nos)) {
                                    //items.supplement_nos = 0;
                                }
                            });
                        });
                        $scope.additionals['supplements'].push(data.supplements);

                        $scope.additionals['checkErrorsSupplement'](productIndex, $scope.additionals['controlSupplements'].length-1);
                      }

                      $timeout(function () {
                          $scope.additionals['buttonDisabledProduct'][supplement.food_product_id] = false;
                      }, 500);
                });

                $scope.additionals['updateTotalPrice']();
        }

        $scope.additionals['addSupplement'] = function (supplement, supplementValue, productIndex, additionals_supplements, supplementType, keyControl, keySupplets) {

          if (angular.isUndefined($scope.selectedProduct)) {
             $scope.selectedProduct = $scope.selectedProductParent;
          }
          if (angular.isUndefined($scope.selectedProduct)) {
              $scope.selectedProduct = $scope.selectedProductNavigate;
          }
         if (!angular.isUndefined($scope.selectedProduct) && (angular.isUndefined($scope.selectedProduct['supplement_parent_index']) && angular.isUndefined($scope.selectedProduct['supplement_parent_id']))) {
             if (angular.isUndefined($scope.selectedProduct.food_supplements)) {
                $scope.selectedProduct.food_supplements = [];
              }
             $scope.selectedProductSub = $scope.selectedProduct.food_supplements;
           } else {
             if (angular.isUndefined($scope.selectedProduct.sub)) {
                $scope.selectedProduct.sub = [];
              }
             $scope.selectedProductSub = $scope.selectedProduct.sub;
           }

           /* if parent has max_free then all subsupplement has max_free */
           if($scope.selectedProduct['supplement_max_free'] == 1) {
                supplement.supplement_max_free = 1;
           }

            if (!angular.isUndefined($scope.modelData['source_incident_id']) && $scope.modelData['source_incident_id'] != 0) {
                  supplement['supplement_price'] = 0;
                  supplement['supplement_discount_value'] = 0;
             }

             var p_additional_categories = $scope.additionals['settings']['p_additional_categories'].split(',');
             if (!angular.isUndefined(supplement) && !angular.isUndefined(supplement['food_category_id']) && $scope.modelData.shipping_method_id == 4 && p_additional_categories.indexOf(supplement['food_category_id'].toString()) < 0) {
                 supplement['supplement_discount_type'] = 0;
                 supplement['supplement_discount_value'] = 50;
             }

            if (!angular.isUndefined(supplementType)) {
                if (supplementType == 'multiple') {
                    if (supplementValue == true) {

                      if (angular.isUndefined($scope.indexSups[productIndex])) {
                        $scope.indexSups[productIndex] = 0;
                      }
                      $scope.indexSups[productIndex] = $scope.indexSups[productIndex] + 1;
                      //supplement['supplement_index'] = $scope.selectedProductSub.length + 1;
                      supplement['supplement_index'] = $scope.indexSups[productIndex];
                      if (!angular.isUndefined(additionals_supplements['max_free']) && additionals_supplements['max_free'] != '') {
                          var number = 0;
                          angular.forEach($scope.selectedProductSub, function (item, key) {
                              if (parseInt(item.food_category_id) == parseInt(additionals_supplements['food_category_id'])) {
                                  supplement['max_free_no'] = additionals_supplements['max_free'];
                                  number++;
                              }
                              if (number >= parseInt(additionals_supplements['max_free'])) {
                                  supplement.supplement_max_free = 0;
                              }
                          })

                          if (number < parseInt(additionals_supplements['max_free'])) {
                              $scope.selectedProductSub.push(supplement);
                              $scope.selectedProductSub[$scope.selectedProductSub.length - 1].supplement_max_free = 1;
                          } else {
                              $scope.selectedProductSub.push(supplement);
                          }
                      } else {
                          $scope.selectedProductSub.push(supplement);
                      }

                      $scope.additionals['getSubSupplements'](supplement, productIndex, additionals_supplements, supplementType, 'sup');
                    } else {

                      if (!angular.isUndefined(additionals_supplements['max_free']) && additionals_supplements['max_free'] != '') {
                          angular.forEach($scope.selectedProductSub, function (item, key) {
                              if (parseInt(item.food_category_id) == parseInt(additionals_supplements['food_category_id'])) {
                                  supplement['max_free_no'] = additionals_supplements['max_free'];
                              }
                          })
                        }
                        //$scope.additionals['removeSupplement'](productIndex, $scope.selectedProduct, supplement);
                        //$scope.indexSups[productIndex] = $scope.indexSups[productIndex] - 1;

                        $scope.additionals['supplements'][keyControl][$scope.additionals.indexCategorySupplement]['supplets'][keySupplets]['supplement_nos'] = 0;
                        $scope.additionals['cloneSupplement'](supplement, supplementValue, productIndex, 0, $scope.additionals['supplements'][keyControl][$scope.additionals.indexCategorySupplement], 'multiple');
                    }

                    $scope.additionals['updateTotalPrice']();
                }
                if (supplementType == 'single') {
                  //$scope.additionals['nextSupplement']($scope.additionals.indexCategorySupplement);

                  angular.forEach($scope.additionals['supplements'], function (itemSup, keySup) {
                    angular.forEach(itemSup, function (item, key) {
                          angular.forEach(item.supplets, function (items, keys) {
                            if (items.supplement_id+'-'+items.supplement_parent_id+'-'+items.supplement_parent_index == supplementValue) {

                              var pos = $scope.selectedProductSub.findIndex(function (e) {
                                     if (items.supplement_option == 0 && parseInt(items.food_category_id) == parseInt(e.food_category_id)) {
                                     return e;
                                   }
                               });
                               if(pos >= 0){
                                 items['supplement_index'] = $scope.selectedProductSub[pos]['supplement_index'];
                                 $scope.selectedProductSub[pos] = items;
                               } else {
                                 $scope.indexSups[productIndex] = $scope.indexSups[productIndex] + 1;
                                 //items['supplement_index'] = $scope.selectedProductSub.length + 1;
                                 items['supplement_index'] = $scope.indexSups[productIndex];
                                 $scope.selectedProductSub.push(items);
                               }

                            }
                        });
                    });});

                  var supplementArray = supplementValue.split('-');
                  var existingPositionSupplement = $scope.selectedProductSub.findIndex(function (e) {
                       if (e['supplement_id'] == supplementArray[0] && e['supplement_parent_id'] == supplementArray[1] && e['supplement_parent_index'] == supplementArray[2]) {
                         return e;
                       }
                   });
                   if(existingPositionSupplement >= 0){
                     $scope.additionals['getSubSupplements']($scope.selectedProductSub[existingPositionSupplement], productIndex, additionals_supplements, supplementType, 'sup');
                   }

                  $scope.additionals['updateTotalPrice']();
                }
            }
            $scope.additionals['checkErrorsSupplement'](productIndex, keyControl);
        }

        $scope.additionals['cloneSupplement'] = function (supplement, supplementValue, productIndex, supplementNos, additionals_supplements, supplementType) {

            if (!angular.isUndefined($scope.modelData['source_incident_id']) && $scope.modelData['source_incident_id'] != 0) {
                supplement['supplement_price'] = 0;
                supplement['supplement_discount_value'] = 0;
            }
            if (!angular.isUndefined($scope.modelData.food_products[productIndex])) {
                if (angular.isUndefined($scope.modelData.food_products[productIndex].food_supplements)) {
                    $scope.modelData.food_products[productIndex].food_supplements = [];
                }
            }

            if (!angular.isUndefined(supplementType)) {
                if (supplementType == 'multiple') {
                   // if (supplementValue == true) {

                    //  $scope.modelData.food_products[productIndex]['supplements']['multiple']
                        if (!angular.isUndefined($scope.modelData.food_products[productIndex])) {
                            if (angular.isUndefined($scope.modelData.food_products[productIndex].supplements)) {
                                $scope.modelData.food_products[productIndex].supplements = [];
                            }
                            if (angular.isUndefined($scope.modelData.food_products[productIndex].supplements.multiple)) {
                                $scope.modelData.food_products[productIndex].supplements.multiple = [];
                            }
                           // if (angular.isUndefined($scope.modelData.food_products[productIndex].supplements.multiple.length)) {
                           //        $scope.modelData.food_products[productIndex].supplements.multiple = Object.values($scope.modelData.food_products[productIndex].supplements.multiple);
                           // }
                        }

                        var no = 0; var sup = [];
                        if (angular.isUndefined($scope.selectedProduct)) {
                           $scope.selectedProduct = $scope.selectedProductParent;
                        }
                        if (angular.isUndefined($scope.selectedProduct)) {
                            $scope.selectedProduct = $scope.selectedProductNavigate;
                        }
                        if (!angular.isUndefined($scope.selectedProduct) && (angular.isUndefined($scope.selectedProduct['supplement_parent_index']) && angular.isUndefined($scope.selectedProduct['supplement_parent_id']))) {
                             if (angular.isUndefined($scope.selectedProduct.food_supplements)) {
                                $scope.selectedProduct.food_supplements = [];
                              }
                             $scope.selectedProductSub = $scope.selectedProduct.food_supplements;
                        } else {
                            if (angular.isUndefined($scope.selectedProduct.sub)) {
                              $scope.selectedProduct.sub = [];
                            }
                            $scope.selectedProductSub = $scope.selectedProduct.sub;
                        }

                        //angular.forEach($scope.modelData.food_products[productIndex].food_supplements, function (item, key) {
                        angular.forEach($scope.selectedProductSub, function (item, key) {
                            if(supplement['supplement_id'] == item['supplement_id']){
                                   //$scope.modelData.food_products[productIndex].food_supplements.splice(key, 1);
                                  //delete $scope.modelData.food_products[productIndex].food_supplements[key];
                                  //item['supplement_index'] = no;
                                  sup[no] = item;
                                  no++;
                            }
                        });
                        if(supplementNos >= no ) {
                          for (i = 1; i <= supplementNos-no; i++) {
                              var newSupplement = {};
                              newSupplement['extra'] = supplement['extra'];
                              newSupplement['food_category_id'] = supplement['food_category_id'];
                              newSupplement['food_product_id'] = supplement['food_product_id'];
                              newSupplement['regular'] = supplement['regular'];
                              newSupplement['supplement_category_order'] = supplement['supplement_category_order'];
                              newSupplement['supplement_display_menu'] = supplement['supplement_display_menu'];
                              newSupplement['supplement_id'] = supplement['supplement_id'];
                              //  if (!angular.isUndefined(sup[sup.length-1]['supplement_index'])) {
                              //        newSupplement['supplement_index'] = sup[sup.length-1]['supplement_index'] + 1;
                              //  } else {
                              //        newSupplement['supplement_index'] = 0;
                              // }
                              if (angular.isUndefined($scope.indexSups[productIndex])) {
                              $scope.indexSups[productIndex] = 0;
                              }
                              $scope.indexSups[productIndex] = $scope.indexSups[productIndex] + 1;
                              //supplement['supplement_index'] = $scope.selectedProductSub.length + 1;
                              newSupplement['supplement_index'] = $scope.indexSups[productIndex];
                              newSupplement['supplement_name'] = supplement['supplement_name'];
                              newSupplement['supplement_long_name'] = supplement['supplement_name'];
                              //newSupplement['supplement_nos'] = supplement['supplement_nos'];
                              newSupplement['supplement_option'] = supplement['supplement_option'];
                              newSupplement['supplement_packaging'] = supplement['supplement_packaging'];
                              newSupplement['supplement_price'] = supplement['supplement_price'];
                              newSupplement['supplement_type_price'] = supplement['supplement_type_price'];
                              newSupplement['supplement_parent_id'] = supplement['supplement_parent_id'];
                              newSupplement['supplement_parent_index'] = supplement['supplement_parent_index'];
                              newSupplement['supplement_sgr'] = supplement['supplement_sgr'];
                              newSupplement['sgr_id'] = supplement['sgr_id'];
                              newSupplement['supplement_discount_type'] = supplement['supplement_discount_type'];
                              newSupplement['supplement_discount_value'] = supplement['supplement_discount_value'];
                              newSupplement['order_supplement_discount_value'] = supplement['order_supplement_discount_value'];

                              if (!angular.isUndefined(additionals_supplements['max_free']) && additionals_supplements['max_free'] != '') {
                                  var number = 0;
                                  angular.forEach($scope.selectedProductSub, function (item, key) {
                                      if (parseInt(item.food_category_id) == parseInt(additionals_supplements['food_category_id'])) {
                                          newSupplement['max_free_no'] = additionals_supplements['max_free'];
                                          number++;
                                      }
                                      if (number >= parseInt(additionals_supplements['max_free'])) {
                                          newSupplement.supplement_max_free = 0;
                                      }
                                  })

                                  /* if parent has max_free then all subsupplement has max_free */
                                  if($scope.selectedProduct['supplement_max_free'] == 1) {
                                       newSupplement.supplement_max_free = 1;
                                  }

                                  if (number < parseInt(additionals_supplements['max_free'])) {
                                      $scope.selectedProductSub.push(newSupplement);
                                      $scope.selectedProductSub[$scope.selectedProductSub.length - 1].supplement_max_free = 1;
                                  } else {
                                      //sup.push(newSupplement);
                                      $scope.selectedProductSub.push(newSupplement);
                                  }
                              } else {
                                  /* if parent has max_free then all subsupplement has max_free */
                                  if($scope.selectedProduct['supplement_max_free'] == 1) {
                                       newSupplement.supplement_max_free = 1;
                                  }

                                  //sup.push(newSupplement);
                                  //$scope.modelData.food_products[productIndex].food_supplements.push(newSupplement);
                                  $scope.selectedProductSub.push(newSupplement);
                                  // if (angular.isUndefined($scope.modelData.food_products[productIndex]['supplements']['multiple'][newSupplement['supplement_index']])) {
                                  //       $scope.modelData.food_products[productIndex]['supplements']['multiple'][newSupplement['supplement_index']] = {};
                                  //  }
                                  // $scope.modelData.food_products[productIndex]['supplements']['multiple'][newSupplement['supplement_index']][newSupplement['supplement_id']] = true;
                            }
                        }
                     } else {//delete
                          var nos = 0;
                          angular.forEach($scope.selectedProductSub, function (item, key) {
                             if(supplement['supplement_id'] == item['supplement_id']){
                                nos++;
                                if(nos <= no - supplementNos){
                                  for (i = 1; i <= no - supplementNos ; i++) {
                                      $scope.additionals['removeSupplement'](productIndex, $scope.selectedProduct, supplement);
                                      //delete $scope.selectedProductSub[key];
                                      // $scope.modelData.food_products[productIndex].food_supplements.splice(i, 1);
                                      //delete $scope.modelData.food_products[productIndex].food_supplements[key];
                                    }
                                 }
                              }
                          });
                          $scope.selectedProductSub =
                          $scope.selectedProductSub.filter(function (el, key){
                                 return el != null;
                          });
                          $scope.modelData.food_products[productIndex].food_supplements =
                          $scope.modelData.food_products[productIndex].food_supplements.filter(function (el, key){
                                 return el != null;
                          });
                         var crt = 0;
                         angular.forEach($scope.selectedProductSub, function (item, key) {
                            if(supplement['supplement_id'] == item['supplement_id']){
                                item['supplement_index'] = crt;
                                crt++;
                            }
                         });

                         if (!angular.isUndefined($scope.selectedProductSub)) {
                              $scope.modelData.food_products[productIndex].supplements.multiple = [];
                              angular.forEach($scope.selectedProductSub, function (item, key) {
                                 if (angular.isUndefined($scope.modelData.food_products[productIndex].supplements.multiple[item['supplement_index']])) {
                                          $scope.modelData.food_products[productIndex].supplements.multiple[item['supplement_index']] = {};
                                  }

                                  if (!angular.isUndefined($scope.modelData.food_products[productIndex].supplements) && !angular.isUndefined($scope.modelData.food_products[productIndex].supplements.single) ) {
                                      if (angular.isUndefined($scope.modelData.food_products[productIndex].supplements.single.length)) {
                                          var supplements_single = Object.values($scope.modelData.food_products[productIndex].supplements.single);
                                      } else {
                                          var supplements_single = $scope.modelData.food_products[productIndex].supplements.single;
                                      }
                                  }

                                if((!angular.isUndefined($scope.modelData.food_products[productIndex].supplements) && !angular.isUndefined($scope.modelData.food_products[productIndex].supplements.single) && supplements_single.indexOf(item['supplement_id']) === -1  ) || angular.isUndefined($scope.modelData.food_products[productIndex].supplements.single)){
                                    $scope.modelData.food_products[productIndex].supplements.multiple[item['supplement_id']+'-'+item['supplement_parent_id']+'-'+item['supplement_parent_index']] = true;
                                }

                              });
                           }
                       }
                      $scope.additionals['updateTotalPrice']();
                      $scope.additionals['multi'] = $scope.selectedProductSub.length;

                   // } else {
                        /*var pos = $scope.modelData.food_products[productIndex].food_supplements.map(function (e) {
                            return e['supplement_id'];
                        }).indexOf(supplement['supplement_id']);
                        $scope.additionals['removeSupplement'](supplement.supplement_price, productIndex, pos, supplement.supplement_id);
                        */

                       /*
                        angular.forEach($scope.modelData.food_products[productIndex].food_supplements, function (item, key) {
                                if(supplement['supplement_id'] == item['supplement_id'] && supplement['supplement_index'] == item['supplement_index']){
                                        $scope.additionals['removeSupplement'](supplement.supplement_price, productIndex, key, supplement.supplement_id, item['supplement_index'], supplementNos);
                                }
                        });*/
                 //   }
                }
            }
        }

        $scope.additionals['editProduct'] = function (product, index, type, on) {

          $scope.additionals['controlSupplements'] = [];
          $scope.additionals['supplements'] = [];

          //$scope.selectedProductSub = [];

          $scope.type = type;
          if (!angular.isUndefined(on)) {
              $scope.additionals['on'] = true;
          }
          $scope.actionSup = 'edit';

          if(angular.isUndefined(type) || type == 'prod'){
            $scope.additionals['selectedProduct'] = $scope.modelData.food_products[index];
            $scope.additionals['indexProduct'] = index;
            var productId = $scope.additionals['selectedProduct']['food_product_id'];
            //var productIndex = index;
            var productIndex = 0;
            var productParentId = 0;
            var productParentIndex = 0;
            var children = product['food_supplements'];
            $scope.selectedProductName = product['food_product_name'];
            $scope.selectedProductNavigate = product;
            $scope.selectedProduct = product;
          }
          if(type == 'sup'){
            $scope.additionals['indexProduct'] = index;
            var productId = product['supplement_id'];
            var productIndex = product['supplement_index'];
            var productParentId = product['supplement_id'];
            var productParentIndex = product['supplement_index'];
            var children = product['sub'];

            if (angular.isUndefined($scope.selectedSupplements)){
              $scope.selectedSupplements = [];
            }
            $scope.selectedSupplements.push(product);
            $scope.selectedProduct = $scope.selectedSupplements[$scope.selectedSupplements.length - 1];
          }

          if (angular.isUndefined($scope.indexSups)){
            $scope.indexSups = {};
          }
          if (angular.isUndefined($scope.indexSups[$scope.modelData.food_products.length - 1])){
            $scope.indexSups[$scope.modelData.food_products.length - 1] = 0;
          }

          if (!angular.isUndefined($scope.modelData.order_source)) {
              var pathSup = $scope.path + '/getSupplements/?productId=' + productId + '&orderSource=' + $scope.modelData.order_source+'&type='+type;
          } else {
              var pathSup = $scope.path + '/getSupplements/?productId=' + productId+'&type='+type;
          }
          if ($location.path() == $scope.path + '/orderPersonal') {
             pathSup = pathSup + '&order_type=personal';
          }
          if (!angular.isUndefined($scope.modelData.order_orig_id) && $scope.modelData.order_orig_id != 0 && $scope.modelData.order_orig_id != null && $scope.modelData.order_orig_id != 'null') {
              pathSup = pathSup + '&order_type=import';
          }
          if (!angular.isUndefined($scope.modelData['source_incident_id']) && $scope.modelData['source_incident_id'] != 0 && $scope.modelData['source_incident_id'] != null && $scope.modelData['source_incident_id'] != 'null') {
              pathSup = pathSup + '&order_type=incident';
          }

          Crud.get(pathSup)
          .success(function (data) {
              if (data.supplements.length > 0) {
                if (angular.isUndefined($scope.additionals['controlSupplements'])) {
                  //$scope.additionals['controlSupplements'] = [];
                }
                $scope.additionals['controlSupplements'].push({'controlSupplement':true});
              }
              $scope.additionals.indexCategorySupplement = 0;

              if (angular.isUndefined($scope.additionals['supplements'])) {
                    $scope.additionals['supplements'] = [];
              }
              if (angular.isUndefined($scope.additionals.indexSupplement)) {
                    $scope.additionals.indexSupplement = 0;
              }

            if(!angular.isUndefined(children)) {
              // console.log(data.supplements)
              // console.log($scope.additionals['supplements'])
             if(children.length > 0){
              angular.forEach(children, function (itemSup, keySup) {
                angular.forEach(data.supplements, function (item, key) {
                  angular.forEach(item.supplets, function (items, keys) {
                    items.supplement_parent_index = productIndex;

                    if(parseInt(items.supplement_id) == parseInt(itemSup.supplement_id)){
                      if (angular.isUndefined($scope.modelData.food_products[index]['supplements'])) {
                        $scope.modelData.food_products[index]['supplements'] = {};
                      }

                      if (items.supplement_option == 0) {
                        if (angular.isUndefined($scope.modelData.food_products[index]['supplements']['single'])) {
                          $scope.modelData.food_products[index]['supplements']['single'] = [];
                        }
                        if (angular.isUndefined($scope.modelData.food_products[index]['supplements']['single'][0])) {
                          $scope.modelData.food_products[index]['supplements']['single'][0] = [];
                        }

                        $scope.modelData.food_products[index]['supplements']['single'][0][key] = itemSup['supplement_id']+'-'+productParentId+'-'+productIndex;
                      }
                      if (items.supplement_option == 1) {
                        if (angular.isUndefined($scope.modelData.food_products[index]['supplements']['multiple'])) {
                          $scope.modelData.food_products[index]['supplements']['multiple'] = [];
                        }

                        $scope.modelData.food_products[index]['supplements']['multiple'][itemSup['supplement_id']+'-'+productParentId+'-'+productIndex] = true;

                        if(parseInt(items.supplement_id) == parseInt(itemSup.supplement_id) && parseInt(items.supplement_parent_id) == parseInt(itemSup.supplement_parent_id) && parseInt(items.supplement_parent_index) == parseInt(itemSup.supplement_parent_index) ) {
                            var groupArray = children.filter(function (e, i, arr) {
                                if(parseInt(e.supplement_id) == parseInt(itemSup.supplement_id) && parseInt(e.supplement_parent_id) == parseInt(itemSup.supplement_parent_id) && parseInt(items.supplement_parent_index) == parseInt(itemSup.supplement_parent_index) ) {
                                    return true;
                                }
                            });            ;
                            data.supplements[key]['supplets'][keys]['supplement_nos'] = groupArray.length;
                        }
                      }

                    }
                  });
                });
              })
            } else {
                angular.forEach(data.supplements, function (item, key) {
                    angular.forEach(item.supplets, function (items, keys) {
                        items.supplement_parent_index = 0;
                    });
                });
              }
            }
            $scope.additionals['supplements'].push(data.supplements);


         });
          // $scope.additionals['selectedProductClass'] = [];
          // if (!angular.isUndefined($scope.additionals['food_products'])) {
          //     var productIndex = $scope.additionals['food_products'].map(function (e) {
          //         return e['food_product_id'];
          //     }).indexOf($scope.additionals['selectedProduct']['food_product_id']);
          //     $scope.additionals['selectedProductClass'][productIndex] = 'selected-product';
          // }
        }

        $scope.additionals['total_product'] = 0;
        $scope.additionals['updateTotalPrice'] = function () {

            $scope.additionals['total_product'] = 0;
            $scope.additionals['total_product_discount'] = 0;
            $scope.additionals['order_product_sgr'] = 0;

            var total_product_discount = 0;
            var total_supplement_discount = 0;
            angular.forEach($scope.modelData['food_products'], function (itemProduct, keyProduct) {
                if (!angular.isUndefined(itemProduct['food_product_discount_type'])) {
                    if (itemProduct['food_product_discount_type'] == 0) {
                        total_product_discount = total_product_discount + parseFloat(itemProduct.food_product_price * itemProduct.food_product_discount_value / 100) * itemProduct.food_product_quantity;
                    } else {
                        total_product_discount = total_product_discount + parseFloat(itemProduct.food_product_discount_value) * itemProduct.food_product_quantity;
                    }
                }

                $scope.additionals['total_product'] = $scope.additionals['total_product'] + parseFloat(itemProduct.food_product_price) * itemProduct.food_product_quantity + parseFloat(itemProduct.food_product_packaging) * itemProduct.food_product_quantity;

                $scope.additionals['order_product_sgr'] = $scope.additionals['order_product_sgr'] + parseFloat(itemProduct.food_product_sgr) * itemProduct.food_product_quantity;

                var linearArray = $scope.additionals['linearArray'](itemProduct['food_supplements']);
                //angular.forEach(itemProduct.food_supplements, function (itemSupplement, keySupplement) {
                angular.forEach(linearArray, function (itemSupplement, keySupplement) {
                    if (!angular.isUndefined(itemSupplement.supplement_price)) {
                        if (angular.isUndefined(itemSupplement.supplement_max_free) || itemSupplement.supplement_max_free == 0) {
                            if (!angular.isUndefined(itemSupplement['supplement_discount_type']) && itemSupplement['supplement_discount_type'] != null && itemSupplement['supplement_discount_type'] != 'null') {
                                if (itemSupplement['supplement_discount_type'] == 0) {
                                    total_supplement_discount = total_supplement_discount + parseFloat(itemSupplement.supplement_price * itemSupplement.supplement_discount_value / 100) * itemProduct.food_product_quantity;
                                } else {
                                    total_supplement_discount = total_supplement_discount + parseFloat(itemSupplement.supplement_discount_value) * itemProduct.food_product_quantity;
                                }
                            }

                            $scope.additionals['total_product'] = $scope.additionals['total_product'] + parseFloat(itemSupplement.supplement_price) * itemProduct.food_product_quantity + parseFloat(itemSupplement.supplement_packaging) * itemProduct.food_product_quantity;

                            $scope.additionals['order_product_sgr'] = $scope.additionals['order_product_sgr'] + parseFloat(itemSupplement.supplement_sgr) * itemProduct.food_product_quantity;
                        } else {
                            $scope.additionals['order_product_sgr'] = $scope.additionals['order_product_sgr'] + parseFloat(itemSupplement.supplement_sgr) * itemProduct.food_product_quantity;
                        }
                    }
                });

                if (itemProduct.food_product_quantity != '' && itemProduct.food_product_quantity == 0) {
                    $scope.modelData.food_products.splice(keyProduct, 1);
                    $scope.additionals['updateTotalPrice']();
                }
            });

            $scope.additionals['total_product_discount'] = total_product_discount + total_supplement_discount;
            $scope.additionals['total_product'] = $scope.additionals['total_product'] - $scope.additionals['total_product_discount'];

            $scope.additionals['total_product_discount'] = parseFloat($scope.additionals['total_product_discount']);
            $scope.additionals['total_product'] = parseFloat($scope.additionals['total_product']);

            $scope.modelData['order_total'] = $scope.formatDecimal($scope.additionals['total_product']);
            $scope.additionals['order_product_sgr'] = parseFloat($scope.additionals['order_product_sgr']);

            $scope.additionals['applyDiscountCampaign']();
            $scope.additionals['selectAddress']($scope.modelData, $scope.modelData.select_address);

        }

        $scope.additionals['changeQuantityJs'] = function (product) {
           product['food_product_quantity'] = parseInt(product['food_product_quantity']);
           $scope.additionals['updateTotalPrice']();
        }

        $scope.additionals['removeProduct'] = function (productPrice, productQuantity, index) {

            $scope.modelData.food_products.splice(index, 1);
            $scope.additionals['updateTotalPrice']();

            //$scope.additionals['selectedProduct'] = {};
            //$scope.additionals['selectedProduct'].food_product_quantity = 0;
            $scope.additionals['selectedProduct'] = $scope.modelData.food_products[$scope.modelData.food_products.length - 1];
            $scope.additionals['indexProduct'] = $scope.additionals['indexProduct'] - 1;
            if (!angular.isUndefined($scope.additionals['selectedProduct'])) {
                if (!angular.isUndefined($scope.modelData.order_source)) {
                    var pathSup = $scope.path + '/getSupplements/?productId=' + $scope.additionals['selectedProduct']['food_product_id'] + '&orderSource=' + $scope.modelData.order_source+'&type=prod';
                } else {
                    var pathSup = $scope.path + '/getSupplements/?productId=' + $scope.additionals['selectedProduct']['food_product_id']+'&type=prod';
                }
                if ($location.path() == $scope.path + '/orderPersonal') {
                   pathSup = pathSup + '&order_type=personal';
                }
                if (!angular.isUndefined($scope.modelData.order_orig_id) && $scope.modelData.order_orig_id != 0 && $scope.modelData.order_orig_id != null && $scope.modelData.order_orig_id != 'null') {
                    pathSup = pathSup + '&order_type=import';
                }
                if (!angular.isUndefined($scope.modelData['source_incident_id']) && $scope.modelData['source_incident_id'] != 0 && $scope.modelData['source_incident_id'] != null && $scope.modelData['source_incident_id'] != 'null') {
                    pathSup = pathSup + '&order_type=incident';
                }
                Crud.get(pathSup)
                        .success(function (data) {
                            $scope.additionals.indexCategorySupplement = 0;
                            //$scope.additionals['supplements'] = data.supplements;
                            if (angular.isUndefined($scope.additionals['supplements'])) {
                              $scope.additionals['supplements'] = [];
                            }
                            $scope.additionals['supplements'].push(data.supplements);
                        });
            }

            if ($scope.modelData.food_products.length <= 0 || index == $scope.modelData.food_products.length) {
                $scope.additionals['supplements'] = [];
                $scope.modelData.product_errors = {};
                $scope.additionals['selectedProduct'] = {};
                $scope.additionals['selectedProductClass'] = [];
            }

            if (!angular.isUndefined($scope.additionals['selectedProductClass'])) {
                $scope.additionals['selectedProductClass'][index] = '';
            }
        }

        $scope.additionals['getSupplementById'] = function (supplementId, array) {
          var position = array.map(function (e) {
              return e['supplement_id'];
          }).indexOf(parseInt(supplementId));
          if (!angular.isUndefined(position) && position >= 0) {
              return array[position];
          }
        }

        $scope.additionals['controlMentionProduct'] = [];
        $scope.additionals['mentionProduct'] = function (ev, index, keyCode) {

            angular.forEach($scope.modelData.food_products, function (item, key) {
                if (key == index) {
                    if ($scope.additionals['controlMentionProduct'][index] == true) {
                        if (!angular.isUndefined(keyCode)) {
                            if (ev.keyCode === 27) {
                                $scope.additionals['controlMentionProduct'][index] = false;
                            }
                        } else {
                            $scope.additionals['controlMentionProduct'][index] = false;
                        }
                    } else {
                        $scope.additionals['controlMentionProduct'][index] = true;
                    }
                } else {
                    $scope.additionals['controlMentionProduct'][key] = false;
                }
            })
        }

        $scope.additionals['controlClientProduct'] = [];
        $scope.additionals['clientProduct'] = function (ev, index, keyCode) {

            angular.forEach($scope.modelData.food_products, function (item, key) {
                if (key == index) {
                    if ($scope.additionals['controlClientProduct'][index] == true) {
                        if (!angular.isUndefined(keyCode)) {
                            if (ev.keyCode === 27) {
                                $scope.additionals['controlClientProduct'][index] = false;
                            }
                        } else {
                            $scope.additionals['controlClientProduct'][index] = false;
                        }
                    } else {
                        $scope.additionals['controlClientProduct'][index] = true;
                    }
                } else {
                    $scope.additionals['controlClientProduct'][key] = false;
                }
            })
        }

        $scope.additionals['removeSupplement'] = function (productIndex, parent, supplement) {

          if(parseInt(parent['supplement_id']) == parseInt(supplement['supplement_id']) && parseInt(parent['supplement_parent_id']) == parseInt(supplement['supplement_parent_id']) && parseInt(parent['supplement_parent_index']) == parseInt(supplement['supplement_parent_index']) ){
              parentSub = $scope.modelData.food_products[productIndex].food_supplements;
            } else {
              var parentSub = [];
              if(!angular.isUndefined(parent.sub)) {
                parentSub = parent.sub;
              }
              if(!angular.isUndefined(parent.food_supplements)) {
                parentSub = parent.food_supplements;
              }
            }

            var position = parentSub.findIndex(function (e) {
                if (e['supplement_option'] == 1 && e['supplement_id'] == supplement['supplement_id'] && e['supplement_parent_id'] == supplement['supplement_parent_id'] && e['supplement_parent_index'] == supplement['supplement_parent_index']) {
                  return e;
                }
            });

            if(position >= 0){
              parentSub.splice(position, 1);
            }

          if (!angular.isUndefined($scope.modelData.food_products[productIndex].supplements)){
              if (!angular.isUndefined($scope.modelData.food_products[productIndex].supplements.multiple)) {
                  delete $scope.modelData.food_products[productIndex].supplements.multiple[supplement['supplement_id']+'-'+supplement['supplement_parent_id']+'-'+supplement['supplement_parent_index']];
              }
          }

          if(supplement.supplement_max_free = 1) {
            var number = 0;
            angular.forEach(parentSub, function (item, key) {
                if (parseInt(item.food_category_id) == parseInt(supplement.food_category_id)) {
                    number++;
                    if (!angular.isUndefined(supplement.max_free_no) && number <= parseInt(supplement.max_free_no)) {
                        item.supplement_max_free = 1;
                        item.max_free_no = supplement.max_free_no;
                    } else {
                        /* if parent has max_free then all subsupplement has max_free */
                        if(!angular.isUndefined(parent.is_parent) && parent.is_parent == 1 && !angular.isUndefined(parent['supplement_max_free']) && parent['supplement_max_free'] == 1) {

                        } else {
                            item.supplement_max_free = 0;
                        }

                    }
                }
            })
          }

          $scope.additionals['updateTotalPrice']();
        }

        $scope.additionals['nextSupplement'] = function (indexSupplement) {
            // if (indexSupplement < $scope.additionals['supplements'].length - 1) {
            //     $scope.additionals.indexCategorySupplement = indexSupplement + 1;
            // }
            angular.forEach($scope.additionals['supplements'], function (itemSup, keySup) {
              if (indexSupplement < itemSup.length - 1) {
                  $scope.additionals.indexCategorySupplement = indexSupplement + 1;
              }
            });
        }
        $scope.additionals['previousSupplement'] = function (indexSupplement) {
            // if (indexSupplement > 0) {
            //     $scope.additionals.indexCategorySupplement = indexSupplement - 1;
            // }
            angular.forEach($scope.additionals['supplements'], function (itemSup, keySup) {
              if (indexSupplement > 0) {
                  $scope.additionals.indexCategorySupplement = indexSupplement - 1;
              }
            });
        }

        $scope.maxDate = new Date();
        $scope.minDate = '2010-01-01';
        var current_init_date = new Date();
        current_init_date.setHours(0, 0, 0, 0);
        $scope.search.dateFrom = current_init_date;

        $scope.additionals['controlExpandStep'] = [];
        //$scope.additionals['controlExpandStep'][1] = true;
        $scope.additionals['expandStep'] = function (step) {
            $scope.additionals['on'] = false;
            if ($scope.additionals['controlExpandStep'][step] == false || angular.isUndefined($scope.additionals['controlExpandStep'][step])) {
                $scope.additionals['controlExpandStep'][step] = true;
            }
            var interm = [];
            angular.forEach($scope.additionals['controlExpandStep'], function (item, key) {
                if (key != step) {
                    interm[key] = item;
                }
            });
            angular.forEach(interm, function (itemi, keyi) {
                $scope.additionals['controlExpandStep'][keyi] = false;
            });

        }

        $scope.printNP = $window;
        $scope.additionals['printOrderNP'] = function (modelId) {

            Crud.show(modelId, $scope.path)
                    .success(function (data) {

                        var model = data;

                        var address_mention = '';
                        if (!angular.isUndefined(model['address'][model['select_address']])) {
                            if (!angular.isUndefined(model['address'][model['select_address']]['address_mention'])) {
                                address_mention = model['address'][model['select_address']]['address_mention'];
                            }
                        }
                        /*print order*/
                        var popup = $scope.printNP.open('', '_blank', 'width=800,height=300,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no,top=50');
                        popup.document.open();
                        var html = '<div class="order-print">'
                                + '<h2>Nr. comanda: ' + model.order_no + '</h2>'
                                + '<div>Client: ' + model.client_first_name + ' ' + model.client_last_name + '</div>'
                                + '<div>Tel: ' + model.order_phone + '</div>'
                                + '<div>Adresa: str.' + model.street_name;
                        if (model.address_no) {
                            html = html + '<span ng-if=" model.address_no">, nr. ' + model.address_no + '</span>'
                        }
                        if (model.address_block) {
                            html = html + '<span ng-if="model.address_block">, bl. ' + model.address_block + '</span>'
                        }
                        if (model.address_sc) {
                            html = html + '<span ng-if="model.address_sc">, cartier ' + model.address_sc + '</span>'
                        }
                        if (model.address_level) {
                            html = html + '<span ng-if="model.address_level">, et. ' + model.address_level + '</span>'
                        }
                        if (model.address_flat) {
                            html = html + '<span ng-if="model.address_flat">, ap. ' + model.address_flat + '</span>'
                        }
                        if (model.section_name) {
                            html = html + '<span ng-if="model.section_name">, sc. ' + model.section_name + '</span>'
                        }
                        if (model.locality_name) {
                            html = html + '<span ng-if="model.locality_name">, loc. ' + model.locality_name + '</span>'
                        }
                        if (model.county_name) {
                            html = html + '<span ng-if="model.county_name">, jud. ' + model.county_name + '</span>'
                        }
                        if (address_mention) {
                            html = html + '<span ng-if="address_mention"> ( ' + address_mention + ' )</span>'
                        }
                        html = html + '</div>'
                                + '<div>Metoda de plata: ' + model.payment_method_name + '</div>'
                                + '<div>Start comanda: ' + moment(model.order_start).format('DD/MM/YY HH:mm:ss') + '</div>';

                        if (model.food_products) {
                            html = html + '<div class="margin-top">Produse comandate: </div>';
                            angular.forEach(model.food_products, function (item, key) {
                                html = html + '<div class="margin-left margin-top clear">';
                                html = html + '<div class="div-big left">' + $scope.additionals['truncate'](item['food_product_name'], 30) + '</div>';
                                html = html + '<div class="div-small left">x</div>';
                                html = html + '<div class="div-big left">' + item['food_product_quantity'] + '</div>';
                                html = html + '<div class="div-small left"> = </div>';
                                html = html + '<div class="div-mmedium left align-right">' + $scope.formatDecimal(item['food_product_price'] * item['food_product_quantity']) + ' &nbsp; ' + $rootScope.currency + '</div>';
                                /*html = html + '<div class="div-mmedium left align-right">' + $scope.formatDecimal(item['food_product_packaging'] * item['food_product_quantity']) + ' &nbsp; ' + $rootScope.currency + '</div>';*/

                                angular.forEach(item['food_supplements'], function (itemSupplement, keySupplement) {
                                    html = html + '<div class="margin-left clear">';
                                    html = html + '<div class="div-big-sup left">' + $scope.additionals['truncate'](itemSupplement['supplement_name'], 26) + '</div>';
                                    html = html + '<div class="div-small left">x</div>';
                                    html = html + '<div class="div-big left">' + item['food_product_quantity'] + '</div>';
                                    html = html + '<div class="div-small left"> = </div>';
                                    html = html + '<div class="div-mmedium left align-right">' + $scope.formatDecimal(itemSupplement['supplement_price'] * item['food_product_quantity']) + ' &nbsp; ' + $rootScope.currency + '</div>';
                                    /*html = html + '<div class="div-mmedium left align-right">' + $scope.formatDecimal(itemSupplement['supplement_packaging'] * item['food_product_quantity']) + ' &nbsp; ' + $rootScope.currency + '</div>';*/
                                    html = html + '</div>';
                                });
                                html = html + '</div>';
                            });

                            html = html + '<div class="margin-left margin-top clear">';
                            html = html + '<div class="div-big left">&nbsp;</div>';
                            html = html + '<div class="div-small left">&nbsp;</div>';
                            html = html + '<div class="div-big left">Total produse</div>';
                            html = html + '<div class="div-small left"> = </div>';
                            html = html + '<div class="div-mmedium left align-right">' + model['order_amount'] + ' &nbsp; ' + $rootScope.currency + '</div>';
                            html = html + '</div>';

                            if (model['order_packaging'] > 0) {
                                html = html + '<div class="margin-left margin-top clear">';
                                html = html + '<div class="div-big left">&nbsp;</div>';
                                html = html + '<div class="div-small left">&nbsp;</div>';
                                html = html + '<div class="div-big left">Ambalaj</div>';
                                html = html + '<div class="div-small left"> = </div>';
                                html = html + '<div class="div-mmedium left align-right">' + model['order_packaging'] + ' &nbsp; ' + $rootScope.currency + '</div>';
                                html = html + '</div>';
                            }
                            if (model['order_product_discount'] > 0) {
                                html = html + '<div class="margin-left margin-top clear">';
                                html = html + '<div class="div-big left">&nbsp;</div>';
                                html = html + '<div class="div-small left">&nbsp;</div>';
                                html = html + '<div class="div-big left">Discount produse</div>';
                                html = html + '<div class="div-small left"> = </div>';
                                html = html + '<div class="div-mmedium left align-right">' + model['order_product_discount'] + ' &nbsp; ' + $rootScope.currency + '</div>';
                                html = html + '</div>';
                            }
                            if (model['order_client_discount'] > 0) {
                                html = html + '<div class="margin-left margin-top clear">';
                                html = html + '<div class="div-big left">&nbsp;</div>';
                                html = html + '<div class="div-small left">&nbsp;</div>';
                                html = html + '<div class="div-big left">Discount clienti</div>';
                                html = html + '<div class="div-small left"> = </div>';
                                html = html + '<div class="div-mmedium left align-right">' + model['order_client_discount'] + ' &nbsp; ' + $rootScope.currency + '</div>';
                                html = html + '</div>';
                            }
                            if (model['order_loyalty_point_discount'] > 0) {
                                html = html + '<div class="margin-left margin-top clear">';
                                html = html + '<div class="div-big left">&nbsp;</div>';
                                html = html + '<div class="div-small left">&nbsp;</div>';
                                html = html + '<div class="div-big left">Discount pct. fidelizare</div>';
                                html = html + '<div class="div-small left"> = </div>';
                                html = html + '<div class="div-mmedium left align-right">' + model['order_loyalty_point_discount'] + ' &nbsp; ' + $rootScope.currency + '</div>';
                                html = html + '</div>';
                            }
                            if (model['order_shipping'] > 0) {
                                html = html + '<div class="margin-left margin-top clear">';
                                html = html + '<div class="div-big left">&nbsp;</div>';
                                html = html + '<div class="div-small left">&nbsp;</div>';
                                html = html + '<div class="div-big left">Transport</div>';
                                html = html + '<div class="div-small left"> = </div>';
                                html = html + '<div class="div-mmedium left align-right">' + model['order_shipping'] + ' &nbsp; ' + $rootScope.currency + '</div>';
                                html = html + '</div>';
                            }
                            if (model['order_product_sgr'] > 0) {
                                html = html + '<div class="margin-left margin-top clear">';
                                html = html + '<div class="div-big left">&nbsp;</div>';
                                html = html + '<div class="div-small left">&nbsp;</div>';
                                html = html + '<div class="div-big left">Transport</div>';
                                html = html + '<div class="div-small left"> = </div>';
                                html = html + '<div class="div-mmedium left align-right">' + model['order_product_sgr'] + ' &nbsp; ' + $rootScope.currency + '</div>';
                                html = html + '</div>';
                            }
                            if (model['order_discount'] > 0) {
                                html = html + '<div class="margin-left margin-top clear">';
                                html = html + '<div class="div-big left">&nbsp;</div>';
                                html = html + '<div class="div-small left">&nbsp;</div>';
                                html = html + '<div class="div-big left">Discount</div>';
                                html = html + '<div class="div-small left"> = </div>';
                                html = html + '<div class="div-mmedium left align-right">' + model['order_discount'] + ' &nbsp; ' + $rootScope.currency + '</div>';
                                html = html + '</div>';
                            }
                            if (model['tazz_discount'] > 0) {
                                html = html + '<div class="margin-left margin-top clear">';
                                html = html + '<div class="div-big left">&nbsp;</div>';
                                html = html + '<div class="div-small left">&nbsp;</div>';
                                html = html + '<div class="div-big left">Tazz Discount</div>';
                                html = html + '<div class="div-small left"> = </div>';
                                html = html + '<div class="div-mmedium left align-right">' + model['tazz_discount'] + ' &nbsp; ' + $rootScope.currency + '</div>';
                                html = html + '</div>';
                            }
                            if (model['order_shipping'] > 0 || model['order_product_sgr'] > 0 || model['order_discount'] > 0 || model['tazz_discount'] > 0 || model['order_product_discount'] > 0 || model['order_client_discount'] > 0 || model['order_loyalty_point_discount'] > 0) {
                                html = html + '<div class="margin-left margin-top clear">';
                                html = html + '<div class="div-big left">&nbsp;</div>';
                                html = html + '<div class="div-small left">&nbsp;</div>';
                                html = html + '<div class="div-big left">Total</div>';
                                html = html + '<div class="div-small left"> = </div>';
                                html = html + '<div class="div-mmedium left align-right">' + $scope.formatDecimal(model['order_total']) + ' &nbsp; ' + $rootScope.currency + '</div>';
                                html = html + '</div>';
                            }
                            if (model['order_partial'] != 0) {
                                html = html + '<div class="margin-left margin-top clear">';
                                html = html + '<div class="div-big left">&nbsp;</div>';
                                html = html + '<div class="div-small left">&nbsp;</div>';
                                html = html + '<div class="div-big left">Plata partiala</div>';
                                html = html + '<div class="div-small left"> = </div>';
                                html = html + '<div class="div-mmedium left align-right">' + model['order_partial'] + ' &nbsp; ' + $rootScope.currency + '</div>';
                                html = html + '</div>';
                            }

                        }

                        if (model.order_mention) {
                            html = html + '<div class="margin-top">Mentiuni: ' + model.order_mention + '</div>'
                        }
                        if (model.order_planning) {
                            html = html + '<div class="margin-top">Programare comanda: ' + model.order_planning + '</div>'
                        }
                        if (model.order_packets) {
                            html = html + '<div class="margin-top">Nr.pachete: ' + model.order_packets + '</div>'
                        }
                        if (model.driver_name) {
                            html = html + '<div class="margin-top">Sofer: ' + model.driver_name + '</div>'
                        }
                        html = html + '<div></div>';

                        popup.document.write('<!DOCTYPE html><html><head><title>Nr. comanda: ' + model.order_no + '</title>'
                                + '<link rel="stylesheet" type="text/css" href="/css/print.css" />'
                                + '</head><body onload="window.print(); window.close();">'
                                + html
                                + '</body></html>');
                        //popup.document.close();
                        /*end print order*/
                    });
        }

        /* validate order */
        $scope.validates = function (ev, path, model, index) {
            Crud.get($scope.path + '/saveOrderMode?order_id=' + model.id)
                    .success(function (management) {
                        if (management.current.order_id == parseInt(model.id) && management.current.order_by == $rootScope.session.user.id) {

                            $scope.additionals['invalid'] = '';
                            $mdDialog.show({
                                controller: DialogController,
                                templateUrl: 'validateDialog.tmpl.html',
                                parent: angular.element(document.body),
                                targetEvent: ev,
                                clickOutsideToClose: true,
                                onRemoving: function (event, removePromise) {
                                    Crud.get(path + '/closeOrderMode?order_id=' + model.id)
                                            .success(function (data) {
                                            });
                                },
                                locals: {
                                    pathTemplate: $scope.pathTemplate,
                                    additionals: $scope.additionals,
                                    models: $scope.modelsPreloaded,
                                    model: model
                                }
                            }).then(function () {

                            });

                            DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'additionals', 'models', 'model'];

                            function DialogController($scope, $mdDialog, pathTemplate, additionals, models, model) {
                                $scope.pathTemplate = pathTemplate;
                                $scope.modelsPreloaded = models;
                                $scope.modelDataValidate = model;
                                $scope.cancel = function () {
                                    $mdDialog.cancel();
                                    if (!angular.isUndefined(model)) {
                                        Crud.get(path + '/closeOrderMode?order_id=' + model.id)
                                                .success(function (data) {
                                                });
                                    }
                                };
                                $scope.additionals = additionals;

                                /* validate order */
                                $scope.validatesOrder = function () {
                                    $scope.additionals['buttonDisabled'] = true;
                                    $scope.isLoading = true;
                                    var post = {
                                        'id': model.id,
                                        'delivery_time': $scope.modelDataValidate.delivery_time,
                                        'route': 'validates'
                                    };
                                    //Crud.get(path + '/validates/' + model.id)
                                    Crud.post('form-urlencoded', post, path + '/validates')
                                            .success(function (data) {
                                                if (!angular.isUndefined(data.invalid)) {
                                                    $scope.additionals['invalid'] = data.invalid;
                                                } else {
                                                    model['order_status'] = 1;
                                                    //$scope.additionals['printOrderBC'](model);

                                                    /*if (!angular.isUndefined($scope.modelsPreloaded)) {
                                                     var position = $scope.modelsPreloaded.map(function (e) {
                                                     return e['id'];
                                                     }).indexOf(model.id);
                                                     $scope.modelsPreloaded.splice(position, 1);
                                                     }*/
                                                     if ((model['order_planning'] != null && model['order_planning'] != 'null' && model['order_planning'] != '' && moment().format('DD/MM/YYYY') == moment(model.order_planning).format('DD/MM/YYYY')) || (model['order_planning'] == null || model['order_planning'] == 'null' || model['order_planning'] == '')
                                                    ) {
                                                      var post = {};
                                                      post['id'] = model.id;
                                                      post['route'] = 'printOrderAsincron';
                                                      $scope.additionals['printOrderAsincron'](path, post);
                                                    }

                                                    if (!angular.isUndefined(data.controlTazz)) {
                                                      if (!angular.isUndefined(data.controlTazz.order_orig_id) && data.controlTazz.order_orig_id != 0) {
                                                          var post = {};
                                                          post['order_orig_id'] = data.controlTazz.order_orig_id;
                                                          post['delivery_time'] = data.controlTazz.delivery_time;
                                                          post['route'] = 'responseTazz';
                                                          $scope.additionals['responseTazz'](path, post);
                                                      }
                                                    }
                                                    // var postCbms = {};
                                                    // postCbms['order'] = {'id': model.id};
                                                    // postCbms['route'] = 'cbms';
                                                    // $scope.additionals['cbms'](path, postCbms);

                                                }
                                                $scope.isLoading = false;
                                                $mdDialog.hide();
                                                $scope.additionals['buttonDisabled'] = false;
                                                /*if (!angular.isUndefined(model)) {
                                                 Crud.get(path + '/closeOrderMode?order_id=' + model.id)
                                                 .success(function (data) {
                                                 });
                                                 }*/
                                            })
                                            .error(function (data) {
                                                $scope.errors = data.errors;
                                                $scope.isLoading = false;
                                                $scope.additionals['buttonDisabled'] = true;
                                            });
                                };
                            }
                        }
                    });
        };

        /* cancellation order */
        $scope.cancellationModel = function (ev, path, model) {

           $scope.actionLabel = 'Anulare comanda';
           $scope.modelData[$scope.additionals['columnDisplay']] = model.order_no;

            Crud.get($scope.path + '/saveOrderMode?order_id=' + model.id)
                    .success(function (management) {
                        if (management.current.order_id == parseInt(model.id) && management.current.order_by == $rootScope.session.user.id) {

                            $scope.additionals['invalid'] = '';
                            $mdDialog.show({
                                controller: DialogController,
                                templateUrl: 'cancelDialog.tmpl.html',
                                parent: angular.element(document.body),
                                targetEvent: ev,
                                clickOutsideToClose: true,
                                onRemoving: function (event, removePromise) {
                                    Crud.get(path + '/closeOrderMode?order_id=' + model.id)
                                            .success(function (data) {
                                            });
                                },
                                locals: {pathTemplate: $scope.pathTemplate, additionals: $scope.additionals}
                            }).then(function (cancellationOrder) {
                            });

                            DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'additionals'];

                            function DialogController($scope, $mdDialog, pathTemplate, additionals) {
                                $scope.pathTemplate = pathTemplate;
                                $scope.cancel = function () {
                                    $mdDialog.cancel();
                                    if (!angular.isUndefined(model)) {
                                        Crud.get(path + '/closeOrderMode?order_id=' + model.id)
                                                .success(function (data) {
                                                });
                                    }
                                };
                                $scope.additionals = additionals;

                                /* cancel order */
                                if (angular.isUndefined($scope.modelDataCancellation)) {
                                    $scope.modelDataCancellation = {};
                                }
                                $scope.modelDataCancellation.reason_cancellation = model.reason_cancellation;
                                $scope.cancellationOrder = function () {
                                    $scope.additionals['buttonDisabled'] = true;
                                    $scope.isLoading = true;
                                    var post = {};
                                    post['route'] = 'cancellation';
                                    post['id'] = model.id;
                                    post['reason_cancellation'] = $scope.modelDataCancellation.reason_cancellation;

                                    Crud.post('form-urlencoded', post, path + '/cancellation')
                                            .success(function (data) {
                                                if (!angular.isUndefined(data.invalid)) {
                                                    $scope.additionals['invalid'] = data.invalid;
                                                } else {
                                                    model['order_status'] = 2;
                                                }
                                                $scope.modelDataCancellation = {};
                                                $scope.isLoading = false;
                                                $mdDialog.hide();
                                                $scope.additionals['buttonDisabled'] = false;
                                                if (!angular.isUndefined(model)) {
                                                    Crud.get(path + '/closeOrderMode?order_id=' + model.id)
                                                            .success(function (data) {
                                                            });
                                                }

                                            })
                                            .error(function (data) {
                                                $scope.errors = data.errors;
                                                $scope.isLoading = false;
                                                $scope.additionals['buttonDisabled'] = false;
                                            });
                                };
                            }
                        }
                    });
        };

        $scope.timer = function (date, minDiff) {
            var start = date;
            var end = moment();

            var duration = moment.duration(end.diff(start));
            durations = duration.as('milliseconds');
             if (!angular.isUndefined(minDiff)) {
                durations = durations + minDiff*60*1000;
            }
            if(durations > 0){
                return moment.utc(durations).format('HH : mm : ss');
            } else {
                return '00 : 00 : 00';
            }
        }

        $scope.reqTazz = function (model) {
          Crud.get($scope.path + '/makeTazzResponse?order_id=' + model['id'])
              .success(function (data) {
              });
        }

        $scope.getNotifications = function (model) {
          Crud.get($scope.path + '/getNotifications?order_id=' + model['id'])
              .success(function (data) {
              });
        }

        $scope.formatDateOrder = function (date) {
            return moment(date).format('DD MMM');
        }

        $scope.additionals['cbms'] = function (path, post) {
            Crud.post('form-urlencoded', post, path + '/cbms')
                .success(function (data) {
                });
        }

        $scope.additionals['responseTazz'] = function (path, post) {
            Crud.post('form-urlencoded', post, path + '/responseTazz')
                .success(function (data) {
                });
        }

        $scope.additionals['printOrderAsincron'] = function (path, post, originalStatus) {
            post['originalStatus'] = originalStatus;
            Crud.post('form-urlencoded', post, path + '/printOrderAsincron')
                    .success(function (dataPrint) {
                        if (!angular.isUndefined(dataPrint.errors_print)) {
                            if (dataPrint.errors_print != '') {

                                $mdDialog.show({
                                    controller: DialogController,
                                    templateUrl: 'printOrderAsincronDialog.tmpl.html',
                                    parent: angular.element(document.body),
                                    //targetEvent: ev,
                                    clickOutsideToClose: true,
                                    locals: {
                                        pathTemplate: $scope.pathTemplate,
                                        error: dataPrint,
                                        additionals: $scope.additionals
                                    }
                                }).then();
                                DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'error', 'additionals'];

                                function DialogController($scope, $mdDialog, pathTemplate, error, additionals) {
                                    $scope.pathTemplate = pathTemplate;
                                    $scope.cancel = function () {
                                        $mdDialog.cancel();
                                    };
                                    $scope.additionals = additionals;
                                    $scope.additionals['buttonDisabled'] = false;

                                    $scope.errors_print = dataPrint.errors_print;
                                    $scope.errors = error;
                                }
                            }
                        }
                    })
                    .error(function (dataPrint) {

                    });
        }

        $scope.printOrder = function (ev, path, modelId, doc) {

            $scope.additionals['buttonDisabled'] = true;
            var post = {};
            post['id'] = modelId;
            post['route'] = 'printOrder';
            post['doc'] = doc;

            Crud.post('form-urlencoded', post, path + '/printOrder')
                    .success(function (data) {
                        $scope.additionals['buttonDisabled'] = false;
                    })
                    .error(function (data) {

                        $mdDialog.show({
                            controller: DialogController,
                            templateUrl: 'printOrderDialog.tmpl.html',
                            parent: angular.element(document.body),
                            targetEvent: ev,
                            clickOutsideToClose: true,
                            locals: {pathTemplate: $scope.pathTemplate, error: data, additionals: $scope.additionals}
                        }).then(function (destroyModel) {
                        });
                        DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'error', 'additionals'];

                        function DialogController($scope, $mdDialog, pathTemplate, error, additionals) {
                            $scope.pathTemplate = pathTemplate;
                            $scope.cancel = function () {
                                $mdDialog.cancel();
                            };
                            $scope.additionals = additionals;
                            $scope.additionals['buttonDisabled'] = false;

                            $scope.errors = error.errors;
                        }
                    });

        }

        $scope.currentDate = moment().format('DD MMM');
        var midnight = "11:59:59 pm";
        var now = null;

        if ($location.path() == $scope.path + '/getOrder' || $route.current.$$route.originalPath.split(':')[0] == $scope.path + '/view/') {

          $rootScope.stopTimerOrder = $interval(function () {
            if (!angular.isUndefined($scope.additionals.showData) && Object.keys($scope.additionals.showData).length !== 0) {
              $scope.additionals.timerShowOrder = $scope.timer($scope.additionals.showData.validated_at);
            }
            if (!angular.isUndefined($scope.models) && $scope.models.length > 0) {
              angular.forEach($scope.models, function (item, key) {
                    if ($location.path() == $scope.path + '/getOrder') {
                       item.timerOrder = $scope.timer(item.validated_at);
                     }

                   if ($route.current.$$route.originalPath.split(':')[0] == $scope.path + '/view/') {
                        if(item['order_planning'] != null && item['order_planning'] != ''){
                           item.timerOrderPlann = $scope.timer(item['order_planning'], item['planned_time']);
                        } else {
                          item.timerOrder = $scope.timer(item.validated_at);
                        }

                        item.class = ((
                            ($scope.timer(item['validated_at']) > '00 : 40 : 00' && item['order_planning'] == null) || ($scope.timer(item['order_planning'], item['planned_time']) > '00 : 40 : 00' && item['order_planning'] != null && item['order_planning'] != '') ) &&  item['source_incident_id'] == 0 && item['has_delivery'] == 0 ? 'black' : '' ) || (item['source_incident_id'] != 0 ? 'green' : '') || (item['has_delivery'] != 0 ? 'yellow' : '');

                            if($scope.timer(item['order_planning'], item['planned_time']) == '00 : 00 : 00' && item['order_planning'] != null && item['order_planning'] != ''){
                              item.disablePlann = true;
                            } else {
                              item.disablePlann = false;
                            }

                            if(($scope.timer(item['order_planning'], item['planned_time']) != '00 : 00 : 00' && item['order_planning'] != null && item['order_planning'] != '') || ($scope.timer(item['validated_at'], item['planned_time']) != '00 : 00 : 00' && item['order_planning'] == null)){
                              item.checkPlann = true;
                            } else {
                              item.checkPlann = false;
                            }

                            model = item;
                            /* automat request Tazz */
                            if (!angular.isUndefined($scope.kitchen)  && $scope.kitchen['kitchen_center'] == 1) {
                                 if(!angular.isUndefined(model)  && !angular.isUndefined(model['order_source'])  && model['order_source'] == 5 && !angular.isUndefined(model['order_planning'])  && model['order_planning'] != null &&  model['order_planning'] != 'null' &&  model['order_planning'] != ''){
                                      now = moment();
                                      nowH = now.add(1, "hours");
                                      nowHour = nowH.format("HH:mm:ss");

                                      var nowS = nowH.add(1, "seconds");
                                      nowSec =nowS.format("HH:mm:ss");

                                      if (nowHour <= moment(model['order_planning']).format("HH:mm:ss") &&  moment(model['order_planning']).format("HH:mm:ss") < nowSec) {
                                           $scope.reqTazz(model);
                                      }
                              }
                            }
                            /* end automat request Tazz */

                            /* automat confirmation */
                            if(!angular.isUndefined(model) && !angular.isUndefined(model['order_planning'])  && model['order_planning'] != null &&  model['order_planning'] != 'null' &&  model['order_planning'] != '' && !angular.isUndefined(model['control_additionals_categories'])  && model['control_additionals_categories'] == 1){

                                    now = moment();
                                    nowH = now.add(model['planned_time'], "minutes");
                                    nowHour = nowH.format("HH:mm:ss");

                                    var nowS = nowH.add(1, "seconds");
                                    nowSec = nowS.format("HH:mm:ss");

                                    if (nowHour <= moment(model['order_planning']).format("HH:mm:ss") &&  moment(model['order_planning']).format("HH:mm:ss") < nowSec) {
                                           $scope.sendOrder(window.event, $scope.path, model);
                                    }
                            }
                            /* end automat confirmation */

                            /* send automat notifications */
                            if(!angular.isUndefined(model) && !angular.isUndefined(model['order_planning'])  && model['order_planning'] != null &&  model['order_planning'] != 'null' &&  model['order_planning'] != ''){

                                    now = moment();
                                    nowH = now.add(60, "minutes");
                                    nowHour = nowH.format("HH:mm:ss");

                                    var nowS = now.add(-1, "seconds");
                                    nowSec = nowS.format("HH:mm:ss");
                                    //console.log(nowSec)
                                    //console.log(moment().format("HH:mm:ss") +'<='+moment(model['order_planning']).format("HH:mm:ss")+'<='+nowHour)

                                    if (moment(model['order_planning']).format("HH:mm:ss") <= nowHour &&  moment(model['order_planning']).format("HH:mm:ss") >= moment().format("HH:mm:ss")  &&  moment(model['order_planning']).format("HH:mm:ss") > nowSec) {
                                         $scope.getNotifications(model);
                                    }
                            }
                            /* end send automat notifications */

                  }
              });
            }

            now = moment().format("h:mm:ss a");
            if (now === midnight) {
                $scope.currentDate = moment().add(1, 'days').format('DD MMM');
            }
          }, 1000);

        }

        $scope.cancelSearchOrderNot0 = function (ev, path) {
            $scope.search = {};

            if ($scope.controlSearchOrder == 1) {
                $scope.getOrders(path, 1, perPage, 'not0')
            }
            angular.element(document.querySelector('mdp-date-picker .md-input-has-value')).removeClass('md-input-has-value');
            angular.element(document.querySelector('mdp-date-picker .md-input-invalid')).removeClass('md-input-invalid');
            angular.element(document.querySelector('mdp-date-picker .md-input-has-value')).removeClass('md-input-has-value');
            angular.element(document.querySelector('mdp-date-picker .md-input-invalid')).removeClass('md-input-invalid');
            var form = document.getElementById('search-form');
            form.reset();

            $timeout($scope.removeDate, 500);

        }

        $scope.total = [];
        var perPage = 5;
        var perPageKitchen = 10;
        $scope.getOrders = function (path, offset, per_page, orderStatus) {
            if (angular.isUndefined(per_page) || per_page == 'undefined') {
                if (!angular.isUndefined($scope.kitchenId)) {
                    per_page = perPageKitchen;
                } else {
                    per_page = perPage;
                }
            }
            $scope.additionals['buttonDisabledPagination'] = true;
            $scope.rangeUpdated = [];
            if (angular.isUndefined($scope.no_pagesUpdated)) {
                $scope.no_pagesUpdated = 1;
            }
            $scope.isLoadingPaginationUpdated = true;
            $scope.$watch('no_pagesUpdated', function (item) {
                item = $scope.no_pagesUpdated;
            }, true);

            if ($scope.controlSearchOrder == 1) {
                $scope.search['route'] = 'search';
                var pathOrder = $scope.path + '/search?page=' + offset + '&per_page=' + per_page;
                if (!angular.isUndefined(orderStatus)) {
                    pathOrder = pathOrder + '&orderStatus=' + orderStatus;
                }
                var crud = Crud.post('form-urlencoded', $scope.search, pathOrder);
            } else {

                if ($scope.searchControl == true) {

                    $scope.search['route'] = 'search';
                    if ($location.path() != $scope.path + '/orderPlanned'){
                      $scope.search['order_status'] = 1;
                    }
                    var pathOrder = $scope.path + '/search?page=' + offset + '&per_page=' + per_page;
                    if (!angular.isUndefined($scope.kitchenId)) {
                        pathOrder = pathOrder + '&kitchenId=' + $scope.kitchenId;
                    }
                    var crud = Crud.post('form-urlencoded', $scope.search, pathOrder);
                } else {
                    var pathOrder = $scope.path + '/index?page=' + offset + '&per_page=' + per_page;
                    if (!angular.isUndefined($scope.typeView)) {
                        pathOrder = pathOrder + '&typeView=' + $scope.typeView;
                    }
                    if (!angular.isUndefined($scope.kitchenId)) {
                        pathOrder = pathOrder + '&kitchenId=' + $scope.kitchenId;
                    }
                    if (!angular.isUndefined(orderStatus)) {
                        pathOrder = pathOrder + '&orderStatus=' + orderStatus;
                    }
                    var crud = Crud.get(pathOrder);
                }
            }
            crud.success(function (data) {
                if (!angular.isUndefined(data.invalid)) {
                    $scope.additionals['invalid'] = data.invalid;
                } else {
                    if (!angular.isUndefined(data.data)) {
                        if (data.data.length > 0) {
                            if (!angular.isUndefined($scope.kitchenId)) {
                                if (angular.isUndefined($scope.additionals['products'])) {
                                    $scope.additionals['products'] = {};
                                }
                                angular.forEach(data.data, function (item, index) {

                                    /* calculate times in sections */
                                    $scope.additionals['calcProcess'](item, 'Kitchen');
                                    /* end calculate times in sections */

                                    $scope.additionals['updateKitchenButton'](item);

                                });

                            }

                            $scope.stop = data.next_page_url;
                            $scope.fromUpdated = data.from;
                            $scope.toUpdated = data.to;
                            $scope.totalUpdated = data.total;
                            $scope.no_pagesUpdated = Math.ceil(data.total / data.per_page);

                            if (per_page == 0) {
                                $scope.rangeUpdated = [{}];
                            } else {
                                for (var i = 0; i < $scope.no_pagesUpdated; i++) {
                                    $scope.rangeUpdated[i] = i;
                                }
                            }

                            $scope.models = data.data;
                            $scope.models.per_page = data.per_page;
                            $scope.models.current_page = data.current_page;

                        } else {
                            $scope.models = [];
                        }
                        $scope.orders_by_day = data.orders_by_day;
                        if (!angular.isUndefined($scope.total)) {
                            $scope.total['order'] = data.total;
                        }
                    } else {
                        $scope.orders_by_day = data.orders_by_day;
                        $scope.models = data.data;
                        if (!angular.isUndefined($scope.total)) {
                          $scope.total['order'] = data.total;
                        }
                    }

                }
                $scope.isLoadingPaginationUpdated = false;
                // if ($scope.searchControl == true) {
                //     $scope.additionals['buttonDisabledView'] = false;
                // } else {
                //     $scope.additionals['buttonDisabledPagination'] = false;
                // }
                $scope.additionals['buttonDisabledPagination'] = false;
            });

        };

        $scope.getOrdersPreloaded = function (path, offset, per_page, orderStatus) {

            if (angular.isUndefined(per_page) || per_page == 'undefined') {
                per_page = perPage;
            }
            $scope.additionals['buttonDisabledPagination'] = true;
            $scope.rangePreloaded = [];
            if (angular.isUndefined($scope.no_pagesPreloaded)) {
                $scope.no_pagesPreloaded = 1;
            }
            $scope.isLoadingPaginationPreloaded = true;
            $scope.$watch('no_pagesPreloaded', function (item) {
                item = $scope.no_pagesPreloaded;
            }, true);

            var pathOrder = $scope.path + '/index?page=' + offset + '&per_page=' + per_page + '&typeView=' + $scope.typeView;
            if (!angular.isUndefined(orderStatus)) {
                pathOrder = pathOrder + '&orderStatus=' + orderStatus;
            }
            var crud = Crud.get(pathOrder);
            crud.success(function (data) {
                if (!angular.isUndefined(data.invalid)) {
                    $scope.additionals['invalid'] = data.invalid;
                } else {
                    $scope.stopPreloaded = data.next_page_url;
                    $scope.fromPreloaded = data.from;
                    $scope.toPreloaded = data.to;
                    $scope.totalPreloaded = data.total;
                    $scope.no_pagesPreloaded = Math.ceil(data.total / data.per_page);

                    if (per_page == 0) {
                        $scope.rangePreloaded = [{}];
                    } else {
                        for (var i = 0; i < $scope.no_pagesPreloaded; i++) {
                            $scope.rangePreloaded[i] = i;
                        }
                    }
                    $scope.modelsPreloaded = data.data;
                    $scope.modelsPreloaded.per_page = data.per_page;
                    $scope.modelsPreloaded.current_page = data.current_page;
                }
                $scope.isLoadingPaginationPreloaded = false;
                $scope.additionals['buttonDisabledPagination'] = false;
            });

        };

        $scope.getOrdersHistory = function (path, offset, per_page, clientId, callId) {

          if ($location.path() != $scope.path + '/orderPersonal') {
            if (angular.isUndefined(per_page) || per_page == 'undefined') {
                per_page = perPage;
            }
            if (!angular.isUndefined(callId)) {
                $scope.callIdHistory = callId;
            }
            $scope.additionals['buttonDisabledPagination'] = true;
            $scope.rangeHistory = [];
            if (angular.isUndefined($scope.no_pagesHistory)) {
                $scope.no_pagesHistory = 1;
            }
            $scope.isLoadingPaginationHistory = true;
            $scope.$watch('no_pagesHistory', function (item) {
                item = $scope.no_pagesHistory;
            }, true);

            var pathOrder = $scope.path + '/getHistoryOrder?page=' + offset + '&per_page=' + per_page + '&clientId=' + clientId;
            var crud = Crud.get(pathOrder);
            crud.success(function (data) {
                if (!angular.isUndefined(data.invalid)) {
                    $scope.additionals['invalid'] = data.invalid;
                } else {

                    if (!angular.isUndefined(data.data)) {
                        if (data.data.length <= 0) {
                            $scope.modelsHistory = [];
                        } else {
                            if (angular.isUndefined($scope.modelsHistory)) {
                                $scope.modelsHistory = [];
                            }
                            angular.forEach(data.data, function (item, index) {
                                item.callId = $scope.callIdHistory;
                            });
                        }
                        $scope.fromHistory = data.from;
                        $scope.stopHistory = data.next_page_url;
                        $scope.toHistory = data.to;
                        $scope.totalHistory = data.total;
                        $scope.no_pagesHistory = Math.ceil(data.total / data.per_page);

                        if (per_page == 0) {
                            $scope.rangeHistory = [{}];
                        } else {
                            for (var i = 0; i < $scope.no_pagesHistory; i++) {
                                $scope.rangeHistory[i] = i;
                            }
                        }
                        $scope.modelsHistory = data.data;
                        $scope.modelsHistory.per_page = data.per_page;
                        $scope.modelsHistory.current_page = data.current_page;
                    }
                }
                $scope.isLoadingPaginationHistory = false;
                $scope.additionals['buttonDisabledPagination'] = false;
            });
          }

        };

        $scope.cancelOrder = function (ev, model) {

            //$scope.modelData = {};
            $scope.additionals['function'](ev, {});

            $scope.modelsHistory = [];
            $scope.errors = {};
            $scope.action = 'store';
            $scope.additionals['total_product'] = 0;
            $scope.additionals['order_product_sgr'] = 0;
            $scope.additionals['closeStep'](1);
            $scope.additionals['controlCategories'] = false;
            $scope.additionals['controlProducts'] = false;
            $scope.additionals['controlMentionProduct'] = [];
            $scope.additionals['controlClientProduct'] = [];

            $scope.additionals['supplements'] = [];
            $scope.additionals['selectedProduct'] = {};
            $scope.additionals['selectedProduct'].food_product_quantity = 0;
            $scope.additionals['selectedProductClass'] = [];

            $scope.additionals['selectedItemClientFirstName'] = null;
            $scope.additionals['selectedItemClientLastName'] = null;

            $scope.additionals['closeTime']();

            if (!angular.isUndefined(model)) {
                $scope.closeOrderMode(ev, $scope.path, model.id);
            }

            $scope.additionals['searchTermCategory'] = '';
            $scope.additionals['searchTermProduct'] = '';
            $scope.additionals['searchTermSupplement'] = '';
            $scope.lastOrderClient = '';
            $scope.modelsHistory = [];
            $scope.additionals.showData = {};

        };

        $scope.additionals['controlExpandAddress'] = [];
        $scope.additionals['controlExpandAddress'][0] = true;
        $scope.additionals['expandAddress'] = function (keyAddress) {
            if ($scope.additionals['controlExpandAddress'][keyAddress] == true) {
                $scope.additionals['controlExpandAddress'][keyAddress] = false;
            } else {
                $scope.additionals['controlExpandAddress'][keyAddress] = true;
            }
        }

        /* remove fields */
        $scope.additionals['removeFields'] = function (field, modelData, keyAddress) {
            switch (field) {
                case 'county':
                    modelData.address[keyAddress].locality_name = '';
                    modelData.address[keyAddress].section_name = '';
                    modelData.address[keyAddress].street_name = '';
                    /*modelData.address[keyAddress].address_no = '';
                     modelData.address[keyAddress].address_section = '';
                     modelData.address[keyAddress].address_block = '';
                     modelData.address[keyAddress].address_level = '';
                     modelData.address[keyAddress].address_flat = '';
                     modelData.address[keyAddress].address_type = '';*/
                    break;

                case 'locality':
                    modelData.address[keyAddress].section_name = '';
                    modelData.address[keyAddress].street_name = '';
                    /*modelData.address[keyAddress].address_no = '';
                     modelData.address[keyAddress].address_section = '';
                     modelData.address[keyAddress].address_block = '';
                     modelData.address[keyAddress].address_level = '';
                     modelData.address[keyAddress].address_flat = '';
                     modelData.address[keyAddress].address_type = '';*/
                    break;

                case 'section':
                    /* modelData.address[keyAddress].street_name = '';
                     modelData.address[keyAddress].address_no = '';
                     modelData.address[keyAddress].address_section = '';
                     modelData.address[keyAddress].address_block = '';
                     modelData.address[keyAddress].address_level = '';
                     modelData.address[keyAddress].address_flat = '';
                     modelData.address[keyAddress].address_type = '';*/
                    break;

                case 'street':
                    modelData.address[keyAddress].section_name = '';
                    /*modelData.address[keyAddress].address_no = '';
                     modelData.address[keyAddress].address_section = '';
                     modelData.address[keyAddress].address_block = '';
                     modelData.address[keyAddress].address_level = '';
                     modelData.address[keyAddress].address_flat = '';
                     modelData.address[keyAddress].address_type = '';*/
                    break;
            }
        }

        /* update mqtt many orders */
        $scope.mqttUpdateManyOrders = function (models) {
            if (models[0].current_status == -1) { //case for delete orders
                angular.forEach(models, function (items, keys) {
                    if (!angular.isUndefined($scope.models)) {
                        var positionUpdated = $scope.models.map(function (e) {
                            return e['id'];
                        }).indexOf(parseInt(items.order_id));
                        if (positionUpdated >= 0) {
                            if (!angular.isUndefined($scope.total)) {
                                $scope.total['order'] = $scope.total['order'] - 1;
                                if ($scope.total['order'] < 0) {
                                    $scope.total['order'] = 0;
                                }
                            }
                            $scope.models.splice(positionUpdated, 1);
                            if ($location.path() == $scope.path + '/getOrder' ||
                             $route.current.$$route.originalPath.split(':')[0] == $scope.path + '/view/') {
                                if ($scope.models.length <= 0) {
                                    var no_pagesUpdated = Math.ceil(($scope.totalUpdated - 1) / perPage);
                                    if ($scope.models.current_page > no_pagesUpdated) {
                                        $scope.models.current_page = no_pagesUpdated;
                                    }
                                    if (angular.isUndefined($scope.models.current_page) || $scope.models.current_page == 0) {
                                        $scope.models.current_page = 1;
                                    }
                                    $scope.getOrders($scope.path, $scope.models.current_page, perPage, 'not0');
                                }
                            } else {
                                /*if ($scope.models.length <= 0) {
                                 $scope.getPaginateModel($scope.path, $scope.models.current_page, 10);
                                 }*/
                            }

                        }
                    }

                    if (!angular.isUndefined($scope.modelsPreloaded)) {
                        var positionPreloaded = $scope.modelsPreloaded.map(function (e) {
                            return e['id'];
                        }).indexOf(parseInt(items.order_id));
                        if (positionPreloaded >= 0) {
                            $scope.modelsPreloaded.splice(positionPreloaded, 1);
                            if ($location.path() == $scope.path + '/getOrder' ||
                             $route.current.$$route.originalPath.split(':')[0] == $scope.path + '/view/') {
                                if ($scope.modelsPreloaded.length <= 0) {
                                    var no_pagesPreloaded = Math.ceil(($scope.totalPreloaded - 1) / perPage);
                                    if ($scope.modelsPreloaded.current_page > no_pagesPreloaded) {
                                        $scope.modelsPreloaded.current_page = no_pagesPreloaded;
                                    }
                                    if (angular.isUndefined($scope.modelsPreloaded.current_page) || $scope.modelsPreloaded.current_page == 0) {
                                        $scope.modelsPreloaded.current_page = 1;
                                    }
                                    $scope.getOrdersPreloaded($scope.path, $scope.modelsPreloaded.current_page, perPage, 0);
                                }
                            }
                        }
                    }
                });
            } else {
                if (models[0].order_id == 'im') {
                    /* for imports */
                    if (!angular.isUndefined($scope.modelsPreloaded)) {
                        var no_pagesPreloaded = Math.ceil(($scope.totalPreloaded - 1) / perPage);
                        if ($scope.modelsPreloaded.current_page > no_pagesPreloaded) {
                            $scope.modelsPreloaded.current_page = no_pagesPreloaded;
                        }
                        if (angular.isUndefined($scope.modelsPreloaded.current_page) || $scope.modelsPreloaded.current_page == 0) {
                            $scope.modelsPreloaded.current_page = 1;
                        }
                        $scope.getOrdersPreloaded($scope.path, $scope.modelsPreloaded.current_page, perPage, 0);
                    }
                    if ($location.path() != $scope.path + '/getOrder' &&
                     $route.current.$$route.originalPath.split(':')[0] != $scope.path + '/view/') {
                        if (!angular.isUndefined($scope.models)) {
                            if (angular.isUndefined($scope.models.per_page)) {
                                $scope.models.per_page = 10;
                            }
                            $scope.getPaginateModel($scope.path, $scope.models.current_page, $scope.models.per_page);
                        }
                    }
                } else {
                    /* for delivery */
                    angular.forEach(models, function (items, keys) {
                        if (!angular.isUndefined($scope.models)) {
                            var positionUpdated = $scope.models.map(function (e) {
                                return e['id'];
                            }).indexOf(parseInt(items.order_id));
                            if (positionUpdated >= 0) {
                                $scope.models[positionUpdated]['order_status'] = items.current_status;
                            }
                        }
                    });

                }
            }
            $scope.$apply();
        }

        /* mqtt update orders */
        if ($location.path() == $scope.path + '/getOrder' || $location.path() == $scope.path + '/orderPlanned' || $location.path() == $scope.path) {
            $scope.mqttUpdateSlotStatus = function (model) {
                var model = model[0];
                if (!angular.isUndefined($scope.models)) {

                    if (model['orders']) {
                        angular.forEach(model['orders'], function (item, key) {
                            var positionUpdated = $scope.models.map(function (e) {
                                return e['id'];
                            }).indexOf(parseInt(item.order_id));
                            if (positionUpdated >= 0) {
                                $scope.models[positionUpdated]['order_status'] = item['order_status'];
                                $scope.models[positionUpdated]['reason_nondelivery'] = item['reason_nondelivery'];
                            }
                        });
                    }

                }
            }

            $scope.mqttUpdateOrderStatus = function (model) {
                if (!angular.isUndefined($scope.models)) {
                    var positionUpdated = $scope.models.map(function (e) {
                        return e['id'];
                    }).indexOf(parseInt(model[0].order_id));
                    if (positionUpdated >= 0) {
                        $scope.models[positionUpdated]['order_status'] = model[0]['order_status'];
                        $scope.models[positionUpdated]['reason_nondelivery'] = model[0]['reason_nondelivery'];
                    }

                    $scope.$apply();
                }
            }
        }

        /* planned order */
        if ($location.path() == $scope.path + '/orderPlanned'){
            $scope.typeView = 'planned-order';
            $scope.pathTemplate = 'orders/orders';
            $scope.title = 'Comenzi / Comenzi planificate';

            $scope.getOrders($scope.path, 1, 10);

            $scope.search['type_planning'] = 'order_planned';
            $scope.search['field'] = 'order_planning';
            $scope.search['dateFromPlanned'] = current_init_date;

            $scope.cancelSearchOrderPlanned = function (ev, path) {
                $scope.search = {};
                $scope.search['type_planning'] = 'order_planned';
                $scope.search['field'] = 'order_planning';
                if ($scope.searchControl == true) {
                    $scope.searchControl = false;
                    $scope.models = [];
                    $scope.getOrders($scope.path, 1, 10);
                }

                angular.element(document.querySelector('mdp-date-picker .md-input-has-value')).removeClass('md-input-has-value');
                angular.element(document.querySelector('mdp-date-picker .md-input-invalid')).removeClass('md-input-invalid');
                angular.element(document.querySelector('mdp-date-picker .md-input-has-value')).removeClass('md-input-has-value');
                angular.element(document.querySelector('mdp-date-picker .md-input-invalid')).removeClass('md-input-invalid');
                var form = document.getElementById('search-form');
                form.reset();

                $timeout($scope.removeDate, 500);

            }

        }
        /* end planned order */

        /* personal order */
        if ($location.path() == $scope.path + '/orderPersonal'){
            $scope.typeView = 'personal-order';
            $scope.pathTemplate = 'orders/orders';
            $scope.title = 'Comenzi / Comenzi personal';

            $scope.getOrders($scope.path, 1, 10);

            $scope.search['type_personal'] = 'order_personal';
            //$scope.search['field'] = 'order_planning';
            //$scope.search['dateFromPlanned'] = current_init_date;

            $scope.cancelSearchOrderPlanned = function (ev, path) {
                $scope.search = {};
                $scope.search['type_planning'] = 'order_planned';
                $scope.search['field'] = 'order_planning';
                if ($scope.searchControl == true) {
                    $scope.searchControl = false;
                    $scope.models = [];
                    $scope.getOrders($scope.path, 1, 10);
                }

                angular.element(document.querySelector('mdp-date-picker .md-input-has-value')).removeClass('md-input-has-value');
                angular.element(document.querySelector('mdp-date-picker .md-input-invalid')).removeClass('md-input-invalid');
                angular.element(document.querySelector('mdp-date-picker .md-input-has-value')).removeClass('md-input-has-value');
                angular.element(document.querySelector('mdp-date-picker .md-input-invalid')).removeClass('md-input-invalid');
                var form = document.getElementById('search-form');
                form.reset();

                $timeout($scope.removeDate, 500);

            }
        }
        $scope.saveOrderPersonal = function (ev, path) {

            $scope.modelData['order_phone'] = '1234512345';
            $scope.modelData['payment_method_id'] = 1;
            $scope.modelData['shipping_method_id'] = 4;
            $scope.modelData['order_source'] = 0;
            $scope.additionals['changeFieldPhone']($scope.modelData);
            delete $scope.modelData['address'];

            $scope.controlSH = true;
            if ($scope.mode_action == 'page') {
                $scope.action = 'saveOrderPersonal';
                $scope.errors = {};
                $scope.additionals['invalid'] = '';
              //  $scope.modelData = {};

                $scope.cancel = function () {
                    $scope.modelData = {};
                    $scope.errors = {};
                    $scope.controlSH = false;
                };
                if (!angular.isUndefined($scope.additionals['function'])) {
                    //$scope.additionals['function'](ev, $scope.modelData);
                }

                /* save a model */
                $scope.saveModel = function () {

                    $scope.additionals['buttonDisabled'] = true;
                    if (!angular.isUndefined($scope.additionals['internFunction'])) {
                        //$scope.additionals['internFunction'](ev, $scope.modelData);
                    }
                    $scope.isLoading = true;
                    $scope.modelData['field'] = $scope.search['field'];
                    $scope.modelData['order'] = $scope.search['order'];

                    if ($scope.additionals['content_type'] == 'form-urlencoded') {
                        $scope.post = $scope.modelData;
                    }
                    if ($scope.additionals['content_type'] == 'undefined') {
                        $scope.post = new FormData();
                        angular.forEach($scope.modelData, function (item, key) {
                            $scope.post.append(key, item);
                        });
                    }
                    if ($scope.additionals['content_type'] == 'json') {
                        $scope.post = $scope.modelData;
                    }

                    $scope.post['route'] = 'saveOrderPersonal';
                    delete $scope.post['address'];
                    Crud.post($scope.additionals['content_type'], $scope.post, path+ '/saveOrderPersonal')
                      .success(function (data) {
                          if (!angular.isUndefined(data.invalid)) {
                              $scope.additionals['invalid'] = data.invalid;
                          } else {
                              if (!angular.isUndefined($scope.additionals['functionResult'])) {
                                  $scope.additionals['functionResult'](ev, data);
                              }
                              if (!angular.isUndefined(data.position)) {
                                  var no_pages = Math.ceil((data.position + 1) / $scope.state.itemsPerPage);
                              } else {
                                  var no_pages = Math.ceil(($scope.total + 1) / $scope.state.itemsPerPage);
                              }

                              if (data.currentModel) {
                                if ((data.currentModel['order_planning'] != null && data.currentModel['order_planning'] != 'null' && data.currentModel['order_planning'] != '' && moment().format('DD/MM/YYYY') == moment(data.currentModel.order_planning).format('DD/MM/YYYY')) || (data.currentModel['order_planning'] == null || data.currentModel['order_planning'] == 'null' || data.currentModel['order_planning'] == '')
                               ) {
                                  var post = {};
                                  post['id'] = data.currentModel.id;
                                  post['route'] = 'printOrderAsincron';
                                  $scope.additionals['printOrderAsincron'](path, post);
                                }

                                // var postCbms = {};
                                // postCbms['order'] = {'id': data.currentModel.id};
                                // postCbms['route'] = 'cbms';
                                // $scope.additionals['cbms']($scope.path, postCbms);
                              }

                              if (!angular.isUndefined(data.newDependentFields)) {
                                  angular.forEach(data.newDependentFields, function (item, key) {
                                      if (item instanceof Array) {
                                          angular.forEach(item, function (itemArray, keyArray) {
                                              $scope.additionals[key].push(itemArray);
                                          });
                                      } else {
                                          $scope.additionals[key].push(item);
                                      }
                                  });
                              }
                          }
                          $scope.modelData = {};
                          $scope.errors = {};
                          $scope.isLoading = false;
                          $scope.controlSH = false;
                          $scope.additionals['buttonDisabled'] = false;
                      })
                      .error(function (data) {
                          $scope.isLoading = false;
                          $scope.errors = data.errors;
                          $scope.additionals['buttonDisabled'] = false;
                          if (!angular.isUndefined($scope.additionals['functionErrors'])) {
                              $scope.additionals['functionErrors'](ev, data);
                          }
                          if (data == null) {
                              $rootScope.checkNetworkConnection();
                          }
                      });
                };
            }
        }

        $scope.updateOrderPersonalModel = function (ev, path,  modelId) {

            Crud.show(modelId, $scope.path)
                .success(function (data) {

                    $scope.additionals['calcProcess'](data);

                    $scope.additionals['discount_campaigns'] = data['discount_campaigns'];

                    $scope.updateOrderPersonal(ev, path, data);

                    $scope.additionals['total_product_discount'] = parseFloat(data.order_product_discount);
                    $scope.additionals['total_product'] = parseFloat(data.order_amount) - parseFloat(data.order_product_discount);
                    $scope.additionals['total_client_discount'] = parseFloat(data.order_client_discount);
                    $scope.additionals['total_loyalty_point_discount'] = parseFloat(data.order_loyalty_point_discount);
                    $scope.additionals['shipping'] = parseFloat(data.order_shipping);
                    $scope.additionals['order_product_sgr'] = parseFloat(data.order_product_sgr);

            });
          }

        $scope.updateOrderPersonal = function (ev, path,  model) {
            $scope.controlSH = true;
            if ($scope.mode_action == 'page') {
                $scope.action = 'updateOrderPersonal';
                $scope.errors = {};
                $scope.additionals['invalid'] = '';

              var currentModel = {};
              angular.forEach(model, function (item, key) {
                  currentModel[key] = item;
              });
              $scope.modelData = currentModel;

                $scope.cancel = function () {
                    $scope.modelData = {};
                    $scope.errors = {};
                    $scope.controlSH = false;
                };
                if (!angular.isUndefined($scope.additionals['function'])) {
                    //$scope.additionals['function'](ev, $scope.modelData);
                }

                /* save a model */
                $scope.saveModel = function () {

                    $scope.additionals['buttonDisabled'] = true;
                    if (!angular.isUndefined($scope.additionals['internFunction'])) {
                        //$scope.additionals['internFunction'](ev, $scope.modelData);
                    }
                    $scope.isLoading = true;
                    $scope.modelData['field'] = $scope.search['field'];
                    $scope.modelData['order'] = $scope.search['order'];

                    if ($scope.additionals['content_type'] == 'form-urlencoded') {
                        $scope.post = $scope.modelData;
                    }
                    if ($scope.additionals['content_type'] == 'undefined') {
                        $scope.post = new FormData();
                        angular.forEach($scope.modelData, function (item, key) {
                            $scope.post.append(key, item);
                        });
                    }
                    if ($scope.additionals['content_type'] == 'json') {
                        $scope.post = $scope.modelData;
                    }

                    $scope.post['route'] = 'updateOrderPersonal';
                    delete $scope.post['address'];
                    Crud.post($scope.additionals['content_type'], $scope.post, path+ '/updateOrderPersonal')
                      .success(function (data) {
                          if (!angular.isUndefined(data.invalid)) {
                              $scope.additionals['invalid'] = data.invalid;
                          } else {
                              if (!angular.isUndefined($scope.additionals['functionResult'])) {
                                  $scope.additionals['functionResult'](ev, data);
                              }
                              if (!angular.isUndefined(data.position)) {
                                  var no_pages = Math.ceil((data.position + 1) / $scope.state.itemsPerPage);
                              } else {
                                  var no_pages = Math.ceil(($scope.total + 1) / $scope.state.itemsPerPage);
                              }

                              if (data.currentModel) {
                                if ((data.currentModel['order_planning'] != null && data.currentModel['order_planning'] != 'null' && data.currentModel['order_planning'] != '' && moment().format('DD/MM/YYYY') == moment(data.currentModel.order_planning).format('DD/MM/YYYY')) || (data.currentModel['order_planning'] == null || data.currentModel['order_planning'] == 'null' || data.currentModel['order_planning'] == '')
                               ) {
                                  var post = {};
                                  post['id'] = data.currentModel.id;
                                  post['route'] = 'printOrderAsincron';
                                  $scope.additionals['printOrderAsincron'](path, post);
                                }

                                // var postCbms = {};
                                // postCbms['order'] = {'id': data.currentModel.id};
                                // postCbms['route'] = 'cbms';
                                // $scope.additionals['cbms']($scope.path, postCbms);
                              }

                              if (!angular.isUndefined(data.newDependentFields)) {
                                  angular.forEach(data.newDependentFields, function (item, key) {
                                      if (item instanceof Array) {
                                          angular.forEach(item, function (itemArray, keyArray) {
                                              $scope.additionals[key].push(itemArray);
                                          });
                                      } else {
                                          $scope.additionals[key].push(item);
                                      }
                                  });
                              }
                          }
                          $scope.modelData = {};
                          $scope.errors = {};
                          $scope.isLoading = false;
                          $scope.controlSH = false;
                          $scope.additionals['buttonDisabled'] = false;
                      })
                      .error(function (data) {
                          $scope.isLoading = false;
                          $scope.errors = data.errors;
                          $scope.additionals['buttonDisabled'] = false;
                          if (!angular.isUndefined($scope.additionals['functionErrors'])) {
                              $scope.additionals['functionErrors'](ev, data);
                          }
                          if (data == null) {
                              $rootScope.checkNetworkConnection();
                          }
                      });
                };
            }
        }
        /* end planned order */

        /* get order */
        if ($location.path() == $scope.path + '/getOrder') {

            /* show call by id */
            $scope.mqttUpdateCall = function (model, status) {
                // console.log(model)
                // console.log(status)

                if (status == 1) {//Apel in curs
                    var positionCall = $scope.calls.map(function (e) {
                        return e['id'];
                    }).indexOf(parseInt(model.id));
                    if (positionCall < 0) {
                        if (moment().format('DD/MM/YYYY') == moment(model.call_start).format('DD/MM/YYYY')) {
                            $scope.calls.unshift(model);
                            //$scope.calls = $filter('orderBy')($scope.calls, 'call_start');
                            $scope.calls = $scope.additionals['uniqueArray']($scope.calls);
                        }
                        var audioElement = document.createElement('audio');
                        audioElement.setAttribute('src', $scope.additionals['publicAudioPath'] + '/notification.mp3');
                        audioElement.play();
                    }
                }
                if (status == 2) {//Apel preluat
                    if (!angular.isUndefined($scope.calls)) {
                        var positionCall = $scope.calls.map(function (e) {
                            return e['id'];
                        }).indexOf(parseInt(model.id));
                        if (positionCall >= 0) {
                            $scope.calls[positionCall] = model;
                        }
                    }
                }
                if (status == 3) {//Apel incheiat
                    if (!angular.isUndefined($scope.calls)) {
                        var positionCall = $scope.calls.map(function (e) {
                            return e['id'];
                        }).indexOf(parseInt(model.id));
                        if (positionCall >= 0) {
                            $scope.calls.splice(positionCall, 1);
                        }
                    }
                    if (!angular.isUndefined($scope.missedCalls)) {
                        // var positionMissedCall = $scope.missedCalls.map(function (e) {
                        //     return e['id'];
                        // }).indexOf(parseInt(model.id));
                        // if (positionMissedCall >= 0) {
                        //     $scope.missedCalls.splice(positionMissedCall, 1);
                        // }
                        $scope.missedCalls = $scope.missedCalls.filter(function (e, i, arr) {
                            return e['call_source'] != model['call_source'];
                        });
                    }
                }
                if (status == 0) { //Apel nepreluat
                    if (!angular.isUndefined($scope.calls)) {
                        var positionCall = $scope.calls.map(function (e) {
                            return e['id'];
                        }).indexOf(parseInt(model.id));
                        if (positionCall >= 0) {
                            $scope.calls.splice(positionCall, 1);
                        }
                    }
                    //
                    if (!angular.isUndefined($scope.missedCalls)) {
                        var positionMissedCall = $scope.missedCalls.map(function (e) {
                            return e['id'];
                        }).indexOf(parseInt(model.id));
                        if (positionMissedCall < 0) {
                            if (moment().format('DD/MM/YYYY') == moment(model.call_start).format('DD/MM/YYYY')) {
                                $scope.missedCalls.unshift(model);
                                $scope.missedCalls = $filter('orderBy')($scope.missedCalls, 'call_start', true);
                                $scope.missedCalls = $scope.additionals['uniqueArray']($scope.missedCalls);
                            }
                        }
                    }
                }
                if (status == 4) {//Reapel
                    if (!angular.isUndefined($scope.missedCalls)) {
                        var positionMissedCall = $scope.missedCalls.map(function (e) {
                            return e['id'];
                        }).indexOf(parseInt(model.id));
                        if (positionMissedCall >= 0) {
                            $scope.missedCalls[positionMissedCall] = model;

                        }
                    }
                }
                if (status == '3r') {//Reapel incheiat - the same status 3
                    if (!angular.isUndefined($scope.missedCalls)) {
                        // var positionMissedCall = $scope.missedCalls.map(function (e) {
                        //     return e['id'];
                        // }).indexOf(parseInt(model.id));
                        // if (positionMissedCall >= 0) {
                        //     $scope.missedCalls.splice(positionMissedCall, 1);
                        // }
                        $scope.missedCalls = $scope.missedCalls.filter(function (e, i, arr) {
                            return (e['call_source'] != model['call_source'] && e['call_source'] != model['call_destination']);
                        });
                    }
                }

            };

            /*set time listen*/
            /*$scope.getExternOrders = function () {
             Crud.get('/import/executeBig')
             .success(function (data) {})
             .error(function (data) {})
             .then(function () {
             Crud.get('/import/executeHip')
             .success(function (data) {})
             .error(function (data) {});
             });
             }*/

            /*$scope.timeListen = function () {
             //console.log(moment().format('H:mm:ss'))
             return moment().format('H:mm:ss');
             }*/

            /*$scope.$watch('timeListen()', function (item) {
             if (moment(item, 'H:mm:ss') > moment('8:00:00', 'H:mm:ss') && moment(item, 'H:mm:ss') < moment('23:00:00', 'H:mm:ss')) {
             //if (moment(item, 'H:mm:ss') > moment('0:40:00', 'H:mm:ss') && moment(item, 'H:mm:ss') < moment('0:45:00', 'H:mm:ss')) {
             //console.log(localStorage.getItem('currentDate')+'-'+moment().format('DD/MM/YYYY'))
             if (angular.isUndefined(localStorage.getItem('currentDate')) || localStorage.getItem('currentDate') == null || localStorage.getItem('currentDate') == '' || localStorage.getItem('currentDate') != moment().format('DD/MM/YYYY')) {
             localStorage.setItem('currentDate', moment().format('DD/MM/YYYY'));
             if (localStorage.getItem('currentDate') == moment().format('DD/MM/YYYY')) {
             Crud.get('/ami/listen')
             .success(function (data) {})
             .error(function (data) {
             localStorage.setItem('currentDate', '');
             })
             }
             }
             } else {
             if (localStorage.getItem('currentDate') != '') {
             Crud.get('/ami/stopListen')
             .success(function (data) {
             localStorage.setItem('currentDate', '');
             })
             .error(function (data) {
             })
             }
             }
             /!*for (var i = 8; i <= 23; i++) {
             if (item == i+':39:00') {
             //if (item == i+':52:00' || item == i + ' : 09 : 00') {
             //if (item == i + ' : 00 : 00' || item == i + ' : 32 : 00' || item == i + ' : 33 : 00' || item == i + ' : 34 : 00' || item == i + ' : 35 : 00' || item == i + ' : 36 : 00' || item == i + ' : 37 : 00' || item == i + ' : 38 : 00' || item == i + ' : 39 : 00'|| item == i + ' : 40 : 00'|| item == i + ' : 50 : 00'|| item == i + ' : 55 : 00') {
             //if (item == i + ' : 00 : 00' || item == i + ' : 05 : 00' || item == i + ' : 10 : 00' || item == i + ' : 15 : 00' || item == i + ' : 20 : 00' || item == i + ' : 25 : 00' || item == i + ' : 30 : 00' || item == i + ' : 35 : 00' || item == i + ' : 40 : 00'|| item == i + ' : 45 : 00'|| item == i + ' : 50 : 00'|| item == i + ' : 55 : 00') {
             //if (item == i + ' : 00 : 00' || item == i + ' : 10 : 00' || item == i + ' : 20 : 00' || item == i + ' : 30 : 00' || item == i + ' : 40 : 00' || item == i + ' : 50 : 00') {
             $scope.getExternOrders();
             }
             }*!/
             }, true);*/
            /*end time listen*/
            $scope.typeView = 'get-order';

            /* recall client */
            $scope.additionals['changeStatusReCall'] = function (ev, model) {
                if ((model.call_status != 4 && model.call_destination != $rootScope.session.user.interior_no) || model.call_destination == $rootScope.session.user.interior_no) {

                    $scope.cancelOrder(ev);
                    $scope.selectReCall = 1;

                    Crud.get($scope.path + '/changeStatusReCall?call_id=' + model.id)
                            .success(function (data) {

                                $scope.additionals['getSections'](data.call, 0);

                                model.call_status = 4;
                                var callResult = data.call;
                                $scope.fromCall = 1;

                                if ($scope.action == 'store') {
                                    if (!angular.isUndefined(callResult['discount_campaigns'])) {
                                        $scope.additionals['discount_campaigns'] = callResult['discount_campaigns'];
                                        //$scope.additionals['applyDiscountCampaign']();
                                    } else {
                                        $scope.additionals['discount_campaigns'] = [];
                                    }
                                    if (!angular.isUndefined(callResult['loyalty_point_accumulated'])) {
                                        $scope.additionals['loyalty_point_accumulated'] = callResult['loyalty_point_accumulated'];
                                    } else {
                                        $scope.additionals['loyalty_point_accumulated'] = 0;
                                    }
                                }
                                if ($scope.action == 'update' && $scope.order_phone_original == callResult['client_phone']) {
                                    $scope.additionals['discount_campaigns'] = callResult['discount_campaigns'];
                                    //$scope.additionals['applyDiscountCampaign']();
                                }

                                if (!angular.isUndefined(callResult['client_blacklist_reason'])) {
                                  $scope.modelData.client_blacklist_reason = callResult['client_blacklist_reason'];
                                } else {
                                    $scope.modelData.client_blacklist_reason = '';
                                }

                                //if( callResult.call_destination == $rootScope.session.user.interior_no ) {
                                if ((!angular.isUndefined(callResult['client_first_name']) && callResult['client_first_name'] != '') || (!angular.isUndefined(callResult['client_last_name']) && callResult['client_last_name'] != '')) {
                                    $scope.modelData.client_id = callResult.client_id;
                                    $scope.modelData.client_first_name = callResult.client_first_name;
                                    $scope.modelData.client_last_name = callResult.client_last_name;
                                    $scope.modelData.order_phone = callResult.client_phone;
                                    $scope.modelData.call_source = callResult.call_source;
                                    $scope.modelData.call_destination = callResult.call_destination;
                                    $scope.modelData.call_id = model.id;
                                    $scope.modelData.shipping_method_id = 1;

                                    angular.forEach(callResult.address, function (itemAddress, keyAddress) {
                                        $scope.additionals['selectedItemLocality'][keyAddress] = '';
                                        $scope.additionals['selectedItemStreet'][keyAddress] = '';

                                        $scope.modelData['address'][keyAddress] = {};
                                        angular.forEach(itemAddress, function (itemAddressDetail, keyAddressDetail) {
                                            $scope.modelData['address'][keyAddress][keyAddressDetail] = itemAddressDetail;
                                        });
                                    });
                                    $scope.modelData.select_address = 0;
                                    //$scope.additionals['changeFieldClient'](model);

                                    $scope.additionals['clients'] = [{}];
                                    if (!angular.isUndefined(callResult.client_first_name)) {
                                        $scope.additionals['clients'][0].client_first_name = callResult.client_first_name;
                                        $scope.additionals['clients'][0].value = callResult.client_first_name;
                                    }
                                    if (!angular.isUndefined(callResult.client_last_name)) {
                                        $scope.additionals['clients'][0].client_last_name = callResult.client_last_name;
                                        $scope.additionals['clients'][0].value = callResult.client_last_name;
                                    }
                                    if (!angular.isUndefined(callResult.client_first_name) && !angular.isUndefined(callResult.client_last_name)) {
                                        $scope.additionals['clients'][0].value = callResult.client_first_name + ' ' + callResult.client_last_name;
                                    }
                                    $scope.additionals['clients'][0].client_phone = callResult.client_phone;
                                    $scope.additionals['clients'][0].id = callResult.client_id;
                                    $scope.additionals['clients'][0].address = callResult.address;

                                    $scope.modelsHistory = [];
                                    $scope.getOrdersHistory($scope.path, 1, perPage, callResult.client_id, model.id);
                                } else {
                                    $scope.modelData = {};
                                    $scope.modelData.order_phone = callResult.call_source;
                                    $scope.modelData.call_destination = callResult.call_destination;
                                    $scope.modelData.call_source = model.call_source;
                                    $scope.modelData.call_id = model.id;
                                    $scope.modelData.shipping_method_id = 1;
                                    //$scope.additionals['address'] = [{}];
                                    //$scope.modelData['address'] = [{'county_name': 'Cluj'}];
                                    angular.forEach(callResult.address, function (itemAddress, keyAddress) {
                                        $scope.additionals['selectedItemLocality'][keyAddress] = '';
                                        $scope.additionals['selectedItemStreet'][keyAddress] = '';

                                        $scope.modelData['address'][keyAddress] = {};
                                        angular.forEach(itemAddress, function (itemAddressDetail, keyAddressDetail) {
                                            $scope.modelData['address'][keyAddress][keyAddressDetail] = itemAddressDetail;
                                        });
                                    });
                                    $scope.modelData.select_address = 0;
                                }
                                $scope.additionals['getLastOrderClient'](model.call_source);
                                /*} else {
                                 $scope.selectReCall = 0;
                                 $scope.modelData = {};
                                 $scope.modelData.call_id = model.id;
                                 $scope.modelData.shipping_method_id = 1;
                                 $scope.lastOrderClient = '';
                                 $scope.modelLastOrder = {};
                                 angular.forEach(callResult.address, function (itemAddress, keyAddress) {
                                 $scope.additionals['selectedItemLocality'][keyAddress] = '';
                                 $scope.additionals['selectedItemStreet'][keyAddress] = '';

                                 $scope.modelData['address'][keyAddress] = {};
                                 angular.forEach(itemAddress, function (itemAddressDetail, keyAddressDetail) {
                                 $scope.modelData['address'][keyAddress][keyAddressDetail] = itemAddressDetail;
                                 });
                                 });
                                 $scope.modelData.select_address = 0;
                                 }
                                 */
                            });

                    //$scope.getDependedFields();
                    $scope.errors = {};
                    $scope.action = 'store';

                    $scope.modelData.food_products = [];
                    //$scope.modelData.order_no = '';
                    $scope.modelData.order_amount = 0;
                    $scope.modelData.order_shipping = 0;
                    $scope.modelData.order_total = 0;

                }
                $scope.additionals['total_product'] = 0;
                $scope.additionals['order_product_sgr'] = 0;
                $scope.additionals['closeStep'](1);
                $scope.additionals['controlCategories'] = false;
                $scope.additionals['controlProducts'] = false;
                $scope.additionals['controlMentionProduct'] = [];
                $scope.additionals['controlClientProduct'] = [];

            }

            /* select client*/
            $scope.additionals['selectClient'] = function (ev, model) {

                if ((model.call_status != 2 && model.call_destination != $rootScope.session.user.interior_no) || model.call_destination == $rootScope.session.user.interior_no) {

                    $scope.cancelOrder(ev);
                    $scope.selectCall = 1;
                    Crud.get($scope.path + '/changeStatusCall?call_id=' + model.id)
                        .success(function (data) {

                            $scope.additionals['getSections'](data.call, 0);

                            model.call_status = 2;
                            var callResult = data.call;

                            if ($scope.action == 'store') {
                                if (!angular.isUndefined(callResult['discount_campaigns'])) {
                                    $scope.additionals['discount_campaigns'] = callResult['discount_campaigns'];
                                    //$scope.additionals['applyDiscountCampaign']();
                                } else {
                                    $scope.additionals['discount_campaigns'] = [];
                                }
                                if (!angular.isUndefined(callResult['loyalty_point_accumulated'])) {
                                    $scope.additionals['loyalty_point_accumulated'] = callResult['loyalty_point_accumulated'];
                                } else {
                                    $scope.additionals['loyalty_point_accumulated'] = 0;
                                }
                            }
                            if ($scope.action == 'update' && $scope.order_phone_original == callResult['client_phone']) {
                                $scope.additionals['discount_campaigns'] = callResult['discount_campaigns'];
                                //$scope.additionals['applyDiscountCampaign']();
                            }

                            $scope.fromCall = 1;
                            //if( callResult.call_destination == $rootScope.session.user.interior_no ) {

                            if (!angular.isUndefined(callResult['client_blacklist_reason'])) {
                              $scope.modelData.client_blacklist_reason = callResult['client_blacklist_reason'];
                            } else {
                                $scope.modelData.client_blacklist_reason = '';
                            }

                            if ((!angular.isUndefined(callResult['client_first_name']) && callResult['client_first_name'] != '') || (!angular.isUndefined(callResult['client_last_name']) && callResult['client_last_name'] != '')) {
                                $scope.modelData.client_id = callResult.client_id;
                                $scope.modelData.client_first_name = callResult.client_first_name;
                                $scope.modelData.client_last_name = callResult.client_last_name;
                                $scope.modelData.order_phone = callResult.client_phone;
                                $scope.modelData.call_source = callResult.call_source;
                                $scope.modelData.call_destination = callResult.call_destination;
                                $scope.modelData.shipping_method_id = 1;
                                $scope.modelData.call_id = model.id;
                                //$scope.modelData.address = callResult.address;
                                angular.forEach(callResult.address, function (itemAddress, keyAddress) {
                                    $scope.additionals['selectedItemLocality'][keyAddress] = '';
                                    $scope.additionals['selectedItemStreet'][keyAddress] = '';

                                    $scope.modelData['address'][keyAddress] = {};
                                    angular.forEach(itemAddress, function (itemAddressDetail, keyAddressDetail) {
                                        $scope.modelData['address'][keyAddress][keyAddressDetail] = itemAddressDetail;
                                    });
                                });
                                $scope.modelData.select_address = 0;

                                //$scope.additionals['changeFieldClient'](model);

                                $scope.additionals['clients'] = [{}];
                                if (!angular.isUndefined(callResult.client_first_name)) {
                                    $scope.additionals['clients'][0].client_first_name = callResult.client_first_name;
                                    $scope.additionals['clients'][0].value = callResult.client_first_name;
                                }
                                if (!angular.isUndefined(callResult.client_last_name)) {
                                    $scope.additionals['clients'][0].client_last_name = callResult.client_last_name;
                                    $scope.additionals['clients'][0].value = callResult.client_last_name;
                                }
                                if (!angular.isUndefined(callResult.client_first_name) && !angular.isUndefined(callResult.client_last_name)) {
                                    $scope.additionals['clients'][0].value = callResult.client_first_name + ' ' + callResult.client_last_name;
                                }
                                $scope.additionals['clients'][0].client_phone = callResult.client_phone;
                                $scope.additionals['clients'][0].id = callResult.client_id;
                                $scope.additionals['clients'][0].address = callResult.address;

                                $scope.modelsHistory = [];
                                $scope.getOrdersHistory($scope.path, 1, perPage, callResult.client_id, model.id);
                            } else {
                                $scope.modelData = {};
                                $scope.modelData.order_phone = callResult.call_source;
                                $scope.modelData.call_destination = callResult.call_destination;
                                $scope.modelData.call_source = model.call_source;
                                $scope.modelData.call_id = model.id;
                                $scope.modelData.shipping_method_id = 1;
                                //$scope.additionals['address'] = [{}];
                                //$scope.modelData['address'] = [{'county_name': 'Cluj'}];
                                angular.forEach(callResult.address, function (itemAddress, keyAddress) {
                                    $scope.additionals['selectedItemLocality'][keyAddress] = '';
                                    $scope.additionals['selectedItemStreet'][keyAddress] = '';

                                    $scope.modelData['address'][keyAddress] = {};
                                    angular.forEach(itemAddress, function (itemAddressDetail, keyAddressDetail) {
                                        $scope.modelData['address'][keyAddress][keyAddressDetail] = itemAddressDetail;
                                    });
                                });
                                $scope.modelData.select_address = 0;
                            }
                            $scope.additionals['getLastOrderClient'](model.call_source);
                            /*} else {
                             $scope.selectCall = 0;
                             $scope.modelData = {};
                             $scope.modelData.call_id = model.id;
                             $scope.modelData.shipping_method_id = 1;
                             $scope.lastOrderClient = '';
                             $scope.modelLastOrder = {};
                             angular.forEach(callResult.address, function (itemAddress, keyAddress) {
                             $scope.additionals['selectedItemLocality'][keyAddress] = '';
                             $scope.additionals['selectedItemStreet'][keyAddress] = '';

                             $scope.modelData['address'][keyAddress] = {};
                             angular.forEach(itemAddress, function (itemAddressDetail, keyAddressDetail) {
                             $scope.modelData['address'][keyAddress][keyAddressDetail] = itemAddressDetail;
                             });
                             });
                             $scope.modelData.select_address = 0;

                             }*/
                        });

                    //$scope.getDependedFields();
                    $scope.errors = {};
                    $scope.action = 'store';

                    $scope.modelData.food_products = [];
                    //$scope.modelData.order_no = '';
                    $scope.modelData.order_amount = 0;
                    $scope.modelData.order_shipping = 0;
                    $scope.modelData.order_total = 0;

                    $scope.additionals['total_product'] = 0;
                    $scope.additionals['order_product_sgr'] = 0;
                    $scope.additionals['closeStep'](1);
                    $scope.additionals['controlCategories'] = false;
                    $scope.additionals['controlProducts'] = false;
                    $scope.additionals['controlMentionProduct'] = [];
                    $scope.additionals['controlClientProduct'] = [];
                }
            }

            $scope.action = 'store';
            if (!angular.isUndefined($scope.additionals['function'])) {
                $scope.additionals['function']('', $scope.modelData);
            }

            /* update price */
            $scope.additionals['updatePrice'] = function (foodProducts) {
                var post = {};
                post['food_products'] = foodProducts;
                post['route'] = 'updatePrice';
                Crud.post('form-urlencoded', post, $scope.path + '/updatePrice')
                        .success(function (data) {
                            $scope.modelData['food_products'] = data['food_products'];
                            $scope.additionals['updateTotalPrice']();
                        });

            };

            /* add history order */
            $scope.addHistoryOrder = function (ev, path, model, history) {
                if ($scope.action == 'addincident') {
                    $scope.action = 'store';
                    var new_model = {};
                    new_model['food_products'] = model['food_products'];
                    new_model['order_phone'] = model['order_phone'];
                    new_model['client_id'] = model['client_id'];
                    new_model['client_email'] = model['client_email'];
                    new_model['client_first_name'] = model['client_first_name'];
                    new_model['client_last_name'] = model['client_last_name'];
                    new_model['client_cutlery'] = model['client_cutlery'];
                    new_model['client_gdpr'] = model['client_gdpr'];

                    $scope.additionals['changeFieldPhone'](model);
                    model = {};
                    model = new_model;
                    $scope.modelData = model;
                }

                if (history != 'history') {
                    $scope.additionals['buttonDisabled'] = true;
                }

                if (!angular.isUndefined(model)) {
                    var currentModel = {};
                    angular.forEach(model, function (item, key) {
                        switch (key) {
                            case 'food_products':
                                currentModel['food_products'] = [];
                                angular.forEach(item, function (itemDetail, keyDetail) {
                                    currentModel['food_products'][keyDetail] = {};
                                    angular.forEach(itemDetail, function (itemDetail1, keyDetail1) {
                                        if (keyDetail1 == 'food_supplements') {
                                            currentModel['food_products'][keyDetail]['food_supplements'] = [];
                                            angular.forEach(itemDetail['food_supplements'], function (itemDetailSup, keyDetailSup) {
                                                currentModel['food_products'][keyDetail]['food_supplements'][keyDetailSup] = {};
                                                angular.forEach(itemDetailSup, function (itemDetail1Sup, keyDetail1Sup) {
                                                    currentModel['food_products'][keyDetail]['food_supplements'][keyDetailSup][keyDetail1Sup] = itemDetail1Sup;
                                                });
                                            });
                                        } else {
                                            currentModel['food_products'][keyDetail][keyDetail1] = itemDetail1;
                                        }
                                    });
                                });
                                break;

                            default:
                                currentModel[key] = item;
                                break;
                        }
                    });

                    $scope.modelData.food_products = currentModel.food_products;
                    //$scope.modelData.order_no = 0;
                    $scope.modelData.order_orig_id = '';
                    if (!angular.isUndefined(model.callId)) {
                        $scope.modelData.call_id = model.callId;
                    }

                    //$scope.additionals['discount_campaigns'] = data['discount_campaigns'];
                    //$scope.editModel(ev, path, data, section);
                    $scope.additionals['updateTotalPrice']();

                    //$scope.additionals['total_product_discount'] = model.order_product_discount;
                    //$scope.additionals['total_product'] = parseFloat(model.order_amount) - parseFloat(model.order_product_discount);
                    //$scope.additionals['total_client_discount'] = model.order_client_discount;
                    //$scope.additionals['total_loyalty_point_discount'] = model.total_loyalty_point_discount;
                }
            };

            /* save model */
            $scope.saveModel = function (ev, path, model, history) {
                if (history != 'history') {
                    $scope.additionals['buttonDisabled'] = true;
                }
                $scope.action = 'store';

                if (!angular.isUndefined(model)) {
                    var currentModel = {};
                    angular.forEach(model, function (item, key) {
                        switch (key) {
                            case 'food_products':
                                currentModel['food_products'] = [];
                                angular.forEach(item, function (itemDetail, keyDetail) {
                                    currentModel['food_products'][keyDetail] = {};
                                    angular.forEach(itemDetail, function (itemDetail1, keyDetail1) {
                                        if (keyDetail1 == 'food_supplements') {
                                            currentModel['food_products'][keyDetail]['food_supplements'] = [];
                                            angular.forEach(itemDetail['food_supplements'], function (itemDetailSup, keyDetailSup) {
                                                currentModel['food_products'][keyDetail]['food_supplements'][keyDetailSup] = {};
                                                angular.forEach(itemDetailSup, function (itemDetail1Sup, keyDetail1Sup) {
                                                    currentModel['food_products'][keyDetail]['food_supplements'][keyDetailSup][keyDetail1Sup] = itemDetail1Sup;
                                                });
                                            });
                                        } else {
                                            currentModel['food_products'][keyDetail][keyDetail1] = itemDetail1;
                                        }
                                    });
                                });
                                break;
                            case 'address':
                                currentModel['address'] = [];
                                angular.forEach(item, function (itemAddress, keyAddress) {
                                    $scope.additionals['selectedItemLocality'][keyAddress] = '';
                                    $scope.additionals['selectedItemStreet'][keyAddress] = '';

                                    currentModel['address'][keyAddress] = {};
                                    angular.forEach(itemAddress, function (itemAddressDetail, keyAddressDetail) {
                                        currentModel['address'][keyAddress][keyAddressDetail] = itemAddressDetail;
                                    });
                                });
                                break;
                            default:
                                currentModel[key] = item;
                                break;
                        }
                    });

                    $scope.modelData = currentModel;
                    //$scope.modelData.order_no = 0;
                    $scope.modelData.order_orig_id = '';
                    $scope.modelData.call_id = model.callId;

                    //$scope.additionals['discount_campaigns'] = data['discount_campaigns'];
                    //$scope.editModel(ev, path, data, section);
                    $scope.additionals['updateTotalPrice']();

                    $scope.additionals['total_product_discount'] = model.order_product_discount;
                    $scope.additionals['total_product'] = parseFloat(model.order_amount) - parseFloat(model.order_product_discount);
                    $scope.additionals['total_client_discount'] = model.order_client_discount;
                    $scope.additionals['total_loyalty_point_discount'] = model.total_loyalty_point_discount;
                    $scope.additionals['order_product_sgr'] = parseFloat(model.order_product_sgr);

                    // if (!angular.isUndefined(model.order_planning)) {
                    //     if (model.order_planning != null) {
                    //         var timeArray = model.order_planning.split(':');
                    //         var current_time = new Date();
                    //         current_time.setHours(timeArray[0], timeArray[1], timeArray[2], 0);
                    //         $scope.modelData.order_planning = current_time;
                    //     }
                    // }
                    if (!angular.isUndefined(model.order_planning)) {
                        if (model.order_planning != null) {
                            var dateArray = model.order_planning.split(' ');
                            $scope.modelData.order_planning_date = new Date(model.order_planning);
                            $scope.modelData.order_planning_time = new Date(moment().format('D MMM, YYYY') + ' ' + dateArray[1]);
                        }
                    } else {
                        //model.order_planning_date = current_init_date;
                        //model.order_planning_time = new Date();
                    }

                } else {
                    if (!angular.isUndefined($scope.additionals['internFunction'])) {
                        $scope.additionals['internFunction'](ev, $scope.modelData);
                    }
                    $scope.isLoading = true;
                    $scope.modelData['field'] = $scope.search['field'];
                    $scope.modelData['order'] = $scope.search['order'];

                    if ($scope.additionals['content_type'] == 'form-urlencoded') {
                        $scope.post = $scope.modelData;
                    }
                    if ($scope.additionals['content_type'] == 'undefined') {
                        $scope.post = new FormData();
                        angular.forEach($scope.modelData, function (item, key) {
                            $scope.post.append(key, item);
                        });
                    }
                    if ($scope.additionals['content_type'] == 'json') {
                        $scope.post = $scope.modelData;
                    }
                    // angular.forEach($scope.post.food_products, function (itemProduct, indexProduct) {
                    //   delete itemProduct['sub'];
                    // });

                    Crud.save($scope.additionals['content_type'], $scope.post, $scope.path)
                            .success(function (data) {
                                if (!angular.isUndefined(data.invalid)) {
                                    $scope.additionals['invalid'] = data.invalid;
                                } else {
                                    if (!angular.isUndefined($scope.additionals['functionResult'])) {
                                        $scope.additionals['functionResult'](ev, data);
                                    }
                                    if (!angular.isUndefined(data.newDependentFields)) {
                                        angular.forEach(data.newDependentFields, function (item, key) {
                                            $scope.additionals[key].push(item);
                                        });
                                    }
                                    if (data.currentModel) {
                                      if ((data.currentModel['order_planning'] != null && data.currentModel['order_planning'] != 'null' && data.currentModel['order_planning'] != '' && moment().format('DD/MM/YYYY') == moment(data.currentModel.order_planning).format('DD/MM/YYYY')) || (data.currentModel['order_planning'] == null || data.currentModel['order_planning'] == 'null' || data.currentModel['order_planning'] == '')
                                     ) {
                                        var post = {};
                                        post['id'] = data.currentModel.id;
                                        post['route'] = 'printOrderAsincron';
                                        $scope.additionals['printOrderAsincron']($scope.path, post);
                                      }

                                        // var postCbms = {};
                                        // postCbms['order'] = {'id': data.currentModel.id};
                                        // postCbms['route'] = 'cbms';
                                        // $scope.additionals['cbms']($scope.path, postCbms);
                                    }
                                }

                                $scope.selectCall = 0;
                                $scope.selectReCall = 0;
                                $scope.additionals['function'](ev, {});
                                $scope.errors = {};
                                $scope.isLoading = false;
                                $scope.action = 'store';
                                $scope.additionals['total_product'] = 0;
                                $scope.additionals['order_product_sgr'] = 0;
                                $scope.additionals['buttonDisabled'] = false;
                                $scope.additionals['closeTime']();

                            })
                            .error(function (data) {
                                $scope.isLoading = false;
                                $scope.errors = data.errors;
                                if (!angular.isUndefined($scope.additionals['functionErrors'])) {
                                    $scope.additionals['functionErrors'](ev, data);
                                }
                                $scope.additionals['buttonDisabled'] = false;
                            });
                }
            };

            /* edit model */
            $scope.editModel = function (ev, path, model) {
                Crud.get($scope.path + '/saveOrderMode?order_id=' + model.id)
                        .success(function (management) {
                            if (management.current.order_id == parseInt(model.id) && management.current.order_by == $rootScope.session.user.id) {
                                /*$scope.editActive = [];
                                 angular.forEach(management.others, function (item, key) {
                                 $scope.editActive[item] = 'order_active_other';
                                 });
                                 $scope.editActive[model.id] = 'order_active';*/

                                 $scope.additionals['originalModel'] = angular.copy(model);

                                $scope.action = 'update';
                                $scope.additionals['invalid'] = '';
                                var currentModel = {};
                                angular.forEach(model, function (item, key) {
                                    currentModel[key] = item;
                                });
                                $scope.modelData = currentModel;
                                $scope.cancel = function () {
                                    $scope.modelData = {};
                                    $scope.errors = {};
                                    $scope.controlSH = false;
                                };

                                if (!angular.isUndefined($scope.additionals['function'])) {
                                    $scope.additionals['function'](ev, $scope.modelData);
                                }
                                $scope.additionals['total_product_discount'] = parseFloat(model.order_product_discount);
                                $scope.additionals['total_product'] = parseFloat(model.order_amount) - parseFloat(model.order_product_discount);
                                $scope.additionals['total_client_discount'] = parseFloat(model.order_client_discount);
                                $scope.additionals['total_loyalty_point_discount'] = parseFloat(model.order_loyalty_point_discount);
                                $scope.additionals['shipping'] = parseFloat(model.order_shipping);
                                $scope.additionals['order_product_sgr'] = parseFloat(model.order_product_sgr);

                                $scope.updateModel = function () {

                                    $scope.additionals['buttonDisabled'] = true;
                                    if (!angular.isUndefined($scope.additionals['internFunction'])) {
                                        $scope.additionals['internFunction'](ev, $scope.modelData);
                                    }
                                    $scope.isLoading = true;

                                    var post = {};
                                    angular.extend(post, $scope.modelData);
                                    if (post.order_status == 0) {
                                        post.order_status = 1;
                                    }

                                    Crud.update($scope.additionals['content_type'], post, $rootScope.typeId, path)
                                            .success(function (data) {
                                                if (!angular.isUndefined(data.invalid)) {
                                                    $scope.additionals['invalid'] = data.invalid;
                                                } else {

                                                    if (!angular.isUndefined($scope.additionals['functionResult'])) {
                                                        $scope.additionals['functionResult'](ev, data);
                                                    }

                                                    /*if (!angular.isUndefined($scope.selected[model[$rootScope.typeId]])) {
                                                     $scope.selected[model[$rootScope.typeId]] = model;
                                                     }
                                                     if (!angular.isUndefined(data.currentModel)) {
                                                     if (!angular.isUndefined($scope.models)) {
                                                     $scope.getElement($scope.models, data.currentModel);
                                                     }
                                                     if (!angular.isUndefined($scope.modelData)) {
                                                     $scope.modelData = data.currentModel;
                                                     }
                                                     } else {
                                                     if (!angular.isUndefined($scope.models)) {
                                                     $scope.getElement($scope.models, currentModel);
                                                     }
                                                     if (!angular.isUndefined($scope.modelData)) {
                                                     $scope.modelData = currentModel;
                                                     }
                                                     }*/
                                                    if (data.currentModel) {
                                                        if (!angular.isUndefined(data.controlChangedOrder) && data.controlChangedOrder == 1) {
                                                          var post = {};
                                                          post['id'] = data.currentModel.id;
                                                          post['route'] = 'printOrderAsincron';
                                                          $scope.additionals['printOrderAsincron'](path, post, $scope.additionals['originalModel']['order_status']);
                                                        }

                                                        if (!angular.isUndefined(data.controlTazz)) {
                                                          if (!angular.isUndefined(data.controlTazz.order_orig_id) && data.controlTazz.order_orig_id != 0) {
                                                              var post = {};
                                                              post['order_orig_id'] = data.controlTazz.order_orig_id;
                                                              post['delivery_time'] = data.controlTazz.delivery_time;
                                                              post['route'] = 'responseTazz';
                                                              $scope.additionals['responseTazz'](path, post);
                                                          }
                                                        }

                                                        // var postCbms = {};
                                                        // postCbms['order'] = $scope.additionals['originalModel'];
                                                        // postCbms['route'] = 'cbms';
                                                        // $scope.additionals['cbms'](path, postCbms);
                                                    }


                                                }
                                                $scope.errors = {};
                                                $scope.isLoading = false;
                                                $scope.action = 'store';
                                                $scope.additionals['buttonDisabled'] = false;
                                                if ($location.path() != $scope.path + '/getOrder') {
                                                    $scope.modelData = {};
                                                } else {
                                                    $scope.additionals['function'](ev, {});
                                                }
                                                $scope.closeOrderMode(ev, path, model.id);
                                            })
                                            .error(function (data) {
                                                $scope.action = 'update';
                                                $scope.isLoading = false;
                                                $scope.errors = data.errors;
                                                if ($location.path() == '/order/getOrder' || $location.path() == '/order' || $location.path() == '/order/orderPlanned') {
                                                    if (angular.isUndefined(data.errors)) {
                                                      data.errors = {};
                                                    }
                                                    if(!angular.isUndefined(data.errors.order_planning_date) && data.errors.order_planning_date[0] == "Nu se poate sterge data de planificare pentru ca data de start < data curenta"){

                                                        if (!angular.isUndefined(model.order_planning)) {
                                                          if (model.order_planning != null) {

                                                              var dateArray = model.order_planning.split(' ');
                                                              $scope.modelData.order_planning_date = new Date(model.order_planning);
                                                              $scope.modelData.order_planning_time = new Date(dateArray[0] + ' ' + dateArray[1]);
                                                          }
                                                      }
                                                    }
                                                }
                                                $scope.additionals['buttonDisabled'] = false;
                                            });
                                };

                            } else {
                                //$scope.editActive = [];
                                $scope.modelData = {};
                            }

                        });
            };

            /* show model */
            $scope.showModelOrder = function (ev, path, model, key) {
                Crud.get($scope.path + '/saveOrderMode?order_id=' + model)
                        .success(function (management) {
                            if (management.current.order_id == parseInt(model) && management.current.order_by == $rootScope.session.user.id) {
                                $scope.additionals['buttonDisabled'] = true;
                                /* key is index model */
                                if (!angular.isUndefined(key)) {
                                    $scope.additionals['indexModel'] = key;
                                }
                                $scope.modelData = {};
                                $scope.additionals.showData = {};
                                $scope.action = 'show';
                                Crud.show(model, path)
                                  .success(function (data) {
                                      $scope.additionals['originalModelShow'] = angular.copy(data);

                                      $scope.modelData = data;
                                      $scope.additionals.showData = data;

                                      $scope.additionals['calcProcess'](data);
                                      $scope.additionals['buttonDisabled'] = false;
                                  });
                            }
                        });
            };

            /* get calls */
            $scope.filtersCall = {};
            $scope.getCalls = function () {
                Crud.get($scope.path + '/getCalls')
                        .success(function (data) {
                            if (!angular.isUndefined(data.invalid)) {
                                $scope.additionals['invalid'] = data.invalid;
                            } else {
                                $scope.calls = data;
                            }
                            $scope.columnsCall = {
                                'call_source': {'label': 'Nr. tel', 'filter': 1, 'filterType': 'input'},
                                'client_id': {'label': 'Client', 'filter': 1, 'filterType': 'input', 'associate': 1, 'relation': 'client', 'colRelation': 'client_name'},
                                'call_start': {'label': 'Data/ora', 'filter': 1, 'filterType': 'input'},
                                'call_status': {'label': 'Status', 'filter': 1, 'filterType': 'select'},
                                'call_destination': {'label': 'Ext.', 'filter': 1, 'filterType': 'input'},
                            };

                            $scope.columnsCall.call_status.options = [
                                {'id': 1, 'value': 'in curs', 'color': 'rgba(193, 32, 38, 0.7)', 'color-even': 'rgba(193, 32, 38, 0.5)'}, //red
                                {'id': 2, 'value': 'preluat', 'color': 'rgba(242, 237, 86, 0.9)', 'color-even': 'rgba(242, 237, 86, 0.7)'}//yellow
                            ];
                            $scope.additionals['buttonDisabled'] = false;

                            $scope.additionals['call_status_string'] = JSON.stringify($scope.columnsCall['call_status'].options);
                        });
            }

            /* get missed calls */
            $scope.getMissedCalls = function () {
                Crud.get($scope.path + '/getMissedCalls')
                        .success(function (data) {
                            if (!angular.isUndefined(data.invalid)) {
                                $scope.additionals['invalid'] = data.invalid;
                            } else {
                                $scope.missedCalls = data;
                            }
                            $scope.columnsMissedCall = {
                                'call_source': {'label': 'Nr. tel', 'filter': 1, 'filterType': 'input'},
                                'client_id': {'label': 'Client', 'filter': 1, 'filterType': 'input', 'associate': 1, 'relation': 'client', 'colRelation': 'client_name'},
                                'call_start': {'label': 'Data/ora', 'filter': 1, 'filterType': 'input'},
                                'call_status': {'label': 'Status', 'filter': 1, 'filterType': 'select'},
                                'call_destination': {'label': 'Ext.', 'filter': 1, 'filterType': 'input'},
                            };

                            $scope.columnsMissedCall.call_status.options = [
                                {'id': 0, 'value': 'nepreluat', 'color': 'rgba(169, 215, 65, 0.9)', 'color-even': 'rgba(169, 215, 65, 0.7)'}, //green
                                {'id': 4, 'value': 'preluat', 'color': 'rgba(242, 237, 86, 0.9)', 'color-even': 'rgba(242, 237, 86, 0.7)'}//yellow
                            ];
                            $scope.additionals['buttonDisabled'] = false;

                            $scope.additionals['call_status_missed_string'] = JSON.stringify($scope.columnsMissedCall['call_status'].options);
                        });
            }

            /* close call */
            $scope.closeCall = function (ev, model) {

                if (model.call_destination == $rootScope.session.user.interior_no) {
                    $scope.additionals['buttonDisabled'] = true;
                    var post = {};
                    if (!angular.isUndefined(model.call_id)) {
                        post['call_id'] = model.call_id;
                    } else {
                        post['call_id'] = model.id;
                    }
                    post['route'] = 'closeCall';
                    Crud.post('form-urlencoded', post, $scope.path + '/closeCall')
                            .success(function (data) {
                                $scope.selectCall = 0;
                                $scope.modelData = {};
                                $scope.errors = {};
                                $scope.additionals['buttonDisabled'] = false;
                                $scope.lastOrderClient = '';
                                $scope.modelsHistory = [];

                                $scope.additionals['loyalty_point_accumulated'] = 0;
                                $scope.additionals['discount_campaigns'] = [];
                            });
                }
            }

            $scope.closeReCall = function (ev, model) {
                if (model.call_destination == $rootScope.session.user.interior_no) {
                    $scope.additionals['buttonDisabled'] = true;
                    var post = {};
                    if (!angular.isUndefined(model.call_id)) {
                        post['call_id'] = model.call_id;
                    } else {
                        post['call_id'] = model.id;
                    }
                    post['route'] = 'closeCall';

                    Crud.post('form-urlencoded', post, $scope.path + '/closeReCall')
                            .success(function (data) {
                                $scope.selectReCall = 0;
                                $scope.modelData = {};
                                $scope.errors = {};
                                $scope.additionals['buttonDisabled'] = false;
                                $scope.lastOrderClient = '';
                                $scope.modelsHistory = [];

                                $scope.additionals['loyalty_point_accumulated'] = 0;
                                $scope.additionals['discount_campaigns'] = [];
                            });
                }
            }

            $scope.controlSearchOrder = 0;
            $scope.toggleSearch = function (ev) {
                if ($scope.controlSearchOrder == 0) {
                    $scope.controlSearchOrder = 1;
                } else {
                    $scope.controlSearchOrder = 0;
                    $scope.getOrders($scope.path, 1, perPage, 'not0');
                }
            }

            /* updated orders */
            $scope.fromUpdated = 1;
            $scope.current_pageUpdated = [];
            $scope.last_pageUpdated = [];
            $scope.totalUpdated = [];
            $scope.models = [];
            $scope.getOrders($scope.path, 1, perPage, 'not0');
            /* end updated orders */

            /* preloaded orders */
            $scope.fromPreloaded = 1;
            $scope.current_pagePreloaded = [];
            $scope.last_pagePreloaded = [];
            $scope.totalPreloaded = [];
            $scope.modelsPreloaded = [];
            $scope.getOrdersPreloaded($scope.path, 1, perPage, 0);
            $scope.filtersPreloaded = {};
            $scope.$watch('filtersPreloaded', function () {
                $scope.filterColumnPreloaded = $scope.filtersPreloaded;
            }, true);
            /* end preloaded orders */

            $scope.getCalls();
            $scope.getMissedCalls();

            $scope.filtersHistory = {};
            $scope.$watch('filtersHistory', function () {
                $scope.filterColumnHistory = $scope.filtersHistory;
            }, true);
        }

        /* view order */
        if ($route.current.$$route.originalPath.split(':')[0] == $scope.path + '/view/') {

            $scope.typeView = 'view-order';
            $scope.kitchenId = $routeParams['kitchen'];
            $scope.pathTemplate = 'orders/vieworders';

            /* move order */
            $scope.modelDataKitchen = {};
            $scope.moveOrder = function (ev, path, orderId, kitcheId, key) {

                if ($scope.kitchenId != $scope.modelDataKitchen.kitchen_id) {
                    $scope.additionals['buttonDisabled'] = true;
                    $scope.isLoading = true;

                    var post = {};
                    post['route'] = 'moveOrder';
                    post['order_id'] = orderId;
                    post['current_kitchen_id'] = $scope.kitchenId;
                    post['kitchen_id'] = $scope.modelDataKitchen.kitchen_id;

                    Crud.post('form-urlencoded', post, path + '/moveOrder')
                            .success(function (data) {
                                if (!angular.isUndefined(data.invalid)) {
                                    $scope.additionals['invalid'] = data.invalid;
                                } else {
                                }
                                $scope.modelDataKitchen = {};
                                $scope.errors = {};
                                $scope.isLoading = false;
                                $scope.controlSH = false;
                                $scope.additionals['buttonDisabled'] = false;

                                var postPrint = {};
                                postPrint['id'] = orderId;
                                postPrint['route'] = 'printOrderAsincron';
                                $scope.additionals['printOrderAsincron'](path, postPrint);

                            })
                            .error(function (data) {
                                $scope.isLoading = false;
                                $scope.errors = data.errors;
                                $scope.additionals['buttonDisabled'] = false;
                                if (data == null) {
                                    $rootScope.checkNetworkConnection();
                                }
                            });
                } else {
                    $scope.modelDataKitchen = {};
                    $scope.errors = {};
                }
            };
            /* end move order */

            /* check location */
            $scope.checkLocation = function (data) {
                var control = 0;
                if (!angular.isUndefined($scope.localitiesKitchen)) {
                    angular.forEach($scope.localitiesKitchen, function (itemLoc, keyLoc) {
                        //if(itemLoc.count_order > 0) {
                        if (data.section_name != null && data.section_name != '') {
                            angular.forEach(itemLoc['section'], function (itemSection, keySec) {
                                if (data.section_name == itemSection.section_name) {
                                    //if (itemSection.count_order > 0) {
                                    if (!angular.isUndefined($scope.sectionsView)) {
                                        if (!angular.isUndefined($scope.sectionsView)) {
                                            if (!angular.isUndefined($scope.sectionsView[itemLoc.locality_id])) {
                                                if ($scope.sectionsView[itemLoc.locality_id][itemSection.section_id] == true) {
                                                    control = 1;
                                                }
                                            }
                                        }
                                    }
                                    //}
                                }
                            });
                        } else {
                            if (data.locality_name != null && data.locality_name != '' && data.locality_name == itemLoc.locality_name) {
                                if (!angular.isUndefined($scope.localitiesView)) {
                                    if ($scope.localitiesView[itemLoc.locality_id] == true) {
                                        control = 1;
                                    }
                                }
                            }
                        }
                        //}
                    });
                }

                return control;

            }
            /* end check location */

            /* update kitchen buttons */
            $scope.additionals['updateKitchenButton'] = function (model) {
                angular.forEach(model.kitchens_finished, function (itemKitchenFinished, indexKitchenFinished) {

                    if (angular.isUndefined($scope.additionals['products'][model['id']])) {
                        $scope.additionals['products'][model['id']] = {};
                    }
                    if (angular.isUndefined($scope.additionals['products'][model['id']][indexKitchenFinished])) {
                        $scope.additionals['products'][model['id']][indexKitchenFinished] = {};
                    }
                    if (!angular.isUndefined(itemKitchenFinished['finished'])) {
                        if (itemKitchenFinished['finished'] == 1) {
                            $scope.additionals['products'][model['id']][indexKitchenFinished]['all'] = true;
                        } else {
                            $scope.additionals['products'][model['id']][indexKitchenFinished]['all'] = false;
                        }
                    }

                });

            }
            /* end update kitchen buttons */

            /* mqtt update localities/sections on kitchen */
            $scope.mqttUpdateLocalitiesSectionsKitchen = function (model) {

              angular.forEach(model, function (itemOrder, keyOrder) {
                if(itemOrder.length == 0){
                  $scope.localitiesKitchen = [];
                  $scope.total_count_order = 0;
                }
                angular.forEach(itemOrder, function (itemKitchen, keyKitchen) {
                  if(parseInt(itemKitchen['kitchen_id']) == parseInt($scope.kitchenId)){
                      $scope.localitiesKitchen = itemKitchen.localities;
                      $scope.total_count_order = 0;
                      angular.forEach(itemKitchen.localities, function (item, key) {
                          $scope.total_count_order = $scope.total_count_order + item['count_order'];
                      });
                    }
                });
              });
            }
            /* mqtt update localities/sections on kitchen */

            /* mqtt update orders on kitchen */
            $scope.mqttUpdateOrderKitchen = function (model, current_status, ex_status) {
              // console.log(current_status)
              // console.log(ex_status)
              // console.log(model)

              if (current_status <= 3) {
                if (angular.isUndefined($scope.notificationsCancellationTazz)) {
                  $scope.notificationsCancellationTazz = [];
                }
                if (!angular.isUndefined(model.notificationsCancellationTazz)) {
                  if (!angular.isUndefined(model.notificationsCancellationTazz.order_no)) {
                    var positionUpdatedNotification = $scope.notificationsCancellationTazz.map(function (e) {
                        return e['order_no'];
                    }).indexOf(parseInt(model.notificationsCancellationTazz.order_no));
                    if (positionUpdatedNotification < 0) {
                      $scope.notificationsCancellationTazz.push(model.notificationsCancellationTazz);
                    }
                  }
                }
              }

                $scope.controlExpand[model.id] = false;

                /* calculate times in sections */
                $scope.additionals['calcProcess'](model, 'Kitchen');
                /* end calculate times in sections */

                if (!angular.isUndefined($scope.kitchenId)) {
                    per_page = perPageKitchen;
                } else {
                    per_page = perPage;
                }

                if (angular.isUndefined($scope.localitiesView) || $scope.localitiesView == null) {
                    $scope.localitiesView = {};
                }
                if (angular.isUndefined($scope.sectionsView) || $scope.sectionsView == null) {
                    $scope.sectionsView = {};
                }

                if (current_status == 1) {
                    if (ex_status == 1) {

                        $scope.controlExpand[parseInt(model.id)] = false;

                        var positionUpdated = $scope.models.map(function (e) {
                            return e['id'];
                        }).indexOf(parseInt(model.id));
                        if (positionUpdated < 0) {

                            if (Object.keys($scope.localitiesView).length === 0 && Object.keys($scope.sectionsView).length === 0) {

                                angular.forEach(model.kitchens, function (item, key) {
                                    if ($scope.kitchenId == item && ((moment().format('DD/MM/YYYY') == moment(model.order_start).format('DD/MM/YYYY') && angular.isUndefined(model['order_planning']) || model['order_planning'] == null) || (!angular.isUndefined(model['order_planning']) && model['order_planning'] != null && model['order_planning'] != 'null' && model['order_planning'] != '' && moment().format('DD/MM/YYYY') == moment(model.order_planning).format('DD/MM/YYYY'))   ) ) {

                                        //if (!angular.isUndefined(model['kitchens_finished'])) {
                                            //if (model['kitchens_finished'][parseInt(item)]['finished'] == 0) {

                                              if ((!angular.isUndefined(model['order_planning']) && model['order_planning'] != null && model['order_planning'] != 'null' && model['order_planning'] != '' && moment().format('DD/MM/YYYY') == moment(model.order_planning).format('DD/MM/YYYY')) || (angular.isUndefined(model['order_planning']) || model['order_planning'] == null)  ) {

                                                $scope.total['order'] = $scope.total['order'] + 1;
                                                var current_page = $scope.models.current_page;

                                                $scope.models.push(model);
                                                $scope.models = $filter('orderBy')($scope.models, 'order_start');
                                                $scope.additionals['sortByProp'] ($scope.models, 'source_incident_id');

                                                $scope.models = $scope.additionals['uniqueArray']($scope.models);
                                                $scope.models.current_page = current_page;

                                                if (angular.isUndefined($scope.additionals['products'][model['id']])) {
                                                    $scope.additionals['products'][model['id']] = {};
                                                }
                                                if (angular.isUndefined($scope.additionals['products'][model['id']][parseInt(item)])) {
                                                    $scope.additionals['products'][model['id']][parseInt(item)] = {};
                                                }
                                                $scope.additionals['products'][model['id']][parseInt(item)]['all'] = false;
                                              }
                                            //}
                                        //}
                                    }
                                });
                            } else {

                                if (model['kitchens'].indexOf(parseInt($scope.kitchenId)) > -1 && moment().format('DD/MM/YYYY') == moment(model.order_start).format('DD/MM/YYYY')) {
                                    if (model.shipping_method_id == 1) {
                                        var controlLocation = $scope.checkLocation(model);
                                        if (controlLocation == 1) {
                                            var current_page = $scope.models.current_page;

                                            $scope.total['order'] = $scope.total['order'] + 1;

                                            $scope.models.push(model);
                                            $scope.models = $filter('orderBy')($scope.models, 'order_start');
                                            $scope.additionals['sortByProp'] ($scope.models, 'source_incident_id');
                                            $scope.models = $scope.additionals['uniqueArray']($scope.models);

                                            $scope.models.current_page = current_page;
                                        }
                                    } else {
                                        var current_page = $scope.models.current_page;

                                        $scope.total['order'] = $scope.total['order'] + 1;

                                        $scope.models.push(model);
                                        $scope.models = $filter('orderBy')($scope.models, 'order_start');
                                        $scope.additionals['sortByProp'] ($scope.models, 'source_incident_id');
                                        $scope.models = $scope.additionals['uniqueArray']($scope.models);

                                        $scope.models.current_page = current_page;
                                    }
                                }
                            }

                        } else {

                            if (model['kitchens'].indexOf(parseInt($scope.kitchenId)) <= -1 || (!angular.isUndefined(model['order_planning']) && model['order_planning'] != null && model['order_planning'] != 'null' && model['order_planning'] != '' && moment().format('DD/MM/YYYY') != moment(model.order_planning).format('DD/MM/YYYY'))  ) {
                                $scope.total['order'] = $scope.total['order'] - 1;
                                if ($scope.total['order'] < 0) {
                                    $scope.total['order'] = 0;
                                }
                                $scope.models.splice(positionUpdated, 1);
                            } else {

                                if (Object.keys($scope.localitiesView).length === 0 && Object.keys($scope.sectionsView).length === 0) {
                                    angular.forEach(model.kitchens, function (item, key) {
                                        if ($scope.kitchenId == item && moment().format('DD/MM/YYYY') == moment(model.order_start).format('DD/MM/YYYY')) {
                                            $scope.models[positionUpdated] = model;
                                        }
                                    });
                                } else {
                                    if (model.shipping_method_id == 1) {
                                        var controlLocation = $scope.checkLocation(model);
                                        if (controlLocation == 1) {
                                            $scope.models[positionUpdated] = model;
                                        } else {
                                            $scope.total['order'] = $scope.total['order'] - 1;
                                            if ($scope.total['order'] < 0) {
                                                $scope.total['order'] = 0;
                                            }
                                            $scope.models.splice(positionUpdated, 1);
                                        }
                                    } else {
                                        $scope.models[positionUpdated] = model;
                                    }
                                }
                            }

                        }

                    } else {
                        var positionUpdated = $scope.models.map(function (e) {
                            return e['id'];
                        }).indexOf(parseInt(model.id));
                        if (positionUpdated < 0) {
                            if (Object.keys($scope.localitiesView).length === 0 && Object.keys($scope.sectionsView).length === 0) {
                                angular.forEach(model.kitchens, function (item, key) {
                                    if ($scope.kitchenId == item && ((moment().format('DD/MM/YYYY') == moment(model.order_start).format('DD/MM/YYYY') && angular.isUndefined(model['order_planning']) || model['order_planning'] == null) || (!angular.isUndefined(model['order_planning']) && model['order_planning'] != null && model['order_planning'] != 'null' && model['order_planning'] != '' && moment().format('DD/MM/YYYY') == moment(model.order_planning).format('DD/MM/YYYY'))   ) ) {

                                        $scope.total['order'] = $scope.total['order'] + 1;
                                        var current_page = $scope.models.current_page;
                                        $scope.models.push(model);
                                        $scope.models = $filter('orderBy')($scope.models, 'order_start');
                                        $scope.additionals['sortByProp'] ($scope.models, 'source_incident_id');
                                        $scope.models = $scope.additionals['uniqueArray']($scope.models);

                                        $scope.models.current_page = current_page;
                                    }
                                });
                            } else {
                                if (model['kitchens'].indexOf(parseInt($scope.kitchenId)) > -1 && ((moment().format('DD/MM/YYYY') == moment(model.order_start).format('DD/MM/YYYY') && angular.isUndefined(model['order_planning']) || model['order_planning'] == null) || (!angular.isUndefined(model['order_planning']) && model['order_planning'] != null && model['order_planning'] != 'null' && model['order_planning'] != '' && moment().format('DD/MM/YYYY') == moment(model.order_planning).format('DD/MM/YYYY'))   ) ) {
                                    if (model.shipping_method_id == 1) {
                                        var controlLocation = $scope.checkLocation(model);
                                        if (controlLocation == 1) {
                                            var current_page = $scope.models.current_page;

                                            $scope.total['order'] = $scope.total['order'] + 1;
                                            $scope.models.push(model);
                                            $scope.models = $filter('orderBy')($scope.models, 'order_start');
                                            $scope.additionals['sortByProp'] ($scope.models, 'source_incident_id');
                                            $scope.models = $scope.additionals['uniqueArray']($scope.models);

                                            $scope.models.current_page = current_page;
                                        }
                                    } else {
                                        $scope.total['order'] = $scope.total['order'] + 1;
                                        var current_page = $scope.models.current_page;

                                        $scope.models.push(model);
                                        $scope.models = $filter('orderBy')($scope.models, 'order_start');
                                        $scope.additionals['sortByProp'] ($scope.models, 'source_incident_id');
                                        $scope.models = $scope.additionals['uniqueArray']($scope.models);

                                        $scope.models.current_page = current_page;
                                    }
                                }
                            }

                        }

                    }
                } else {

                    if (!angular.isUndefined($scope.models)) {
                        var positionUpdated = $scope.models.map(function (e) {
                            return e['id'];
                        }).indexOf(parseInt(model.id));
                        if (positionUpdated >= 0) {

                            $scope.total['order'] = $scope.total['order'] - 1;
                            if ($scope.total['order'] < 0) {
                                $scope.total['order'] = 0;
                            }
                            $scope.models.splice(positionUpdated, 1);
                            if ($scope.models.length <= 0) {
                                var no_pagesUpdated = Math.ceil(($scope.total - 1) / per_page);
                                if ($scope.models.current_page > no_pagesUpdated) {
                                    $scope.models.current_page = no_pagesUpdated;
                                }
                                if (angular.isUndefined($scope.models.current_page) || $scope.models.current_page == 0) {
                                    $scope.models.current_page = 1;
                                }
                                $scope.getOrders($scope.path, $scope.models.current_page, per_page);
                            }
                        }
                    }
                }

                $scope.additionals['updateKitchenButton'](model);

            };

            $scope.mqttMoveOrderKitchen = function (model, current_status, ex_status) {

                $scope.controlExpand[model.id] = false;

                /* calculate times in sections */
                $scope.additionals['calcProcess'](model, 'Kitchen');
                /* end calculate times in sections */

                if (!angular.isUndefined($scope.kitchenId)) {
                    per_page = perPageKitchen;
                } else {
                    per_page = perPage;
                }

                if (angular.isUndefined($scope.localitiesView) || $scope.localitiesView == null) {
                    $scope.localitiesView = {};
                }
                if (angular.isUndefined($scope.sectionsView) || $scope.sectionsView == null) {
                    $scope.sectionsView = {};
                }

                if (!angular.isUndefined($scope.models)) {
                    var positionUpdated = $scope.models.map(function (e) {
                        return e['id'];
                    }).indexOf(parseInt(model.id));
                    if (positionUpdated >= 0) {
                        if (model.kitchens.indexOf(parseInt($scope.kitchenId)) < 0) {
                            $scope.total['order'] = $scope.total['order'] - 1;
                            if ($scope.total['order'] < 0) {
                                $scope.total['order'] = 0;
                            }
                            $scope.models.splice(positionUpdated, 1);
                            /*if ($scope.models.length <= 0) {
                             var no_pagesUpdated = Math.ceil(($scope.total - 1) / per_page);
                             if ($scope.models.current_page > no_pagesUpdated) {
                             $scope.models.current_page = no_pagesUpdated;
                             }
                            if (angular.isUndefined($scope.models.current_page) || $scope.models.current_page == 0) {
                                $scope.models.current_page = 1;
                            }
                             $scope.getOrders($scope.path, $scope.models.current_page, per_page);
                             }*/
                        }
                    } else {
                        if (Object.keys($scope.localitiesView).length === 0 && Object.keys($scope.sectionsView).length === 0) {
                            angular.forEach(model.kitchens, function (item, key) {
                                if ($scope.kitchenId == item && ((moment().format('DD/MM/YYYY') == moment(model.order_start).format('DD/MM/YYYY') && angular.isUndefined(model['order_planning']) || model['order_planning'] == null) || (!angular.isUndefined(model['order_planning']) && model['order_planning'] != null && model['order_planning'] != 'null' && model['order_planning'] != '' && moment().format('DD/MM/YYYY') == moment(model.order_planning).format('DD/MM/YYYY'))   ) ) {
                                    $scope.total['order'] = $scope.total['order'] + 1;
                                    var current_page = $scope.models.current_page;

                                    $scope.models.push(model);
                                    $scope.models = $filter('orderBy')($scope.models, 'order_start');
                                    $scope.additionals['sortByProp'] ($scope.models, 'source_incident_id');
                                    $scope.models = $scope.additionals['uniqueArray']($scope.models);

                                    $scope.models.current_page = current_page;
                                }
                            });
                        } else {
                            if (model['kitchens'].indexOf(parseInt($scope.kitchenId)) > -1 ((moment().format('DD/MM/YYYY') == moment(model.order_start).format('DD/MM/YYYY') && angular.isUndefined(model['order_planning']) || model['order_planning'] == null) || (!angular.isUndefined(model['order_planning']) && model['order_planning'] != null && model['order_planning'] != 'null' && model['order_planning'] != '' && moment().format('DD/MM/YYYY') == moment(model.order_planning).format('DD/MM/YYYY'))   ) ) {
                                if (model.shipping_method_id == 1) {
                                    var controlLocation = $scope.checkLocation(model);
                                    if (controlLocation == 1) {
                                        var current_page = $scope.models.current_page;

                                        $scope.total['order'] = $scope.total['order'] + 1;
                                        $scope.models.push(model);
                                        $scope.models = $filter('orderBy')($scope.models, 'order_start');
                                        $scope.additionals['sortByProp'] ($scope.models, 'source_incident_id');
                                        $scope.models = $scope.additionals['uniqueArray']($scope.models);

                                        $scope.models.current_page = current_page;
                                    }
                                } else {
                                    var current_page = $scope.models.current_page;

                                    $scope.total['order'] = $scope.total['order'] + 1;
                                    $scope.models.push(model);
                                    $scope.models = $filter('orderBy')($scope.models, 'order_start');
                                    $scope.additionals['sortByProp'] ($scope.models, 'source_incident_id');
                                    $scope.models = $scope.additionals['uniqueArray']($scope.models);

                                    $scope.models.current_page = current_page;
                                }
                            }
                        }
                    }
                }

            };

            $scope.mqttUpdateFoodProductsKitchen = function (model) {

                if (!angular.isUndefined($scope.kitchenId)) {
                    per_page = perPageKitchen;
                } else {
                    per_page = perPage;
                }

                if (angular.isUndefined($scope.localitiesView) || $scope.localitiesView == null) {
                    $scope.localitiesView = {};
                }
                if (angular.isUndefined($scope.sectionsView) || $scope.sectionsView == null) {
                    $scope.sectionsView = {};
                }

                var positionUpdated = $scope.models.map(function (e) {
                    return e['id'];
                }).indexOf(parseInt(model.id));
                if (positionUpdated < 0) {
                    if (Object.keys($scope.localitiesView).length === 0 && Object.keys($scope.sectionsView).length === 0) {
                        /*angular.forEach(model.kitchens, function (item, key) {
                         if ($scope.kitchenId == item && moment().format('DD/MM/YYYY') == moment(model.order_start).format('DD/MM/YYYY')) {
                         var current_page = $scope.models.current_page;

                         $scope.models.push(model);
                         $scope.models = $filter('orderBy')($scope.models, 'order_start');

                         $scope.models = $scope.additionals['uniqueArray']($scope.models);
                         $scope.models.current_page = current_page;
                         }
                         });*/
                    } else {
                        if (model['kitchens'].indexOf(parseInt($scope.kitchenId)) > -1 && ((moment().format('DD/MM/YYYY') == moment(model.order_start).format('DD/MM/YYYY') && angular.isUndefined(model['order_planning']) || model['order_planning'] == null) || (!angular.isUndefined(model['order_planning']) && model['order_planning'] != null && model['order_planning'] != 'null' && model['order_planning'] != '' && moment().format('DD/MM/YYYY') == moment(model.order_planning).format('DD/MM/YYYY'))   ) ) {
                            if (model.shipping_method_id == 1) {
                                var controlLocation = $scope.checkLocation(model);
                                if (controlLocation == 1) {
                                    var current_page = $scope.models.current_page;

                                    $scope.models.push(model);
                                    $scope.models = $filter('orderBy')($scope.models, 'order_start');
                                    $scope.models = $scope.additionals['uniqueArray']($scope.models);

                                    $scope.models.current_page = current_page;
                                }
                            } else {
                                var current_page = $scope.models.current_page;

                                $scope.models.push(model);
                                $scope.models = $filter('orderBy')($scope.models, 'order_start');
                                $scope.models = $scope.additionals['uniqueArray']($scope.models);

                                $scope.models.current_page = current_page;
                            }
                        }
                    }
                } else {
                    if (model['kitchens'].indexOf(parseInt($scope.kitchenId)) <= -1) {
                        $scope.models.splice(positionUpdated, 1);
                    } else {

                        if (angular.isUndefined($scope.additionals['products'])) {
                            $scope.additionals['products'] = {};
                        }
                        var item = model;
                        if (angular.isUndefined($scope.additionals['products'][item['id']])) {
                            $scope.additionals['products'][item['id']] = {};
                        }
                       if (!angular.isUndefined(item['current_kitchen'])) {
                         if (angular.isUndefined($scope.additionals['products'][item['id']][parseInt(item['current_kitchen'])])) {
                             $scope.additionals['products'][item['id']][parseInt(item['current_kitchen'])] = {};
                         }
                         if (!angular.isUndefined(item['food_products_value'])) {
                             if (item['food_products_value'] == 'true') {
                                 $scope.additionals['products'][item['id']][parseInt(item['current_kitchen'])]['all'] = true;
                             } else {
                                 $scope.additionals['products'][item['id']][parseInt(item['current_kitchen'])]['all'] = false;
                             }
                         }
                       }

                        angular.forEach(model['kitchens'], function (itemKitchen, indexKitchen) {
                        //if (!angular.isUndefined(item['current_kitchen'])) {
                            if (angular.isUndefined($scope.additionals['products'][item['id']][parseInt(itemKitchen)])) {
                                $scope.additionals['products'][item['id']][parseInt(itemKitchen)] = {};
                            }
                            // if (!angular.isUndefined(item['food_products_value'])) {
                            //     if (item['food_products_value'] == 'true') {
                            //         $scope.additionals['products'][item['id']][parseInt(itemKitchen)]['all'] = true;
                            //     } else {
                            //         $scope.additionals['products'][item['id']][parseInt(itemKitchen)]['all'] = false;
                            //     }
                            // }
                        //}

                        var controlProduct = 0;
                        var controlSupplement = 0;
                        angular.forEach(item.food_products, function (itemProduct, indexProduct) {
                            if (itemProduct.finished == 1) {
                                //$scope.additionals['products'][item['id']][item['current_kitchen']][indexProduct] = true;
                                $scope.additionals['products'][item['id']][parseInt(itemKitchen)][indexProduct] = true;
                            } else {
                                //$scope.additionals['products'][item['id']][item['current_kitchen']][indexProduct] = false;
                                $scope.additionals['products'][item['id']][parseInt(itemKitchen)][indexProduct] = false;
                            }

                            // if (!angular.isUndefined($scope.kitchen)) {
                            //     var positionCategory = $scope.kitchen.food_categories.map(function (e) {
                            //         return e['id'];
                            //     }).indexOf(parseInt(itemProduct['food_category_id']));
                            //     if (positionCategory >= 0) {
                            //         if (angular.isUndefined($scope.additionals['products'][item['id']][item['current_kitchen']][indexProduct]) || $scope.additionals['products'][item['id']][item['current_kitchen']][indexProduct] == false) {
                            //             controlProduct = 1;
                            //         }
                            //     }
                            // }

                           //supplements
                            if (angular.isUndefined($scope.additionals['products'][item['id']][parseInt(itemKitchen)]['product'])) {
                                $scope.additionals['products'][item['id']][parseInt(itemKitchen)]['product'] = {};
                            }
                            if (angular.isUndefined($scope.additionals['products'][item['id']][parseInt(itemKitchen)]['product'][indexProduct])) {
                                $scope.additionals['products'][item['id']][parseInt(itemKitchen)]['product'][indexProduct] = {};
                            }

                            var linearArray = $scope.additionals['linearArray'](itemProduct['food_supplements']);
                            angular.forEach(linearArray, function (itemSupplement, indexSupplement) {
                                if (itemSupplement.finished == 1) {
                                    //$scope.additionals['products'][item['id']][item['current_kitchen']]['product'][indexProduct][itemSupplement['supplement_index']] = true;
                                    $scope.additionals['products'][item['id']][parseInt(itemKitchen)]['product'][indexProduct][itemSupplement['supplement_index']] = true;
                                } else {
                                    //$scope.additionals['products'][item['id']][item['current_kitchen']]['product'][indexProduct][itemSupplement['supplement_index']] = false;
                                    $scope.additionals['products'][item['id']][parseInt(itemKitchen)]['product'][indexProduct][itemSupplement['supplement_index']] = false;
                                }

                                // if (!angular.isUndefined($scope.kitchen)) {
                                //     var positionCategory = $scope.kitchen.food_categories.map(function (e) {
                                //         return e['id'];
                                //     }).indexOf(parseInt(itemProduct['food_category_id']));
                                //     if (positionCategory >= 0) {
                                //         if (angular.isUndefined($scope.additionals['products'][item['id']][item['current_kitchen']]['product'][indexProduct][itemSupplement['supplement_index']]) || $scope.additionals['products'][item['id']][item['current_kitchen']]['product'][indexProduct][itemSupplement['supplement_index']] == false) {
                                //             controlSupplement = 1;
                                //         }
                                //     }
                                // }
                            });
                        });
                        });

                        if (Object.keys($scope.localitiesView).length === 0 && Object.keys($scope.sectionsView).length === 0) {
                            angular.forEach(model.kitchens, function (item, key) {
                                if ($scope.kitchenId == item && ((moment().format('DD/MM/YYYY') == moment(model.order_start).format('DD/MM/YYYY') && angular.isUndefined(model['order_planning']) || model['order_planning'] == null) || (!angular.isUndefined(model['order_planning']) && model['order_planning'] != null && model['order_planning'] != 'null' && model['order_planning'] != '' && moment().format('DD/MM/YYYY') == moment(model.order_planning).format('DD/MM/YYYY'))   ) ) {
                                  if(!angular.isUndefined(model['keyProduct'])){
                                    $scope.models[positionUpdated]['food_products'][parseInt(model['keyProduct'])] = model['food_products'][0];
                                  } else {
                                    $scope.models[positionUpdated]['food_products'] = model['food_products'];
                                  }
                                }
                            });
                        } else {
                            if (model.shipping_method_id == 1) {
                                var controlLocation = $scope.checkLocation(model);
                                if (controlLocation == 1) {
                                  if(!angular.isUndefined(model['keyProduct'])){
                                    $scope.models[positionUpdated]['food_products'][parseInt(model['keyProduct'])] = model['food_products'][0];
                                  } else {
                                    $scope.models[positionUpdated]['food_products'] = model['food_products'];
                                  }
                                } else {
                                    $scope.models.splice(positionUpdated, 1);
                                }
                            } else {
                                if(!angular.isUndefined(model['keyProduct'])){
                                  $scope.models[positionUpdated]['food_products'][parseInt(model['keyProduct'])] = model['food_products'][0];
                                } else {
                                  $scope.models[positionUpdated]['food_products'] = model['food_products'];
                                }
                            }
                        }
                    }

                    var positionUpdated = $scope.models.map(function (e) {
                        return e['id'];
                    }).indexOf(parseInt(model.id));
                    if (parseInt(model['current_kitchen']) == parseInt($scope.kitchenId) && $scope.kitchen['kitchen_center'] == 0) {
                        if (!angular.isUndefined(model['food_products_value'])) {
                            if (model['food_products_value'] == 'true') {
                                $scope.total['order'] = $scope.total['order'] - 1;
                                if ($scope.total['order'] < 0) {
                                    $scope.total['order'] = 0;
                                }
                                $scope.models.splice(positionUpdated, 1);
                            }
                        }
                    }
                }

            };

            var perPageKitchenHistory = 10;
            $scope.getOrdersKitchenHistory = function (path, offset, per_page) {

                if (angular.isUndefined(per_page) || per_page == 'undefined') {
                    per_page = perPage;
                }
                $scope.additionals['buttonDisabledPagination'] = true;
                $scope.rangeKitchenHistory = [];
                if (angular.isUndefined($scope.no_pagesHistory)) {
                    $scope.no_pagesKitchenHistory = 1;
                }
                $scope.isLoadingPaginationKitchenHistory = true;
                $scope.$watch('no_pagesHistory', function (item) {
                    item = $scope.no_pagesKitchenHistory;
                }, true);

                var pathOrder = $scope.path + '/getOrdersKitchenHistory?page=' + offset + '&per_page=' + per_page + '&kitchenId=' + $scope.kitchenId;
                var crud = Crud.get(pathOrder);
                crud.success(function (data) {
                    if (!angular.isUndefined(data.invalid)) {
                        $scope.additionals['invalid'] = data.invalid;
                    } else {

                        if (!angular.isUndefined(data.data)) {
                            if (data.data.length <= 0) {
                                $scope.ordersKitchenHistory = [];
                            } else {
                                if (angular.isUndefined($scope.ordersKitchenHistory)) {
                                    $scope.ordersKitchenHistory = [];
                                }
                            }
                            $scope.fromKitchenHistory = data.from;
                            $scope.stopKitchenHistory = data.next_page_url;
                            $scope.toKitchenHistory = data.to;
                            $scope.totalKitchenHistory = data.total;
                            $scope.no_pagesKitchenHistory = Math.ceil(data.total / data.per_page);

                            if (per_page == 0) {
                                $scope.rangeKitchenHistory = [{}];
                            } else {
                                for (var i = 0; i < $scope.no_pagesKitchenHistory; i++) {
                                    $scope.rangeKitchenHistory[i] = i;
                                }
                            }
                            $scope.ordersKitchenHistory = data.data;
                            $scope.ordersKitchenHistory.per_page = data.per_page;
                            $scope.ordersKitchenHistory.current_page = data.current_page;
                        }
                    }
                    $scope.isLoadingPaginationKitchenHistory = false;
                    $scope.additionals['buttonDisabledPagination'] = false;
                });

            };

            $scope.showOrderKitchenHistory = function (ev, path, model) {

                $scope.additionals['buttonDisabled'] = true;

                Crud.show(model, path)
                        .success(function (data) {
                            if (!angular.isUndefined(data['order_start']) && !angular.isUndefined(data['validated_at'])) {
                                $scope.additionals['dispatchTimeKitchenHistory'] = $scope.additionals['diffDatesMinutes'](data['order_start'], data['validated_at']);
                            }
                            $scope.additionals['calcProcess'](data, 'KitchenHistory');

                            $mdDialog.show({
                                controller: DialogController,
                                templateUrl: 'showDialogKitchenHistory.tmpl.html',
                                parent: angular.element(document.body),
                                targetEvent: ev,
                                clickOutsideToClose: true,
                                locals: {
                                    pathTemplate: $scope.pathTemplate,
                                    model: data,
                                    formatText: $scope.formatText,
                                    formatDate: $scope.formatDate,
                                    columns: $scope.columns,
                                    additionals: $scope.additionals
                                },
                            });
                            DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'model', 'formatText', 'formatDate', 'columns', 'additionals'];
                            function DialogController($scope, $mdDialog, pathTemplate, model, formatText, formatDate, columns, additionals) {
                                $scope.pathTemplate = pathTemplate;
                                $scope.modelDataKitchenHistory = model;
                                $scope.additionals = additionals;
                                $scope.formatText = formatText;
                                $scope.formatDate = formatDate;
                                $scope.columns = columns;
                                $scope.currency = $rootScope.currency;

                                $scope.cancel = function () {
                                    $mdDialog.cancel();
                                };
                            }
                            $scope.additionals['buttonDisabled'] = false;
                        }).error(function (data) {
                            $scope.errors = data.errors;
                            $scope.additionals['buttonDisabled'] = false;
                            if (data == null) {
                                $rootScope.checkNetworkConnection();
                            }
                });

            };

            $scope.getKitchen = function () {
                Crud.get($scope.path + '/getKitchen/' + $scope.kitchenId)
                        .success(function (data) {
                            $scope.kitchen = data;
                            if ($scope.kitchen.allow_history == 1) {
                                $scope.getOrdersKitchenHistory($scope.path, 1, perPageKitchenHistory);
                            }
                        })
                        .error(function (data) {
                        });
            };
            $scope.getKitchen();

            $scope.getSectionsForKitchen = function () {
                Crud.get($scope.path + '/getSectionsForKitchen?kitchenId=' + $scope.kitchenId)
                        .success(function (data) {
                          if (!angular.isUndefined(data[0]) && !angular.isUndefined(data[0].localities)) {
                              $scope.localitiesKitchen = data[0].localities;

                              $scope.total_count_order = 0;
                              angular.forEach(data[0].localities, function (item, key) {
                                  $scope.total_count_order = $scope.total_count_order + item['count_order'];

                              });
                            }
                        })
                        .error(function (data) {
                        });
            };
            $scope.getSectionsForKitchen();

            /* updated orders */
            $scope.fromUpdated = 1;
            $scope.current_pageUpdated = [];
            $scope.last_pageUpdated = [];
            $scope.totalUpdated = [];
            $scope.models = [];
            $scope.getOrders($scope.path, 1, perPageKitchen);
            /* end updated orders */

            $scope.postLocalitiesView = [];
            $scope.postSectionsView = [];
            if (angular.isUndefined($scope.localitiesView)) {
                $scope.localitiesView = {};
            }
            $scope.getSearchOrders = function (localityId, sectionId, currentDate, localitiesView, sectionsView, controlLocality, controlSection) {

                $scope.additionals['buttonDisabledView'] = true;
                $scope.collapseAll($scope.models);

                /*if(!angular.isUndefined(sectionId) && sectionId != '') {
                 $scope.sectionActive = [];
                 $scope.localityActive = [];
                 $scope.sectionActive[sectionId] = 'section-active';
                 } else {
                 $scope.sectionActive = [];
                 $scope.localityActive = [];
                 $scope.localityActive[localityId] = 'locality-active';
                 }*/
                if (angular.isUndefined($scope.localityActive)) {
                    $scope.localityActive = [];
                }
                if (angular.isUndefined($scope.sectionActive)) {
                    $scope.sectionActive = [];
                }

                $scope.models = [];
                $scope.searchControl = true;
                /*if(!angular.isUndefined(localityId)) {
                 $scope.search['locality_id'] = localityId;
                 }
                 if(!angular.isUndefined(sectionId)) {
                 $scope.search['section_id'] = sectionId;
                 }*/
                if (!angular.isUndefined(currentDate)) {
                    $scope.search['currentDate'] = currentDate;
                }
                if (!angular.isUndefined(localitiesView)) {
                    if (localitiesView == true) {
                        $scope.localityActive[localityId] = 'locality-active';
                        $scope.postLocalitiesView.push(localityId);

                        if (controlSection == 0) {
                            if (angular.isUndefined($scope.sectionsView)) {
                                $scope.sectionsView = {};
                            }
                            if (angular.isUndefined($scope.sectionsView[localityId])) {
                                $scope.sectionsView[localityId] = {};
                            }
                            if (!angular.isUndefined($scope.localitiesKitchen)) {
                                var position = $scope.localitiesKitchen.map(function (e) {
                                    return e['locality_id'];
                                }).indexOf(localityId);
                                if (position >= 0) {
                                    if (!angular.isUndefined($scope.localitiesKitchen[position])) {
                                        angular.forEach($scope.localitiesKitchen[position]['section'], function (item, key) {
                                            if (item.count_order > 0) {
                                                $scope.sectionsView[localityId][item.section_id] = true;
                                                $scope.postSectionsView.push(item.section_id);
                                            }
                                        });
                                    }
                                }
                            }
                        }
                    } else {
                        $scope.localityActive[localityId] = '';
                        var index = $scope.postLocalitiesView.indexOf(localityId);
                        if (index > -1) {
                            $scope.postLocalitiesView.splice(index, 1);
                        }
                        if (controlSection == 0) {
                            if (!angular.isUndefined($scope.localitiesKitchen)) {
                                if (angular.isUndefined($scope.sectionsView)) {
                                    $scope.sectionsView = {};
                                }
                                if (angular.isUndefined($scope.sectionsView[localityId])) {
                                    $scope.sectionsView[localityId] = {};
                                }
                                var position = $scope.localitiesKitchen.map(function (e) {
                                    return e['locality_id'];
                                }).indexOf(localityId);
                                if (position >= 0) {
                                    if (!angular.isUndefined($scope.localitiesKitchen[position])) {
                                        angular.forEach($scope.localitiesKitchen[position]['section'], function (item, key) {
                                            if (item.count_order > 0) {
                                                $scope.sectionsView[localityId][item.section_id] = false;
                                                var indexs = $scope.postSectionsView.indexOf(item.section_id);
                                                if (indexs > -1) {
                                                    $scope.postSectionsView.splice(indexs, 1);
                                                }
                                            }
                                        });
                                    }
                                }
                            }
                        }
                    }
                    $scope.search['locality_id'] = '';
                    $scope.search['localitiesView'] = $scope.postLocalitiesView;
                }

                if (!angular.isUndefined(sectionsView)) {
                    if (sectionsView != '123') {
                        if (sectionsView == true) {
                            $scope.postSectionsView.push(sectionId);
                            if (angular.isUndefined($scope.sectionsView)) {
                                $scope.sectionsView = {};
                            }
                            if (angular.isUndefined($scope.sectionsView[localityId])) {
                                $scope.sectionsView[localityId] = {};
                            }
                            $scope.sectionsView[localityId][sectionId] = true;

                            var crtSecAll = 0;
                            var position = $scope.localitiesKitchen.map(function (e) {
                                return e['locality_id'];
                            }).indexOf(localityId);
                            if (position >= 0) {
                                if (!angular.isUndefined($scope.localitiesKitchen[position])) {
                                    angular.forEach($scope.localitiesKitchen[position]['section'], function (item, key) {
                                        if (item.count_order > 0) {
                                            if (angular.isUndefined($scope.sectionsView[localityId][item.section_id]) || $scope.sectionsView[localityId][item.section_id] == false) {
                                                crtSecAll = 1;
                                            }
                                        }
                                    });
                                }
                                if (crtSecAll == 0) {
                                    if (angular.isUndefined($scope.localitiesView)) {
                                        $scope.localitiesView = {};
                                    }
                                    $scope.localitiesView[localityId] = true;
                                    //$scope.postSectionsView = [];
                                    //$scope.postLocalitiesView.push(localityId);
                                }
                            }

                        } else {
                            var index = $scope.postSectionsView.indexOf(sectionId);
                            if (index > -1) {
                                $scope.postSectionsView.splice(index, 1);
                            }
                            if (controlLocality == 0) {
                                if (angular.isUndefined($scope.localitiesView)) {
                                    $scope.localitiesView = {};
                                }
                                $scope.localitiesView[localityId] = false;
                                var indexloc = $scope.postLocalitiesView.indexOf(localityId);
                                if (indexloc > -1) {
                                    $scope.postLocalitiesView.splice(indexloc, 1);
                                }
                            }

                        }
                        $scope.search['locality_id'] = '';
                        $scope.search['section_id'] = '';
                        $scope.search['sectionsView'] = $scope.postSectionsView;
                    }
                }
                $scope.getOrders($scope.path, 1, perPageKitchen);
            }
            $scope.cancelSearchOrder = function (ev, path) {
                $scope.sectionActive = [];
                $scope.localityActive = [];

                $scope.postLocalitiesView = [];
                $scope.postSectionsView = [];
                if (!angular.isUndefined($scope.localitiesKitchen)) {
                    angular.forEach($scope.localitiesKitchen, function (itemLoc, keyLoc) {
                        if (itemLoc.count_order > 0) {
                            if (!angular.isUndefined($scope.localitiesView)) {
                                $scope.localitiesView[itemLoc.locality_id] = false;
                            }
                            angular.forEach(itemLoc['section'], function (itemSection, keySec) {
                                if (itemSection.count_order > 0) {
                                    if (!angular.isUndefined($scope.sectionsView)) {
                                        if (!angular.isUndefined($scope.sectionsView)) {
                                            if (!angular.isUndefined($scope.sectionsView[itemLoc.locality_id])) {
                                                $scope.sectionsView[itemLoc.locality_id][itemSection.section_id] = false;
                                            }
                                        }
                                    }
                                }
                            });
                        }
                    });
                }

                $scope.search = {};
                if ($scope.searchControl == true) {
                    $scope.searchControl = false;
                    $scope.models = [];
                    $scope.getOrders($scope.path, 1, perPageKitchen);
                }
            }

            $scope.sendOrder = function (ev, path, model, index) {
                   var durations = 0;
                   if (!angular.isUndefined(model['validated_at'])) {
                        if (!angular.isUndefined(model['order_planning'])) {
                           var start = model['order_planning'];
                        } else {
                                var start = model['validated_at'];
                        }
                           var end = moment();

                            duration = moment.duration(end.diff(start));
                            durations = duration.as('milliseconds');

                             if (!angular.isUndefined(model['planned_time'])) {
                                durations = durations + model['planned_time']*60*1000;
                            }
                    }
                   if( (model['order_planning'] == null || model['order_planning'] == '') || (model['order_planning'] != null && model['order_planning'] != '' && durations > 0)  ){

                        if ($scope.kitchen['kitchen_center'] == 1 || model['kitchens_single'][$scope.kitchen.id]['single'] == 1) {

                            /*var controlProductKitchen = 0;
                            var controlSupplementKitchen = 0;

                            angular.forEach(model.food_products, function (itemProduct, indexProduct) {
                                if (itemProduct.finished == 0) {

                                    if (!angular.isUndefined($scope.kitchen)) {
                                        var positionCategory = $scope.kitchen.food_categories.map(function (e) {
                                            return e['id'];
                                        }).indexOf(parseInt(itemProduct['food_category_id']));
                                        if (positionCategory < 0) {
                                            controlProductKitchen = 1;
                                        }
                                    }
                                }*/

                                /*supplements*/
                                /*angular.forEach(itemProduct.food_supplements, function (itemSupplement, indexSupplement) {
                                    if (itemSupplement.finished == 0) {

                                        if (!angular.isUndefined($scope.kitchen)) {
                                            var positionCategory = $scope.kitchen.food_categories.map(function (e) {
                                                return e['id'];
                                            }).indexOf(parseInt(itemProduct['food_category_id']));
                                            if (positionCategory < 0) {
                                                controlSupplementKitchen = 1;
                                            }
                                        }
                                    }
                                });
                            });*/

                           // if (controlProductKitchen == 0 && controlSupplementKitchen == 0) {

                                $scope.additionals['buttonDisabled'] = true;
                                var post = {};
                                post['id'] = model.id;
                                post['kitchen_id'] = $scope.kitchenId;
                                post['route'] = 'sendOrder';

                                Crud.post('form-urlencoded', post, path + '/sendOrder')
                                        .success(function (data) {
                                            //$scope.models.splice(index, 1);
                                            $scope.controlExpand[model.id] = false;
                                            $scope.additionals['buttonDisabled'] = false;

                                        });
                            //}
                        }
                }

            }
            $scope.controlExpand = {};
            $scope.expand = function (modelId, index) {
                if ($scope.controlExpand[modelId] == true) {
                    $scope.controlExpand[modelId] = false;
                } else {
                    $scope.controlExpand[modelId] = true;
                    $scope.controlExpandDetail[modelId] = false;
                    Crud.show(modelId, $scope.path)
                    .success(function (data) {

                        if (!angular.isUndefined($scope.models[index])) {
                            if (!angular.isUndefined(data['order_start']) && !angular.isUndefined(data['validated_at'])) {
                                $scope.models[index]['dispatchTimeKitchen'] = $scope.additionals['diffDatesMinutes'](data['order_start'], data['validated_at']);
                            }
                             if (!angular.isUndefined(data['order_planning']) && data['order_planning'] != null && data['order_planning'] != 'null' && data['order_planning'] != '' && !angular.isUndefined(data['validated_at']) && data['validated_at'] != null && data['validated_at'] != 'null') {
                                    $scope.models[index]['kitchenTimeKitchen'] = $scope.additionals['diffDatesMinutes'](data['validated_at'], data['order_planning'].substring(0, 10)+' '+$scope.additionals['calcPlannedTime'](data['order_planning'], data['planned_time']));

                                   if (!angular.isUndefined(data['processed_at'])) {
                                        $scope.models[index]['plannedTimeKitchen'] = $scope.additionals['diffDatesMinutes'](data['order_planning'].substring(0, 10)+' '+$scope.additionals['calcPlannedTime'](data['order_planning'], data['planned_time']), data['processed_at']);
                                    }
                           } else {
                                if (!angular.isUndefined(data['processed_at']) && !angular.isUndefined(data['validated_at'])) {
                                        $scope.models[index]['kitchenTimeKitchen'] = $scope.additionals['diffDatesMinutes'](data['validated_at'], data['processed_at']);
                                    }
                           }
                            if (!angular.isUndefined(data['delivered_at']) && !angular.isUndefined(data['processed_at'])) {
                                $scope.models[index]['distributionTimeKitchen'] = $scope.additionals['diffDatesMinutes'](data['processed_at'], data['delivered_at']);
                            }
                            if (!angular.isUndefined(data['order_end']) && !angular.isUndefined(data['delivered_at'])) {
                                $scope.models[index]['deliveryTimeKitchen'] = $scope.additionals['diffDatesMinutes'](data['delivered_at'], data['order_end']);
                            }
                        }

                        var item = data;

                        if (angular.isUndefined($scope.additionals['products'])) {
                            $scope.additionals['products'] = {};
                        }

                        if (angular.isUndefined($scope.additionals['products'][item['id']])) {
                            $scope.additionals['products'][item['id']] = {};
                        }
                        if (angular.isUndefined($scope.additionals['products'][item['id']][$scope.kitchen.id])) {
                            $scope.additionals['products'][item['id']][$scope.kitchen.id] = {};
                         }
                         if (angular.isUndefined($scope.additionals['products'][item['id']][$scope.kitchen.id]['product'])) {
                            $scope.additionals['products'][item['id']][$scope.kitchen.id]['product'] = {};
                         }

                        var controlProduct = 0;
                        var controlSupplement = 0;
                        angular.forEach(item.food_products, function (itemProduct, indexProduct) {
                            if (itemProduct.finished == 1) {
                                $scope.additionals['products'][item['id']][$scope.kitchen.id][indexProduct] = true;
                            } else {
                                $scope.additionals['products'][item['id']][$scope.kitchen.id][indexProduct] = false;
                            }
                            if (!angular.isUndefined($scope.kitchen)) {
                                var positionCategory = $scope.kitchen.food_categories.map(function (e) {
                                    return e['id'];
                                }).indexOf(parseInt(itemProduct['food_category_id']));
                                if (positionCategory >= 0) {
                                    if (angular.isUndefined($scope.additionals['products'][item['id']][$scope.kitchen.id][indexProduct]) || $scope.additionals['products'][item['id']][$scope.kitchen.id][indexProduct] == false) {
                                        controlProduct = 1;
                                    }
                                }
                            }

                            /* supplements */
                            if (angular.isUndefined($scope.additionals['products'][item['id']][$scope.kitchen.id]['product'])) {
                                $scope.additionals['products'][item['id']][$scope.kitchen.id]['product'] = {};
                            }
                            if (angular.isUndefined($scope.additionals['products'][item['id']][$scope.kitchen.id]['product'][indexProduct])) {
                                $scope.additionals['products'][item['id']][$scope.kitchen.id]['product'][indexProduct] = {};
                            }

                            var linearArray = $scope.additionals['linearArray'](itemProduct['food_supplements']);
                            angular.forEach(linearArray, function (itemSupplement, indexSupplement) {
                                if (itemSupplement.finished == 1) {
                                    $scope.additionals['products'][item['id']][$scope.kitchen.id]['product'][indexProduct][itemSupplement['supplement_index']] = true;
                                } else {
                                    $scope.additionals['products'][item['id']][$scope.kitchen.id]['product'][indexProduct][itemSupplement['supplement_index']] = false;
                                }
                                if (!angular.isUndefined($scope.kitchen)) {
                                    var positionCategory = $scope.kitchen.food_categories.map(function (e) {
                                        return e['id'];
                                    }).indexOf(parseInt(itemProduct['food_category_id']));
                                    if (positionCategory >= 0) {
                                        if (angular.isUndefined($scope.additionals['products'][item['id']][$scope.kitchen.id]['product'][indexProduct][indexSupplement]) || $scope.additionals['products'][item['id']][$scope.kitchen.id]['product'][indexProduct][itemSupplement['supplement_index']] == false) {
                                            controlSupplement = 1;
                                        }
                                    }
                                }
                            });
                        });

                        if (controlProduct == 0 && controlSupplement == 0) {
                            //$scope.additionals['products'][item['id']][$scope.kitchen.id]['all'] = true;
                        } else {
                            //$scope.additionals['products'][item['id']][$scope.kitchen.id]['all'] = false;
                        }

                        var order_day = $scope.models[index]['order_day'];
                        $scope.models[index] = data;
                        $scope.models[index]['order_day'] = order_day;
                    });
                }
            }

            $scope.expandAll = function (models) {
                angular.forEach(models, function (item, key) {
                    $scope.controlExpand[item.id] = true;
                });
            }
            $scope.collapseAll = function (models) {
                angular.forEach(models, function (item, key) {
                    $scope.controlExpand[item.id] = false;
                });
            }
            $scope.controlExpandDetail = {};
            $scope.expandDetail = function (modelId, index, data) {
                if ($scope.controlExpandDetail[modelId] == true) {
                    $scope.controlExpandDetail[modelId] = false;
                } else {
                    $scope.controlExpandDetail[modelId] = true;
                }

                if (!angular.isUndefined(data['order_start']) && !angular.isUndefined(data['validated_at'])) {
                    $scope.models[index]['dispatchTimeKitchen'] = $scope.additionals['diffDatesMinutes'](data['order_start'], data['validated_at']);
                }
                 if (!angular.isUndefined(data['order_planning']) && data['order_planning'] != null && data['order_planning'] != 'null' && data['order_planning'] != '' && !angular.isUndefined(data['validated_at']) && data['validated_at'] != null && data['validated_at'] != 'null') {
                            $scope.models[index]['kitchenTimeKitchen'] = $scope.additionals['diffDatesMinutes'](data['validated_at'], data['order_planning'].substring(0, 10)+' '+$scope.additionals['calcPlannedTime'](data['order_planning'], data['planned_time']));
                             if (!angular.isUndefined(data['processed_at'])) {
                                $scope.models[index]['plannedTimeKitchen'] = $scope.additionals['diffDatesMinutes'](data['order_planning'].substring(0, 10)+' '+$scope.additionals['calcPlannedTime'](data['order_planning'], data['planned_time']), data['processed_at']);
                            }
                   } else {
                        if (!angular.isUndefined(data['processed_at']) && !angular.isUndefined(data['validated_at'])) {
                                $scope.models[index]['kitchenTimeKitchen'] = $scope.additionals['diffDatesMinutes'](data['validated_at'], data['processed_at']);
                            }
                   }

                if (!angular.isUndefined(data['delivered_at']) && !angular.isUndefined(data['processed_at'])) {
                    $scope.models[index]['distributionTimeKitchen'] = $scope.additionals['diffDatesMinutes'](data['processed_at'], data['delivered_at']);
                }
                if (!angular.isUndefined(data['order_end']) && !angular.isUndefined(data['delivered_at'])) {
                    $scope.models[index]['deliveryTimeKitchen'] = $scope.additionals['diffDatesMinutes'](data['delivered_at'], data['order_end']);
                }

            }

            $scope.additionals['checkCategoryProduct'] = function (categoryId) {
                if (!angular.isUndefined($scope.kitchen)) {
                    var position = $scope.kitchen.food_categories.map(function (e) {
                        return e['id'];
                    }).indexOf(parseInt(categoryId));
                    if (position >= 0) {
                        return false;
                    } else {
                        return true;
                    }
                }
            }
            $scope.additionals['checkCategoryKitchen'] = function (kitchenId) {
                if (!angular.isUndefined($scope.kitchen)) {
                    if (parseInt($scope.kitchen['id']) == parseInt(kitchenId)) {
                        return false;
                    } else {
                        return true;
                    }
                }
            }

            $scope.additionals['order'] = [];
            $scope.additionals['products'] = {};
            $scope.additionals['viewOrderAll'] = function (model, productsValue) {
                   var durations = 0;
                   if (!angular.isUndefined(model['validated_at'])) {
                        if (!angular.isUndefined(model['order_planning'])) {
                           var start = model['order_planning'];
                        } else {
                                var start = model['validated_at'];
                        }
                           var end = moment();

                            duration = moment.duration(end.diff(start));
                            durations = duration.as('milliseconds');

                             if (!angular.isUndefined(model['planned_time'])) {
                                durations = durations + model['planned_time']*60*1000;
                            }
                    }
                   if( (model['order_planning'] == null || model['order_planning'] == '') || (model['order_planning'] != null && model['order_planning'] != '' && durations > 0)  ){

                        var post = {};
                        post['route'] = 'checkProduct';
                        post['kitchen_id'] = $scope.kitchenId;
                        post['order_id'] = model['id'];
                        post['food_products'] = model['food_products'];
                        post['food_products_value'] = productsValue;
                        Crud.post('form-urlencoded', post, $scope.path + '/checkProductAll')
                                .success(function (data) {
                                    $scope.errors = [];
                                }).error(function (data) {
                                    $scope.errors = data.errors;
                                });
                        }
            }

            $scope.additionals['viewOrder'] = function (model, keyProduct, product, productValue, supplement, supplementValue) {
                   var durations = 0;
                   if(!angular.isUndefined(model['validated_at'])) {
                        if (!angular.isUndefined(model['order_planning'])) {
                           var start = model['order_planning'];
                        } else {
                                var start = model['validated_at'];
                        }
                           var end = moment();

                            duration = moment.duration(end.diff(start));
                            durations = duration.as('milliseconds');

                             if (!angular.isUndefined(model['planned_time'])) {
                                durations = durations + model['planned_time']*60*1000;
                            }
                    }
                   if( (model['order_planning'] == null || model['order_planning'] == '') || (model['order_planning'] != null && model['order_planning'] != '' && durations > 0)  ){
                        var post = {};
                        post['route'] = 'checkProduct';
                        post['keyProduct'] = keyProduct;
                        post['kitchen_id'] = $scope.kitchen['id'];
                        post['order_id'] = model['id'];
                        post['food_category_id'] = product['food_category_id'];
                        post['food_product_id'] = product['food_product_id'];
                        post['food_product_index'] = product['food_product_index'];
                        post['food_product_value'] = productValue;
                        //post['food_supplements'] = product['food_supplements'];
                        if (!angular.isUndefined(supplement)) {
                            post['supplement'] = supplement;
                            post['supplement_id'] = supplement['supplement_id'];
                            post['supplement_index'] = supplement['supplement_index'];
                            post['supplement_parent_id'] = supplement['supplement_parent_id'];
                            post['supplement_parent_index'] = supplement['supplement_parent_index'];
                            post['supplement_value'] = supplementValue;
                        }
                        Crud.post('form-urlencoded', post, $scope.path + '/checkProduct')
                                .success(function (data) {
                                    $scope.errors = [];
                                }).error(function (data) {
                            $scope.errors = data.errors;
                        });
                    }

                    $scope.filtersKitchenHistory = {};
                    $scope.$watch('filtersKitchenHistory', function () {
                        $scope.filterColumnKitchenHistory = $scope.filtersKitchenHistory;
                    }, true);
              }
        }

        /* mqtt update order mode */
        $scope.mqttUpdateOrderMode = function (result) {
            $scope.editActive = [];
            angular.forEach(result, function (item, key) {
                if (item.order_by == $rootScope.session.user.id) {
                    $scope.editActive[item.order_id] = 'order_active';
                } else {
                    $scope.editActive[item.order_id] = 'order_active_other';
                }
            });

        }

        $scope.closeOrderMode = function (ev, path, modelId) {
            Crud.get($scope.path + '/closeOrderMode?order_id=' + modelId)
                    .success(function (data) {
                    });
        }

        /* mqtt */
        $rootScope.stopTimerNot = {};
        $scope.setIntervalNot = function (kitchenName, prod){
          var counter = 600;//10 min
          //var counter = 20;
          var timerName = kitchenName;
          if (!angular.isUndefined(prod)) {
            timerName = timerName +'_'+ prod;
          }
          $rootScope.stopTimerNot[timerName] = $interval(function () {
              counter--;
              //console.log(timerName +'  '+counter)
              if (counter == 0) {
                //$rootScope.notificationsOverKitchens = [];
                if(angular.isUndefined(prod)){
                  var positionUpdatedNotification = $rootScope.notificationsOverKitchens.map(function (e) {
                    if(angular.isUndefined(e['total_no_products'])){
                       return e['kitchen_name'];
                    }
                  }).indexOf(kitchenName);
                  if (positionUpdatedNotification >= 0) {
                    $rootScope.notificationsOverKitchens.splice(positionUpdatedNotification, 1);
                  }
                } else {
                  var positionUpdatedNotification = $rootScope.notificationsOverKitchens.map(function (e) {
                    if(!angular.isUndefined(e['total_no_products'])){
                       return e['kitchen_name'];
                    }
                  }).indexOf(kitchenName);
                  if (positionUpdatedNotification >= 0) {
                    $rootScope.notificationsOverKitchens.splice(positionUpdatedNotification, 1);
                  }
                }
                $interval.cancel($rootScope.stopTimerNot[timerName]);
              }
          }, 1000);
        }

        $scope.mqttUpdateOrder = function (model, current_status, ex_status) {
              // console.log(current_status)
              // console.log(ex_status)
              //console.log(model)
            if($location.path() == $scope.path + '/getOrder'){

            //if (!angular.isUndefined(model.notificationsCancellationTazz)) {

              if (current_status <= 3) {
                if (angular.isUndefined($scope.notificationsCancellationTazz)) {
                  $scope.notificationsCancellationTazz = [];
                }
                if (!angular.isUndefined(model.notificationsCancellationTazz)) {
                  if (!angular.isUndefined(model.notificationsCancellationTazz.order_no)) {
                    var positionUpdatedNotification = $scope.notificationsCancellationTazz.map(function (e) {
                        return e['order_no'];
                    }).indexOf(parseInt(model.notificationsCancellationTazz.order_no));
                    if (positionUpdatedNotification < 0) {
                      $scope.notificationsCancellationTazz.push(model.notificationsCancellationTazz);
                    }
                  }
                }
              }
            //} else {

            //condition for exclude imports
             if ((current_status <= 3 && (model.order_orig_id == 0 || model.order_orig_id == null)) || (

current_status <= 3 && ex_status != -1 && (model.order_orig_id != 0 && model.order_orig_id != null)

             ) ) {
               if (angular.isUndefined($rootScope.notificationsOverKitchens)) {
              	   $rootScope.notificationsOverKitchens = [];
               }
               if (angular.isUndefined(model.notificationsOverKitchens)) {
                   model.notificationsOverKitchens = [];
               }
               //$rootScope.notificationsOverKitchens = model.notificationsOverKitchens;
               ///*
               angular.forEach(model.notificationsOverKitchens, function (item, index) {
                 if (!angular.isUndefined(item.kitchen_name)) {
                   if (!angular.isUndefined(item.total_no_products)) {
                       /*var notificationsOverKitchens_filtered = $rootScope.notificationsOverKitchens.filter(function (e, i, arr) {
                           return (e['kitchen_name'] == item.kitchen_name && !angular.isUndefined(e['total_no_products']));
                       });
                       console.log(notificationsOverKitchens_filtered)
                       if (notificationsOverKitchens_filtered.length <= 0) {
                         $rootScope.notificationsOverKitchens.push(item);
                       } else {
                         $rootScope.notificationsOverKitchens[0] = item;
                       }
                       */
                       var positionUpdatedNotification = $rootScope.notificationsOverKitchens.map(function (e) {
                           if(!angular.isUndefined(e['total_no_products'])){
                              return e['kitchen_name'];
                           }
                       }).indexOf(item.kitchen_name);
                       if (positionUpdatedNotification < 0) {
                         if(angular.isUndefined(item['not_update'])){
                           $rootScope.notificationsOverKitchens.push(item);
                           $scope.setIntervalNot(item['kitchen_name'], 'prod');
                         }
                       } else {
                         //$rootScope.notificationsOverKitchens[positionUpdatedNotification] = item;
                         if(angular.isUndefined(item['not_update'])){
                           $interval.cancel($rootScope.stopTimerNot[item.kitchen_name+'_prod']);
                           $scope.setIntervalNot(item['kitchen_name'], 'prod');
                         }
                       }
                   } else {
                     var positionUpdatedNotification = $rootScope.notificationsOverKitchens.map(function (e) {
                       if(angular.isUndefined(e['total_no_products'])){
                          return e['kitchen_name'];
                       }
                     }).indexOf(item.kitchen_name);
                     if (positionUpdatedNotification < 0) {
                       if(angular.isUndefined(item['not_update'])){
                         $rootScope.notificationsOverKitchens.push(item);
                         $scope.setIntervalNot(item['kitchen_name']);
                       }
                     } else {
                       if(angular.isUndefined(item['not_update'])){
                          $interval.cancel($rootScope.stopTimerNot[item.kitchen_name]);
                          $scope.setIntervalNot(item['kitchen_name']);
                       }
                     }
                   }
                 }
               });

               ///*
               for (var index = $rootScope.notificationsOverKitchens.length; index--;) {
               //angular.forEach($rootScope.notificationsOverKitchens, function (item, index) {
                   if (!angular.isUndefined($rootScope.notificationsOverKitchens[index].kitchen_name)) {
                       if (!angular.isUndefined($rootScope.notificationsOverKitchens[index].total_no_products)) {
                         var positionUpdatedNotification = model.notificationsOverKitchens.map(function (e) {
                             if(!angular.isUndefined(e['total_no_products'])){
                                return e['kitchen_name'];
                             }
                         }).indexOf($rootScope.notificationsOverKitchens[index].kitchen_name);

                         if (positionUpdatedNotification < 0 || (current_status != 1 && (model.order_planning == null || model.order_planning == 'null' || model.order_planning == '' || angular.isUndefined(model.order_planning)  ))   ) {
                           $interval.cancel($rootScope.stopTimerNot[$rootScope.notificationsOverKitchens[index].kitchen_name+'_prod']);
                           $rootScope.notificationsOverKitchens.splice(index, 1);
                         }
                       } else {
                         var positionUpdatedNotification = model.notificationsOverKitchens.map(function (e) {
                             if(angular.isUndefined(e['total_no_products'])){
                                return e['kitchen_name'];
                             }
                         }).indexOf($rootScope.notificationsOverKitchens[index].kitchen_name);
                         if (positionUpdatedNotification < 0 || (current_status != 1 && (model.order_planning == null || model.order_planning == 'null' || model.order_planning == '' || angular.isUndefined(model.order_planning)  )) ) {
                              $interval.cancel($rootScope.stopTimerNot[$rootScope.notificationsOverKitchens[index].kitchen_name]);
                             $rootScope.notificationsOverKitchens.splice(index, 1);
                         }
                       }
                   }
               //});
             }
               //*/
            }
          //}

          }

            if (current_status == 0) {
                if (ex_status == 0) {
                    //preloaded
                    if (!angular.isUndefined($scope.modelsPreloaded)) {
                        var positionPreloaded = $scope.modelsPreloaded.map(function (e) {
                            return e['id'];
                        }).indexOf(parseInt(model.id));
                        if (positionPreloaded >= 0) {
                            $scope.modelsPreloaded[positionPreloaded] = model;

                            if (($location.path() == $scope.path + '/orderPlanned' && (angular.isUndefined(model['order_planning']) || model['order_planning'] == null) ) ||

                                (($location.path() == $scope.path || $location.path() == $scope.path + '/getOrder')
                                && model['order_planning'] != null && model['order_planning'] != 'null' && model['order_planning'] != '' &&
                                moment().format('DD/MM/YYYY') != moment(model.order_planning).format('DD/MM/YYYY'))

                              ) {

                                  $scope.modelsPreloaded.splice(positionPreloaded, 1);
                                  if ($scope.modelsPreloaded.length <= 0) {
                                      var no_pagesPreloaded = Math.ceil(($scope.totalPreloaded - 1) / perPage);
                                      if ($scope.modelsPreloaded.current_page > no_pagesPreloaded) {
                                          $scope.modelsPreloaded.current_page = no_pagesPreloaded;
                                      }
                                      if (angular.isUndefined($scope.modelsPreloaded.current_page) || $scope.modelsPreloaded.current_page == 0) {
                                          $scope.modelsPreloaded.current_page = 1;
                                      }
                                  }

                                }
                        } else {
                          if (($location.path() == $scope.path + '/orderPlanned' && !angular.isUndefined(model['order_planning']) && model['order_planning'] != null && model['order_planning'] != 'null' && model['order_planning'] != '') ||

                             (($location.path() == $scope.path || $location.path() == $scope.path + '/getOrder')
                             && ((model['order_planning'] != null && model['order_planning'] != 'null' && model['order_planning'] != '' &&
                             moment().format('DD/MM/YYYY') == moment(model.order_planning).format('DD/MM/YYYY')) ||
                             (model['order_planning'] == null || model['order_planning'] == 'null' || model['order_planning'] == ''))
                           )

                           ) {

                               if (angular.isUndefined($scope.from) || $scope.from == 'null' || $scope.from == null) {
                                   $scope.from = 1;
                               }
                               var current_page = $scope.modelsPreloaded.current_page;
                               var per_page = $scope.modelsPreloaded.per_page;
                               $scope.modelsPreloaded.unshift(model);
                               $scope.modelsPreloaded = $filter('orderBy')($scope.modelsPreloaded, 'order_planning', true);
                               $scope.modelsPreloaded = $scope.additionals['uniqueArray']($scope.modelsPreloaded);

                               $scope.modelsPreloaded.current_page = current_page;
                               $scope.modelsPreloaded.per_page = per_page;

                             }
                        }
                    }
                } else {
                    if (ex_status == -1) { //for imports

                          if (($location.path() == $scope.path && $scope.searchControl != true) || ($location.path() == $scope.path + '/orderPlanned' && $scope.searchControl != true)) {
                              if (!angular.isUndefined($scope.models)) {
                                  var positionUpdated = $scope.models.map(function (e) {
                                      return e['id'];
                                  }).indexOf(parseInt(model.id));
                                  if (positionUpdated < 0) {

                                    if ((moment().format('DD/MM/YYYY') == moment(model.order_start).format('DD/MM/YYYY') && $location.path() != $scope.path + '/orderPlanned' && (angular.isUndefined(model['order_planning']) || model['order_planning'] == null)) || (!angular.isUndefined(model['order_planning']) && model['order_planning'] != null && model['order_planning'] != 'null' && model['order_planning'] != '' && ((moment().format('DD/MM/YYYY') == moment(model.order_planning).format('DD/MM/YYYY') && $location.path() != $scope.path + '/orderPlanned') || $location.path() == $scope.path + '/orderPlanned')
                                  )    ) {

                                          if (angular.isUndefined($scope.from) || $scope.from == 'null' || $scope.from == null) {
                                              $scope.from = 1;
                                          }
                                          var current_page = $scope.models.current_page;
                                          var per_page = $scope.models.per_page;
                                          $scope.models.unshift(model);
                                          if($location.path() == $scope.path + '/orderPlanned') {
                                              $scope.models = $scope.models.reduce(function(acc, element) {
                                                  if (element['order_status'] == 1) {
                                                    return [element, ...acc];
                                                  }
                                                  return [...acc, element];
                                              }, []);
                                          } else {
                                            $scope.models = $filter('orderBy')($scope.models, 'order_start', true);
                                          }
                                          $scope.models = $scope.additionals['uniqueArray']($scope.models);

                                          $scope.models.current_page = current_page;
                                          $scope.models.per_page = per_page;

                                      }
                                  } else {
                                      $scope.models[positionUpdated] = model;
                                  }
                              }
                          }

                        if (!angular.isUndefined($scope.modelsPreloaded)) {
                            var positionPreloaded = $scope.modelsPreloaded.map(function (e) {
                                return e['id'];
                            }).indexOf(parseInt(model.id));
                            if (positionPreloaded < 0) {
                                if ((moment().format('DD/MM/YYYY') == moment(model.order_start).format('DD/MM/YYYY') && angular.isUndefined(model['order_planning']) || model['order_planning'] == null) || (!angular.isUndefined(model['order_planning']) && model['order_planning'] != null && model['order_planning'] != 'null' && model['order_planning'] != '' && moment().format('DD/MM/YYYY') == moment(model.order_planning).format('DD/MM/YYYY'))    ) {
                                    if (!angular.isUndefined($scope.fromPreloaded)) {
                                        $scope.fromPreloaded = 1;
                                    }
                                    var current_page = $scope.modelsPreloaded.current_page;
                                    $scope.modelsPreloaded.unshift(model);
                                    $scope.modelsPreloaded = $filter('orderBy')($scope.modelsPreloaded, 'order_start');
                                    $scope.modelsPreloaded = $scope.additionals['uniqueArray']($scope.modelsPreloaded);

                                    $scope.modelsPreloaded.current_page = current_page;
                                }
                            } else {
                                    $scope.modelsPreloaded[positionPreloaded] = model;
                            }
                        }
                    } else {

                        //move to preloaded
                        if (!angular.isUndefined($scope.models)) {
                            var positionUpdated = $scope.models.map(function (e) {
                                return e['id'];
                            }).indexOf(parseInt(model.id));
                            if (positionUpdated >= 0) {
                                if ($location.path() == $scope.path + '/getOrder'  || $route.current.$$route.originalPath.split(':')[0] == $scope.path + '/view/') {
                                    $scope.models.splice(positionUpdated, 1);
                                    if ($scope.models.length <= 0) {
                                        var no_pagesUpdated = Math.ceil(($scope.totalUpdated - 1) / perPage);
                                        if ($scope.models.current_page > no_pagesUpdated) {
                                            $scope.models.current_page = no_pagesUpdated;
                                        }
                                        if (angular.isUndefined($scope.models.current_page) || $scope.models.current_page == 0) {
                                            $scope.models.current_page = 1;
                                        }
                                        $scope.getOrders($scope.path, $scope.models.current_page, perPage, 'not0');
                                    }
                                } else {
                                    $scope.models[positionUpdated] = model;
                                    if($location.path() == $scope.path + '/orderPlanned') {
                                        $scope.models = $scope.models.reduce(function(acc, element) {
                                            if (element['order_status'] == 1) {
                                              return [element, ...acc];
                                            }
                                            return [...acc, element];
                                        }, []);
                                    }
                                }
                            }
                        }

                        if (!angular.isUndefined($scope.modelsPreloaded)) {
                            var positionPreloaded = $scope.modelsPreloaded.map(function (e) {
                                return e['id'];
                            }).indexOf(parseInt(model.id));
                            if (positionPreloaded < 0) {
                                if ((moment().format('DD/MM/YYYY') == moment(model.order_start).format('DD/MM/YYYY') && angular.isUndefined(model['order_planning']) || model['order_planning'] == null) || (!angular.isUndefined(model['order_planning']) && model['order_planning'] != null && model['order_planning'] != 'null' && model['order_planning'] != '' && moment().format('DD/MM/YYYY') == moment(model.order_planning).format('DD/MM/YYYY'))    ) {
                                    if (!angular.isUndefined($scope.fromPreloaded)) {
                                        $scope.fromPreloaded = 1;
                                    }
                                    var current_page = $scope.modelsPreloaded.current_page;
                                    $scope.modelsPreloaded.unshift(model);
                                    $scope.modelsPreloaded = $filter('orderBy')($scope.modelsPreloaded, 'order_start');
                                    $scope.modelsPreloaded = $scope.additionals['uniqueArray']($scope.modelsPreloaded);

                                    $scope.modelsPreloaded.current_page = current_page;
                                }

                            }
                        }
                    }
                }

            } else {
                if (ex_status == 0) {
                    //move to updated
                    if (!angular.isUndefined($scope.modelsPreloaded)) {
                        var positionPreloaded = $scope.modelsPreloaded.map(function (e) {
                            return e['id'];
                        }).indexOf(parseInt(model.id));
                        if (positionPreloaded >= 0) {
                            $scope.modelsPreloaded.splice(positionPreloaded, 1);
                            if ($scope.modelsPreloaded.length <= 0) {
                                var no_pagesPreloaded = Math.ceil(($scope.totalPreloaded - 1) / perPage);
                                if ($scope.modelsPreloaded.current_page > no_pagesPreloaded) {
                                    $scope.modelsPreloaded.current_page = no_pagesPreloaded;
                                }
                                if (angular.isUndefined($scope.modelsPreloaded.current_page) || $scope.modelsPreloaded.current_page == 0) {
                                    $scope.modelsPreloaded.current_page = 1;
                                }
                                //$scope.getOrdersPreloaded($scope.path, $scope.modelsPreloaded.current_page, perPage, 0);
                            }
                        }
                    }

                    if (!angular.isUndefined($scope.models)) {
                        var positionUpdated = $scope.models.map(function (e) {
                            return e['id'];
                        }).indexOf(parseInt(model.id));
                        if (positionUpdated < 0) {
                            if (($location.path() == $scope.path && $scope.searchControl != true) || ($location.path() == $scope.path + '/getOrder' && $scope.controlSearchOrder != true) || ($location.path() == $scope.path + '/orderPlanned' && $scope.searchControl != true)) {
                              if ((moment().format('DD/MM/YYYY') == moment(model.order_start).format('DD/MM/YYYY') && $location.path() != $scope.path + '/orderPlanned' && (angular.isUndefined(model['order_planning']) || model['order_planning'] == null)) || (!angular.isUndefined(model['order_planning']) && model['order_planning'] != null && model['order_planning'] != 'null' && model['order_planning'] != '' && ((moment().format('DD/MM/YYYY') == moment(model.order_planning).format('DD/MM/YYYY') && $location.path() != $scope.path + '/orderPlanned') || $location.path() == $scope.path + '/orderPlanned')
                            )    ) {
                                     if (angular.isUndefined($scope.from) || $scope.from == 'null' || $scope.from == null) {
                                                $scope.from = 1;
                                     }
                                    var current_page = $scope.models.current_page;
                                    $scope.models.unshift(model);
                                    if($location.path() == $scope.path + '/orderPlanned') {
                                        $scope.models = $scope.models.reduce(function(acc, element) {
                                            if (element['order_status'] == 1) {
                                              return [element, ...acc];
                                            }
                                            return [...acc, element];
                                        }, []);
                                    } else {
                                        $scope.models = $filter('orderBy')($scope.models, 'order_start', true);
                                    }
                                    $scope.models = $scope.additionals['uniqueArray']($scope.models);

                                    $scope.models.current_page = current_page;
                                }
                            }
                        } else {
                            $scope.models[positionUpdated] = model;
                        }

                    }

                } else {
                    //updated
                    if (ex_status == -1) {//case of store

                        if (!angular.isUndefined($scope.models)) {
                            var positionUpdated = $scope.models.map(function (e) {
                                return e['id'];
                            }).indexOf(parseInt(model.id));
                            if (positionUpdated < 0) {

                                if($location.path() == $scope.path + '/orderPersonal' && model.shipping_method_id == 4 && model.payment_method_id == 1 && model.order_source == 0) {
                                  if (angular.isUndefined($scope.from) || $scope.from == 'null' || $scope.from == null) {
                                      $scope.from = 1;
                                  }
                                  var current_page = $scope.models.current_page;
                                  $scope.models.unshift(model);
                                  $scope.models = $filter('orderBy')($scope.models, 'order_start', true);
                                  $scope.models = $scope.additionals['uniqueArray']($scope.models);
                                  $scope.models.current_page = current_page;
                                }

                                if (($location.path() == $scope.path && $scope.searchControl != true) || ($location.path() == $scope.path + '/getOrder' && $scope.controlSearchOrder != true && model.shipping_method_id != 3) || ($location.path() == $scope.path + '/orderPlanned' && $scope.searchControl != true && model.shipping_method_id != 3)) {
                                    if ((moment().format('DD/MM/YYYY') == moment(model.order_start).format('DD/MM/YYYY') && $location.path() != $scope.path + '/orderPlanned' && (angular.isUndefined(model['order_planning']) || model['order_planning'] == null)) || (!angular.isUndefined(model['order_planning']) && model['order_planning'] != null && model['order_planning'] != 'null' && model['order_planning'] != '' && ((moment().format('DD/MM/YYYY') == moment(model.order_planning).format('DD/MM/YYYY') && $location.path() != $scope.path + '/orderPlanned') || $location.path() == $scope.path + '/orderPlanned')
                                  )    ) {
                                        if (angular.isUndefined($scope.from) || $scope.from == 'null' || $scope.from == null) {
                                                $scope.from = 1;
                                        }

                                        var current_page = $scope.models.current_page;
                                        $scope.models.unshift(model);
                                        $scope.models = $filter('orderBy')($scope.models, 'order_start', true);
                                        $scope.models = $scope.additionals['uniqueArray']($scope.models);

                                        $scope.models.current_page = current_page;
                                    }
                                }

                            } else {
                                $scope.models[positionUpdated] = model;
                            }
                        }
                    } else {
                        if (!angular.isUndefined($scope.models)) {
                            var positionUpdated = $scope.models.map(function (e) {
                                return e['id'];
                            }).indexOf(parseInt(model.id));
                            if (positionUpdated >= 0) {

                                $scope.models[positionUpdated] = model;
                                if($location.path() == $scope.path + '/orderPlanned') {
                                    $scope.models = $scope.models.reduce(function(acc, element) {
                                        if (element['order_status'] == 1) {
                                          return [element, ...acc];
                                        }
                                        return [...acc, element];
                                    }, []);
                                }

                                if (($location.path() == $scope.path + '/orderPlanned' && (angular.isUndefined(model['order_planning']) || model['order_planning'] == null) ) ||

                                (($location.path() == $scope.path || $location.path() == $scope.path + '/getOrder')
                                && model['order_planning'] != null && model['order_planning'] != 'null' && model['order_planning'] != '' &&
                                moment().format('DD/MM/YYYY') != moment(model.order_planning).format('DD/MM/YYYY'))

                              ) {

                                  $scope.models.splice(positionUpdated, 1);
                                  if ($scope.models.length <= 0) {
                                      var no_pagesUpdated = Math.ceil(($scope.totalUpdated - 1) / perPage);
                                      if ($scope.models.current_page > no_pagesUpdated) {
                                          $scope.models.current_page = no_pagesUpdated;
                                      }
                                      if (angular.isUndefined($scope.models.current_page) || $scope.models.current_page == 0) {
                                          $scope.models.current_page = 1;
                                      }
                                      $scope.getOrders($scope.path, $scope.models.current_page, perPage);
                                  }

                                }

                            } else {

                              if (($location.path() == $scope.path + '/orderPlanned' && !angular.isUndefined(model['order_planning']) && model['order_planning'] != null && model['order_planning'] != 'null' && model['order_planning'] != '') ||

                              (($location.path() == $scope.path || $location.path() == $scope.path + '/getOrder')
                              && ((model['order_planning'] != null && model['order_planning'] != 'null' && model['order_planning'] != '' &&
                              moment().format('DD/MM/YYYY') == moment(model.order_planning).format('DD/MM/YYYY')) ||
                              (model['order_planning'] == null || model['order_planning'] == 'null' || model['order_planning'] == ''))
                            )

                            ) {

                                if (angular.isUndefined($scope.from) || $scope.from == 'null' || $scope.from == null) {
                                    $scope.from = 1;
                                }
                                var current_page = $scope.models.current_page;
                                var per_page = $scope.models.per_page;
                                $scope.models.unshift(model);

                                if($location.path() == $scope.path + '/orderPlanned') {
                                    $scope.models = $scope.models.reduce(function(acc, element) {
                                        if (element['order_status'] == 1) {
                                          return [element, ...acc];
                                        }
                                        return [...acc, element];
                                    }, []);
                                } else {
                                    $scope.models = $filter('orderBy')($scope.models, 'order_planning', true);
                                }
                                $scope.models = $scope.additionals['uniqueArray']($scope.models);

                                $scope.models.current_page = current_page;
                                $scope.models.per_page = per_page;

                              }


                            }
                        }
                    }

                }
            }

            $scope.$apply();
        };

        Mqtt.addListener({'id': 'order_status', 'funct': statusOrder});
        function statusOrder(result, channel) {
            // console.log(channel);
            // console.log(result);
            var model = result;
            if (channel == 'order_status') {

                if (!angular.isUndefined($scope.models)) {
                    var positionUpdated = $scope.models.map(function (e) {
                        return e['id'];
                    }).indexOf(parseInt(model.id));
                    if (positionUpdated >= 0) {
                        $scope.models[positionUpdated]['order_status'] = model['order_status'];
                        $scope.models[positionUpdated]['reason_nondelivery'] = model['reason_nondelivery'];
                    }
                }

            }
        }

        Mqtt.addListener({'id': 'order', 'funct': arrivedOrder});
        function arrivedOrder(result, channel) {
            // console.log(channel);
            // console.log(result);

            if (channel == 'call_updated') {
                if ($location.path() == $scope.path + '/getOrder') {
                    $scope.mqttUpdateCall(result, result.current_status);
                }
            }

            if (channel == 'order_updated') {
                if ($location.path() == $scope.path + '/getOrder' || $location.path() == $scope.path + '/orderPlanned' || $location.path() == $scope.path + '/orderPersonal' || $location.path() == $scope.path) {
                    $scope.mqttUpdateOrder(result, result.current_status, result.ex_status);
                }
                if ($route.current.$$route.originalPath.split(':')[0] == $scope.path + '/view/') {
                    $scope.mqttUpdateOrderKitchen(result, result.current_status, result.ex_status);
                }
            }

            if (channel == 'localities_sections_channel') {
                if ($route.current.$$route.originalPath.split(':')[0] == $scope.path + '/view/') {
                    $scope.mqttUpdateLocalitiesSectionsKitchen(result);
                }
            }

            if (channel == 'move_order') {
                if ($route.current.$$route.originalPath.split(':')[0] == $scope.path + '/view/') {
                    $scope.mqttMoveOrderKitchen(result, result.current_status, result.ex_status);
                }
            }

            if (channel == 'food_products_updated') {
                if ($route.current.$$route.originalPath.split(':')[0] == $scope.path + '/view/') {
                    $scope.mqttUpdateFoodProductsKitchen(result);
                }
            }

            if (channel == 'order_status') {
                if ($location.path() == $scope.path + '/getOrder' || $location.path() == $scope.path + '/orderPlanned' || $location.path() == $scope.path) {
                    $scope.mqttUpdateOrderStatus(result, result.current_status, result.ex_status);
                }
            }

            if (channel == 'slot_status') {
                if ($location.path() == $scope.path + '/getOrder' || $location.path() == $scope.path + '/orderPlanned' || $location.path() == $scope.path) {
                    $scope.mqttUpdateSlotStatus(result);
                }
            }

            if (channel == 'many_orders') {
                $scope.mqttUpdateManyOrders(result);
            }

            if (channel == 'order_edited') {
                if ($location.path() == $scope.path + '/getOrder') {
                    $scope.mqttUpdateOrderMode(result);
                }
            }

        }
        /* end mqtt */

        /* close order */
        $scope.closeOrder = function (ev, path, model) {
            $scope.additionals['invalid'] = '';
            $scope.modelData = {};
            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'closeOrderDialog.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {pathTemplate: $scope.pathTemplate, path: path, model: model, additionals: $scope.additionals}
            }).then(function (closeModel) {
                if (angular.isUndefined($scope.additionals['invalid']) || $scope.additionals['invalid'] == '') {
                    if (!angular.isUndefined($scope.additionals['dataCurrentModel'])) {
                        if (!angular.isUndefined($scope.models) && !angular.isUndefined($scope.models)) {
                            $scope.getElement($scope.models, $scope.additionals['dataCurrentModel']);
                        }
                        if (!angular.isUndefined($scope.modelData)) {
                            $scope.modelData = $scope.additionals['dataCurrentModel'];
                        }
                    } else {
                        if (!angular.isUndefined($scope.models) && !angular.isUndefined($scope.models)) {
                            $scope.getElement($scope.models, currentModel, $rootScope.typeId);
                        }
                        if (!angular.isUndefined($scope.modelData)) {
                            $scope.modelData = currentModel;
                        }
                    }
                }
            });
            DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'path', 'model', 'additionals'];
            function DialogController($scope, $mdDialog, pathTemplate, path, model, additionals) {
                $scope.pathTemplate = pathTemplate;
                $scope.cancel = function () {
                    $mdDialog.cancel();
                };
                $scope.path = path;
                $scope.additionals = additionals;
                $scope.modelData = model;

                /* close model */
                $scope.closeModel = function () {
                    $scope.isLoading = true;
                    var typeRequest = 'form-urlencoded';
                    var post = {};
                    post['route'] = 'closeOrder';
                    post['id'] = model.id;
                    Crud.post(typeRequest, post, $scope.path + '/closeOrder')
                            .success(function (data) {
                                if (!angular.isUndefined(data.invalid)) {
                                    $scope.additionals['invalid'] = data.invalid;
                                } else {
                                    if (!angular.isUndefined(data.currentModel)) {
                                        $scope.additionals['dataCurrentModel'] = data.currentModel;
                                    }
                                }
                                $scope.isLoading = false;
                                $mdDialog.hide();
                            })
                            .error(function (data) {
                                $scope.errors = data.errors;
                                $scope.isLoading = false;
                            });
                };
            }
        };

        /* detail model */
        $scope.center = [46.779608, 23.593165];
        $scope.controlOrderRoute = false;
        $scope.getOrderMap = function (orderId, off) {
              if (angular.isUndefined($scope.controlOrderRoute) || $scope.controlOrderRoute == false) {
                  $scope.controlOrderRoute = true;
                  if ($scope.mapOrder != null) {
                      $scope.mapOrder.remove();
                      $scope.mapOrder = null;
                  }
                  $timeout(function () {
                      $scope.initMapOrder(orderId, off);
                  }, 100);
            } else {
                  $scope.controlOrderRoute = false;
            }
        }
        $scope.initMapOrder = function (orderId, off) {
            var LocalOpenStreet = L.tileLayer(
                'https://api.947.ro:8081/tiles/{z}/{x}/{y}.png',
                {maxZoom: 22, type: 'osm_local'}
            );
            if (!$scope.mapOrder || $scope.mapOrder == undefined) {
                $scope.mapOrder = L.map('map-order', {
                    center: $scope.center,
                    zoom: 13,
                    //scrollWheelZoom: true,
                    zoomControl: true,
                    layers: [LocalOpenStreet],
                });
                //$scope.markersEstimated[0] = $scope.makeMarker(0, 0, '<div class="marker marker-center"></div>', {lat:$scope.center[0], lng:$scope.center[1]});

                $scope.mapOrder.doubleClickZoom.disable();
                $scope.mapOrder.zoomControl.setPosition('bottomright');
                //$scope.mapOrder.invalidateSize();
                $scope.mapOrder._onResize();

                var brightnessMapControl =  L.Control.extend({
                    options: {
                        position: 'bottomright'
                    },
                    onAdd: function (map) {
                        var container = L.DomUtil.create('button', 'leaflet-bar leaflet-control leaflet-control-custom leaflet-control-brightnessmap');
                        container.title = "Luminozitate/contrast";
                        container.onclick = function(ev) {
                            $scope.brightnessMap(ev);
                        }
                        return container;
                    }
                });
                $scope.mapOrder.addControl(new brightnessMapControl());

                var fullMapControl = L.Control.extend({
                    options: {
                        position: 'bottomright'
                    },
                    onAdd: function (map) {
                        var container = L.DomUtil.create('button', 'leaflet-bar leaflet-control leaflet-control-custom leaflet-control-fullmap minus');
                        container.title = "Extinde harta";
                        container.onclick = function (ev) {
                            $scope.fullsizeMap(ev);
                        }
                        return container;
                    }
                });
                $scope.mapOrder.addControl(new fullMapControl());

                var legend = L.control({position: 'bottomleft'});
                legend.onAdd = function (map) {
                    var div = L.DomUtil.create('div', 'info legend-order'),
                        colors = ['#4ea2e7', '#d00000', '#2ebe3c'],
                        labels = ['Start comanda curenta', 'End comanda curenta', 'End comenzi din slot'];
                    var closeButton = '<button type="button" id="close-legend">Legend</button>';
                    var html = closeButton+'<div class="div-legend hide">';
                    for (var i = 0; i < colors.length; i++) {
                       html +=
                            '<i style="background:' + colors[i] + '"></i> ' +
                            labels[i] + '<br>' ;
                    }
                    html += '</div>';
                    div.innerHTML = html;
                    div.onclick = function (ev) {
                        $scope.toggleLegend();
                    }
                    return div;
                };
                legend.addTo($scope.mapOrder);

                var OpenStreetMap = L.tileLayer(
                    'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
                    {maxZoom: 18, type: 'osm'}
                );
                var terrainMutant = L.gridLayer.googleMutant({
                    maxZoom: 24,
                    type: 'terrain'
                });
                var hybridMutant = L.gridLayer.googleMutant({
                    maxZoom: 24,
                    type: 'hybrid'
                });
                var roadMutant = L.gridLayer.googleMutant({
                    maxZoom: 24,
                    type:'roadmap'
                });
                var satMutant = L.gridLayer.googleMutant({
                    maxZoom: 24,
                    type:'satellite'
                });
                var trafficMutant = L.gridLayer.googleMutant({
                    maxZoom: 24,
                    type:'roadmap'
                });
                var transitMutant = L.gridLayer.googleMutant({
                    maxZoom: 24,
                    type:'roadmap'
                });
                L.control.layers({
                    'LocalOpenStreet': LocalOpenStreet,
                    'OpenStreetMap': OpenStreetMap,
                    'Google Terrain': terrainMutant,
                    'Google Hybrid': hybridMutant,
                    'Google Roadmap': roadMutant,
                    'Google Aerial': satMutant,
                    'Google Traffic': trafficMutant,
                    'Google Transit': transitMutant
                }, {}, {
                    collapsed: false  /*set true if wants event on mouseover*/
                }).addTo($scope.mapOrder);

                $('.leaflet-control-layers').hide();
                $('.leaflet-control-layers').css('top','15px');
                $('.leaflet-control-layers').css('right','15px');

                $scope.mapOrder.on('baselayerchange', function(e) {
                    $scope.mapOrder.eachLayer(function(layer) {
                        if (layer.options.type == 'terrain' || layer.options.type == 'hybrid' || layer.options.type == 'road' || layer.options.type == 'sat' || layer.options.type == 'traffic' || layer.options.type == 'transit') {
                            $scope.mapOrder.options.maxZoom = 20;
                        }
                        if (layer.options.type == 'osm_local' || layer.options.type == 'osm') {
                            $scope.mapOrder.options.maxZoom = 22;
                        }
                    });
                });
            }
            $scope.getRouteByOrder(orderId, off);
        }
        $scope.brightnessMap = function (ev) {
            angular.element(document.querySelector('.leaflet-layer')).toggleClass('opacity-layer ');
            angular.element(document.querySelector('.leaflet-google-layer')).toggleClass('opacity-layer ');
        }
        $scope.fullsizeMap = function (ev) {
            $scope.fullSize();
            angular.element(document.querySelector('.leaflet-control-fullmap')).toggleClass('minus plus');
            if ($scope.mapOrder) {
                $scope.mapOrder.invalidateSize();
                $scope.mapOrder._onResize();
            }
        }
        $scope.toggleLegend = function () {
            angular.element(document.querySelector('.div-legend')).toggleClass('hide show');
        }
        $scope.openLayers = function () {
            $('.leaflet-control-layers').toggle();
        }
        $scope.color_driver = 'e7534e';
        $scope.limit = 100;
        $scope.offset = 0;
        $scope.end_point = 0;
        $scope.no_markers = 0;
        $scope.dataRoute = {};
        $scope.dataRoute.routes = [];
        $scope.routeOrder = [];
        $scope.driver_points = [];
        $scope.order_points = [];
        var driver_point_object;
        var order_point_object;
        $scope.getRouteByOrder = function (orderId, off) {
            if (!angular.isUndefined(off)) {
                $scope.dataRoute = {};
                $scope.dataRoute.routes = [];

                $scope.offset = 0;
                $scope.end_point = 0;
                $scope.no_markers = 0;
                $scope.dataRoute = {};
                $scope.dataRoute.routes = [];
                $scope.removeRouteOrder();
            }

            $scope.isLoadingOrderRoute = true;
            var post = {};
            post['route'] = 'getRouteByOrder';
            post['offset'] = $scope.offset;
            post['limit'] = $scope.limit;
            if (!angular.isUndefined(orderId) && orderId != null && orderId != 'null') {
                post['order_id'] = orderId;
            } else {
                post['order_id'] = $routeParams.id;
            }
            Crud.post($scope.additionals['content_type'], post, $scope.path + '/getRouteByOrder')
                .success(function (data) {
                  $scope.isLoadingOrderRoute = false;

                      if (!angular.isUndefined(data['positionsEndOrder'])) {
                        angular.forEach(data['positionsEndOrder'], function (itemPosition, keyPosition) {
                            $scope.addOrderPoint(itemPosition['driver_latitude'], itemPosition['driver_longitude'], itemPosition['driver_date'], itemPosition['order_no']);
                        });
                      }
                      if (!angular.isUndefined(data['routes'])) {
                        $scope.no_markers = $scope.no_markers + data['routes'].length;
                        if($scope.offset == 0){
                            $scope.dataRoute.routes = data['routes'];
                        } else {
                            $scope.dataRoute.routes = [$scope.dataRoute['routes'][$scope.dataRoute['routes'].length - 1]].concat(data['routes']);
                        }
                        $scope.offset = $scope.offset + $scope.limit;
                        if(data['routes'].length == $scope.limit) {
                            $scope.getRouteByOrder(orderId);
                        } else {
                            $scope.end_point = 1;
                        }
                        $scope.loadRoute($scope.dataRoute, $scope.offset/$scope.limit);
                    }
                });
        }

        $scope.loadRoute = function(slot, off) {
            if (!angular.isUndefined($scope.center_marker)) {
                $scope.mapOrder.removeLayer($scope.center_marker);
            }
            if (!angular.isUndefined(slot['routes'])) {
                if (slot['routes'] && slot['routes'].length > 0) {
                    if(off > 1) {
                        $scope.no_markers = $scope.no_markers + 1;
                    }
                    let latlngs = []; let driver_point_object = [];
                    angular.forEach(slot['routes'], function (itemRoute, keyRoute) {
                        latlngs[keyRoute] = [slot['routes'][keyRoute]['driver_latitude'], slot['routes'][keyRoute]['driver_longitude']];

                        if (!angular.isUndefined(slot['routes'][keyRoute+1])) {
                            latlngs[keyRoute+1] = [slot['routes'][keyRoute+1]['driver_latitude'], slot['routes'][keyRoute+1]['driver_longitude']];
                        }
                        $scope.addDriverPoint(slot['routes'][keyRoute]['driver_latitude'], slot['routes'][keyRoute]['driver_longitude'], slot['routes'][keyRoute]['driver_date']);

                        if (!angular.isUndefined(slot['routes'][keyRoute+1])) {
                            if (angular.isUndefined($scope.routeOrder[off])) {
                                $scope.routeOrder[off] = [];
                            }
                            if (angular.isUndefined($scope.routeOrder[off][keyRoute])) {
                                $scope.routeOrder[off][keyRoute] = [];
                            }
                            if (!angular.isUndefined(latlngs[keyRoute]) && !angular.isUndefined(latlngs[keyRoute+1])) {
                                $scope.routeOrder[off][keyRoute] =  L.polyline([latlngs[keyRoute], latlngs[keyRoute+1]], {color: '#'+$scope.color_driver, weight: 5, opacity: 0.7});
                            }
                            $scope.routeOrder[off][keyRoute].addTo($scope.mapOrder);
                        }
                    });
                    //$scope.routeOrder[off] = L.polyline(latlngs, {color: '#' + $scope.color_driver, weight: 5, opacity: 0.7});
                    //$scope.routeOrder[off].addTo($scope.mapOrder);
                }
            }
        }

        $scope.addOrderPoint = function(latitude, longitude, driver_date, order_no) {

            if($scope.mapOrder) {
                if (angular.isUndefined(order_point_object)) {
                    order_point_object = [];
                }
                var i = $scope.order_points.length;
                var html = '';

                if (!angular.isUndefined(order_no)) {
                  var html = '<div class="point point-green-medium"></div>';
                  var point_popup = '<h2 class="red text-center">End comanda nr:'+order_no+':</h2>';
                }
                point_popup += '<div class="text-center">lat. '+latitude+'</div>';
                point_popup += '<div class="text-center">lng. '+longitude+'</div>';
                if (!angular.isUndefined(driver_date)) {
                    point_popup += '<div class="text-center">ora: ' + moment(driver_date).format('HH:mm:ss') + '</div>';
                }
                var order_point_object = L.marker(
                  [latitude, longitude],
                  {
                      draggable: false,
                      icon: L.divIcon({
                          className: 'point-div-icon',
                          html: html,
                          popupAnchor: [0, -10]
                      })
                  });
                $scope.order_points[i] = order_point_object.addTo($scope.mapOrder).bindPopup(point_popup, {
                    maxWidth: 120,
                    maxHeight: 85
                });
            }
        }

        $scope.addDriverPoint = function(latitude, longitude, driver_date) {

            if($scope.mapOrder) {
                if (angular.isUndefined(driver_point_object)) {
                    driver_point_object = [];
                }
                var i = $scope.driver_points.length;
                var html = '';
                if(i == 0) {
                    var html = '<div class="marker-blue"></div>';
                    var point_popup = '<h2 class="red text-center">Start comanda:</h2>';
                }
                //console.log(i+'='+$scope.no_markers+'-'+$scope.end_point)
                if($scope.end_point == 1 && i == $scope.no_markers - 1) {
                    var html = '<div class="marker-red"></div>';
                    var point_popup = '<h2 class="red text-center">End comanda:</h2>';
                }
                point_popup += '<div class="text-center">lat. '+latitude+'</div>';
                point_popup += '<div class="text-center">lng. '+longitude+'</div>';
                if (!angular.isUndefined(driver_date)) {
                    point_popup += '<div class="text-center">ora: ' + moment(driver_date).format('HH:mm:ss') + '</div>';
                }
                driver_point_object[i] = L.marker(
                    [latitude, longitude],
                    {
                        draggable: false,
                        icon: L.divIcon({
                            className: 'point-div-icon',
                            html: html,
                            popupAnchor: [0, -50]
                        })
                    });
                if (!angular.isUndefined($scope.driver_points[i]) && $scope.driver_points[i] != null) {
                    $scope.driver_points[i].setLatLng([latitude, longitude]);
                } else {
                    $scope.driver_points[i] = driver_point_object[i].addTo($scope.mapOrder).bindPopup(point_popup, {
                        maxWidth: 120,
                        maxHeight: 85
                    });
                }
            }
        }

        $scope.removeRouteOrder = function() {
          if($scope.mapOrder) {
            if (!angular.isUndefined($scope.routeOrder) && $scope.routeOrder.length > 0) {
                angular.forEach($scope.routeOrder, function (itemRouteOrder, keyRouteOrder) {
                    angular.forEach($scope.routeOrder[keyRouteOrder], function (itemRouteOrderSegment, keyRouteOrderSegment) {
                        $scope.mapOrder.removeLayer($scope.routeOrder[keyRouteOrder][keyRouteOrderSegment]);
                    });
                });
            }
            if (!angular.isUndefined($scope.driver_points) && $scope.driver_points.length > 0) {
                angular.forEach($scope.driver_points, function (itemPointDriver, keyPointDriver) {
                    if (!angular.isUndefined($scope.driver_points[keyPointDriver])) {
                        $scope.mapOrder.removeLayer($scope.driver_points[keyPointDriver]);
                    }
                });
                $scope.driver_points = [];
            }
            if (!angular.isUndefined($scope.order_points) && $scope.order_points.length > 0) {
                angular.forEach($scope.order_points, function (itemPointOrder, keyPointOrder) {
                    if (!angular.isUndefined($scope.order_points[keyPointOrder])) {
                        $scope.mapOrder.removeLayer($scope.order_points[keyPointOrder]);
                    }
                });
                $scope.order_points = [];
            }
          }
        }

        $rootScope.detailOrder = function () {
            $scope.mode_action = 'dialog';
            $interval.cancel($rootScope.stopTimerShowOrder);
            $scope.controlOrderRoute = false;

            Crud.show($routeParams.id, $scope.path)
                .success(function (data) {

                    $scope.additionals['originalModelShow'] = angular.copy(data);

                    $scope.modelData = data;
                    $rootScope.stopTimerShowOrder = $interval(function () {
                        $scope.modelData.timerShowOrder = $scope.timer(data.validated_at);
                    }, 1000);
                    $scope.additionals['calcProcess'](data);
                });
        }

        /* reports */
        if ($rootScope.settings.enable_packaging == 1) {
            $scope.nonDisplay = 0;
        } else {
            $scope.nonDisplay = 1;
        }
        $scope.printReport = $window;
        $scope.isLoadingPrinter = false;
        $scope.printPreview = function (ev, path, availableColumns, columns) {

            $scope.isLoadingPrinter = true;
            var popup = $scope.printReport.open('', '_blank', 'width=800,height=300,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no,top=50');
            popup.document.open();

            Crud.search($scope.search, path, 1, 'p')
                    .success(function (data) {
                        $scope.isLoadingPagination = false;
                        $scope.isLoadingPrinter = false;

                        $scope.additionals['buttonDisabledPagination'] = false;
                        var printColumns = {};
                        if (!angular.isUndefined(availableColumns) && availableColumns.length > 0) {
                            angular.forEach(columns, function (item, index) {
                                if (availableColumns.indexOf(index) >= 0) {
                                    printColumns[index] = item;
                                }
                            });
                        } else {
                            printColumns = columns;
                        }
                        var title = 'Raport ';
                        if ($scope.search['reportType'] == 'reportDetail') {
                            title = title + 'detaliat';
                        }
                        if ($scope.search['reportType'] == 'reportCancellation') {
                            title = title + 'comenzi anulate';
                        }
                        if ($scope.search['reportType'] == 'reportCancellationTazz') {
                            title = title + 'comenzi anulate de catre Tazz';
                        }
                        if ($scope.search['reportType'] == 'reportCancellationTazzGeneral') {
                            title = title + 'general comenzi anulate de catre Tazz';
                        }
                        if ($scope.search['reportType'] == 'reportPlanned') {
                            title = title + 'comenzi planificate';
                        }
                        if ($scope.search['reportType'] == 'reportIncidents') {
                            title = title + 'incidente';
                        }
                        if ($scope.search['reportType'] == 'reportKitchen') {
                            title = title + 'timp de procesare';
                        }
                        if ($scope.search['reportType'] == 'reportKitchenAverage') {
                            title = title + 'timp mediu de procesare';
                        }
                        if ($scope.search['reportType'] == 'reportDaily') {
                            title = title + 'zilnic';
                        }
                        if ($scope.search['reportType'] == 'reportMonthly') {
                            title = title + 'lunar';
                        }
                        if ($scope.search['reportType'] == 'reportDailySource') {
                            title = title + 'zilnic pe surse de provenienta';
                        }
                        if ($scope.search['reportType'] == 'reportSource') {
                            title = title + 'pe surse de provenienta';
                        }
                        if ($scope.search['reportType'] == 'reportShipping') {
                            title = title + 'privind taxa de transport';
                        }
                        if ($scope.search['reportType'] == 'reportDiscount') {
                            title = title + 'privind situatia reducerilor';
                        }
                        if ($scope.search['reportType'] == 'reportDiscountDetail') {
                            title = title + 'privind situatia detaliata a reducerilor';
                        }
                        if ($scope.search['reportType'] == 'reportDiscountClientDetail') {
                            title = title + 'privind situatia detaliata a reducerilor per client';
                        }
                        if ($scope.search['reportType'] == 'reportDiscountImportDetail') {
                            title = title + 'privind situatia detaliata a reducerilor din import';
                        }
                        if ($scope.search['reportType'] == 'reportDispatcher') {
                            title = title + 'dispeceri';
                        }
                        if ($scope.search['reportType'] == 'reportDetailSgr') {
                            title = title + 'detaliat';
                        }
                        if ($scope.search['reportType'] == 'reportDailySgr') {
                            title = title + 'zilnic';
                        }
                        if ($scope.search['reportType'] == 'reportGeneralSgr') {
                            title = title + 'general';
                        }
                        if ($scope.search['reportType'] == 'reportMonetary') {
                            title = title + 'de monetar';
                        }
                        title = title + '  ';
                        if ($scope.search['dateFrom']) {
                            title = title + moment($scope.search['dateFrom']).format('DD/MM/YY');
                        }
                        if ($scope.search['timeFrom']) {
                            title = title + moment($scope.search['timeFrom']).format(' HH:mm:ss');
                        }
                        if ($scope.search['dateFrom'] || $scope.search['timeFrom']) {
                            title = title + '   ';
                        }
                        if ($scope.search['dateTo']) {
                            title = title + moment($scope.search['dateTo']).format('DD/MM/YY');
                        }
                        if ($scope.search['timeTo']) {
                            title = title + moment($scope.search['timeTo']).format(' HH:mm:ss');
                        }

                        var html = '<div class="report-print">';
                        var orders = data.data;
                        if (orders.length > 0) {
                            html = html + '<table><tr>';
                            html = html + '<th>Nr.</th>';
                            angular.forEach(printColumns, function (itemColumn, keyColumn) {
                                if (!itemColumn['nonDisplay']) {
                                    html = html + '<th>' + itemColumn['label'] + '</th>';
                                }
                            });
                            html = html + '</tr>';

                            var order_amount = 0;
                            var order_shipping = 0;
                            var order_product_discount = 0;
                            var order_client_discount = 0;
                            var order_loyalty_point_discount = 0;
                            var order_discount = 0;
                            var tazz_discount = 0;
                            var order_packaging = 0;
                            var order_numbers = 0;
                            var total_discount = 0;
                            var order_tip = 0;
                            var order_product_sgr = 0;
                            var food_product_sgr_0 = 0;
                            var food_product_sgr_1 = 0;
                            var food_product_sgr_2 = 0;
                            var food_product_sgr_3 = 0;
                            var total = 0;
                            var call_numbers = 0;
                            var imported_order_numbers = 0;
                            var phone_order_numbers = 0;
                            var order_nos_exceeded = 0;

                            angular.forEach(orders, function (item, key) {
                                html = html + '<tr>';
                                var keys = key + 1;
                                html = html + '<td>' + keys + '</td>';
                                angular.forEach(printColumns, function (itemColumn, keyColumn) {
                                    if (keyColumn == 'order_incidents') {
                                        html = html + '<td class="align-left">';
                                        angular.forEach(item[keyColumn], function (itemColumnIncident, keyColumnIncident) {
                                            var keyColumnIncidents = keyColumnIncident + 1;
                                            if (itemColumnIncident['food_product_id'] == 0) {
                                                html = html + keyColumnIncidents + ': ' + itemColumnIncident['order_incident'] + '<br><br>';
                                            }
                                            if (itemColumnIncident['food_product_id'] != 0) {
                                                html = html + keyColumnIncidents + '.' + itemColumnIncident['food_product_name'] + ' (' + itemColumnIncident['food_product_code'] + ') :' + itemColumnIncident['food_product_quantity'] + ' (buc) - ' + itemColumnIncident['food_product_incident'] + '<br><br>';
                                            }
                                        });
                                        html = html + '</td>';
                                    }
                                    if (keyColumn == 'department_incidents') {
                                        html = html + '<td class="align-left">';
                                        angular.forEach(item['order_incidents'], function (itemColumnIncident, keyColumnIncident) {
                                            html = html + $scope.additionals['associativeColumn']($scope.additionals['incident_department'], itemColumnIncident['department_incident']) + '<br><br>';
                                        });
                                        html = html + '</td>';
                                    }
                                    if (keyColumn == 'discount_campaigns_type0' || keyColumn == 'discount_campaigns_type1') {
                                        html = html + '<td class="align-left">';
                                        angular.forEach(item[keyColumn], function (itemDisc, indexDisc) {
                                          if (!angular.isUndefined(itemDisc)) {

        html = html + $scope.additionals['associativeColumn']($scope.additionals['discount_campaign_type'], itemDisc['discount_campaign_type']) +' '+itemDisc['discount_campaign_value']+' '+$scope.additionals['associativeColumn']($scope.additionals['discount_campaign_value_type'], itemDisc['discount_campaign_value_type'], 'mark');

        if(itemDisc['discount_campaign_reason']) {
            html = html + '('+itemDisc['discount_campaign_reason']+')';
        }
        html = html + '<br><br>';
                                          }
                                        });
                                        html = html + '</td>';
                                    }
                                    if (keyColumn != 'order_incidents' && keyColumn != 'department_incidents' && keyColumn != 'discount_campaigns_type0' && keyColumn != 'discount_campaigns_type1') {
                                      if(angular.isUndefined(item[keyColumn]) || item[keyColumn] == null || item[keyColumn] == 'null'){
                                        item[keyColumn] = '';
                                      }
                                      if(keyColumn == 'order_discount_reason'){
                                        item[keyColumn] = parseInt(item[keyColumn]);
                                      }
                                      if(keyColumn == 'percent_nos_estimated_time_exceeded'){
                                        item[keyColumn] = parseInt(item['order_nos_exceeded'] * 100/ item['order_numbers']);
                                      }
                                        if (!itemColumn['nonDisplay']) {
                                            if (itemColumn['filterType'] == 'select') {
                                                if (!angular.isUndefined(item[keyColumn]) && item[keyColumn] !== '') {
                                                    html = html + '<td>' + $scope.additionals['associativeColumn'](printColumns[keyColumn], item[keyColumn]) + '</td>';
                                                } else {
                                                    html = html + '<td></td>';
                                                }
                                            } else {
                                                if (!angular.isUndefined(item[keyColumn]) && item[keyColumn] != '') {
                                                    html = html + '<td>' + item[keyColumn] + '</td>';
                                                } else {
                                                    html = html + '<td></td>';
                                                }
                                            }
                                        }
                                    }
                                });
                                html = html + '</tr>';

                                order_amount = order_amount + parseFloat(item['order_amount']);
                                order_product_discount = order_product_discount + parseFloat(item['order_product_discount']);
                                order_client_discount = order_client_discount + parseFloat(item['order_client_discount']);
                                order_loyalty_point_discount = order_loyalty_point_discount + parseFloat(item['order_loyalty_point_discount']);
                                order_shipping = order_shipping + parseFloat(item['order_shipping']);
                                order_discount = order_discount + parseFloat(item['order_discount']);
                                tazz_discount = tazz_discount + parseFloat(item['tazz_discount']);
                                order_packaging = order_packaging + parseFloat(item['order_packaging']);
                                order_numbers = order_numbers + parseInt(item['order_numbers']);
                                total_discount = total_discount + parseFloat(item['total_discount']);
                                order_tip = order_tip + parseFloat(item['order_tip']);
                                order_product_sgr = order_product_sgr + parseFloat(item['order_product_sgr']);
                                food_product_sgr_0 = food_product_sgr_0 + parseFloat(item['food_product_sgr_0']);
                                food_product_sgr_1 = food_product_sgr_1 + parseFloat(item['food_product_sgr_1']);
                                food_product_sgr_2 = food_product_sgr_2 + parseFloat(item['food_product_sgr_2']);
                                food_product_sgr_3 = food_product_sgr_3 + parseFloat(item['food_product_sgr_3']);
                                total = total + parseFloat(item['total']);

                                call_numbers = call_numbers + parseFloat(item['call_numbers']);
                                imported_order_numbers = imported_order_numbers + parseFloat(item['imported_order_numbers']);
                                phone_order_numbers = phone_order_numbers + parseFloat(item['phone_order_numbers']);

                                order_nos_exceeded = order_nos_exceeded + item['order_nos_exceeded'];
                            });

                            html = html + '<tr>';
                            html = html + '<td>Total</td>';
                            angular.forEach(printColumns, function (itemColumn, keyColumn) {
                                if (!itemColumn['nonDisplay']) {
                                    if (keyColumn == 'order_numbers') {
                                        html = html + '<td class="align-right total">' + order_numbers + '</td>';
                                    } else if (keyColumn == 'order_amount') {
                                        html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](order_amount) + '</td>';
                                    } else if (keyColumn == 'order_product_discount') {
                                        html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](order_product_discount) + '</td>';
                                    } else if (keyColumn == 'order_client_discount') {
                                        html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](order_client_discount) + '</td>';
                                    } else if (keyColumn == 'order_loyalty_point_discount') {
                                        html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](order_loyalty_point_discount) + '</td>';
                                    } else if (keyColumn == 'order_shipping') {
                                        html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](order_shipping) + '</td>';
                                    } else if (keyColumn == 'order_discount') {
                                        html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](order_discount) + '</td>';
                                    } else if (keyColumn == 'tazz_discount') {
                                        html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](tazz_discount) + '</td>';
                                    } else if (keyColumn == 'order_packaging') {
                                        html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](order_packaging) + '</td>';
                                    } else if (keyColumn == 'total') {
                                        html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](total) + '</td>';
                                    } else if (keyColumn == 'total_discount') {
                                        html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](total_discount) + '</td>';
                                    } else if (keyColumn == 'order_tip') {
                                        html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](order_tip) + '</td>';
                                    } else if (keyColumn == 'order_product_sgr') {
                                        html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](order_product_sgr) + '</td>';
                                    } else if (keyColumn == 'food_product_sgr_0') {
                                        html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](food_product_sgr_0) + '</td>';
                                    } else if (keyColumn == 'food_product_sgr_1') {
                                        html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](food_product_sgr_1) + '</td>';
                                    } else if (keyColumn == 'food_product_sgr_2') {
                                        html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](food_product_sgr_2) + '</td>';
                                    } else if (keyColumn == 'food_product_sgr_3') {
                                        html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](food_product_sgr_3) + '</td>';
                                    } else if (keyColumn == 'call_numbers') {
                                        html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](call_numbers) + '</td>';
                                    } else if (keyColumn == 'imported_order_numbers') {
                                        html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](imported_order_numbers) + '</td>';
                                    } else if (keyColumn == 'phone_order_numbers') {
                                        html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](phone_order_numbers) + '</td>';
                                    } else if (keyColumn == 'order_nos_exceeded') {
                                        html = html + '<td class="align-right total">' + order_nos_exceeded + '</td>';
                                    } else {
                                        html = html + '<td></td>';
                                    }
                                }

                            });
                            html = html + '</tr>';

                            html = html + '</table>';
                        }

                        popup.document.write('<!DOCTYPE html><html><head><title>' + title + '</title>'
                                + '<link rel="stylesheet" type="text/css" href="/css/print-preview.css" />'
                                + '</head><body onload="window.print(); window.close();">'
                                + html
                                + '</body></html>');
                        //popup.document.close();

                    }).error(function (data) {
                $scope.isLoadingPagination = false;
                $scope.errors = data.errors;
            });

        }

        $scope.additionals['report'] = 0;
        if ($location.path() == $scope.path + '/reportDetail') {
            $scope.columns = {
                //'id':{'label':'Id', 'filter':1, 'filterType':'input'},
                //'address_detail':{'label': 'Adresa', 'filter': 1, 'filterType': 'input'},
                'street_name': {'label': 'Strada', 'filter': 1, 'filterType': 'input'},
                'address_no': {'label': 'Nr.str.', 'filter': 1, 'filterType': 'input'},
                'locality_name': {'label': 'Loc.', 'filter': 1, 'filterType': 'input'},
                'order_no': {'label': 'Nr.com.', 'filter': 1, 'filterType': 'input'},
                'client_name': {'label': 'Client', 'filter': 1, 'filterType': 'input'},
                'payment_method_name': {'label': 'Plata', 'filter': 1, 'filterType': 'select'},
                'shipping_method_name': {'label': 'Livrare', 'filter': 1, 'filterType': 'select'},
                //'call_id':{'label': 'Telefon', 'filter': 1, 'filterType': 'input'},
                'order_phone': {'label': 'Telefon', 'filter': 1, 'filterType': 'input'},
                'order_source': {'label': 'Sursa', 'filter': 1, 'filterType': 'select'},
                'order_orig_id': {'label': 'Id extern', 'filter': 1, 'filterType': 'input'},
                'order_start': {'label': 'Start', 'filter': 1, 'filterType': 'input'},
                'order_end': {'label': 'End', 'filter': 1, 'filterType': 'input'},
                'order_status': {'label': 'Status comanda', 'filter': 1, 'filterType': 'select'},
                //'status': {'label': 'Status', 'filter': 1, 'filterType': 'select'},
                //'created_by':{'label':'Adaugat', 'filter':1, 'filterType':'input'},
                'order_amount': {'label': 'Total produse (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_packaging': {'label': 'Cost ambalaj (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input', 'nonDisplay': $scope.nonDisplay},
                'order_product_discount': {'label': 'Discount produse (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_discount': {'label': 'Discount comanda (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'tazz_discount': {'label': 'Discount tazz (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_client_discount': {'label': 'Discount client (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_loyalty_point_discount': {'label': 'Discount pct. fidelizare (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_shipping': {'label': 'Transport (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_tip': {'label': 'Tips (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_product_sgr': {'label': 'SGR (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'total': {'label': 'Total (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                //'order_partial':{'label':'Plata partiala ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'}
            };
            // $scope.columns.status.options = [
            //     {'id': '', 'value': ''},
            //     {'id': 1, 'value': 'true'},
            //     {'id': 0, 'value': 'false'}
            // ];

            $scope.columns.order_status.options = $scope.order_status;
            $scope.columns.order_source.options = $scope.order_source;

            $scope.search['reportType'] = 'reportDetail';
            $scope.additionals['reportType'] = 'reportDetail';
            $scope.title = 'Comenzi / Raport detaliat';
            $scope.classAction = 'td-small';
            $scope.additionals['report'] = 1;
        }

        if ($location.path() == $scope.path + '/reportCancellation') {
            $scope.additionals['getUsers'] = function () {
                Crud.get($scope.path + '/getUsers')
                        .success(function (data) {
                            $scope.additionals['users'] = data.users;
                        });
            }
            $scope.additionals['getUsers']();

            $scope.additionals['getDrivers'] = function () {
                Crud.get($scope.path + '/getDrivers')
                        .success(function (data) {
                            $scope.additionals['drivers'] = data.drivers;
                        });
            }
            $scope.additionals['getDrivers']();
            $scope.columns = {
                //'id':{'label':'Id', 'filter':1, 'filterType':'input'},
                'order_start': {'label': 'Data com.', 'filter': 1, 'filterType': 'input'},
                'canceled_at': {'label': 'Data anulare', 'filter': 1, 'filterType': 'input'},
                'canceled_order': {'label': 'Utilizator/Sofer', 'filter': 1, 'filterType': 'input'},
                'order_no': {'label': 'Nr.com.', 'filter': 1, 'filterType': 'input'},
                'order_source': {'label': 'Sursa', 'filter': 1, 'filterType': 'select'},
                'reason_cancellation': {'label': 'Motiv anulare', 'filter': 1, 'filterType': 'input'},
                'order_status': {'label': 'stat.', 'filter': 1, 'filterType': 'input', 'nonDisplay': 1},
                'total': {'label': 'Total (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
            };

            $scope.columns.order_status.options = $scope.order_status;
            $scope.columns.order_source.options = $scope.order_source;

            $scope.search['reportType'] = 'reportCancellation';
            $scope.additionals['reportType'] = 'reportCancellation';
            $scope.title = 'Comenzi / Raport comenzi anulate';
            $scope.classAction = 'td-small';
            $scope.additionals['report'] = 1;
        }

        if ($location.path() == $scope.path + '/reportCancellationTazz') {

            $scope.columns = {
                //'id':{'label':'Id', 'filter':1, 'filterType':'input'},
                'order_start': {'label': 'Data com.', 'filter': 1, 'filterType': 'input'},
                'canceled_at': {'label': 'Data anulare', 'filter': 1, 'filterType': 'input'},
                'cancellation_status_tazz': {'label': 'Status anulare', 'filter': 1, 'filterType': 'select'},
                'order_no': {'label': 'Nr.com.', 'filter': 1, 'filterType': 'input'},
                'order_orig_id': {'label': 'Id extern', 'filter': 1, 'filterType': 'input'},
                'order_status': {'label': 'Status com.', 'filter': 1, 'filterType': 'select'},
                'total': {'label': 'Total (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
            };
            $scope.columns['cancellation_status_tazz'].options = $scope.additionals['cancellation_status_tazz'].options;
            $scope.columns.order_status.options = $scope.order_status;

            $scope.search['reportType'] = 'reportCancellationTazz';
            $scope.additionals['reportType'] = 'reportCancellationTazz';
            $scope.title = 'Comenzi / Raport comenzi anulate de catre Tazz';
            $scope.classAction = 'td-small';
            $scope.additionals['report'] = 1;
        }

        if ($location.path() == $scope.path + '/reportCancellationTazzGeneral') {

            $scope.changeColumnsCancellationTazzGeneral = function (reportTypeGeneral) {
                if (!angular.isUndefined(reportTypeGeneral)) {

                    if($scope.search.reportTypeGeneral == 'day'){
                      $scope.columns = {
                          'date': {'label': 'Perioada selectie', 'filter': 1, 'filterType': 'input'},
                          'orders_nos': {'label': 'Nr.comenzi', 'filter': 1, 'filterType': 'input'},
                          'total': {'label': 'Total (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                      };
                    }
                    if($scope.search.reportTypeGeneral == 'cancellation_status'){
                      $scope.columns = {
                          'cancellation_status_tazz': {'label': 'Status anulare', 'filter': 1, 'filterType': 'select'},
                          'orders_nos': {'label': 'Nr.comenzi', 'filter': 1, 'filterType': 'input'},
                          'total': {'label': 'Total (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                      };
                      $scope.columns['cancellation_status_tazz'].options = $scope.additionals['cancellation_status_tazz'].options;
                    }
                } else {
                  $scope.columns = {
                      'date': {'label': 'Perioada selectie', 'filter': 1, 'filterType': 'input'},
                      'orders_nos': {'label': 'Nr.comenzi', 'filter': 1, 'filterType': 'input'},
                      'total': {'label': 'Total (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                  };
                }
            }
            $scope.additionals.reportTypeGeneral = $scope.search.reportTypeGeneral;
            $scope.searchModel = function (ev, path) {
                $scope.searchControl = true;
                $scope.last = 0;
                $scope.firstTime = 1;
                $scope.firstLoad = 0;
                $scope.getPaginateModel(path, 1, $scope.defaultItem);
                $scope.changeColumnsCancellationTazzGeneral($scope.search.reportTypeGeneral);
                $scope.additionals.reportTypeGeneral = $scope.search.reportTypeGeneral;
            }

            $scope.search['dateFromCancellation'] = current_init_date;
            $scope.search['reportType'] = 'reportCancellationTazzGeneral';
            $scope.additionals['reportType'] = 'reportCancellationTazzGeneral';
            $scope.title = 'Comenzi / Raport general comenzi anulate de catre Tazz';
            $scope.classAction = 'td-small';
            $scope.additionals['report'] = 1;
        }

        if ($location.path() == $scope.path + '/reportPlanned') {

            $scope.columns = {
                //'id':{'label':'Id', 'filter':1, 'filterType':'input'},
                'order_start': {'label': 'Data creare', 'filter': 1, 'filterType': 'input'},
                'order_planning': {'label': 'Data planificare', 'filter': 1, 'filterType': 'input'},
                'order_no': {'label': 'Nr.com.', 'filter': 1, 'filterType': 'input'},
                'order_source': {'label': 'Sursa', 'filter': 1, 'filterType': 'select'},
                'order_status': {'label': 'Status', 'filter': 1, 'filterType': 'select'},
                'total': {'label': 'Total (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
            };

            $scope.columns.order_status.options = $scope.order_status;
            $scope.columns.order_source.options = $scope.order_source;

            $scope.search['reportType'] = 'reportPlanned';
            $scope.search['field'] = 'order_planning';
            $scope.search['dateFromPlanned'] = current_init_date;
            $scope.additionals['reportType'] = 'reportPlanned';
            $scope.title = 'Comenzi / Raport comenzi planificate';
            $scope.classAction = 'td-small';
            $scope.additionals['report'] = 1;
        }

        if ($location.path() == $scope.path + '/reportIncidents') {

            $scope.controlToggleText = [];
            $scope.toggleText = function (key, index) {
                if (angular.isUndefined($scope.controlToggleText[key])) {
                    $scope.controlToggleText[key] = [];
                }
                if (angular.isUndefined($scope.controlToggleText[key][index]) || $scope.controlToggleText[key][index] == false) {
                    $scope.controlToggleText[key][index] = true;
                } else {
                    $scope.controlToggleText[key][index] = false;
                }
            }

            $scope.columns = {
                'order_start': {'label': 'Data', 'filter': 1, 'filterType': 'input', 'class': 'td-bbig'},
                'order_no': {'label': 'Nr.com.', 'filter': 1, 'filterType': 'input'},
                'order_incidents': {'label': 'Incidente', 'filter': 1, 'filterType': 'input'},
                'department_incidents': {'label': 'Departamente', 'filter': 1, 'filterType': 'input'},
                'total': {'label': 'Valoare produse (' + $rootScope.currency + ')', 'filter': 0, 'filterType': 'input'}
            };

            /*$scope.columns = {
             'date': {'label': 'Data', 'filter': 1, 'filterType': 'input', 'class': 'td-bbig'},
             'order_no': {'label': 'Nr.com.', 'filter': 1, 'filterType': 'input'},
             'food_product_name': {'label': 'Produs', 'filter': 1, 'filterType': 'input'},
             'food_product_quantity': {'label': 'Cantitate produs', 'filter': 1, 'filterType': 'input'},
             'incident': {'label': 'Incident', 'filter': 1, 'filterType': 'input'},
             'department_incident': {'label': 'Departament', 'filter': 0, 'filterType': 'input'},
             'total': {'label': 'Valoare produs (' + $rootScope.currency + ')', 'filter': 0, 'filterType': 'input'}
             };*/

            $scope.search['reportType'] = 'reportIncidents';
            $scope.additionals['reportType'] = 'reportIncidents';
            $scope.title = 'Comenzi / Raport incidente';
            $scope.classAction = 'td-small';
            $scope.additionals['report'] = 1;
            $scope.additionals['mentionReport'] = 'Pentru a vizualiza in intregime incidentul, apasati pe produs';
        }

        if ($location.path() == $scope.path + '/reportKitchen') {
            Crud.getDependedFields($scope.path)
                    .success(function (data) {
                        $scope.columns = {
                            //'id':{'label':'Id', 'filter':1, 'filterType':'input'},
                            'order_no': {'label': 'Nr. comanda', 'filter': 1, 'filterType': 'input'}
                        };
                        $scope.additionals['kitchens'] = data.kitchens;
                        angular.forEach($scope.additionals['kitchens'], function (item, index) {
                            $scope.columns['kitchen_' + item['id']] = {'label': item['kitchen_name'] + ' (' + item['target_time'] + ' min) ', 'filter': 1, 'filterType': 'input'};
                        });
                    });

            $scope.search['reportType'] = 'reportKitchen';
            $scope.additionals['reportType'] = 'reportKitchen';
            $scope.title = 'Comenzi / Raport timp de procesare in bucatarii';
            $scope.classAction = 'td-small';
            $scope.additionals['report'] = 1;
        }

        if ($location.path() == $scope.path + '/reportKitchenAverage') {
            Crud.getDependedFields($scope.path)
            .success(function (data) {
                $scope.columns = {
                    //'id':{'label':'Id', 'filter':1, 'filterType':'input'},
                    'date': {'label': 'Data/Interval', 'filter': 1, 'filterType': 'input'},
                };
                $scope.additionals['kitchens'] = data.kitchens;
                angular.forEach($scope.additionals['kitchens'], function (item, index) {
                    $scope.columns['kitchen_' + item['id']] = {'label': item['kitchen_name'] + ' (' + item['target_time'] + ' min) ', 'filter': 1, 'filterType': 'input'};
                });
            });

            $scope.search['reportType'] = 'reportKitchenAverage';
            $scope.additionals['reportType'] = 'reportKitchenAverage';
            $scope.title = 'Comenzi / Raport timp mediu de procesare in bucatarii';
            $scope.classAction = 'td-small';
            $scope.additionals['report'] = 1;
            $scope.search.period = 'hourly';
            $scope.search.field = 'date';
        }

        if ($location.path() == $scope.path + '/reportDispatcher') {
          $scope.columns = {
              'user_name': {'label': 'Dispecer', 'filter': 1, 'filterType': 'input'},
              'call_numbers': {'label': 'Nr. apeluri', 'filter': 1, 'filterType': 'input'},
              'imported_order_numbers': {'label': 'Nr. comenzi importate', 'filter': 1, 'filterType': 'input'},
              'phone_order_numbers': {'label': 'Nr. comenzi telefonice', 'filter': 1, 'filterType': 'input'},
              //'direct_order_numbers': {'label': 'Nr. comenzi directe', 'filter': 1, 'filterType': 'input'},
              //'order_numbers': {'label': 'Nr. comenzi', 'filter': 1, 'filterType': 'input'},
            }

            $scope.search['reportType'] = 'reportDispatcher';
            $scope.additionals['reportType'] = 'reportDispatcher';
            $scope.title = 'Raport eficienta dispeceri';
            $scope.classAction = 'td-small';
            $scope.additionals['report'] = 1;
            $scope.search.field = 'date';
        }

        if ($location.path() == $scope.path + '/reportDaily') {
            $scope.controlGetOrder = false;
            $scope.columns = {
                'date': {'label': 'Data', 'filter': 1, 'filterType': 'input'},
                //'order_nos':{'label':'Comenzi', 'filter':1, 'filterType':'input'},
                'order_numbers': {'label': 'Nr. comenzi', 'filter': 1, 'filterType': 'input'},
                'order_amount': {'label': 'Total produse (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_packaging': {'label': 'Cost ambalaj (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input', 'nonDisplay': $scope.nonDisplay},
                'order_product_discount': {'label': 'Discount produse (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_discount': {'label': 'Discount comanda (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'tazz_discount': {'label': 'Discount Tazz (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_client_discount': {'label': 'Discount client (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_loyalty_point_discount': {'label': 'Discount pct. fidelizare (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_shipping': {'label': 'Transport (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_tip': {'label': 'Tips (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_product_sgr': {'label': 'SGR (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'total': {'label': 'Total (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                //'order_partial':{'label':'Plata partiala ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'}
                'order_nos_exceeded': {'label': 'Nr. comenzi cu timp estimat depasit', 'filter': 1, 'filterType': 'input'},
                'percent_nos_estimated_time_exceeded': {'label': 'Timp estimat depasit %', 'filter': 1, 'filterType': 'input'}
            };

            $scope.search['reportType'] = 'reportDaily';
            $scope.additionals['reportType'] = 'reportDaily';
            $scope.title = 'Comenzi / Raport zilnic';
            $scope.classAction = 'td-small';
            $scope.additionals['report'] = 1;

        }

        if ($location.path() == $scope.path + '/reportDetailSgr') {
            $scope.controlGetOrder = false;
            $scope.columns = {
                'order_no': {'label': 'Nr. comanda', 'filter': 1, 'filterType': 'input'},
                'order_amount': {'label': 'Total produse (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'food_product_sgr_0': {'label': 'Fara ambalaj (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'food_product_sgr_1': {'label': 'Plastic (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'food_product_sgr_2': {'label': 'Aluminiu (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'food_product_sgr_3': {'label': 'Sticla (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_product_sgr': {'label': 'Total SGR (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'total': {'label': 'Total (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'}
            };

            $scope.search['reportType'] = 'reportDetailSgr';
            $scope.additionals['reportType'] = 'reportDetailSgr';
            $scope.title = 'SGR / Raport SGR detaliat';
            $scope.classAction = 'td-small';
            $scope.additionals['report'] = 1;
        }

        if ($location.path() == $scope.path + '/reportDailySgr') {
            $scope.controlGetOrder = false;
            $scope.columns = {
                'date': {'label': 'Data', 'filter': 1, 'filterType': 'input'},
                'order_numbers': {'label': 'Nr. comenzi', 'filter': 1, 'filterType': 'input'},
                'order_amount': {'label': 'Total produse (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'food_product_sgr_0': {'label': 'Fara ambalaj (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'food_product_sgr_1': {'label': 'Plastic (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'food_product_sgr_2': {'label': 'Aluminiu (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'food_product_sgr_3': {'label': 'Sticla (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_product_sgr': {'label': 'Total SGR (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'total': {'label': 'Total (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'}
            };

            $scope.search['reportType'] = 'reportDailySgr';
            $scope.additionals['reportType'] = 'reportDailySgr';
            $scope.title = 'SGR / Raport SGR zilnic';
            $scope.classAction = 'td-small';
            $scope.additionals['report'] = 1;

        }

        if ($location.path() == $scope.path + '/reportGeneralSgr') {
            $scope.controlGetOrder = false;
            $scope.columns = {
                'order_numbers': {'label': 'Nr. comenzi', 'filter': 1, 'filterType': 'input'},
                'order_amount': {'label': 'Total produse (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'food_product_sgr_0': {'label': 'Fara ambalaj (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'food_product_sgr_1': {'label': 'Plastic (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'food_product_sgr_2': {'label': 'Aluminiu (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'food_product_sgr_3': {'label': 'Sticla (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_product_sgr': {'label': 'Total SGR (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'total': {'label': 'Total (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'}
            };

            $scope.search['reportType'] = 'reportGeneralSgr';
            $scope.additionals['reportType'] = 'reportGeneralSgr';
            $scope.title = 'SGR / Raport SGR general';
            $scope.classAction = 'td-small';
            $scope.additionals['report'] = 1;
        }

        if ($location.path() == $scope.path + '/reportMonetary') {
            $scope.classModel = 'monetary';
            $scope.columns = {
              'created_at': {'label': 'Data', 'filter': 1, 'filterType': 'input'},
              'order_no': {'label': 'Comanda', 'filter': 1, 'filterType': 'input'},
              'no_receipt': {'label': 'Nr. bon', 'filter': 1, 'filterType': 'input'},
              'no_report_z': {'label': 'Nr. Z', 'filter': 1, 'filterType': 'input'},
              'total_receipt': {'label': 'Total bonuri', 'filter': 1, 'filterType': 'input'}
            };
            $scope.search['reportType'] = 'reportMonetary';
            $scope.additionals['reportType'] = 'reportMonetary';
            $scope.title = 'Comenzi / Raport de monetar';
            $scope.classAction = 'td-small';
            $scope.additionals['report'] = 1;

            $scope.additionals['downloadMonetary'] = function (ev, path) {

              var typeRequest = 'form-urlencoded';
              var post = $scope.search;
              post['route'] = 'downloadMonetary';

              $mdDialog.show({
                  controller: DialogController,
                  templateUrl: 'reportMonetaryDialog.tmpl.html',
                  parent: angular.element(document.body),
                  targetEvent: ev,
                  clickOutsideToClose: true,
                  locals: {
                      pathTemplate: $scope.pathTemplate,
                      additionals: $scope.additionals
                  }
              }).then(function () {

              });
              DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'additionals'];
              function DialogController($scope, $mdDialog, pathTemplate, additionals) {
                  $scope.pathTemplate = pathTemplate;
                  $scope.additionals = additionals;
                  $scope.cancel = function () {
                      $mdDialog.cancel();
                  };
                  $scope.isLoading = true;
                  $scope.additionals['buttonDisabled'] = true;

                  Crud.post(typeRequest, post, path + '/downloadMonetary')
                      .success(function (data) {
                          //window.location = path + '/downloadMonetaryFile';
                          //var data = 'aaaa\r\n\r\n  bbbb\r\n  cccc';
                          //console.log(data)
                          var element = document.createElement('a');
                          element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(data));
                          if (navigator.userAgent.indexOf("Firefox") != -1) {
                              element.setAttribute('download', 'monetar.txt');
                          } else {
                              element.setAttribute('download', 'monetar');
                          }
                          element.style.display = 'none';
                          document.body.appendChild(element);
                          element.click();
                          document.body.removeChild(element);

                          $scope.isLoading = false;
                          $scope.additionals['buttonDisabled'] = false;
                          $mdDialog.cancel();
                      });
              }
            }
        }

        /* show model report daily */
        $scope.additionals['totalCount'] = 0;
        $scope.additionals['countInit'] = function() {
           return  $scope.additionals['totalCount'] ++;
        }
        $scope.showModelReportDaily = function (ev, path, model, type) {
            $scope.additionals['buttonDisabled'] = true;
            $scope.additionals['type'] = '';
            if (!angular.isUndefined(type)) {
                     $scope.additionals['type'] = type;
             }

            if ($scope.mode_action == 'page') {
                $scope.controlSH = true;
                $scope.action = 'show';
                angular.element(document.querySelector('.fill-height')).animate({scrollTop: 250}, "slow");
                $scope.modelData = {};
                $scope.modelData = model;
                if (typeof model.order_nos === 'string') {
                    $scope.modelData.order_nos = model.order_nos.split(', ');
                }
                if (typeof model.order_ids === 'string') {
                    $scope.modelData.order_ids = model.order_ids.split(', ');
                }
                 if (typeof model.order_exceeded === 'string') {
                    $scope.modelData.order_exceeded = model.order_exceeded.split(', ');
                }
                $scope.cancel = function () {
                    $scope.modelData = {};
                    $scope.errors = {};
                    $scope.controlSH = false;
                    $scope.additionals['buttonDisabled'] = false;
                };
                $scope.additionals['buttonDisabled'] = false;
            }
            if ($scope.mode_action == 'dialog') {
                var typeRequest = 'form-urlencoded';
                model['route'] = 'showReportDaily';
                $mdDialog.show({
                    controller: DialogController,
                    templateUrl: 'showDialog.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    locals: {
                        path: $scope.path,
                        pathTemplate: $scope.pathTemplate,
                        model: model,
                        search: $scope.search,
                        formatText: $scope.formatText,
                        formatDate: $scope.formatDate,
                        columns: $scope.columns,
                        additionals: $scope.additionals
                    },
                });
                DialogController.$inject = ['$scope', '$mdDialog', 'path', 'pathTemplate', 'model', 'search', 'formatText', 'formatDate', 'columns', 'additionals'];
                function DialogController($scope, $mdDialog, path, pathTemplate, model, search, formatText, formatDate, columns, additionals) {
                    $scope.pathTemplate = pathTemplate;
                    $scope.path = path;
                    $scope.modelData = model;
                    if (typeof model.order_nos === 'string') {
                        $scope.modelData.order_nos = model.order_nos.split(', ');
                    }
                    if (typeof model.order_ids === 'string') {
                        $scope.modelData.order_ids = model.order_ids.split(', ');
                    }
                    $scope.additionals = additionals;
                    $scope.formatText = formatText;
                    $scope.formatDate = formatDate;
                    $scope.columns = columns;
                    $scope.search = search;

                    $scope.cancel = function () {
                        $mdDialog.cancel();
                        $scope.additionals['buttonDisabled'] = false;
                    };
                    $scope.additionals['buttonDisabled'] = false;
                }
            }
        };

        if ($location.path() == $scope.path + '/reportMonthly') {
            $scope.controlGetOrder = false;
            $scope.columns = {
                'month': {'label': 'Luna', 'filter': 1, 'filterType': 'input'},
                //'order_nos':{'label':'Comenzi', 'filter':1, 'filterType':'input'},
                'order_numbers': {'label': 'Nr. comenzi', 'filter': 1, 'filterType': 'input'},
                'order_amount': {'label': 'Total produse (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_packaging': {'label': 'Cost ambalaj (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input', 'nonDisplay': $scope.nonDisplay},
                'order_product_discount': {'label': 'Discount produse (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_discount': {'label': 'Discount comanda (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'tazz_discount': {'label': 'Discount Tazz (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_client_discount': {'label': 'Discount client (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_loyalty_point_discount': {'label': 'Discount pct. fidelizare (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_shipping': {'label': 'Transport (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_tip': {'label': 'Tips (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_product_sgr': {'label': 'SGR (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'total': {'label': 'Total (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                //'order_partial':{'label':'Plata partiala ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'}
            };

            $scope.search['reportType'] = 'reportMonthly';
            $scope.additionals['reportType'] = 'reportMonthly';
            $scope.title = 'Comenzi / Raport lunar';
            $scope.classAction = 'td-small';
            $scope.additionals['report'] = 1;

        }

        if ($location.path() == $scope.path + '/reportDailySource') {
            $scope.controlGetOrder = false;
            $scope.columns = {
                'date': {'label': 'Data', 'filter': 1, 'filterType': 'input'},
                'order_source': {'label': 'Sursa', 'filter': 1, 'filterType': 'select'},
                //'order_nos':{'label':'Comenzi', 'filter':1, 'filterType':'input'},
                'order_numbers': {'label': 'Nr. comenzi', 'filter': 1, 'filterType': 'input'},
                'order_amount': {'label': 'Total produse (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_packaging': {'label': 'Cost ambalaj (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input', 'nonDisplay': $scope.nonDisplay},
                'order_product_discount': {'label': 'Discount produse (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_discount': {'label': 'Discount comanda (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'tazz_discount': {'label': 'Discount Tazz (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_client_discount': {'label': 'Discount client (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_loyalty_point_discount': {'label': 'Discount pct. fidelizare (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_shipping': {'label': 'Transport (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_tip': {'label': 'Tips (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_product_sgr': {'label': 'SGR (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'total': {'label': 'Total (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                //'order_partial':{'label':'Plata partiala ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'}
            };

            $scope.columns.order_source.options = $scope.order_source;

            $scope.search['reportType'] = 'reportDailySource';
            $scope.additionals['reportType'] = 'reportDailySource';
            $scope.title = 'Comenzi / Raport zilnic pe surse de provenienta';
            $scope.classAction = 'td-small';
            $scope.additionals['report'] = 1;

        }

        if ($location.path() == $scope.path + '/reportSource') {
            $scope.controlGetOrder = false;
            $scope.columns = {
                //'date':{'label':'Data', 'filter':1, 'filterType':'input'},
                'order_source': {'label': 'Sursa', 'filter': 1, 'filterType': 'select'},
                //'order_nos':{'label':'Comenzi', 'filter':1, 'filterType':'input'},
                'order_numbers': {'label': 'Nr. comenzi', 'filter': 1, 'filterType': 'input'},
                'order_amount': {'label': 'Total produse (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_packaging': {'label': 'Cost ambalaj (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input', 'nonDisplay': $scope.nonDisplay},
                'order_product_discount': {'label': 'Discount produse (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_discount': {'label': 'Discount comanda (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'tazz_discount': {'label': 'Discount Tazz (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_client_discount': {'label': 'Discount client (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_loyalty_point_discount': {'label': 'Discount pct. fidelizare (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_shipping': {'label': 'Transport (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_tip': {'label': 'Tips (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_product_sgr': {'label': 'SGR (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'total': {'label': 'Total (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                //'order_partial':{'label':'Plata partiala ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'}
            };

            $scope.columns.order_source.options = $scope.order_source;

            $scope.search['reportType'] = 'reportSource';
            $scope.additionals['reportType'] = 'reportSource';
            $scope.title = 'Comenzi / Raport pe surse de provenienta';
            $scope.classAction = 'td-small';
            $scope.additionals['report'] = 1;

        }

        if ($location.path() == $scope.path + '/reportShipping') {
            $scope.controlGetOrder = false;
            $scope.columns = {
                'date': {'label': 'Perioada', 'filter': 1, 'filterType': 'input'},
                'order_numbers': {'label': 'Nr. comenzi', 'filter': 1, 'filterType': 'input'},
                'order_shipping': {'label': 'Transport (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'total': {'label': 'Total (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'}
            };
            $scope.search['reportType'] = 'reportShipping';
            $scope.additionals['reportType'] = 'reportShipping';
            $scope.title = 'Comenzi / Raport privind taxa de transport';
            $scope.classAction = 'td-small';
            $scope.additionals['report'] = 1;

        }

        if ($location.path() == $scope.path + '/reportDiscount') {
            $scope.controlGetOrder = false;
            $scope.columns = {
                'date': {'label': 'Perioada', 'filter': 1, 'filterType': 'input'},
                'order_numbers': {'label': 'Nr. comenzi', 'filter': 1, 'filterType': 'input'},
                'order_amount': {'label': 'Total produse (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_product_discount': {'label': 'Discount produse (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_discount': {'label': 'Discount comanda (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'tazz_discount': {'label': 'Discount Tazz (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_client_discount': {'label': 'Discount client (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_loyalty_point_discount': {'label': 'Discount pct. fidelizare (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'total_discount': {'label': 'Total discount (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_shipping': {'label': 'Transport (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_tip': {'label': 'Tips (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_product_sgr': {'label': 'SGR (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'total': {'label': 'Total (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
            };

            $scope.search['reportType'] = 'reportDiscount';
            $scope.additionals['reportType'] = 'reportDiscount';
            $scope.title = 'Comenzi / Raport privind situatia reducerilor';
            $scope.classAction = 'td-small';
            $scope.additionals['report'] = 1;

        }

        if ($location.path() == $scope.path + '/reportDiscountDetail') {
            $scope.controlGetOrder = false;
            $scope.columns = {
                //'id':{'label':'Id', 'filter':1, 'filterType':'input'},
                'order_no': {'label': 'Nr.com.', 'filter': 1, 'filterType': 'input'},
                'order_start': {'label': 'Start', 'filter': 1, 'filterType': 'input'},
                'client_name': {'label': 'Client', 'filter': 1, 'filterType': 'input'},
                'order_source': {'label': 'Sursa', 'filter': 1, 'filterType': 'select'},

                'order_status': {'label': 'Status comanda', 'filter': 1, 'filterType': 'select'},
                'order_amount': {'label': 'Total produse (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_packaging': {'label': 'Cost ambalaj (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input', 'nonDisplay': $scope.nonDisplay},
                'order_product_discount': {'label': 'Discount produse (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_discount': {'label': 'Discount comanda (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'tazz_discount': {'label': 'Discount Tazz (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_client_discount': {'label': 'Discount client (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_loyalty_point_discount': {'label': 'Discount pct. fidelizare (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'total_discount': {'label': 'Total discount (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_shipping': {'label': 'Transport (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_tip': {'label': 'Tips (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_product_sgr': {'label': 'SGR (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'total': {'label': 'Total (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                //'order_partial':{'label':'Plata partiala ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'}
                //'order_discount_reason': {'label': 'Motiv reducere', 'filter': 1, 'filterType': 'select'},
            };

            $scope.columns.order_status.options = $scope.order_status;
            $scope.columns.order_source.options = $scope.order_source;

            Crud.getDependedFields($scope.path)
            .success(function (data) {
                $scope.columns['order_discount_reason'] =  {'label': 'Motiv reducere', 'filter': 1, 'filterType': 'select'};
                $scope.additionals['order_discount_reasons'] = data.discountsReasons;
                if (!angular.isUndefined($scope.additionals['order_discount_reasons'])) {
                  $scope.additionals['order_discount_reason_string'] = JSON.stringify($scope.additionals['order_discount_reasons']);
                }
                $scope.columns.order_discount_reason.options = $scope.additionals['order_discount_reasons'];
            });

            $scope.search['reportType'] = 'reportDiscountDetail';
            $scope.additionals['reportType'] = 'reportDiscountDetail';
            $scope.title = 'Comenzi / Raport privind situatia detaliata a reducerilor';
            $scope.classAction = 'td-small';
            $scope.additionals['report'] = 1;
        }

        if ($location.path() == $scope.path + '/reportDiscountClientDetail') {
            $scope.controlGetOrder = false;
            $scope.columns = {
                //'id':{'label':'Id', 'filter':1, 'filterType':'input'},
                'order_no': {'label': 'Nr.com.', 'filter': 1, 'filterType': 'input'},
                'order_start': {'label': 'Start', 'filter': 1, 'filterType': 'input'},
                'client_name': {'label': 'Client', 'filter': 1, 'filterType': 'input'},
                'order_source': {'label': 'Sursa', 'filter': 1, 'filterType': 'select'},
                'order_status': {'label': 'Status comanda', 'filter': 1, 'filterType': 'select'},

                /*'order_amount': {'label': 'Total produse (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_packaging': {'label': 'Cost ambalaj (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input', 'nonDisplay': $scope.nonDisplay},
                'order_product_discount': {'label': 'Discount produse (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_discount': {'label': 'Discount comanda (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'tazz_discount': {'label': 'Discount Tazz (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_client_discount': {'label': 'Discount client (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_loyalty_point_discount': {'label': 'Discount pct. fidelizare (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'total_discount': {'label': 'Total discount (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_shipping': {'label': 'Transport (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_tip': {'label': 'Tips (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_product_sgr': {'label': 'SGR (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},*/

                'discount_campaigns_type0': {'label': 'Reducere one-time client', 'filter': 1, 'filterType': 'input'},
                'discount_campaigns_type1': {'label': 'Reducere multipla client', 'filter': 1, 'filterType': 'input'},

                'order_client_discount': {'label': 'Total reducere client (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'total': {'label': 'Total (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                //'order_partial':{'label':'Plata partiala ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'}
                //'order_discount_reason': {'label': 'Motiv reducere', 'filter': 1, 'filterType': 'select'},
            };

            $scope.columns.order_status.options = $scope.order_status;
            $scope.columns.order_source.options = $scope.order_source;

            $scope.search['reportType'] = 'reportDiscountClientDetail';
            $scope.additionals['reportType'] = 'reportDiscountClientDetail';
            $scope.title = 'Comenzi / Raport privind situatia detaliata a reducerilor per client';
            $scope.classAction = 'td-small';
            $scope.additionals['report'] = 1;
        }

        if ($location.path() == $scope.path + '/reportDiscountImportDetail') {
            $scope.controlGetOrder = false;
            $scope.columns = {
                //'id':{'label':'Id', 'filter':1, 'filterType':'input'},
                'order_no': {'label': 'Nr.com.', 'filter': 1, 'filterType': 'input'},
                'order_start': {'label': 'Start', 'filter': 1, 'filterType': 'input'},
                'order_source': {'label': 'Sursa', 'filter': 1, 'filterType': 'select'},

                'tazz_partner_discount': {'label': 'Tazz partner discount', 'filter': 1, 'filterType': 'input'},
                'tazz_ecm_discount': {'label': 'Tazz ecm discount', 'filter': 1, 'filterType': 'input'},
                'tazz_voucher_value': {'label': 'Tazz voucher value', 'filter': 1, 'filterType': 'input'},
                //'tazz_loyalty_point_discount': {'label': 'Tazz discount pct.fid.', 'filter': 1, 'filterType': 'input'},

                'bbelly_product_discount': {'label': 'BigBelly product discount', 'filter': 1, 'filterType': 'input'},
                'bbelly_anniversary_voucher': {'label': 'BigBelly voucher aniversar', 'filter': 1, 'filterType': 'input'},
                'bbelly_voucher': {'label': 'BigBelly voucher', 'filter': 1, 'filterType': 'input'},
                'bbelly_loyalty_point_discount': {'label': 'BigBelly discount pct.fid.', 'filter': 1, 'filterType': 'input'},

                'total_discount_import': {'label': 'Total discount import', 'filter': 1, 'filterType': 'input'},
                'total_discount': {'label': 'Total discount aplicatie(' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'}
            };

            $scope.columns.order_source.options = $scope.order_source;

            $scope.search['reportType'] = 'reportDiscountImportDetail';
            $scope.additionals['reportType'] = 'reportDiscountImportDetail';
            $scope.title = 'Comenzi / Raport privind situatia detaliata a reducerilor din import';
            $scope.classAction = 'td-small';
            $scope.additionals['report'] = 1;
        }

        if ($location.path() == $scope.path + '/reportSection') {
            $scope.controlGetOrder = false;
            $scope.columns = {
                'section_name': {'label': 'Cartier/Localitate', 'filter': 1, 'filterType': 'input'},
                //'order_nos':{'label':'Comenzi', 'filter':1, 'filterType':'input'},
                'order_numbers': {'label': 'Nr. comenzi', 'filter': 1, 'filterType': 'input'},
                'order_amount': {'label': 'Total produse (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_packaging': {'label': 'Cost ambalaj (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input', 'nonDisplay': $scope.nonDisplay},
                'order_product_discount': {'label': 'Discount produse (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_discount': {'label': 'Discount comanda (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'tazz_discount': {'label': 'Discount Tazz (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_client_discount': {'label': 'Discount client (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_loyalty_point_discount': {'label': 'Discount pct. fidelizare (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_shipping': {'label': 'Transport (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_tip': {'label': 'Tips (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'order_product_sgr': {'label': 'SGR (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                'total': {'label': 'Total (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input'},
                //'order_partial':{'label':'Plata partiala ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'}
            };
            $scope.search['reportType'] = 'reportSection';
            $scope.additionals['reportType'] = 'reportSection';
            $scope.title = 'Comenzi / Raport vanzari pe cartiere';
            $scope.classAction = 'td-small';
            $scope.additionals['report'] = 1;

            $scope.additionals['search_localities'] = [];
            $scope.additionals['getSearchLocalities'] = function () {
                return Crud.get($scope.path + '/getLocalities?county_name=Cluj')
                  .then(function (data) {
                      $scope.additionals['search_localities'] = data.data.localities;
                  });
            }
            $scope.additionals['getSearchLocalities']();
        }

        /* show model report daily source */
        $scope.showModelReportDailySource = function (ev, path, model) {
            $scope.additionals['buttonDisabled'] = true;
            if ($scope.mode_action == 'page') {
                $scope.controlSH = true;
                $scope.action = 'show';
                angular.element(document.querySelector('.fill-height')).animate({scrollTop: 250}, "slow");
                $scope.modelData = {};
                $scope.modelData = model;
                if (typeof model.order_nos === 'string') {
                    $scope.modelData.order_nos = model.order_nos.split(', ');
                }
                if (typeof model.order_ids === 'string') {
                    $scope.modelData.order_ids = model.order_ids.split(', ');
                }
                $scope.cancel = function () {
                    $scope.modelData = {};
                    $scope.errors = {};
                    $scope.controlSH = false;
                    $scope.additionals['buttonDisabled'] = false;
                };
                $scope.additionals['buttonDisabled'] = false;
            }
            if ($scope.mode_action == 'dialog') {
                var typeRequest = 'form-urlencoded';
                model['route'] = 'showReportDaily';
                $mdDialog.show({
                    controller: DialogController,
                    templateUrl: 'showDialog.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    locals: {
                        path: $scope.path,
                        pathTemplate: $scope.pathTemplate,
                        model: model,
                        search: $scope.search,
                        formatText: $scope.formatText,
                        formatDate: $scope.formatDate,
                        columns: $scope.columns,
                        additionals: $scope.additionals
                    },
                });
                DialogController.$inject = ['$scope', '$mdDialog', 'path', 'pathTemplate', 'model', 'search', 'formatText', 'formatDate', 'columns', 'additionals'];
                function DialogController($scope, $mdDialog, path, pathTemplate, model, search, formatText, formatDate, columns, additionals) {
                    $scope.pathTemplate = pathTemplate;
                    $scope.path = path;
                    $scope.modelData = model;
                    if (typeof model.order_nos === 'string') {
                        $scope.modelData.order_nos = model.order_nos.split(', ');
                    }
                    if (typeof model.order_ids === 'string') {
                        $scope.modelData.order_ids = model.order_ids.split(', ');
                    }
                    $scope.additionals = additionals;
                    $scope.formatText = formatText;
                    $scope.formatDate = formatDate;
                    $scope.columns = columns;
                    $scope.search = search;

                    $scope.cancel = function () {
                        $mdDialog.cancel();
                        $scope.additionals['buttonDisabled'] = false;
                    };
                    $scope.additionals['buttonDisabled'] = false;
                }
            }
        };

        /* show model report source */
        $scope.showModelReportSource = function (ev, path, model) {
            $scope.additionals['buttonDisabled'] = true;
            if ($scope.mode_action == 'page') {
                $scope.controlSH = true;
                $scope.action = 'show';
                angular.element(document.querySelector('.fill-height')).animate({scrollTop: 250}, "slow");
                $scope.modelData = {};
                $scope.modelData = model;
                if (typeof model.order_nos === 'string') {
                    $scope.modelData.order_nos = model.order_nos.split(', ');
                }
                if (typeof model.order_ids === 'string') {
                    $scope.modelData.order_ids = model.order_ids.split(', ');
                }
                $scope.cancel = function () {
                    $scope.modelData = {};
                    $scope.errors = {};
                    $scope.controlSH = false;
                    $scope.additionals['buttonDisabled'] = false;
                };
                $scope.additionals['buttonDisabled'] = false;
            }
            if ($scope.mode_action == 'dialog') {
                var typeRequest = 'form-urlencoded';
                model['route'] = 'showReportSource';
                $mdDialog.show({
                    controller: DialogController,
                    templateUrl: 'showDialog.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    locals: {
                        path: $scope.path,
                        pathTemplate: $scope.pathTemplate,
                        model: model,
                        search: $scope.search,
                        formatText: $scope.formatText,
                        formatDate: $scope.formatDate,
                        columns: $scope.columns,
                        additionals: $scope.additionals
                    },
                });
                DialogController.$inject = ['$scope', '$mdDialog', 'path', 'pathTemplate', 'model', 'search', 'formatText', 'formatDate', 'columns', 'additionals'];
                function DialogController($scope, $mdDialog, path, pathTemplate, model, search, formatText, formatDate, columns, additionals) {
                    $scope.pathTemplate = pathTemplate;
                    $scope.path = path;
                    $scope.modelData = model;
                    if (typeof model.order_nos === 'string') {
                        $scope.modelData.order_nos = model.order_nos.split(', ');
                    }
                    if (typeof model.order_ids === 'string') {
                        $scope.modelData.order_ids = model.order_ids.split(', ');
                    }
                    $scope.additionals = additionals;
                    $scope.formatText = formatText;
                    $scope.formatDate = formatDate;
                    $scope.columns = columns;
                    $scope.search = search;

                    $scope.cancel = function () {
                        $mdDialog.cancel();
                        $scope.additionals['buttonDisabled'] = false;
                    };
                    $scope.additionals['buttonDisabled'] = false;
                }
            }
        };

        /* show model report discount */
        $scope.showModelReportDiscount = function (ev, path, model) {
            $scope.additionals['buttonDisabled'] = true;

            if ($scope.mode_action == 'page') {
                $scope.controlSH = true;
                $scope.action = 'show';
                angular.element(document.querySelector('.fill-height')).animate({scrollTop: 250}, 'slow');

                $scope.modelData = {};
                $scope.cancel = function () {
                    $scope.modelData = {};
                    $scope.errors = {};
                    $scope.controlSH = false;
                };
                if (!angular.isUndefined($scope.additionals['function'])) {
                    $scope.additionals['function'](ev, $scope.modelData);
                }

                var typeRequest = 'form-urlencoded';
                var post = $scope.search;
                post['route'] = 'showReportDiscount';
                if (!angular.isUndefined(model['date'])) {
                    post['date'] = model['date'];
                }
                Crud.post(typeRequest, post, path + '/showReportDiscount')
                        .success(function (data) {
                            $scope.modelData = data;
                            $scope.additionals['buttonDisabled'] = false;
                        });
            }
            if ($scope.mode_action == 'dialog') {
                var typeRequest = 'form-urlencoded';
                var post = $scope.search;
                post['route'] = 'showReportDiscount';
                if (!angular.isUndefined(model['date'])) {
                    post['date'] = model['date'];
                }
                Crud.post(typeRequest, post, path + '/showReportDiscount')
                        .success(function (data) {

                            $mdDialog.show({
                                controller: DialogController,
                                templateUrl: 'showDialog.tmpl.html',
                                parent: angular.element(document.body),
                                targetEvent: ev,
                                clickOutsideToClose: true,
                                locals: {
                                    pathTemplate: $scope.pathTemplate,
                                    model: data,
                                    formatText: $scope.formatText,
                                    formatDate: $scope.formatDate,
                                    columns: $scope.columns,
                                    additionals: $scope.additionals
                                },
                            });
                            DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'model', 'formatText', 'formatDate', 'columns', 'additionals'];
                            function DialogController($scope, $mdDialog, pathTemplate, model, formatText, formatDate, columns, additionals) {
                                $scope.pathTemplate = pathTemplate;
                                $scope.modelData = model;
                                $scope.additionals = additionals;
                                $scope.formatText = formatText;
                                $scope.formatDate = formatDate;
                                $scope.columns = columns;
                                $scope.currency = $rootScope.currency;

                                $scope.cancel = function () {
                                    $mdDialog.cancel();
                                };
                            }
                            $scope.additionals['buttonDisabled'] = false;
                        }).error(function (data) {
                    $scope.errors = data.errors;
                    $scope.additionals['buttonDisabled'] = false;
                    if (data == null) {
                        $rootScope.checkNetworkConnection();
                    }

                });
            }
        };

        $scope.cancelSearchReport = function (ev, path, reportType) {
            $scope.search = {};

            if ($scope.searchControl == true) {
                if (!angular.isUndefined(reportType)) {
                    $scope.search['reportType'] = reportType;
                    $scope.additionals['reportType'] = reportType;
                    if (reportType == 'reportGeneral') {
                        $scope.search.reportTypeGeneral = 'driver';
                    }
                }
                $scope.getPaginateModel(path, 1, $scope.defaultItem);
            }
            angular.element(document.querySelector('.expand-collapse-content')).slideToggle('200', function () {
                angular.element(document.querySelector('#collapse i')).toggleClass('fa-minus fa-plus');
            });
            angular.element(document.querySelector('mdp-date-picker .md-input-has-value')).removeClass('md-input-has-value');
            angular.element(document.querySelector('mdp-date-picker .md-input-invalid')).removeClass('md-input-invalid');
            angular.element(document.querySelector('mdp-date-picker .md-input-has-value')).removeClass('md-input-has-value');
            angular.element(document.querySelector('mdp-date-picker .md-input-invalid')).removeClass('md-input-invalid');
            var form = document.getElementById('search-form');
            form.reset();

            $timeout($scope.removeDate, 500);

        }

        /* add campaign discount */
        if (angular.isUndefined($scope.modelDataDiscountCampaign)) {
            $scope.modelDataDiscountCampaign = {};
        }
        if (angular.isUndefined($scope.modelDataDiscountCampaign.discount_campaign_start_date)) {
            $scope.modelDataDiscountCampaign.discount_campaign_start_date = current_init_date;
        }
        $scope.cancelDiscountCampaign = function () {
            $scope.modelDataDiscountCampaign = {};
            $scope.errors = {};
            $scope.additionals['selectedItemClientPhone'] = '';

            angular.element(document.querySelector('mdp-date-picker .md-input-has-value')).removeClass('md-input-has-value');
            angular.element(document.querySelector('mdp-date-picker .md-input-invalid')).removeClass('md-input-invalid');
            angular.element(document.querySelector('mdp-date-picker .md-input-has-value')).removeClass('md-input-has-value');
            angular.element(document.querySelector('mdp-date-picker .md-input-invalid')).removeClass('md-input-invalid');
            var form = document.getElementById('discount-campaign-form');
            form.reset();

            $timeout($scope.removeDate, 500);
            $timeout(function () {
                $scope.modelDataDiscountCampaign.discount_campaign_start_date = current_init_date;
            }, 1000);

        };

        $scope.addDiscountCampaign = function (path, model) {

            $scope.additionals['buttonDisabledDiscountCampaign'] = true;
            $scope.isLoadingDiscountCampaign = true;

            var post = model;
            post['route'] = 'addDiscountCampaign';

            Crud.post('form-urlencoded', post, path + '/addDiscountCampaign')
                    .success(function (data) {
                        if (!angular.isUndefined(data.invalid)) {
                            $scope.additionals['invalid'] = data.invalid;
                        } else {
                        }
                        $scope.modelDataDiscountCampaign = {};
                        $scope.errors = {};
                        $scope.isLoadingDiscountCampaign = false;
                        $scope.additionals['buttonDisabledDiscountCampaign'] = false;
                        $scope.additionals['selectedItemClientPhone'] = '';
                        $scope.cancelDiscountCampaign();
                    })
                    .error(function (data) {
                        $scope.isLoadingDiscountCampaign = false;
                        $scope.errors = data.errors;
                        $scope.additionals['buttonDisabledDiscountCampaign'] = false;
                        if (data == null) {
                            $rootScope.checkNetworkConnection();
                        }
                    });

        };
        /* end add campaign discount */

        /* close date time field */
        $scope.additionals['closeTimeDiscountCampaign'] = function (ev, field) {
            if (ev.keyCode == 46) {
                if (field == 'end_time') {
                    $scope.modelDataDiscountCampaign.discount_campaign_end_time = undefined;
                }
                if (field == 'start_time') {
                    $scope.modelDataDiscountCampaign.discount_campaign_start_time = undefined;
                }
            }
        }

        /* print bf duplicate */
        $scope.additionals['printBfDuplicate'] = function (ev, path, model, id) {
          var post = {};
          post['prints_receipt'] = model;
          post['id'] = id;
          post['route'] = 'printBfDuplicate';

          Crud.post($scope.additionals['content_type'], post, path + '/printBfDuplicate')
              .success(function (data) {
                  if (!angular.isUndefined(data.invalid)) {
                      $scope.additionals['invalid'] = data.invalid;
                  } else {
                      $scope.additionals['responseBfDuplicate'] = data;
                  }
                  $scope.isLoading = false;
                  $scope.additionals['buttonDisabled'] = false;
              })
              .error(function (data) {
                  $scope.isLoading = false;
                  $scope.additionals['buttonDisabled'] = false;
                  if (data == null) {
                      $rootScope.checkNetworkConnection();
                  }
              });
        }

        $scope.controlOrderChangedHistory = false;
        $scope.getOrderChangedHistory = function (orderId) {
            if (angular.isUndefined($scope.controlOrderChangedHistory) || $scope.controlOrderChangedHistory == false) {
                  $scope.controlOrderChangedHistory = true;
                  return Crud.get($scope.path + '/getOrderChangedHistory?order_id=' + orderId)
                          .success(function (data) {
                              $scope.additionals['orders_changed_history'] = data;
                          });
            } else {
                  $scope.controlOrderChangedHistory = false;
            }
        }

        if (!angular.isUndefined($scope.columns.order_status)) {
          $scope.additionals['order_status_string'] = JSON.stringify($scope.columns.order_status.options);
        }
        if (!angular.isUndefined($scope.columns.order_source)) {
          $scope.additionals['order_source_string'] = JSON.stringify($scope.columns.order_source.options);
        }
        if (!angular.isUndefined($scope.additionals['discount_campaign_type'])) {
          $scope.additionals['discount_campaign_type_string'] = JSON.stringify($scope.additionals['discount_campaign_type'].options);
        }
        if (!angular.isUndefined($scope.additionals['discount_campaign_value_type'])) {
          $scope.additionals['discount_campaign_value_type_string'] = JSON.stringify($scope.additionals['discount_campaign_value_type'].options);
        }
        if (!angular.isUndefined($scope.additionals['discount_type'])) {
          $scope.additionals['food_product_discount_type_string'] = JSON.stringify($scope.additionals['discount_type'].options);
        }
        if (!angular.isUndefined($scope.additionals['discount_type'])) {
          $scope.additionals['supplement_discount_type_string'] = JSON.stringify($scope.additionals['discount_type'].options);
        }
        if (!angular.isUndefined($scope.additionals['incident_department'])) {
          $scope.additionals['department_incident_string'] = JSON.stringify($scope.additionals['incident_department'].options);
        }
        if (!angular.isUndefined($scope.additionals['cancellation_status_tazz'])) {
          $scope.additionals['cancellation_status_tazz_string'] = JSON.stringify($scope.additionals['cancellation_status_tazz'].options);
        }

        /* chat message from dispatcher to kitchen */
        $scope.additionals['sessionUser'] = $rootScope.session.user;
        $scope.additionals['kitchenId'] = $scope.kitchenId;

        $scope.additionals['searchTermTo'];
        $scope.additionals['clearSearchTermTo'] = function() {
            $scope.additionals['searchTermTo'] = '';
        };
        $scope.additionals['onSearchChangeTo'] = function(ev) {
            ev.stopPropagation();
        };

        $scope.messageFromDispatcherToKitchen = function () {
            $scope.chat = {};
            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'messageFromDispatcherToKitchenDialog.tmpl.html',
                parent: angular.element(document.body),
                //targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    pathTemplate: $scope.pathTemplate,
                    additionals: $scope.additionals,
                    path: $scope.path,
                    chat: $scope.chat
                }
            }).then(function () {

            });
            DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'additionals', 'path', 'chat'];
            function DialogController($scope, $mdDialog, pathTemplate, additionals, path, chat) {
                $scope.pathTemplate = pathTemplate;
                $scope.additionals = additionals;
                $scope.path = path;
                $scope.chat = chat;
                $scope.cancel = function () {
                    $mdDialog.cancel();
                };
                $scope.sendMessageFromDispatcherToKitchen = function () {
                  $scope.additionals['sendChatMessage']('user', 'kitchen', $scope.additionals['sessionUser'].id, chat.id_to, chat.message, 'closeDialog');
                }
            }
        }

        $scope.listenChat = function(text) {
            //var lang = 'ro-RO';
            //var text = 'Somnoroase păsărele Pe la cuiburi se adună, Se ascund în rămurele - Noapte bună! Doar izvoarele suspină, Pe când codrul negru tace; Dorm şi florile-n grădină - Dormi în pace! Trece lebăda pe ape Între trestii să se culce - Fie-ţi îngerii aproape, Somnul dulce!';
            //var text = 'Somnoroase păsărele Pe la cuiburi se adună';
            //console.log(text.length)

            var textArray = text.replace(/[\r\n]+/g, "").match(/\ ?(?:.{1,199}[.,?!]|.{1,200}$)/g);
            //console.log(textArray);

            // text = encodeURIComponent(text);
            // var url = 'https://translate.google.com/translate_tts?ie=UTF-8&client=gtx&q='+text+'&tl='+lang;
            // //https://translate.google.com/translate_tts?ie=UTF-8&client=gtx&q=apa&tl=ro-RO
            // //https://translate.google.com/translate_tts?ie=UTF-8&client=tw-ob&q=apa&tl=ro-RO
            // console.log(url)
            // // $('audio').attr('src', url).get(0).play();
            // var audio = new Audio();
            // audio.src =url;
            // audio.play();

            $scope.playChat(textArray, 0);
        }

        $scope.playChat = function(textArray, index) {
          var lang = 'ro-RO';
          textItem = encodeURIComponent(textArray[index]);
          var url = 'https://translate.google.com/translate_tts?ie=UTF-8&client=gtx&q='+textItem+'&tl='+lang;

              var audio = new Audio();
              $scope.audioListen = audio;
              audio.src =url;
              audio.play();
              $scope.controlChatListen = 1;

              audio.addEventListener("ended", function(){
                   var indexRepeted = index + 1;
                   if(indexRepeted < textArray.length){
                      $scope.playChat(textArray, indexRepeted);
                   } else {
                     $scope.controlChatListen = 0;
                   }
              });
        }

        $scope.stopListenChat = function() {
            $scope.controlChatListen = 0;
            $scope.audioListen.pause();
        }

        $scope.additionals['sendChatMessage'] = function (entity_from, entity_to, id_from, id_to, message, closeDialog) {

           $scope.additionals['buttonDisabled'] = true;

            if(!Array.isArray(id_to)) {
              var id_to = [id_to];
            }
            var post = {};
            post['id_to'] = id_to;
            post['id_from'] = id_from;
            post['message'] = message;
            post['route'] = 'store';
            post['entity_from'] = entity_from;
            post['entity_to'] = entity_to;

            Crud.post('form-urlencoded', post, 'chat/store')
                .success(function (data) {
                    $scope.chat.message = '';
                    $scope.additionals['errors'] = {};
                    if(closeDialog) {
                        $scope.chat = {};
                        $mdDialog.cancel();
                    }
                    $scope.isLoading = false;

                    $timeout(function () {
                        $scope.additionals['buttonDisabled'] = false;
                    }, 500);

                })
                .error(function (data) {
                    $scope.additionals['errors'] = data.errors;
                    $scope.isLoading = false;
                    $timeout(function () {
                        $scope.additionals['buttonDisabled'] = false;
                    }, 500);
                    if (data == null) {
                        $rootScope.checkNetworkConnection();
                    }
                });
        };

        $scope.additionals['sendChatAudio'] = function (entity_from, entity_to, id_from, id_to, fileblob) {
            var typeRequest = 'undefined';
            if (typeRequest == 'undefined') {
                $scope.post = new FormData();

                $scope.post.append('audiofile', fileblob, 'generic.mp3');

                $scope.post.append('route', 'store');
                $scope.post.append('entity_from', entity_from);
                $scope.post.append('entity_to', entity_to);
                $scope.post.append('id_from', id_from);

                if(!Array.isArray(id_to)) {
                  var id_to = [id_to];
                }
                angular.forEach(id_to, function (item, key) {
                    $scope.post.append('id_to[]', item);
                });
                $scope.post.append('message', 'r');
            }
            Crud.post(typeRequest, $scope.post, 'chat/store')
                .success(function (data) {
                    $mdDialog.cancel();
                    $scope.errors = {};
                    $scope.isLoading = false;
                    $scope.additionals['buttonDisabled'] = false;
                })
                .error(function (data) {
                    $scope.errors = data.errors;
                    $scope.isLoading = false;
                    $scope.additionals['buttonDisabled'] = false;
                    if (data == null) {
                        $rootScope.checkNetworkConnection();
                    }
                });
        }

        function captureMicrophone(callback) {

           /*navigator.mediaDevices.enumerateDevices().then(function(devices) {
                  return devices.some(function(val) {
                        if(val.kind === "audioinput" && val.label !== "" ) {
                          return val;
                        }
                  });
              })
              .then(function(result) {
                //console.log("result", result);
                if(!result) {
                    navigator.mediaDevices.getUserMedia({audio: true})
                    .then(function(data) {
                        $scope.controlMicrophone = 0;
                    })
                    .catch(function(error) {
                        alert('Unable to access your microphone.');
                        console.error(error);
                    });
                } else {
                    navigator.mediaDevices.getUserMedia({audio: true}).then(callback).catch(function(error) {
                        alert('Unable to access your microphone.');
                        console.error(error);
                    });
                }
            });*/

          //if(navigator.userAgent.indexOf("Chrome") != -1) {
          /*navigator.permissions.query({ name: 'microphone' }).then(function(permissionStatus) {
                //console.log(permissionStatus.state); // granted, denied, prompt
                // permissionStatus.onchange = function(){
                //     console.log("Permission changed to " + this.state);
                // }
                if(permissionStatus.state == 'prompt') {
                  navigator.mediaDevices.getUserMedia({audio: true})
                  .then(function(data) {
                      $scope.controlMicrophone = 0;
                  })
                  .catch(function(error) {
                      alert('Unable to access your microphone.');
                      console.error(error);
                  });
                }
                if(permissionStatus.state == 'granted') {
                  navigator.mediaDevices.getUserMedia({audio: true}).then(callback).catch(function(error) {
                      alert('Unable to access your microphone.');
                      console.error(error);
                  });
                }
            })*/

            navigator.mediaDevices.getUserMedia({audio: true}).then(callback).catch(function(error) {
                alert('Unable to access your microphone.');
                console.error(error);
            });

        }

        function stopRecordingCallback(entity_from, entity_to, id_from, id_to) {
            //audio.srcObject = null;
            var blob = $scope.recorder.getBlob();
            //audio.src = URL.createObjectURL(blob);
            $scope.recorder.microphone.stop();
            $scope.additionals['sendChatAudio'](entity_from, entity_to, id_from, id_to, blob);
        }

        $scope.startRecord = function() {
            /*
            //var elem = ev.currentTarget;
            //console.log(ev)
            //console.log(elem)
            //console.log(angular.element(document.querySelector('#record')))

            // document.getElementById("record").addEventListener("click", function() {
            //     console.log('clickkkkkk1111')
            // });

            // $('#record').on('click', function(e) {
            //     e.preventDefault();
            //     e.stopPropagation();
            //     e.stopImmediatePropagation();
            //
            //     console.log('clickkkkkk')
            // });
            */

            $scope.determinateValue = 0; var counter = 0;
            $rootScope.stopTimerRecord = $interval(function() {
                  $scope.determinateValue += 6;
                  if ($scope.determinateValue > 90) {
                    $scope.determinateValue = 0;
                  }
                  counter++;
                  if(counter > 15) {
                    $scope.stopRecord('kitchen', 'role', $scope.kitchenId, [2]);
                  }
            }, 1000);

            $scope.controlMicrophone = 1;
            captureMicrophone(function(microphone) {
                //audio.srcObject = microphone;
                $scope.recorder = RecordRTC(microphone, {
                    type: 'audio',
                    //recorderType: StereoAudioRecorder,
                    desiredSampRate: 16000
                });
                $scope.recorder.startRecording();
                $scope.recorder.microphone = microphone;
            });
        };

        $scope.stopRecord = function(entity_from, entity_to, id_from, id_to) {
            //$timeout(function () {

                $interval.cancel($rootScope.stopTimerRecord);
                $scope.controlMicrophone = 0;
                if (!angular.isUndefined($scope.recorder)) {
                    //recorder.stopRecording(stopRecordingCallback);
                    $scope.recorder.stopRecording(function() { stopRecordingCallback(entity_from, entity_to, id_from, id_to);});
                }
            //}, 500);
        };

        $scope.location = '';
        if ($route.current.$$route.originalPath.split(':')[0] == $scope.path + '/view/') {
            $scope.location = 'view';
        }
        if ($location.path() == $scope.path + '/getOrder') {
          $scope.location = 'getOrder';
        }
        $scope.playChatAudio = function() {
            audioFile = document.getElementById('player');
            audioFile.play();
            $scope.controlChatAudio = 1;
            audioFile.addEventListener("ended", function() {
                 $scope.controlChatAudio = 0;
            });
        }
        $scope.stopChatAudio = function() {
            document.getElementById('player').pause();
            $scope.controlChatAudio = 0;
        }
        $scope.controlChatMessage = {};
        $scope.controlChatMessage[$scope.kitchenId] = [];
        $scope.controlChatMessageDis = 0;
        $scope.controlMicrophone = 0;
        $scope.controlChatAudio = 0;
        $scope.controlChatListen = 0;
        $scope.closeChatMessage = function(key) {
            if (!angular.isUndefined(key)) {
                //$scope.controlChatMessage[$scope.kitchenId][key] = 0;
                if (!angular.isUndefined($scope.notificationChatKitchen[$scope.kitchenId][key])) {
                    $scope.notificationChatKitchen[$scope.kitchenId].splice(key, 1);
                }
            }
            $scope.controlChatMessageDis = 0;
        }

        $scope.additionals['getChatUsers'] = function () {
    			Crud.get('chat/getUsers')
    				.success(function (data) {
    					   $scope.additionals['users'] = data;
    				});
    		}
        // $scope.openAllChatAudio = function () {
        //     $scope.additionals['getChatUsers']();
        //     $scope.additionals['seeAllChat']('kitchen', 'role', $scope.additionals['kitchenId']);
        //     $scope.openAllChat();
        // }

        $scope.openAllChat = function () {

            $scope.chat = {};
            $scope.errors = {};
            $scope.additionals['modelsChat'] = [];
            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'allChatDialog.tmpl.html',
                parent: angular.element(document.body),
                //targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    pathTemplate: $scope.pathTemplate,
                    additionals: $scope.additionals,
                    path: $scope.path,
                    chat: $scope.chat
                    }
            }).then(function () {

            });

            DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'additionals', 'path', 'chat'];
            function DialogController($scope, $mdDialog, pathTemplate, additionals, path, chat) {
                $scope.pathTemplate = pathTemplate;
                $scope.additionals = additionals;
                $scope.path = path;
                $scope.chat = chat;

                $scope.cancel = function () {
                    $mdDialog.cancel();
                    $scope.chat = {};
                    $scope.additionals['modelsChat'] = [];
                };

                if ($location.path() == $scope.path + '/getOrder') {
                    $scope.additionals['seeAllChat']('role', 'kitchen', 2, $scope.additionals['kitchens'][0].id);
                }
                if ($route.current.$$route.originalPath.split(':')[0] == $scope.path + '/view/') {
                    $scope.additionals['seeAllChat']('kitchen', 'role', $scope.additionals['kitchenId']);
                }

            }
        }

        $scope.additionals['seeAllChat'] = function (entity_from, entity_to, id_from, id_to) {

          if (angular.isUndefined($scope.additionals['selectedIndexKitchen'])) {
            $scope.additionals['selectedIndexKitchen'] = 0;
          }

          $timeout(function () {
              var elem = document.getElementById('chat-message-'+id_to);
              if (!angular.isUndefined(elem) && elem != null && elem != 'null') {
                  elem.focus();
              }
          }, 500);

          var post = {};
          post['route'] = 'getChat';
          post['id_from'] = id_from;
          if (!angular.isUndefined(id_to)) {
              post['id_to'] = id_to;
          }
          post['entity_from'] = entity_from;
          post['entity_to'] = entity_to;

          Crud.post('form-urlencoded', post, 'chat/getChat')
              .success(function (data) {
                  $scope.additionals['modelsChat'] = data;
                  $scope.isLoading = false;

                  $timeout(function () {
                    if(entity_to == 'kitchen') {
                        var target = angular.element(document.querySelector('#custom-scroller-'+id_to));
                        //console.log(target[0].scrollHeight)
                        //console.log(target.get(0).scrollHeight)
                        //console.log( target.find('.div-scroll').height())
                        //console.log( $('#div-scroll-'+id_to).height())

                        //starget.scrollTop($('.div-scroll').height());
                        target.animate({scrollTop: $('#div-scroll-'+id_to).height() + 50}, 'slow');
                    }
                    if(entity_from == 'kitchen') {
                        var target = angular.element(document.querySelector('#custom-scroller-'+id_from));
                        target.animate({scrollTop: $('#div-scroll-'+id_from).height() + 50}, 'slow');
                    }
                  }, 500);

              })
              .error(function (data) {
                  $scope.isLoading = false;
                  if (data == null) {
                      $rootScope.checkNetworkConnection();
                  }
              });
        }

        /* mqtt */
        Mqtt.addListener({'id': 'chat_channel', 'funct': chatMqtt});
        function chatMqtt(result, channel) {
            //console.log(channel)
            //console.log(result)

            if ($route.current.$$route.originalPath.split(':')[0] == $scope.path + '/view/') {

                    if (angular.isUndefined($scope.notificationChatKitchen)) {
                        $scope.notificationChatKitchen = {};
                    }
                    if (angular.isUndefined($scope.notificationChatKitchen[$scope.kitchenId])) {
                        $scope.notificationChatKitchen[$scope.kitchenId] = [];
                    }
                    if (angular.isUndefined($scope.additionals['modelsChat'])) {
                       $scope.additionals['modelsChat'] = [];
                    }
                    angular.forEach(result, function (item, index) {
                      if (!angular.isUndefined(item) && item != null && item != 'null') {
                         if($scope.additionals['kitchenId'] == item.id_to && item.entity_to == 'kitchen') {
                              $scope.controlChatMessage[$scope.kitchenId].push(1);
                              $scope.notificationChatKitchen[$scope.kitchenId].push(item);
                              $scope.additionals['modelsChat'].push(item);

                              $timeout(function () {
                                  var target = angular.element(document.querySelector('#custom-scroller-'+$scope.kitchenId));
                                  target.animate({scrollTop: $('#div-scroll-'+$scope.kitchenId).height() + 50}, 'slow');
                              }, 500);
                         }
                       }
                    });
            }
            if ($location.path() == $scope.path + '/getOrder') {

                if (angular.isUndefined($scope.additionals['modelsChat'])) {
                   $scope.additionals['modelsChat'] = [];
                }
                if (angular.isUndefined($scope.notificationChatUser)) {
                    $scope.notificationChatUser = {};
                }
                angular.forEach(result, function (item, index) {
                  if (!angular.isUndefined(item) && item != null && item != 'null') {
                     if(($rootScope.session.user.roles.indexOf(item.id_to) > -1 || $rootScope.session.user.roles.indexOf('SuperAdmin') > -1) && item.entity_to == 'role') {

                          $scope.controlChatMessageDis = 1;
                          $scope.controlChatAudio = 0;
                          $scope.notificationChatUser[$rootScope.session.user.id] = {};
                          $scope.notificationChatUser[$rootScope.session.user.id].from = item.from;
                          $scope.notificationChatUser[$rootScope.session.user.id].file = '/audio/chat/'+item.file;
                          var audioFile = document.getElementById('player');
                          if(audioFile && audioFile != null && audioFile != 'null') {
                              audioFile.src = $scope.notificationChatUser[$rootScope.session.user.id].file;
                          }

                          if(!angular.isUndefined($scope.additionals['selectedIndexKitchen']) && $scope.additionals['kitchens'][$scope.additionals['selectedIndexKitchen']]['id'] == item.id_from && item.entity_from == 'kitchen') {

                              $scope.additionals['modelsChat'].push(item);

                              $timeout(function () {
                                  var target = angular.element(document.querySelector('#custom-scroller-'+item.id_from));
                                  target.animate({scrollTop: $('#div-scroll-'+item.id_from).height() + 50}, 'slow');
                              }, 500);

                          }
                        }

                       if(($rootScope.session.user.roles.indexOf(item.from) > -1 || $rootScope.session.user.roles.indexOf('SuperAdmin') > -1) && item.entity_from == 'role') {
                           if(!angular.isUndefined($scope.additionals['selectedIndexKitchen']) && $scope.additionals['kitchens'][$scope.additionals['selectedIndexKitchen']]['id'] == item.id_to && item.entity_from == 'role') {

                                $scope.additionals['modelsChat'].push(item);

                                $timeout(function () {
                                    var target = angular.element(document.querySelector('#custom-scroller-'+item.id_to));
                                    target.animate({scrollTop: $('#div-scroll-'+item.id_to).height() + 50}, 'slow');
                                }, 500);

                           }
                       }
                     }
                });

            }
        }
        /* end message from dispatcher to kitchen */

    }]
);
